/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '@/axios/mutator/custom-instance';

export type CalendarProvider = (typeof CalendarProvider)[keyof typeof CalendarProvider];

export const CalendarProvider = {
  google: 'google',
  microsoft: 'microsoft'
} as const;

export interface Calendar {
  userId?: string;
  eventId?: string;
  provider?: CalendarProvider;
}

export type CollaboratorUserType = (typeof CollaboratorUserType)[keyof typeof CollaboratorUserType];

export const CollaboratorUserType = {
  user: 'user',
  assigneeUser: 'assigneeUser',
  ceo: 'ceo',
  jp: 'jp',
  admin: 'admin',
  superAdmin: 'superAdmin',
  internal: 'internal'
} as const;

export interface Collaborator {
  userType?: CollaboratorUserType;
  userId?: string;
}

export interface Link {
  index?: number;
  title?: string;
  link?: string;
}

export type SharedWorkspaceDtoType =
  (typeof SharedWorkspaceDtoType)[keyof typeof SharedWorkspaceDtoType];

export const SharedWorkspaceDtoType = {
  oneOnOne: 'oneOnOne',
  topic: 'topic',
  team: 'team',
  owner: 'owner'
} as const;

export interface SharedWorkspaceDto {
  id: string;
  name?: string;
  calendar?: Calendar;
  videoMeeting?: VideoMeeting;
  type?: SharedWorkspaceDtoType;
  collaborators?: Collaborator[];
  teamIds?: string[];
  excludeAssetsCollaboratorIds?: string[];
  objectiveIds?: string[];
  initiativeIds?: string[];
  metricIds?: string[];
  links?: Link[];
  flowId?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface VideoMeeting {
  url?: string;
}

export interface AttachmentDto {
  name?: string;
}

export type SharedWorkspacePointDtoType =
  (typeof SharedWorkspacePointDtoType)[keyof typeof SharedWorkspacePointDtoType];

export const SharedWorkspacePointDtoType = {
  highlight: 'highlight',
  issue: 'issue'
} as const;

export type SharedWorkspacePointDtoPriority =
  (typeof SharedWorkspacePointDtoPriority)[keyof typeof SharedWorkspacePointDtoPriority];

export const SharedWorkspacePointDtoPriority = {
  L: 'L',
  M: 'M',
  H: 'H'
} as const;

export type SharedWorkspacePointDtoStatus =
  (typeof SharedWorkspacePointDtoStatus)[keyof typeof SharedWorkspacePointDtoStatus];

export const SharedWorkspacePointDtoStatus = {
  pending: 'pending',
  inProgress: 'inProgress',
  resolved: 'resolved'
} as const;

export interface SharedWorkspacePointDto {
  id: string;
  sharedWorkspaceId?: string;
  type?: SharedWorkspacePointDtoType;
  content?: string;
  description?: string;
  ownerId?: string;
  priority?: SharedWorkspacePointDtoPriority;
  durationInMinutes?: number;
  status?: SharedWorkspacePointDtoStatus;
  isStarred?: boolean;
  index?: number;
  attachments?: AttachmentDto[];
  updatedAt?: string;
  createdAt?: string;
}

export type UpdateModuleRequestBusinessArea =
  (typeof UpdateModuleRequestBusinessArea)[keyof typeof UpdateModuleRequestBusinessArea];

export const UpdateModuleRequestBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface UpdateModuleRequest {
  content: string;
  businessArea?: UpdateModuleRequestBusinessArea;
}

export type ModuleAnalysisDtoBusinessArea =
  (typeof ModuleAnalysisDtoBusinessArea)[keyof typeof ModuleAnalysisDtoBusinessArea];

export const ModuleAnalysisDtoBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface ModuleAnalysisDto {
  moduleId: string;
  businessArea?: ModuleAnalysisDtoBusinessArea;
  rating?: number;
  analysis?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Error {
  code?: string;
  message?: string;
}

export interface FileDto {
  fileUrl?: string;
}

export interface FileResponse {
  kind?: string;
  items?: FileDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface Pagination {
  totalPages?: number;
  totalItems?: number;
  currentPageNumber?: number;
  currentPageSize?: number;
}

export interface UpdateRatingRequest {
  rating: number;
}

export interface CustomBusinessAreaRequest {
  name?: string;
  boardIds?: string[];
}

export interface WorkflowContextDto {
  meetings?: WorkflowMeetingsContextDto;
  googleDrive?: WorkflowGoogleDriveContextDto;
}

export type WorkflowDtoStatus = (typeof WorkflowDtoStatus)[keyof typeof WorkflowDtoStatus];

export const WorkflowDtoStatus = {
  enabled: 'enabled',
  disabled: 'disabled'
} as const;

export interface WorkflowDto {
  id?: string;
  title?: string;
  context?: WorkflowContextDto;
  notifications?: WorkflowNotificationsDto;
  flow?: WorkflowFlowDto;
  trigger?: WorkflowTriggerDto;
  status?: WorkflowDtoStatus;
  createdFrom?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type WorkflowEmailNotificationDtoType =
  (typeof WorkflowEmailNotificationDtoType)[keyof typeof WorkflowEmailNotificationDtoType];

export const WorkflowEmailNotificationDtoType = {
  slack: 'slack',
  email: 'email'
} as const;

export interface WorkflowEmailNotificationDto {
  type?: WorkflowEmailNotificationDtoType;
}

export interface WorkflowFlowDto {
  prompt?: string;
}

export interface WorkflowGoogleDriveContextDto {
  files?: WorkflowGoogleDriveFileContextDto[];
}

export interface WorkflowGoogleDriveFileContextDto {
  fileId?: string;
  fileName?: string;
}

export type WorkflowMeetingsContextDtoTimeRange =
  (typeof WorkflowMeetingsContextDtoTimeRange)[keyof typeof WorkflowMeetingsContextDtoTimeRange];

export const WorkflowMeetingsContextDtoTimeRange = {
  last5Meetings: 'last5Meetings',
  last15Meetings: 'last15Meetings',
  yesterday: 'yesterday'
} as const;

export type WorkflowMeetingsContextDtoScope =
  (typeof WorkflowMeetingsContextDtoScope)[keyof typeof WorkflowMeetingsContextDtoScope];

export const WorkflowMeetingsContextDtoScope = {
  internal: 'internal',
  external: 'external',
  all: 'all'
} as const;

export interface WorkflowMeetingsContextDto {
  timeRange?: WorkflowMeetingsContextDtoTimeRange;
  scope?: WorkflowMeetingsContextDtoScope;
  keywords?: string[];
}

export interface WorkflowNotificationsDto {
  email?: WorkflowEmailNotificationDto;
  slack?: WorkflowSlackNotificationDto;
}

export type WorkflowScheduledTriggerDtoDaysOfWeekItem =
  (typeof WorkflowScheduledTriggerDtoDaysOfWeekItem)[keyof typeof WorkflowScheduledTriggerDtoDaysOfWeekItem];

export const WorkflowScheduledTriggerDtoDaysOfWeekItem = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
} as const;

export interface WorkflowScheduledTriggerDto {
  daysOfWeek?: WorkflowScheduledTriggerDtoDaysOfWeekItem[];
  /**
   * Time in HH:MM format (24-hour)
   * @pattern ^([01]?[0-9]|2[0-3]):[0-5][0-9]$
   */
  time?: string;
}

export type WorkflowSlackNotificationDtoType =
  (typeof WorkflowSlackNotificationDtoType)[keyof typeof WorkflowSlackNotificationDtoType];

export const WorkflowSlackNotificationDtoType = {
  slack: 'slack',
  email: 'email'
} as const;

export interface WorkflowSlackNotificationDto {
  type?: WorkflowSlackNotificationDtoType;
}

export interface WorkflowTriggerDto {
  scheduled?: WorkflowScheduledTriggerDto;
}

export interface Assignee {
  userId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  messageId?: string;
}

export type SourceType = (typeof SourceType)[keyof typeof SourceType];

export const SourceType = {
  meeting: 'meeting',
  email: 'email'
} as const;

export interface Source {
  type?: SourceType;
  sourceLocation?: string;
  sourceId?: string;
  context?: string;
}

export type TaskDtoStatus = (typeof TaskDtoStatus)[keyof typeof TaskDtoStatus];

export const TaskDtoStatus = {
  pending: 'pending',
  delegated: 'delegated',
  done: 'done'
} as const;

export type TaskDtoValidity = (typeof TaskDtoValidity)[keyof typeof TaskDtoValidity];

export const TaskDtoValidity = {
  valid: 'valid',
  invalid: 'invalid'
} as const;

export type TaskDtoInvalidityReason =
  (typeof TaskDtoInvalidityReason)[keyof typeof TaskDtoInvalidityReason];

export const TaskDtoInvalidityReason = {
  notRelevant: 'notRelevant',
  alreadyCompleted: 'alreadyCompleted',
  duplicated: 'duplicated',
  unclear: 'unclear'
} as const;

export interface TaskDto {
  id?: string;
  title?: string;
  status?: TaskDtoStatus;
  assignee?: Assignee;
  validity?: TaskDtoValidity;
  invalidityReason?: TaskDtoInvalidityReason;
  source?: Source;
  createdAt?: string;
  updatedAt?: string;
}

export interface AddToAgendaRequest {
  calendarEventIds?: string[];
}

export type StrategicPlanDtoTimeFrame =
  (typeof StrategicPlanDtoTimeFrame)[keyof typeof StrategicPlanDtoTimeFrame];

export const StrategicPlanDtoTimeFrame = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export interface StrategicPlanDto {
  id?: string;
  plan?: string;
  timeFrame?: StrategicPlanDtoTimeFrame;
  year?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type GoalDtoPeriod = (typeof GoalDtoPeriod)[keyof typeof GoalDtoPeriod];

export const GoalDtoPeriod = {
  yearly: 'yearly',
  quarterly: 'quarterly',
  monthly: 'monthly'
} as const;

export interface GoalDto {
  id?: string;
  title?: string;
  period?: GoalDtoPeriod;
  dueDate?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type ChecklistDtoStatus = (typeof ChecklistDtoStatus)[keyof typeof ChecklistDtoStatus];

export const ChecklistDtoStatus = {
  inProgress: 'inProgress',
  dismissed: 'dismissed',
  completed: 'completed'
} as const;

export interface ChecklistDto {
  id?: string;
  items?: ChecklistItemDto[];
  status?: ChecklistDtoStatus;
}

export type ChecklistItemDtoStatus =
  (typeof ChecklistItemDtoStatus)[keyof typeof ChecklistItemDtoStatus];

export const ChecklistItemDtoStatus = {
  inProgress: 'inProgress',
  completed: 'completed'
} as const;

export interface ChecklistItemDto {
  title?: string;
  status?: ChecklistItemDtoStatus;
}

export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  title?: string;
  roleId?: string;
  grantId?: string;
  meetingSetting?: UserMeetingSettings;
}

export type UserMeetingSettingsMeetingsToJoin =
  (typeof UserMeetingSettingsMeetingsToJoin)[keyof typeof UserMeetingSettingsMeetingsToJoin];

export const UserMeetingSettingsMeetingsToJoin = {
  all: 'all',
  host: 'host',
  internal: 'internal',
  none: 'none'
} as const;

export type UserMeetingSettingsSummaryDestination =
  (typeof UserMeetingSettingsSummaryDestination)[keyof typeof UserMeetingSettingsSummaryDestination];

export const UserMeetingSettingsSummaryDestination = {
  all: 'all',
  me: 'me'
} as const;

export type UserMeetingSettingsDefaultSharing =
  (typeof UserMeetingSettingsDefaultSharing)[keyof typeof UserMeetingSettingsDefaultSharing];

export const UserMeetingSettingsDefaultSharing = {
  public: 'public',
  account: 'account',
  me: 'me'
} as const;

export interface UserMeetingSettings {
  meetingsToJoin?: UserMeetingSettingsMeetingsToJoin;
  summaryDestination?: UserMeetingSettingsSummaryDestination;
  defaultSharing?: UserMeetingSettingsDefaultSharing;
  userAliases?: string[];
}

export interface UpdateUserMfaRequest {
  enableEmail?: boolean;
  enableSms?: boolean;
  enableSoftwareToken?: boolean;
}

export type PermissionNamespace = (typeof PermissionNamespace)[keyof typeof PermissionNamespace];

export const PermissionNamespace = {
  businessArea: 'businessArea',
  workspace: 'workspace',
  drive: 'drive',
  meetings: 'meetings',
  actionPlan: 'actionPlan',
  ask: 'ask',
  metrics: 'metrics',
  settings: 'settings'
} as const;

export type PermissionAccess = (typeof PermissionAccess)[keyof typeof PermissionAccess];

export const PermissionAccess = {
  block: 'block',
  view: 'view',
  edit: 'edit'
} as const;

export interface Permission {
  namespace?: PermissionNamespace;
  access?: PermissionAccess;
  resources?: string[];
}

export type RoleDtoType = (typeof RoleDtoType)[keyof typeof RoleDtoType];

export const RoleDtoType = {
  account: 'account',
  platform: 'platform'
} as const;

export interface RoleDto {
  id: string;
  name?: string;
  description?: string;
  type?: RoleDtoType;
  permissions?: Permission[];
  createdAt?: string;
  updatedAt?: string;
}

export type MetricAutomationDefinitionDtoProviderType =
  (typeof MetricAutomationDefinitionDtoProviderType)[keyof typeof MetricAutomationDefinitionDtoProviderType];

export const MetricAutomationDefinitionDtoProviderType = {
  hubspot: 'hubspot',
  quickBooks: 'quickBooks',
  microsoft: 'microsoft',
  google: 'google'
} as const;

export type MetricAutomationDefinitionDtoDataSourceType =
  (typeof MetricAutomationDefinitionDtoDataSourceType)[keyof typeof MetricAutomationDefinitionDtoDataSourceType];

export const MetricAutomationDefinitionDtoDataSourceType = {
  deals: 'deals',
  companies: 'companies',
  contacts: 'contacts',
  tickets: 'tickets',
  bill: 'bill',
  customer: 'customer',
  payment: 'payment',
  invoice: 'invoice',
  googleCalendarEvent: 'googleCalendarEvent',
  microsoftCalendarEvent: 'microsoftCalendarEvent',
  gmail: 'gmail',
  outlook: 'outlook'
} as const;

export interface MetricAutomationDefinitionDto {
  providerType?: MetricAutomationDefinitionDtoProviderType;
  dataSourceId?: string;
  dataSourceType?: MetricAutomationDefinitionDtoDataSourceType;
  query?: MetricAutomationQueryDto;
}

export type MetricAutomationQueryDtoAction =
  (typeof MetricAutomationQueryDtoAction)[keyof typeof MetricAutomationQueryDtoAction];

export const MetricAutomationQueryDtoAction = {
  count: 'count',
  sum: 'sum',
  avg: 'avg',
  min: 'min',
  max: 'max'
} as const;

export interface MetricAutomationQueryDto {
  action?: MetricAutomationQueryDtoAction;
  property?: string;
  filter?: MetricFilterDto;
}

export type MetricDefinitionDtoSource =
  (typeof MetricDefinitionDtoSource)[keyof typeof MetricDefinitionDtoSource];

export const MetricDefinitionDtoSource = {
  manual: 'manual',
  auto: 'auto',
  calc: 'calc'
} as const;

export type MetricDefinitionDtoUnit =
  (typeof MetricDefinitionDtoUnit)[keyof typeof MetricDefinitionDtoUnit];

export const MetricDefinitionDtoUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export type MetricDefinitionDtoSummarize =
  (typeof MetricDefinitionDtoSummarize)[keyof typeof MetricDefinitionDtoSummarize];

export const MetricDefinitionDtoSummarize = {
  sum: 'sum',
  avg: 'avg',
  lastValue: 'lastValue'
} as const;

export type MetricDefinitionDtoTrendType =
  (typeof MetricDefinitionDtoTrendType)[keyof typeof MetricDefinitionDtoTrendType];

export const MetricDefinitionDtoTrendType = {
  more: 'more',
  less: 'less'
} as const;

export type MetricDefinitionDtoDataPointType =
  (typeof MetricDefinitionDtoDataPointType)[keyof typeof MetricDefinitionDtoDataPointType];

export const MetricDefinitionDtoDataPointType = {
  accumulated: 'accumulated',
  independent: 'independent'
} as const;

export type MetricDefinitionDtoPeriod =
  (typeof MetricDefinitionDtoPeriod)[keyof typeof MetricDefinitionDtoPeriod];

export const MetricDefinitionDtoPeriod = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
  annually: 'annually'
} as const;

export interface MetricDefinitionDto {
  id?: string;
  name?: string;
  source?: MetricDefinitionDtoSource;
  ownerId?: string;
  teamIds?: string[];
  unit?: MetricDefinitionDtoUnit;
  summarize?: MetricDefinitionDtoSummarize;
  trendType?: MetricDefinitionDtoTrendType;
  dataPointType?: MetricDefinitionDtoDataPointType;
  period?: MetricDefinitionDtoPeriod;
  targets?: MetricTargetDefinitionDto[];
  automation?: MetricAutomationDefinitionDto;
  isInternal?: boolean;
  baselineValue?: number;
  adminOnly?: boolean;
  okrMetric?: boolean;
  index?: number;
  isArchived?: boolean;
  createdAt?: string;
}

export type MetricFilterDtoMode = (typeof MetricFilterDtoMode)[keyof typeof MetricFilterDtoMode];

export const MetricFilterDtoMode = {
  AND: 'AND',
  OR: 'OR'
} as const;

export interface MetricFilterDto {
  mode?: MetricFilterDtoMode;
  filters?: MetricSingleFilterDto[];
}

export type MetricSingleFilterDtoAction =
  (typeof MetricSingleFilterDtoAction)[keyof typeof MetricSingleFilterDtoAction];

export const MetricSingleFilterDtoAction = {
  '=': '=',
  '!=': '!=',
  '<': '<',
  '<=': '<=',
  '>': '>',
  '>=': '>=',
  BETWEEN: 'BETWEEN',
  LIKE: 'LIKE',
  NOT_LIKE: 'NOT LIKE'
} as const;

export interface MetricSingleFilterDto {
  action?: MetricSingleFilterDtoAction;
  property?: string;
  value?: string;
}

export interface MetricTargetDefinitionDto {
  value?: number;
  timestamp?: string;
}

export interface MetricDefinitionProgressDto {
  metricDefinitionId?: string;
  currentProgress?: number;
  currentBaseline?: number;
  totalProgress?: number;
  totalBaseline?: number;
  currentValue?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface MetricDefinitionProgressResponse {
  kind?: string;
  items?: MetricDefinitionProgressDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MetricDataPointDto {
  id?: string;
  dataSourceId?: string;
  metricDefinitionId?: string;
  value?: number;
  createdAt?: string;
}

export interface MetricDataPointResponse {
  kind?: string;
  items?: MetricDataPointDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface UpdateMeetingTopicsRequest {
  topics?: string[];
}

export interface UpdateMeetingNotesRequest {
  content?: string;
}

export interface InsightDto {
  content?: string;
  share?: boolean;
}

export interface UpdateMeetingInsightsRequest {
  insights?: InsightDto[];
}

export interface UpdateMeetingFollowUpRequest {
  followUp?: string;
}

export interface CancelBotRequest {
  calendarEventId?: string;
  calendarMasterEventId?: string;
  botId?: string;
}

export interface BulkCancelMeetingBotRequest {
  requests?: CancelBotRequest[];
}

export interface UpdateCalendarEventRequest {
  description?: string;
}

export interface AskJourneyUpdateRatingRequest {
  rating?: number;
}

export type UpdateAppNotificationStatusRequestStatus =
  (typeof UpdateAppNotificationStatusRequestStatus)[keyof typeof UpdateAppNotificationStatusRequestStatus];

export const UpdateAppNotificationStatusRequestStatus = {
  read: 'read',
  unread: 'unread'
} as const;

export interface UpdateAppNotificationStatusRequest {
  status?: UpdateAppNotificationStatusRequestStatus;
  notificationIds?: string[];
}

export type BaseThreadContextContextType =
  (typeof BaseThreadContextContextType)[keyof typeof BaseThreadContextContextType];

export const BaseThreadContextContextType = {
  transcript: 'transcript',
  googleDriveFile: 'googleDriveFile',
  text: 'text'
} as const;

export interface BaseThreadContext {
  entityUri?: string;
  contextType?: BaseThreadContextContextType;
}

export type ThreadDtoContextsItem =
  | BaseThreadContext
  | ThreadFileContextDto
  | ThreadGoogleDriveFileContextDto
  | ThreadTextContextDto;

export interface ThreadDto {
  id?: string;
  title?: string;
  isUserCreated?: boolean;
  seenAt?: string;
  contexts?: ThreadDtoContextsItem[];
  filesContext?: ThreadFileContextDto[];
  textsContext?: ThreadTextContextDto[];
  createdAt?: string;
}

export type ThreadFileContextDtoContextType =
  (typeof ThreadFileContextDtoContextType)[keyof typeof ThreadFileContextDtoContextType];

export const ThreadFileContextDtoContextType = {
  transcript: 'transcript',
  googleDriveFile: 'googleDriveFile',
  text: 'text'
} as const;

export interface ThreadFileContextDto {
  entityUri?: string;
  contextType?: ThreadFileContextDtoContextType;
  fileKey?: string;
  bucketName?: string;
}

export type ThreadGoogleDriveFileContextDtoAllOf = {
  fileId?: string;
  fileName?: string;
};

export type ThreadGoogleDriveFileContextDto = BaseThreadContext &
  ThreadGoogleDriveFileContextDtoAllOf;

export type ThreadTextContextDtoContextType =
  (typeof ThreadTextContextDtoContextType)[keyof typeof ThreadTextContextDtoContextType];

export const ThreadTextContextDtoContextType = {
  transcript: 'transcript',
  googleDriveFile: 'googleDriveFile',
  text: 'text'
} as const;

export interface ThreadTextContextDto {
  entityUri?: string;
  contextType?: ThreadTextContextDtoContextType;
  text?: string;
}

export type ActionPlanObjectiveDtoType =
  (typeof ActionPlanObjectiveDtoType)[keyof typeof ActionPlanObjectiveDtoType];

export const ActionPlanObjectiveDtoType = {
  company: 'company',
  businessArea: 'businessArea'
} as const;

export interface ActionPlanObjectiveDto {
  id: string;
  type?: ActionPlanObjectiveDtoType;
  title?: string;
  description?: string;
  boardId?: string;
  businessArea?: string;
  ownerId?: string;
  teamIds?: string[];
  tags?: string[];
  index?: number;
  keyResult?: KeyResult;
  adminOnly?: boolean;
  isArchived?: boolean;
  attachments?: AttachmentDto[];
  createdAt?: string;
  updatedAt?: string;
}

export type KeyResultUnit = (typeof KeyResultUnit)[keyof typeof KeyResultUnit];

export const KeyResultUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export type KeyResultTargetsPeriod =
  (typeof KeyResultTargetsPeriod)[keyof typeof KeyResultTargetsPeriod];

export const KeyResultTargetsPeriod = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
  annually: 'annually'
} as const;

export type KeyResultTrendType = (typeof KeyResultTrendType)[keyof typeof KeyResultTrendType];

export const KeyResultTrendType = {
  more: 'more',
  less: 'less'
} as const;

export type KeyResultPeriod = (typeof KeyResultPeriod)[keyof typeof KeyResultPeriod];

export const KeyResultPeriod = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
  annually: 'annually'
} as const;

export type KeyResultDataPointType =
  (typeof KeyResultDataPointType)[keyof typeof KeyResultDataPointType];

export const KeyResultDataPointType = {
  accumulated: 'accumulated',
  independent: 'independent'
} as const;

export type KeyResultSummarize = (typeof KeyResultSummarize)[keyof typeof KeyResultSummarize];

export const KeyResultSummarize = {
  sum: 'sum',
  avg: 'avg',
  lastValue: 'lastValue'
} as const;

export interface KeyResult {
  subject?: string;
  value?: number;
  unit?: KeyResultUnit;
  startingPoint?: number;
  metricId?: string;
  currentValue?: number;
  targetsPeriod?: KeyResultTargetsPeriod;
  targets?: Target[];
  trendType?: KeyResultTrendType;
  period?: KeyResultPeriod;
  dataPointType?: KeyResultDataPointType;
  summarize?: KeyResultSummarize;
}

export interface Target {
  year?: number;
  period?: number;
  value?: number;
  progress?: number;
}

export type ActionPlanInitiativeDtoStatus =
  (typeof ActionPlanInitiativeDtoStatus)[keyof typeof ActionPlanInitiativeDtoStatus];

export const ActionPlanInitiativeDtoStatus = {
  onTrack: 'onTrack',
  atRisk: 'atRisk',
  failed: 'failed',
  completed: 'completed',
  deferred: 'deferred'
} as const;

export type ActionPlanInitiativeDtoTime =
  (typeof ActionPlanInitiativeDtoTime)[keyof typeof ActionPlanInitiativeDtoTime];

export const ActionPlanInitiativeDtoTime = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export type ActionPlanInitiativeDtoPriority =
  (typeof ActionPlanInitiativeDtoPriority)[keyof typeof ActionPlanInitiativeDtoPriority];

export const ActionPlanInitiativeDtoPriority = {
  L: 'L',
  M: 'M',
  H: 'H'
} as const;

export interface ActionPlanInitiativeDto {
  id: string;
  objectiveIds?: string[];
  title?: string;
  description?: string;
  status?: ActionPlanInitiativeDtoStatus;
  owner?: string;
  ownerId?: string;
  teamIds?: string[];
  tags?: string[];
  assigneeId?: string;
  year?: number;
  time?: ActionPlanInitiativeDtoTime;
  timeframe?: Timeframe;
  goal?: Goal;
  goalProgress?: number;
  priority?: ActionPlanInitiativeDtoPriority;
  priorityDetails?: PriorityDetails;
  index?: number;
  globalIndex?: number;
  metadata?: Metadata;
  isArchived?: boolean;
  attachments?: AttachmentDto[];
  createdAt?: string;
  updatedAt?: string;
}

export type GoalUnit = (typeof GoalUnit)[keyof typeof GoalUnit];

export const GoalUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export interface Goal {
  subject?: string;
  value?: number;
  unit?: GoalUnit;
  startingPoint?: number;
  metricId?: string;
  currentValue?: number;
}

export interface Metadata {
  duplicatedFromId?: string;
  sourceSpaceId?: string;
}

export type PriorityDetailsResources =
  (typeof PriorityDetailsResources)[keyof typeof PriorityDetailsResources];

export const PriorityDetailsResources = {
  L: 'L',
  M: 'M',
  H: 'H'
} as const;

export type PriorityDetailsExpectedValue =
  (typeof PriorityDetailsExpectedValue)[keyof typeof PriorityDetailsExpectedValue];

export const PriorityDetailsExpectedValue = {
  L: 'L',
  M: 'M',
  H: 'H'
} as const;

export interface PriorityDetails {
  resources?: PriorityDetailsResources;
  expectedValue?: PriorityDetailsExpectedValue;
}

export interface Timeframe {
  year?: number;
  month?: number;
  durationInMonths?: number;
}

export interface ActionPlanBoardDto {
  id: string;
  name?: string;
  isDefault?: boolean;
  isArchived?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type ActionPlanActionItemDtoStatus =
  (typeof ActionPlanActionItemDtoStatus)[keyof typeof ActionPlanActionItemDtoStatus];

export const ActionPlanActionItemDtoStatus = {
  pending: 'pending',
  inProgress: 'inProgress',
  completed: 'completed'
} as const;

export type ActionPlanActionItemDtoSprint =
  (typeof ActionPlanActionItemDtoSprint)[keyof typeof ActionPlanActionItemDtoSprint];

export const ActionPlanActionItemDtoSprint = {
  current: 'current',
  backlog: 'backlog'
} as const;

export interface ActionPlanActionItemDto {
  id: string;
  initiativeId?: string;
  title?: string;
  description?: string;
  status?: ActionPlanActionItemDtoStatus;
  sprint?: ActionPlanActionItemDtoSprint;
  dueDate?: string;
  ownerId?: string;
  teamIds?: string[];
  tags?: string[];
  assigneeId?: string;
  index?: number;
  globalIndex?: number;
  metadata?: Metadata;
  isArchived?: boolean;
  isPrivate?: boolean;
  attachments?: AttachmentDto[];
  createdAt?: string;
  updatedAt?: string;
}

export type LinkedEntityDtoType = (typeof LinkedEntityDtoType)[keyof typeof LinkedEntityDtoType];

export const LinkedEntityDtoType = {
  objective: 'objective',
  initiative: 'initiative',
  businessArea: 'businessArea',
  module: 'module',
  workspace: 'workspace',
  sharedWorkspace: 'sharedWorkspace'
} as const;

export interface LinkedEntityDto {
  type?: LinkedEntityDtoType;
  id?: string;
}

export interface WhiteboardDto {
  id: string;
  name?: string;
  data?: string;
  collaboratorUserIds?: string[];
  linkedEntities?: LinkedEntityDto[];
  createdAt?: string;
  updatedAt?: string;
}

export interface WhiteboardResponse {
  kind?: string;
  items?: WhiteboardDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AccountTagsDto {
  tags?: string[];
}

export interface SharedWorkspaceResponse {
  kind?: string;
  items?: SharedWorkspaceDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SearchEntityRequest {
  userIds?: string[];
  entityIds?: string[];
  teamIds?: string[];
}

export interface SharedWorkspacePointResponse {
  kind?: string;
  items?: SharedWorkspacePointDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface StartMeetingRequest {
  flowId?: string;
  userIds?: string[];
}

export interface Flow {
  steps?: MeetingFlowActualStepDto[];
}

export interface MeetingData {
  objectiveIds?: string[];
  initiativeIds?: string[];
  actionItemIds?: string[];
  metricIds?: string[];
  highlightIds?: string[];
  issueIds?: string[];
  ratings?: UserRating[];
}

export type MeetingFlowActualStepDtoType =
  (typeof MeetingFlowActualStepDtoType)[keyof typeof MeetingFlowActualStepDtoType];

export const MeetingFlowActualStepDtoType = {
  custom: 'custom',
  highlights: 'highlights',
  issues: 'issues',
  objectives: 'objectives',
  initiatives: 'initiatives',
  tasks: 'tasks',
  metrics: 'metrics',
  rating: 'rating',
  followUp: 'followUp',
  brainstorming: 'brainstorming'
} as const;

export interface MeetingFlowActualStepDto {
  type?: MeetingFlowActualStepDtoType;
  name?: string;
  durationInMinutes?: number;
  index?: number;
  startTime?: string;
  endTime?: string;
}

export interface SharedWorkspaceMeetingDto {
  id: string;
  spaceId?: string;
  startTime?: string;
  endTime?: string;
  flow?: Flow;
  data?: MeetingData;
  rating?: number;
}

export interface SharedWorkspaceMeetingResponse {
  kind?: string;
  items?: SharedWorkspaceMeetingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type UserRatingAttendance = (typeof UserRatingAttendance)[keyof typeof UserRatingAttendance];

export const UserRatingAttendance = {
  attend: 'attend',
  notAttend: 'notAttend'
} as const;

export interface UserRating {
  userId?: string;
  attendance?: UserRatingAttendance;
  rating?: number;
  description?: string;
}

export interface SharedWorkspaceUpdateDto {
  id: string;
  userId?: string;
  sharedWorkspaceId?: string;
  content?: string;
  initiativeId?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface SharedWorkspaceUpdateResponse {
  kind?: string;
  items?: SharedWorkspaceUpdateDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SharedWorkspacePointCommentDto {
  id: string;
  pointId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface SharedWorkspacePointCommentResponse {
  kind?: string;
  items?: SharedWorkspacePointCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingFlowDto {
  id: string;
  name?: string;
  steps?: MeetingFlowStepDto[];
  createdAt?: string;
  updatedAt?: string;
}

export type MeetingFlowStepDtoType =
  (typeof MeetingFlowStepDtoType)[keyof typeof MeetingFlowStepDtoType];

export const MeetingFlowStepDtoType = {
  custom: 'custom',
  highlights: 'highlights',
  issues: 'issues',
  objectives: 'objectives',
  initiatives: 'initiatives',
  tasks: 'tasks',
  metrics: 'metrics',
  rating: 'rating',
  followUp: 'followUp',
  brainstorming: 'brainstorming'
} as const;

export interface MeetingFlowStepDto {
  type?: MeetingFlowStepDtoType;
  name?: string;
  durationInMinutes?: number;
  index?: number;
}

export interface MeetingFlowResponse {
  kind?: string;
  items?: MeetingFlowDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type MeetingFlowTemplateDtoType =
  (typeof MeetingFlowTemplateDtoType)[keyof typeof MeetingFlowTemplateDtoType];

export const MeetingFlowTemplateDtoType = {
  account: 'account',
  platform: 'platform'
} as const;

export interface MeetingFlowTemplateDto {
  id: string;
  name?: string;
  description?: string;
  type?: MeetingFlowTemplateDtoType;
  steps?: MeetingFlowStepDto[];
  createdAt?: string;
  updatedAt?: string;
}

export interface MeetingFlowTemplateResponse {
  kind?: string;
  items?: MeetingFlowTemplateDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SharedWorkspaceMeetingNoteDto {
  id: string;
  spaceId?: string;
  meetingId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface SharedWorkspaceMeetingNoteResponse {
  kind?: string;
  items?: SharedWorkspaceMeetingNoteDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type SharedWorkspaceMeetingActivityDtoEntityType =
  (typeof SharedWorkspaceMeetingActivityDtoEntityType)[keyof typeof SharedWorkspaceMeetingActivityDtoEntityType];

export const SharedWorkspaceMeetingActivityDtoEntityType = {
  highlight: 'highlight',
  issue: 'issue',
  objective: 'objective',
  initiative: 'initiative',
  task: 'task',
  metric: 'metric'
} as const;

export type SharedWorkspaceMeetingActivityDtoAction =
  (typeof SharedWorkspaceMeetingActivityDtoAction)[keyof typeof SharedWorkspaceMeetingActivityDtoAction];

export const SharedWorkspaceMeetingActivityDtoAction = {
  create: 'create',
  update: 'update',
  delete: 'delete'
} as const;

export interface SharedWorkspaceMeetingActivityDto {
  id: string;
  meetingId?: string;
  userId?: string;
  entityType?: SharedWorkspaceMeetingActivityDtoEntityType;
  entityId?: string;
  entityName?: string;
  action?: SharedWorkspaceMeetingActivityDtoAction;
  newValue?: string;
  createdAt?: string;
}

export interface SharedWorkspaceMeetingActivityResponse {
  kind?: string;
  items?: SharedWorkspaceMeetingActivityDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ResourceDto {
  id: string;
  link?: string;
  title?: string;
  description?: string;
  index?: number;
  type?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ResourceResponse {
  kind?: string;
  items?: ResourceDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CreateGoogleDriveFileRequestType =
  (typeof CreateGoogleDriveFileRequestType)[keyof typeof CreateGoogleDriveFileRequestType];

export const CreateGoogleDriveFileRequestType = {
  doc: 'doc',
  sheet: 'sheet',
  slide: 'slide'
} as const;

export interface CreateGoogleDriveFileRequest {
  type?: CreateGoogleDriveFileRequestType;
  subFolderName?: string;
}

export interface NoteDto {
  id: string;
  content?: string;
  index?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface NoteResponse {
  kind?: string;
  items?: NoteDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface CreateModulePlaybookRequest {
  content?: string;
  levelId?: number;
}

export interface ModulePlaybookDto {
  moduleId?: string;
  elements?: PlaybookElement[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ModulePlaybookResponse {
  kind?: string;
  items?: ModulePlaybookDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface PlaybookElement {
  id?: number;
  content?: string;
}

export type ModulePrioritizationDtoBusinessArea =
  (typeof ModulePrioritizationDtoBusinessArea)[keyof typeof ModulePrioritizationDtoBusinessArea];

export const ModulePrioritizationDtoBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface ModulePrioritizationDto {
  id: string;
  moduleId?: string;
  businessArea?: ModulePrioritizationDtoBusinessArea;
  rating?: number;
  startingPoint?: string;
  explanation?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ModulePrioritizationResponse {
  kind?: string;
  items?: ModulePrioritizationDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CustomModuleRequestBusinessArea =
  (typeof CustomModuleRequestBusinessArea)[keyof typeof CustomModuleRequestBusinessArea];

export const CustomModuleRequestBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface CustomModuleRequest {
  businessArea?: CustomModuleRequestBusinessArea;
  name?: string;
  description?: string;
}

export type ModuleMetadataDtoBusinessArea =
  (typeof ModuleMetadataDtoBusinessArea)[keyof typeof ModuleMetadataDtoBusinessArea];

export const ModuleMetadataDtoBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export type ModuleMetadataDtoType =
  (typeof ModuleMetadataDtoType)[keyof typeof ModuleMetadataDtoType];

export const ModuleMetadataDtoType = {
  platform: 'platform',
  custom: 'custom'
} as const;

export type ModuleMetadataDtoSource =
  (typeof ModuleMetadataDtoSource)[keyof typeof ModuleMetadataDtoSource];

export const ModuleMetadataDtoSource = {
  platform: 'platform',
  link: 'link'
} as const;

export interface ModuleMetadataDto {
  id: string;
  businessArea?: ModuleMetadataDtoBusinessArea;
  type?: ModuleMetadataDtoType;
  name?: string;
  index?: number;
  description?: string;
  scope?: string;
  category?: string;
  active?: boolean;
  source?: ModuleMetadataDtoSource;
  updatedAt?: string;
}

export interface ModuleMetadataResponse {
  kind?: string;
  items?: ModuleMetadataDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type ModuleIdeaDtoBusinessArea =
  (typeof ModuleIdeaDtoBusinessArea)[keyof typeof ModuleIdeaDtoBusinessArea];

export const ModuleIdeaDtoBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface ModuleIdeaDto {
  id?: string;
  moduleId: string;
  businessArea: ModuleIdeaDtoBusinessArea;
  idea: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ModuleIdeaResponse {
  kind?: string;
  items?: ModuleIdeaDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface UploadFileRequest {
  key?: string;
  fileName?: string;
}

export interface FileUploadDto {
  uploadUrl?: string;
}

export interface FileUploadResponse {
  kind?: string;
  items?: FileUploadDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type BusinessAreaMetadataDtoType =
  (typeof BusinessAreaMetadataDtoType)[keyof typeof BusinessAreaMetadataDtoType];

export const BusinessAreaMetadataDtoType = {
  platform: 'platform',
  custom: 'custom'
} as const;

export interface BusinessAreaMetadataDto {
  id?: string;
  name?: string;
  type?: BusinessAreaMetadataDtoType;
  active?: boolean;
  actionPlanDefaultIndex?: number;
  boardIds?: string[];
  roleIndex?: number;
  createdAt?: string;
}

export interface BusinessAreaMetadataResponse {
  kind?: string;
  items?: BusinessAreaMetadataDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type WorkflowCreateRequestStatus =
  (typeof WorkflowCreateRequestStatus)[keyof typeof WorkflowCreateRequestStatus];

export const WorkflowCreateRequestStatus = {
  enabled: 'enabled',
  disabled: 'disabled'
} as const;

export interface WorkflowCreateRequest {
  title?: string;
  context?: WorkflowContextDto;
  notifications?: WorkflowNotificationsDto;
  trigger?: WorkflowTriggerDto;
  flow?: WorkflowFlowDto;
  createdFrom?: string;
  status?: WorkflowCreateRequestStatus;
}

export interface WorkflowResponse {
  kind?: string;
  items?: WorkflowDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface WorkflowTriggerEventDto {
  title?: string;
  context?: WorkflowContextDto;
  notifications?: WorkflowNotificationsDto;
  userId?: string;
  accountId?: number;
  flow?: WorkflowFlowDto;
}

export interface WorkflowTestResultDto {
  thread?: WorkflowTestResultThreadDto;
}

export interface WorkflowTestResultThreadDto {
  title?: string;
  id?: string;
}

export interface TaskResponse {
  kind?: string;
  items?: TaskDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface StrategicPlanResponse {
  kind?: string;
  items?: StrategicPlanDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type SharedMeetingDtoScope =
  (typeof SharedMeetingDtoScope)[keyof typeof SharedMeetingDtoScope];

export const SharedMeetingDtoScope = {
  public: 'public',
  restricted: 'restricted'
} as const;

export interface SharedMeetingDto {
  id?: string;
  scope?: SharedMeetingDtoScope;
  meetingId?: string;
  calendarEventId?: string;
  userIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface SharedMeetingResponse {
  kind?: string;
  items?: SharedMeetingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type QuickActionDtoType = (typeof QuickActionDtoType)[keyof typeof QuickActionDtoType];

export const QuickActionDtoType = {
  emailReply: 'emailReply',
  meetingSummarySync: 'meetingSummarySync',
  taskFollowUp: 'taskFollowUp',
  meetingFollowUp: 'meetingFollowUp'
} as const;

export type QuickActionDtoStatus = (typeof QuickActionDtoStatus)[keyof typeof QuickActionDtoStatus];

export const QuickActionDtoStatus = {
  pending: 'pending',
  done: 'done',
  dismissed: 'dismissed'
} as const;

export interface QuickActionDto {
  id?: string;
  type?: QuickActionDtoType;
  status?: QuickActionDtoStatus;
  sourceId?: string;
  snoozeUntil?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface QuickActionResponse {
  kind?: string;
  items?: QuickActionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type MeetingTemplateDtoProvider =
  (typeof MeetingTemplateDtoProvider)[keyof typeof MeetingTemplateDtoProvider];

export const MeetingTemplateDtoProvider = {
  hubspot: 'hubspot'
} as const;

export interface MeetingTemplateDto {
  id?: string;
  name?: string;
  context?: string;
  tags?: string[];
  sections?: MeetingTemplateSection[];
  provider?: MeetingTemplateDtoProvider;
  createdAt?: string;
  updatedAt?: string;
}

export type MeetingTemplateSectionType =
  (typeof MeetingTemplateSectionType)[keyof typeof MeetingTemplateSectionType];

export const MeetingTemplateSectionType = {
  tasks: 'tasks'
} as const;

export interface MeetingTemplateSection {
  index?: number;
  type?: MeetingTemplateSectionType;
  title?: string;
  prompt?: string;
}

export interface MeetingTemplateResponse {
  kind?: string;
  items?: MeetingTemplateDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface GoalResponse {
  kind?: string;
  items?: GoalDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type DelegateRequestDtoSourceType =
  (typeof DelegateRequestDtoSourceType)[keyof typeof DelegateRequestDtoSourceType];

export const DelegateRequestDtoSourceType = {
  meeting: 'meeting',
  email: 'email'
} as const;

export interface DelegateRequestDto {
  title?: string;
  context?: string;
  sourceType?: DelegateRequestDtoSourceType;
  sourceId?: string;
  bucketName?: string;
  fileKey?: string;
}

export interface DelegateMessageDto {
  message?: string;
}

export interface DelegateMessageResponse {
  kind?: string;
  items?: DelegateMessageDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface DelegateFollowUpRequestDto {
  taskTitle?: string;
  assigneeName?: string;
  delegationContext?: string;
}

export interface DelegateFollowUpMessageDto {
  message?: string;
}

export interface DelegateFollowUpResponse {
  kind?: string;
  items?: DelegateFollowUpMessageDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ChecklistResponse {
  kind?: string;
  items?: ChecklistDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface CreateUserRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  roleId?: string;
  sendInviteEmail?: boolean;
}

export type AccountUserDtoType = (typeof AccountUserDtoType)[keyof typeof AccountUserDtoType];

export const AccountUserDtoType = {
  user: 'user',
  assigneeUser: 'assigneeUser',
  ceo: 'ceo',
  jp: 'jp',
  admin: 'admin',
  superAdmin: 'superAdmin',
  internal: 'internal'
} as const;

export type AccountUserDtoStatus = (typeof AccountUserDtoStatus)[keyof typeof AccountUserDtoStatus];

export const AccountUserDtoStatus = {
  active: 'active',
  pending: 'pending',
  notInvited: 'notInvited'
} as const;

export interface AccountUserDto {
  id: string;
  type?: AccountUserDtoType;
  firstName?: string;
  lastName?: string;
  roleId?: string;
  title?: string;
  email?: string;
  status?: AccountUserDtoStatus;
  photoUrl?: string;
  userAliases?: string[];
}

export interface AccountUserResponse {
  kind?: string;
  items?: AccountUserDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface TeamDto {
  id: string;
  name?: string;
  description?: string;
  userIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface TeamResponse {
  kind?: string;
  items?: TeamDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ContactUsRequest {
  message?: string;
}

export interface RoleResponse {
  kind?: string;
  items?: RoleDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface DataPoint {
  value?: number;
  timestamp?: string;
}

export type MetricDtoUnit = (typeof MetricDtoUnit)[keyof typeof MetricDtoUnit];

export const MetricDtoUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export type MetricDtoPeriod = (typeof MetricDtoPeriod)[keyof typeof MetricDtoPeriod];

export const MetricDtoPeriod = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
  annually: 'annually'
} as const;

export interface MetricDto {
  id: string;
  name?: string;
  unit?: MetricDtoUnit;
  startingMonthOfYear?: number;
  period?: MetricDtoPeriod;
  dataPoints?: DataPoint[];
  targets?: DataPoint[];
  index?: number;
  adminOnly?: boolean;
  updatedAt?: string;
  createdAt?: string;
}

export interface MetricResponse {
  kind?: string;
  items?: MetricDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface RegisterResponse {
  accountId?: number;
  registrationLink?: string;
  zoomMeetingUrl?: string;
}

export interface RegistrationResponse {
  kind?: string;
  items?: RegisterResponse[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MetricDefinitionResponse {
  kind?: string;
  items?: MetricDefinitionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SearchMetricsRequest {
  ids?: string[];
}

export interface BulkMetricDataPointsRequest {
  dataPoints?: MetricDataPointDto[];
}

export type LiveMeetingDetailsDtoProvider =
  (typeof LiveMeetingDetailsDtoProvider)[keyof typeof LiveMeetingDetailsDtoProvider];

export const LiveMeetingDetailsDtoProvider = {
  zoom: 'zoom',
  twilio: 'twilio'
} as const;

export interface LiveMeetingDetailsDto {
  meetingId: string;
  startTime?: string;
  zoom?: Zoom;
  provider?: LiveMeetingDetailsDtoProvider;
}

export interface LiveMeetingResponse {
  kind?: string;
  items?: LiveMeetingDetailsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface Zoom {
  signature?: string;
  meetingId?: string;
  password?: string;
}

export interface SearchRequest {
  content?: string;
}

export interface FollowUps {
  content?: string;
  sentAt?: string;
}

export interface MeetingDetailsDto {
  meeting?: MeetingDto;
  notes?: string;
  topics?: string[];
  insights?: InsightDto[];
}

export interface MeetingDetailsResponse {
  kind?: string;
  items?: MeetingDetailsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type MeetingDtoProvider = (typeof MeetingDtoProvider)[keyof typeof MeetingDtoProvider];

export const MeetingDtoProvider = {
  zoom: 'zoom',
  twilio: 'twilio'
} as const;

export interface MeetingDto {
  id: string;
  number?: number;
  dayOfWeek?: string;
  startTime?: string;
  endTime?: string;
  hasRecording?: boolean;
  insights?: InsightDto[];
  notes?: string;
  followUps?: FollowUps;
  twilioMeetingId?: string;
  provider?: MeetingDtoProvider;
}

export interface ScheduledMeetingDto {
  id: string;
  name?: string;
  participateUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ScheduledMeetingResponse {
  kind?: string;
  items?: ScheduledMeetingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type MeetingFeedbackDtoUserType =
  (typeof MeetingFeedbackDtoUserType)[keyof typeof MeetingFeedbackDtoUserType];

export const MeetingFeedbackDtoUserType = {
  user: 'user',
  assigneeUser: 'assigneeUser',
  ceo: 'ceo',
  jp: 'jp',
  admin: 'admin',
  superAdmin: 'superAdmin',
  internal: 'internal'
} as const;

export interface MeetingFeedbackDto {
  id?: string;
  accountId?: number;
  meetingId?: string;
  userType?: MeetingFeedbackDtoUserType;
  userId?: string;
  rating?: number;
  description?: string;
  createdAt?: string;
}

export interface MeetingFeedbackResponse {
  kind?: string;
  items?: MeetingFeedbackDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface LaunchMeetingBotRequest {
  meetingUrl?: string;
}

export interface SearchMeetingBotsRequest {
  calendarEventIds?: string[];
}

export type MeetingBotDtoStatus = (typeof MeetingBotDtoStatus)[keyof typeof MeetingBotDtoStatus];

export const MeetingBotDtoStatus = {
  scheduled: 'scheduled',
  joining: 'joining',
  cancelled: 'cancelled',
  joined: 'joined',
  failed: 'failed',
  finished: 'finished'
} as const;

export interface MeetingBotDto {
  botId?: string;
  status?: MeetingBotDtoStatus;
  meetingUrl?: string;
  calendarEventId?: string;
  calendarMasterEventId?: string;
  meetingId?: string;
  isManual?: boolean;
  scheduleAt?: string;
  accountId?: number;
  userId?: string;
  createdAt?: string;
}

export interface MeetingBotResponse {
  kind?: string;
  items?: MeetingBotDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ScheduleMeetingBotRequest {
  meetingUrl?: string;
  location?: string;
  calendarEventId?: string;
  calendarMasterEventId?: string;
  isManual?: boolean;
  scheduleAt?: string;
  accountId?: number;
  userId?: string;
}

export interface BulkScheduleMeetingBotRequest {
  requests?: ScheduleMeetingBotRequest[];
}

export interface MeetingAnalysisRequestDto {
  fileKey?: string;
  bucketName?: string;
  calendarId?: string;
  meetingId?: string;
  template?: MeetingAnalysisTemplateDto;
}

export interface MeetingAnalysisTemplateDto {
  templateId?: string;
  context?: string;
}

export type AgentOperationDtoStatus =
  (typeof AgentOperationDtoStatus)[keyof typeof AgentOperationDtoStatus];

export const AgentOperationDtoStatus = {
  pending: 'pending',
  failed: 'failed',
  finished: 'finished'
} as const;

export type AgentOperationDtoSourceType =
  (typeof AgentOperationDtoSourceType)[keyof typeof AgentOperationDtoSourceType];

export const AgentOperationDtoSourceType = {
  meeting: 'meeting'
} as const;

export interface AgentOperationDto {
  id?: string;
  status?: AgentOperationDtoStatus;
  sourceId?: string;
  sourceType?: AgentOperationDtoSourceType;
}

export interface AgentOperationResponse {
  kind?: string;
  items?: AgentOperationDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingAgendaDto {
  id: string;
  meetingId?: string;
  content?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface MeetingAgendaResponse {
  kind?: string;
  items?: MeetingAgendaDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type DataSourceDtoProviderType =
  (typeof DataSourceDtoProviderType)[keyof typeof DataSourceDtoProviderType];

export const DataSourceDtoProviderType = {
  hubspot: 'hubspot',
  quickBooks: 'quickBooks',
  microsoft: 'microsoft',
  google: 'google'
} as const;

export type DataSourceDtoSourceType =
  (typeof DataSourceDtoSourceType)[keyof typeof DataSourceDtoSourceType];

export const DataSourceDtoSourceType = {
  deals: 'deals',
  companies: 'companies',
  contacts: 'contacts',
  tickets: 'tickets',
  bill: 'bill',
  customer: 'customer',
  payment: 'payment',
  invoice: 'invoice',
  googleCalendarEvent: 'googleCalendarEvent',
  microsoftCalendarEvent: 'microsoftCalendarEvent',
  gmail: 'gmail',
  outlook: 'outlook'
} as const;

export interface DataSourceDto {
  id?: string;
  name?: string;
  providerId?: string;
  providerName?: string;
  providerType?: DataSourceDtoProviderType;
  sourceType?: DataSourceDtoSourceType;
  collectInterval?: string;
}

export interface DataSourceResponse {
  kind?: string;
  items?: DataSourceDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type AccountDataProviderRequestProvider =
  | GoogleAccountDataProviderDto
  | HubspotAccountDataProviderDto;

export interface AccountDataProviderRequest {
  provider?: AccountDataProviderRequestProvider;
}

export type BaseAccountDataProviderDtoObjectCredentials = { [key: string]: unknown };

export type BaseAccountDataProviderDtoObjectProviderType =
  (typeof BaseAccountDataProviderDtoObjectProviderType)[keyof typeof BaseAccountDataProviderDtoObjectProviderType];

export const BaseAccountDataProviderDtoObjectProviderType = {
  hubspot: 'hubspot',
  quickBooks: 'quickBooks',
  microsoft: 'microsoft',
  google: 'google'
} as const;

export interface BaseAccountDataProviderDtoObject {
  name?: string;
  userId?: string;
  credentials?: BaseAccountDataProviderDtoObjectCredentials;
  providerType?: BaseAccountDataProviderDtoObjectProviderType;
}

export interface GoogleAccessCredentialsDto {
  accessToken?: string;
  refreshToken?: string;
  tokenType?: string;
  expiresIn?: number;
  scope?: string;
  idToken?: string;
}

export type GoogleAccountDataProviderDtoAllOf = {
  credentials?: GoogleAccessCredentialsDto;
};

export type GoogleAccountDataProviderDto = BaseAccountDataProviderDtoObject &
  GoogleAccountDataProviderDtoAllOf;

export type HubspotAccountDataProviderDtoAllOf = {
  credentials?: HubspotTokenCredentialsDto;
};

export type HubspotAccountDataProviderDto = BaseAccountDataProviderDtoObject &
  HubspotAccountDataProviderDtoAllOf;

export interface HubspotTokenCredentialsDto {
  access_key?: string;
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
}

export interface IntegrationDataProviderResponse {
  kind?: string;
  items?: PartialAccountDataProviderDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type PartialAccountDataProviderDtoProviderType =
  (typeof PartialAccountDataProviderDtoProviderType)[keyof typeof PartialAccountDataProviderDtoProviderType];

export const PartialAccountDataProviderDtoProviderType = {
  hubspot: 'hubspot',
  quickBooks: 'quickBooks',
  microsoft: 'microsoft',
  google: 'google'
} as const;

export interface PartialAccountDataProviderDto {
  id?: string;
  name?: string;
  userId?: string;
  providerType?: PartialAccountDataProviderDtoProviderType;
  createdAt?: string;
}

export interface QuickBooksDataProviderCreateRequest {
  name?: string;
  authCode?: string;
  realmId?: string;
}

export interface MicrosoftDataProviderCreateRequest {
  name?: string;
  code?: string;
  redirectUrl?: string;
}

export interface HubspotDataProviderCreateRequest {
  name?: string;
  code?: string;
}

export interface GoogleDataProviderCreateRequest {
  name?: string;
  authorizationCode?: string;
  redirectUrl?: string;
}

export type UnifiedConnectionDtoProvider =
  (typeof UnifiedConnectionDtoProvider)[keyof typeof UnifiedConnectionDtoProvider];

export const UnifiedConnectionDtoProvider = {
  hubspot: 'hubspot',
  slackbot: 'slackbot',
  googleDrive: 'googleDrive'
} as const;

export interface UnifiedConnectionDto {
  connectionId?: string;
  provider?: UnifiedConnectionDtoProvider;
  createdAt?: string;
  updatedAt?: string;
}

export interface UnifiedConnectionResponse {
  kind?: string;
  items?: UnifiedConnectionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CrmEventDtoType = (typeof CrmEventDtoType)[keyof typeof CrmEventDtoType];

export const CrmEventDtoType = {
  note: 'note',
  task: 'task',
  call: 'call',
  email: 'email',
  meeting: 'meeting',
  marketing_email: 'marketing_email',
  form: 'form',
  page_view: 'page_view'
} as const;

export interface CrmEventDto {
  id?: string;
  call?: PropertyCrmEventCallDto;
  companyIds?: string[];
  contactIds?: string[];
  dealIds?: string[];
  leadIds?: string[];
  email?: PropertyCrmEventEmailDto;
  marketingEmail?: PropertyCrmEventMarketingEmailDto;
  meeting?: PropertyCrmEventMeetingDto;
  note?: PropertyCrmEventNoteDto;
  task?: PropertyCrmEventTaskDto;
  type?: CrmEventDtoType;
  createdBy?: string;
}

export interface PropertyCrmEventCallDto {
  description?: string;
  duration?: number;
  startAt?: string;
}

export interface PropertyCrmEventEmailDto {
  attachmentFileIds?: string[];
  body?: string;
  cc?: string[];
  from?: string;
  subject?: string;
  to?: string[];
}

export interface PropertyCrmEventMarketingEmailDto {
  attachmentFileIds?: string[];
  body?: string;
  cc?: string[];
  from?: string;
  name?: string;
  subject?: string;
  to?: string[];
}

export interface PropertyCrmEventMeetingDto {
  description?: string;
  endAt?: string;
  startAt?: string;
  title?: string;
}

export interface PropertyCrmEventNoteDto {
  description?: string;
  title?: string;
}

export interface PropertyCrmEventTaskDto {
  description?: string;
  dueAt?: string;
  name?: string;
  priority?: string;
  status?: string;
}

export interface CrmEventResponse {
  kind?: string;
  items?: CrmEventDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SavedPostsDto {
  id: string;
  postIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface SavedPostsResponse {
  kind?: string;
  items?: SavedPostsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type AuthorDtoUserType = (typeof AuthorDtoUserType)[keyof typeof AuthorDtoUserType];

export const AuthorDtoUserType = {
  user: 'user',
  assigneeUser: 'assigneeUser',
  ceo: 'ceo',
  jp: 'jp',
  admin: 'admin',
  superAdmin: 'superAdmin',
  internal: 'internal'
} as const;

export interface AuthorDto {
  userId: string;
  userType?: AuthorDtoUserType;
  accountId?: number;
  industry?: string;
}

export interface JourneyAnswer {
  content?: string;
  createdAt?: string;
}

export interface PostDto {
  id: string;
  title?: string;
  content?: string;
  tags?: string[];
  numberOfComments?: number;
  user?: AuthorDto;
  aiAnswer?: string;
  journeyAnswer?: JourneyAnswer;
  createdAt?: string;
  updatedAt?: string;
}

export interface PostResponse {
  kind?: string;
  items?: PostDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface CommentDto {
  id: string;
  postId?: string;
  parentId?: string;
  content?: string;
  user?: AuthorDto;
  createdAt?: string;
  updatedAt?: string;
}

export interface CommentResponse {
  kind?: string;
  items?: CommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SendEmailRequest {
  to?: string[];
  cc?: string[];
  bcc?: string[];
  subject?: string;
  body?: string;
  threadId?: string;
  forward?: boolean;
}

export interface EmailMessageDto {
  id?: string;
  body?: string;
  subject?: string;
  snippet?: string;
  conversation?: string;
  from?: EmailName[];
  to?: EmailName[];
  cc?: EmailName[];
  bcc?: EmailName[];
  date?: number;
}

export interface EmailMessageResponse {
  kind?: string;
  items?: EmailMessageDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface EmailName {
  email?: string;
  name?: string;
}

export interface GenerateEmailMessageRequest {
  prompt?: string;
  replyMessageId?: string;
}

export interface EmailMessageSuggestionDto {
  body?: string;
}

export interface EmailMessageSuggestionResponse {
  kind?: string;
  items?: EmailMessageSuggestionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SignUpRequest {
  email?: string;
  password?: string;
  registrationToken?: string;
}

export interface Mfa {
  userId?: string;
  session?: string;
  challengeName?: string;
}

export interface SignInDetails {
  idToken?: string;
  accessToken?: string;
  refreshToken?: string;
  socketToken?: string;
  type?: string;
  mfa?: Mfa;
}

export interface SignInResponse {
  kind?: string;
  items?: SignInDetails[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SignInRequest {
  email?: string;
  password?: string;
}

export interface SignInRefreshRequest {
  email?: string;
  refreshToken?: string;
}

export interface ResetPasswordRequest {
  confirmationToken?: string;
  confirmationCode?: string;
  newPassword?: string;
}

export interface SignInMfaRequest {
  userId?: string;
  session?: string;
  challengeName?: string;
  code?: string;
}

export interface ForgotPasswordRequest {
  email?: string;
}

export interface ChangePasswordRequest {
  currentPassword?: string;
  newPassword?: string;
}

export interface AccountSignInRequest {
  accountId?: number;
}

export interface AskJourneyRequest {
  question?: string;
}

export interface AskJourneyResponse {
  kind?: string;
  items?: AskJourneyResult[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AskJourneyResult {
  openAiResult?: string;
  answerId: string;
}

export interface AskJourneyAnswerDto {
  id: string;
  question?: string;
  openAiAnswer?: string;
  rating?: number;
  createdAt?: string;
}

export interface ThreadResponse {
  kind?: string;
  items?: ThreadDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ThreadTitleDto {
  title?: string;
}

export interface ThreadTitleResponse {
  kind?: string;
  items?: ThreadTitleDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface StrategicPlanRequestDto {
  goals?: string[];
}

export interface StrategicPlanGenerateResultDto {
  plan?: string;
}

export interface StrategicPlanGenerateResultResponse {
  kind?: string;
  items?: StrategicPlanGenerateResultDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type EmailRespondRequestDtoRespondType =
  (typeof EmailRespondRequestDtoRespondType)[keyof typeof EmailRespondRequestDtoRespondType];

export const EmailRespondRequestDtoRespondType = {
  reply: 'reply',
  forward: 'forward'
} as const;

export interface EmailRespondRequestDto {
  emailContent?: string;
  threadContent?: string;
  respondType?: EmailRespondRequestDtoRespondType;
}

export interface EmailRespondMessageDto {
  message?: string;
}

export interface EmailRespondResponse {
  kind?: string;
  items?: EmailRespondMessageDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface UserAgentInputDto {
  message?: string;
  threadId?: string;
}

export interface ActionPlanObjectiveResponse {
  kind?: string;
  items?: ActionPlanObjectiveDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionItemsDetails {
  total?: number;
  completed?: number;
  inProgress?: number;
  totalDueDateDefined?: number;
  pastDue?: number;
}

export type ActionPlanObjectiveDetailedDtoType =
  (typeof ActionPlanObjectiveDetailedDtoType)[keyof typeof ActionPlanObjectiveDetailedDtoType];

export const ActionPlanObjectiveDetailedDtoType = {
  company: 'company',
  businessArea: 'businessArea'
} as const;

export interface ActionPlanObjectiveDetailedDto {
  id: string;
  type?: ActionPlanObjectiveDetailedDtoType;
  title?: string;
  description?: string;
  boardId?: string;
  businessArea?: string;
  ownerId?: string;
  teamIds?: string[];
  tags?: string[];
  index?: number;
  keyResult?: KeyResult;
  adminOnly?: boolean;
  isArchived?: boolean;
  attachments?: AttachmentDto[];
  createdAt?: string;
  updatedAt?: string;
  initiatives?: ActionPlanInitiativeDto[];
  krProgress?: number;
  currentQProgress?: number;
  keyResultDetails?: KeyResultDetails;
  actionItemsDetails?: ActionItemsDetails;
}

export interface ActionPlanObjectiveDetailedResponse {
  kind?: string;
  items?: ActionPlanObjectiveDetailedDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface KeyResultDetails {
  krProgress?: number;
  currentQBaseline?: number;
  currentQProgress?: number;
  currentValue?: number;
}

export interface ActionPlanObjectiveCommentDto {
  id: string;
  objectiveId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ActionPlanObjectiveCommentResponse {
  kind?: string;
  items?: ActionPlanObjectiveCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SearchCommentsRequest {
  ownerOrAssigneeUserIds?: string[];
  entityIds?: string[];
}

export interface ActionPlanObjectiveDetailedCommentDto {
  id: string;
  objectiveId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
  objectiveTitle?: string;
}

export interface ActionPlanObjectiveDetailedCommentResponse {
  kind?: string;
  items?: ActionPlanObjectiveDetailedCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SearchMetricMetadataRequest {
  metricDefinitionIds?: string[];
}

export type ActionPlanMetricMetadataDtoType =
  (typeof ActionPlanMetricMetadataDtoType)[keyof typeof ActionPlanMetricMetadataDtoType];

export const ActionPlanMetricMetadataDtoType = {
  Initiative: 'Initiative',
  Task: 'Task',
  Objective: 'Objective'
} as const;

export interface ActionPlanMetricMetadataDto {
  type?: ActionPlanMetricMetadataDtoType;
  id?: string;
  title?: string;
  goalDescription?: string;
  ownerId?: string;
  metricDefinitionId?: string;
}

export interface ActionPlanMetricMetadataResponse {
  kind?: string;
  items?: ActionPlanMetricMetadataDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanInitiativeResponse {
  kind?: string;
  items?: ActionPlanInitiativeDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface SearchDetailedInitiativeRequest {
  userIds?: string[];
  objectiveIds?: string[];
  initiativeIds?: string[];
  teamIds?: string[];
}

export type ActionPlanInitiativeDetailedDtoStatus =
  (typeof ActionPlanInitiativeDetailedDtoStatus)[keyof typeof ActionPlanInitiativeDetailedDtoStatus];

export const ActionPlanInitiativeDetailedDtoStatus = {
  onTrack: 'onTrack',
  atRisk: 'atRisk',
  failed: 'failed',
  completed: 'completed',
  deferred: 'deferred'
} as const;

export type ActionPlanInitiativeDetailedDtoTime =
  (typeof ActionPlanInitiativeDetailedDtoTime)[keyof typeof ActionPlanInitiativeDetailedDtoTime];

export const ActionPlanInitiativeDetailedDtoTime = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export type ActionPlanInitiativeDetailedDtoPriority =
  (typeof ActionPlanInitiativeDetailedDtoPriority)[keyof typeof ActionPlanInitiativeDetailedDtoPriority];

export const ActionPlanInitiativeDetailedDtoPriority = {
  L: 'L',
  M: 'M',
  H: 'H'
} as const;

export interface ActionPlanInitiativeDetailedDto {
  id: string;
  objectiveIds?: string[];
  title?: string;
  description?: string;
  status?: ActionPlanInitiativeDetailedDtoStatus;
  owner?: string;
  ownerId?: string;
  teamIds?: string[];
  tags?: string[];
  assigneeId?: string;
  year?: number;
  time?: ActionPlanInitiativeDetailedDtoTime;
  timeframe?: Timeframe;
  goal?: Goal;
  goalProgress?: number;
  priority?: ActionPlanInitiativeDetailedDtoPriority;
  priorityDetails?: PriorityDetails;
  index?: number;
  globalIndex?: number;
  metadata?: Metadata;
  isArchived?: boolean;
  attachments?: AttachmentDto[];
  createdAt?: string;
  updatedAt?: string;
  objective?: ActionPlanObjectiveDto;
}

export interface ActionPlanInitiativeDetailedResponse {
  kind?: string;
  items?: ActionPlanInitiativeDetailedDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanInitiativeCommentDto {
  id: string;
  initiativeId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ActionPlanInitiativeCommentResponse {
  kind?: string;
  items?: ActionPlanInitiativeCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanInitiativeDetailedCommentDto {
  id: string;
  initiativeId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
  initiativeTitle?: string;
}

export interface ActionPlanInitiativeDetailedCommentResponse {
  kind?: string;
  items?: ActionPlanInitiativeDetailedCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanBoardResponse {
  kind?: string;
  items?: ActionPlanBoardDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanActionItemResponse {
  kind?: string;
  items?: ActionPlanActionItemDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanActionItemCommentDto {
  id: string;
  actionItemId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ActionPlanActionItemCommentResponse {
  kind?: string;
  items?: ActionPlanActionItemCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanActionItemDetailedCommentDto {
  id: string;
  actionItemId?: string;
  content?: string;
  userId?: string;
  taggedUserIds?: string[];
  createdAt?: string;
  updatedAt?: string;
  actionItemTitle?: string;
}

export interface ActionPlanActionItemDetailedCommentResponse {
  kind?: string;
  items?: ActionPlanActionItemDetailedCommentDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface BulkPatchRequestSharedWorkspacePointDto {
  items?: SharedWorkspacePointDto[];
}

export interface ActionItems {
  task?: MeetingAnalysisActionItemDto[];
  initiative?: MeetingAnalysisActionItemDto[];
}

export interface MeetingAnalysisActionItemDto {
  assigneeFullName?: string;
  subject?: string;
  description?: string;
  type?: string;
}

export interface MeetingTranscriptionAnalysisDto {
  id?: string;
  meetingId?: string;
  botId?: string;
  analysis?: TranscriptionAnalysisResult;
}

export interface Summary {
  content?: string;
  internalConflicts?: string;
  externalDependencies?: string;
}

export interface TranscriptionAnalysisResult {
  summary?: Summary;
  actionItems?: ActionItems;
  updates?: Update[];
}

export interface Update {
  type?: string;
  fullName?: string;
  description?: string;
}

export interface BulkPatchRequestResourceDto {
  items?: ResourceDto[];
}

export interface BulkPatchRequestNoteDto {
  items?: NoteDto[];
}

export interface PatchModulePlaybookRequest {
  content?: string;
}

export type EmailReplyScope = (typeof EmailReplyScope)[keyof typeof EmailReplyScope];

export const EmailReplyScope = {
  all: 'all',
  internal: 'internal',
  external: 'external'
} as const;

export interface EmailReply {
  enabled?: boolean;
  scope?: EmailReplyScope;
  unRepliedDays?: number;
}

export type MeetingFollowUpScope = (typeof MeetingFollowUpScope)[keyof typeof MeetingFollowUpScope];

export const MeetingFollowUpScope = {
  all: 'all',
  internal: 'internal',
  external: 'external'
} as const;

export interface MeetingFollowUp {
  enabled?: boolean;
  scope?: MeetingFollowUpScope;
  tags?: string[];
}

export interface MeetingSummary {
  enabled?: boolean;
}

export interface TaskFollowUp {
  enabled?: boolean;
  daysAfterDelegation?: number;
}

export interface UserAgentsConfigDto {
  meetingSummary?: MeetingSummary;
  emailReply?: EmailReply;
  meetingFollowUp?: MeetingFollowUp;
  taskFollowUp?: TaskFollowUp;
  createdAt?: string;
  updatedAt?: string;
}

export interface CalendarMeetingDto {
  id: string;
  calendarEventId?: string;
  calendarMasterEventId?: string;
  title?: string;
  botId?: string;
  startTime?: string;
  endTime?: string;
  overview?: CalendarMeetingOverviewDto;
  tasks?: CalendarMeetingTasksDto;
  transcript?: Transcript;
  participants?: Participant[];
  createdAt?: string;
  updatedAt?: string;
}

export interface CalendarMeetingOverviewDto {
  brief?: string;
  topics?: Topic[];
}

export interface CalendarMeetingTasksDto {
  participantsTasks?: ParticipantTasks[];
}

export interface Participant {
  email?: string;
  status?: string;
  name?: string;
  phoneNumber?: string;
  comment?: string;
}

export interface ParticipantTasks {
  name?: string;
  tasks?: string[];
}

export interface Topic {
  startTime?: number;
  endTime?: number;
  title?: string;
}

export interface Transcript {
  bucketName?: string;
  fileKey?: string;
}

export interface MeetingAnalysisDto {
  id: string;
  calendarEventId?: string;
  meetingId?: string;
  meetingTemplateId?: string;
  sections?: Section[];
  createdAt?: string;
  updatedAt?: string;
}

export interface Section {
  index?: number;
  title?: string;
  content?: string;
}

export interface MetricTargetDto {
  year?: number;
  period?: number;
  value?: number;
  progress?: number;
}

export type OkrMetricDtoUnit = (typeof OkrMetricDtoUnit)[keyof typeof OkrMetricDtoUnit];

export const OkrMetricDtoUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export type OkrMetricDtoTargetsPeriod =
  (typeof OkrMetricDtoTargetsPeriod)[keyof typeof OkrMetricDtoTargetsPeriod];

export const OkrMetricDtoTargetsPeriod = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
  semiannually: 'semiannually',
  annually: 'annually'
} as const;

export interface OkrMetricDto {
  id: string;
  name?: string;
  unit?: OkrMetricDtoUnit;
  startingValue?: number;
  value?: number;
  dataPoints?: DataPoint[];
  target?: number;
  targetsPeriod?: OkrMetricDtoTargetsPeriod;
  targets?: MetricTargetDto[];
  progress?: number;
  updatedAt?: string;
  createdAt?: string;
}

export interface BulkPatchRequestMetricDefinitionDto {
  items?: MetricDefinitionDto[];
}

export interface BulkPatchRequestMetricDto {
  items?: MetricDto[];
}

export interface BulkPatchRequestActionPlanObjectiveDto {
  items?: ActionPlanObjectiveDto[];
}

export interface BulkPatchRequestActionPlanInitiativeDto {
  items?: ActionPlanInitiativeDto[];
}

export interface BulkPatchRequestActionPlanActionItemDto {
  items?: ActionPlanActionItemDto[];
}

export interface AccountConfigDto {
  fiscalYearStartMonth?: number;
  shareCeoDataWithJp?: boolean;
}

export type CompanyDetailsGoToMarketModel =
  (typeof CompanyDetailsGoToMarketModel)[keyof typeof CompanyDetailsGoToMarketModel];

export const CompanyDetailsGoToMarketModel = {
  B2B: 'B2B',
  B2C: 'B2C',
  B2B2C: 'B2B2C',
  D2C: 'D2C',
  Marketplace: 'Marketplace',
  P2P: 'P2P',
  B2G: 'B2G',
  Hybrid: 'Hybrid'
} as const;

export interface CompanyDetails {
  description?: string;
  website?: string;
  numberOfEmployees?: number;
  subIndustry?: string;
  employeesRange?: Range;
  annualRevenueRange?: Range;
  location?: string;
  competitors?: string[];
  goToMarketModel?: CompanyDetailsGoToMarketModel;
  salesModel?: string;
}

export interface PatchAccountRequest {
  name?: string;
  logoUrl?: string;
  industry?: string;
  config?: AccountConfigDto;
  companyDetails?: CompanyDetails;
}

export interface Range {
  from?: number;
  to?: number;
}

export interface IdsResponse {
  kind?: string;
  items?: string[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AccountTagsResponse {
  kind?: string;
  items?: AccountTagsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingMediaDto {
  url?: string;
}

export interface MeetingMediaResponse {
  kind?: string;
  items?: MeetingMediaDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingTranscriptionAnalysisResponse {
  kind?: string;
  items?: MeetingTranscriptionAnalysisDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type MeetingAnalysisSuggestionDtoType =
  (typeof MeetingAnalysisSuggestionDtoType)[keyof typeof MeetingAnalysisSuggestionDtoType];

export const MeetingAnalysisSuggestionDtoType = {
  task: 'task',
  initiative: 'initiative'
} as const;

export interface MeetingAnalysisSuggestionDto {
  id?: string;
  meetingId?: string;
  actionItem?: MeetingAnalysisActionItemDto;
  type?: MeetingAnalysisSuggestionDtoType;
}

export interface MeetingAnalysisSuggestionResponse {
  kind?: string;
  items?: MeetingAnalysisSuggestionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CalendarEventRecurrenceFrequency =
  (typeof CalendarEventRecurrenceFrequency)[keyof typeof CalendarEventRecurrenceFrequency];

export const CalendarEventRecurrenceFrequency = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  yearly: 'yearly'
} as const;

export type CalendarEventRecurrenceDaysOfWeekItem =
  (typeof CalendarEventRecurrenceDaysOfWeekItem)[keyof typeof CalendarEventRecurrenceDaysOfWeekItem];

export const CalendarEventRecurrenceDaysOfWeekItem = {
  su: 'su',
  mo: 'mo',
  tu: 'tu',
  we: 'we',
  th: 'th',
  fr: 'fr',
  sa: 'sa'
} as const;

export type CalendarEventRecurrenceStartDayOfWeek =
  (typeof CalendarEventRecurrenceStartDayOfWeek)[keyof typeof CalendarEventRecurrenceStartDayOfWeek];

export const CalendarEventRecurrenceStartDayOfWeek = {
  su: 'su',
  mo: 'mo',
  tu: 'tu',
  we: 'we',
  th: 'th',
  fr: 'fr',
  sa: 'sa'
} as const;

export interface CalendarEventRecurrence {
  startTime?: string;
  endTime?: string;
  frequency?: CalendarEventRecurrenceFrequency;
  interval?: number;
  daysOfWeek?: CalendarEventRecurrenceDaysOfWeekItem[];
  until?: string;
  startDayOfWeek?: CalendarEventRecurrenceStartDayOfWeek;
}

export type CalendarEventWorkspaceSuggestionDtoProvider =
  (typeof CalendarEventWorkspaceSuggestionDtoProvider)[keyof typeof CalendarEventWorkspaceSuggestionDtoProvider];

export const CalendarEventWorkspaceSuggestionDtoProvider = {
  google: 'google',
  microsoft: 'microsoft'
} as const;

export interface CalendarEventWorkspaceSuggestionDto {
  id?: string;
  provider?: CalendarEventWorkspaceSuggestionDtoProvider;
  eventId?: string;
  title?: string;
  recurrence?: CalendarEventRecurrence;
}

export interface CalendarEventWorkspaceSuggestionResponse {
  kind?: string;
  items?: CalendarEventWorkspaceSuggestionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface DriveFileDto {
  id: string;
  link?: string;
  title?: string;
  type?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface DriveFileResponse {
  kind?: string;
  items?: DriveFileDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

/**
 * Entity
 */
export interface BaseModuleData {
  id: string;
}

export interface ModuleDataDto {
  id: string;
  keyQuestions?: string[];
  data?: BaseModuleData;
  updatedAt?: string;
}

export interface ModuleResponse {
  kind?: string;
  items?: ModuleDataDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type LastUsedModuleDtoBusinessArea =
  (typeof LastUsedModuleDtoBusinessArea)[keyof typeof LastUsedModuleDtoBusinessArea];

export const LastUsedModuleDtoBusinessArea = {
  ceo: 'ceo',
  board: 'board',
  strategicPlanning: 'strategicPlanning',
  strategy: 'strategy',
  finance: 'finance',
  people: 'people',
  product: 'product',
  marketing: 'marketing',
  sales: 'sales',
  customerSuccess: 'customerSuccess',
  operations: 'operations',
  market: 'market',
  competition: 'competition',
  partnerships: 'partnerships',
  suppliers: 'suppliers',
  esg: 'esg'
} as const;

export interface LastUsedModuleDto {
  id: string;
  businessArea?: LastUsedModuleDtoBusinessArea;
  lastUsedAt?: string;
}

export interface LastUsedModuleResponse {
  kind?: string;
  items?: LastUsedModuleDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ModuleAnalysisResponse {
  kind?: string;
  items?: ModuleAnalysisDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ModuleDriveFileDto {
  id: string;
  fileUrl?: string;
}

export interface ModuleDriveFileResponse {
  kind?: string;
  items?: ModuleDriveFileDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ModuleRatingDto {
  businessArea?: string;
  module?: string;
  rating?: number;
}

export interface ModuleRatingResponse {
  kind?: string;
  items?: ModuleRatingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface BusinessAreaRatingDto {
  businessArea?: string;
  rating?: number;
}

export interface BusinessAreaRatingResponse {
  kind?: string;
  items?: BusinessAreaRatingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface UserAgentsConfigResponse {
  kind?: string;
  items?: UserAgentsConfigDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CalendarEventDtoVisibility =
  (typeof CalendarEventDtoVisibility)[keyof typeof CalendarEventDtoVisibility];

export const CalendarEventDtoVisibility = {
  default: 'default',
  public: 'public',
  private: 'private'
} as const;

export type CalendarEventDtoMetadata = { [key: string]: string };

export type CalendarEventDtoStatus =
  (typeof CalendarEventDtoStatus)[keyof typeof CalendarEventDtoStatus];

export const CalendarEventDtoStatus = {
  confirmed: 'confirmed',
  tentative: 'tentative',
  cancelled: 'cancelled'
} as const;

export interface CalendarEventDto {
  id?: string;
  grantId?: string;
  when?: When;
  busy?: boolean;
  calendarId?: string;
  hideParticipants?: boolean;
  object?: string;
  participants?: Participant[];
  readOnly?: boolean;
  visibility?: CalendarEventDtoVisibility;
  conferencing?: Conferencing;
  description?: string;
  icalUid?: string;
  location?: string;
  metadata?: CalendarEventDtoMetadata;
  organizer?: EmailName;
  masterEventId?: string;
  recurrence?: string[];
  reminders?: Reminders;
  status?: CalendarEventDtoStatus;
  title?: string;
  creator?: EmailName;
  htmlLink?: string;
  capacity?: number;
  createdAt?: string;
  updatedAt?: string;
}

export type ConferencingProvider = (typeof ConferencingProvider)[keyof typeof ConferencingProvider];

export const ConferencingProvider = {
  Zoom_Meeting: 'Zoom Meeting',
  Google_Meet: 'Google Meet',
  Microsoft_Teams: 'Microsoft Teams',
  Microsoft_Teams_Meeting: 'Microsoft Teams Meeting',
  WebEx: 'WebEx',
  GoToMeeting: 'GoToMeeting',
  skypeForConsumer: 'skypeForConsumer'
} as const;

export interface Conferencing {
  provider?: ConferencingProvider;
  meetingCode?: string;
  password?: string;
  url?: string;
  pin?: string;
  phone?: string[];
}

export type ReminderOverrideReminderMethod =
  (typeof ReminderOverrideReminderMethod)[keyof typeof ReminderOverrideReminderMethod];

export const ReminderOverrideReminderMethod = {
  email: 'email',
  sound: 'sound',
  popup: 'popup',
  display: 'display'
} as const;

export interface ReminderOverride {
  reminderMinutes?: number;
  reminderMethod?: ReminderOverrideReminderMethod;
}

export interface Reminders {
  useDefault?: boolean;
  overrides?: ReminderOverride[];
}

export interface SharedMeetingDataDto {
  meeting?: CalendarMeetingDto;
  event?: CalendarEventDto;
  meetingAnalysis?: MeetingAnalysisDto[];
  transcriptUrl?: string;
  recordingUrl?: string;
}

export interface SharedMeetingDataResponse {
  kind?: string;
  items?: SharedMeetingDataDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface When {
  startTime?: number;
  endTime?: number;
  startTimezone?: string;
  endTimezone?: string;
}

export type CalendarMeetingInfoDtoType =
  (typeof CalendarMeetingInfoDtoType)[keyof typeof CalendarMeetingInfoDtoType];

export const CalendarMeetingInfoDtoType = {
  myMeeting: 'myMeeting',
  publicShared: 'publicShared',
  privateShared: 'privateShared'
} as const;

export interface CalendarMeetingInfoDto {
  id?: string;
  type?: CalendarMeetingInfoDtoType;
  sharedMeetingId?: string;
  title?: string;
  calendarEventId?: string;
  calendarMasterEventId?: string;
  startTime?: string;
  thumbnail?: string;
  participants?: CalendarMeetingInfoParticipant[];
  transcript?: Transcript;
  createdAt?: string;
  updatedAt?: string;
}

export interface CalendarMeetingInfoParticipant {
  userId?: string;
  email?: string;
  name?: string;
}

export interface CalendarMeetingInfoResponse {
  kind?: string;
  items?: CalendarMeetingInfoDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface CalendarMeetingResponse {
  kind?: string;
  items?: CalendarMeetingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface PredefinedMeetingTemplateDto {
  id?: string;
  name?: string;
  description?: string;
  context?: string;
  sections?: TemplateSection[];
  createdAt?: string;
  updatedAt?: string;
}

export interface PredefinedMeetingTemplateResponse {
  kind?: string;
  items?: PredefinedMeetingTemplateDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type TemplateSectionType = (typeof TemplateSectionType)[keyof typeof TemplateSectionType];

export const TemplateSectionType = {
  tasks: 'tasks'
} as const;

export interface TemplateSection {
  index?: number;
  type?: TemplateSectionType;
  title?: string;
  prompt?: string;
  example?: string;
}

export interface MeetingAnalysisResponse {
  kind?: string;
  items?: MeetingAnalysisDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface UserMfaSettingsDto {
  emailEnabled?: boolean;
  smsEnabled?: boolean;
  softTokenEnabled?: boolean;
}

export interface UserMfaSettingsResponse {
  kind?: string;
  items?: UserMfaSettingsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AccountDetails {
  id: number;
  name?: string;
  logoUrl?: string;
  industry?: string;
  ceoName?: string;
  subIndustry?: string;
  employeesRange?: Range;
  location?: string;
  config?: AccountConfigDto;
  companyDetails?: CompanyDetails;
}

export type UserDetailsType = (typeof UserDetailsType)[keyof typeof UserDetailsType];

export const UserDetailsType = {
  user: 'user',
  assigneeUser: 'assigneeUser',
  ceo: 'ceo',
  jp: 'jp',
  admin: 'admin',
  superAdmin: 'superAdmin',
  internal: 'internal'
} as const;

export interface UserDetails {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  type?: UserDetailsType;
  roleId?: string;
  imageUrl?: string;
  accounts?: AccountDetails[];
  currentAccountId?: number;
  features?: UserFeature[];
  meetingSetting?: UserMeetingSettings;
}

export interface UserDetailsResponse {
  kind?: string;
  items?: UserDetails[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type UserFeatureFeature = (typeof UserFeatureFeature)[keyof typeof UserFeatureFeature];

export const UserFeatureFeature = {
  'businessArea:board': 'businessArea:board',
  'businessArea:executive': 'businessArea:executive',
  'businessArea:market': 'businessArea:market',
  'businessArea:competition': 'businessArea:competition',
  'businessArea:strategy': 'businessArea:strategy',
  'businessArea:strategicPlanning': 'businessArea:strategicPlanning',
  'businessArea:sales': 'businessArea:sales',
  'businessArea:marketing': 'businessArea:marketing',
  'businessArea:customerSuccess': 'businessArea:customerSuccess',
  'businessArea:product': 'businessArea:product',
  'businessArea:people': 'businessArea:people',
  'businessArea:finance': 'businessArea:finance',
  'businessArea:operations': 'businessArea:operations',
  'businessArea:esg': 'businessArea:esg',
  workspace: 'workspace',
  'workspace:recentlyWorkedOn': 'workspace:recentlyWorkedOn',
  'workspace:createDriveFile': 'workspace:createDriveFile',
  drive: 'drive',
  meetings: 'meetings',
  actionPlan: 'actionPlan',
  ask: 'ask',
  metrics: 'metrics',
  settings: 'settings'
} as const;

export type UserFeatureAccess = (typeof UserFeatureAccess)[keyof typeof UserFeatureAccess];

export const UserFeatureAccess = {
  block: 'block',
  view: 'view',
  edit: 'edit'
} as const;

export interface UserFeature {
  feature?: UserFeatureFeature;
  access?: UserFeatureAccess;
}

export type MetricSuggestionDtoUnit =
  (typeof MetricSuggestionDtoUnit)[keyof typeof MetricSuggestionDtoUnit];

export const MetricSuggestionDtoUnit = {
  number: 'number',
  percentage: 'percentage',
  currency: 'currency',
  ratio: 'ratio'
} as const;

export interface MetricSuggestionDto {
  name: string;
  unit?: MetricSuggestionDtoUnit;
}

export interface MetricSuggestionResponse {
  kind?: string;
  items?: MetricSuggestionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface OkrMetricResponse {
  kind?: string;
  items?: OkrMetricDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MetricAggregationDataPointDto {
  date?: string;
  value?: number;
}

export interface MetricAggregationDataPointResponse {
  kind?: string;
  items?: MetricAggregationDataPointDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingResponse {
  kind?: string;
  items?: MeetingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingTranscriptDto {
  transcriptUrl?: string;
  disabled?: boolean;
}

export interface MeetingTranscriptResponse {
  kind?: string;
  items?: MeetingTranscriptDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingRecordingDto {
  recordingUrl?: string;
  disabled?: boolean;
}

export interface MeetingRecordingResponse {
  kind?: string;
  items?: MeetingRecordingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface MeetingConnectionDto {
  accessToken?: string;
}

export interface MeetingConnectionResponse {
  kind?: string;
  items?: MeetingConnectionDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ConferenceData {
  conferenceId?: string;
  signature?: string;
  entryPoints?: EntryPoint[];
  conferenceSolution?: ConferenceSolution;
  createRequest?: CreateRequest;
}

export interface ConferenceSolution {
  iconUri?: string;
  key?: string;
  name?: string;
}

export interface CreateRequest {
  requestId?: string;
  status?: string;
}

export interface EntryPoint {
  entryPointType?: string;
  uri?: string;
  label?: string;
  pin?: string;
  accessCode?: string;
  meetingCode?: string;
  passcode?: string;
  password?: string;
  regionCode?: string;
}

export type GoogleCalendarEventDtoExtendedProperties = {
  [key: string]: { [key: string]: unknown };
};

export interface GoogleCalendarEventDto {
  id?: string;
  status?: string;
  summary?: string;
  description?: string;
  start?: string;
  end?: string;
  location?: string;
  organizer?: string;
  attendees?: string[];
  htmlLink?: string;
  kind?: string;
  created?: string;
  updated?: string;
  recurrence?: string[];
  conferenceData?: ConferenceData;
  extendedProperties?: GoogleCalendarEventDtoExtendedProperties;
  icalUID?: string;
}

export interface GoogleCalendarEventResponse {
  kind?: string;
  items?: GoogleCalendarEventDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface CollectorLatestRunDto {
  providerId?: string;
  dataSourceId?: string;
  type?: string;
  updatedAt?: string;
}

export interface CollectorLatestRunResponse {
  kind?: string;
  items?: CollectorLatestRunDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface DataSourceFieldMappingDto {
  name?: string;
  type?: string;
  displayName?: string;
  options?: DataSourceFiledOptionDto[];
}

export interface DataSourceFieldMappingResponse {
  kind?: string;
  items?: DataSourceFieldMappingDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface DataSourceFiledOptionDto {
  value?: string;
  hidden?: boolean;
  displayName?: string;
}

export type DataSourceTypeResponseItemsItem =
  (typeof DataSourceTypeResponseItemsItem)[keyof typeof DataSourceTypeResponseItemsItem];

export const DataSourceTypeResponseItemsItem = {
  deals: 'deals',
  companies: 'companies',
  contacts: 'contacts',
  tickets: 'tickets',
  bill: 'bill',
  customer: 'customer',
  payment: 'payment',
  invoice: 'invoice',
  googleCalendarEvent: 'googleCalendarEvent',
  microsoftCalendarEvent: 'microsoftCalendarEvent',
  gmail: 'gmail',
  outlook: 'outlook'
} as const;

export interface DataSourceTypeResponse {
  kind?: string;
  items?: DataSourceTypeResponseItemsItem[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type CalendarConnectionStatusDtoStatus =
  (typeof CalendarConnectionStatusDtoStatus)[keyof typeof CalendarConnectionStatusDtoStatus];

export const CalendarConnectionStatusDtoStatus = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  NOT_CONNECTED: 'NOT_CONNECTED'
} as const;

export interface CalendarConnectionStatusDto {
  status?: CalendarConnectionStatusDtoStatus;
}

export interface CalendarConnectionStatusResponse {
  kind?: string;
  items?: CalendarConnectionStatusDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type NylasGrantDtoProvider =
  (typeof NylasGrantDtoProvider)[keyof typeof NylasGrantDtoProvider];

export const NylasGrantDtoProvider = {
  microsoft: 'microsoft',
  google: 'google'
} as const;

export interface NylasGrantDto {
  grantId?: string;
  email?: string;
  provider?: NylasGrantDtoProvider;
  accountId?: number;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface NylasGrantResponse {
  kind?: string;
  items?: NylasGrantDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface HubspotContactDto {
  id?: string;
  name?: string;
  emails?: HubspotContactEmailDto[];
}

export interface HubspotContactEmailDto {
  email?: string;
  type?: string;
}

export interface HubspotContactResponse {
  kind?: string;
  items?: HubspotContactDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface HubspotCompanyDto {
  id?: string;
  name?: string;
}

export interface HubspotCompanyResponse {
  kind?: string;
  items?: HubspotCompanyDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type GoogleDriveFileDtoType =
  (typeof GoogleDriveFileDtoType)[keyof typeof GoogleDriveFileDtoType];

export const GoogleDriveFileDtoType = {
  folder: 'folder',
  file: 'file'
} as const;

export interface GoogleDriveFileDto {
  id?: string;
  name?: string;
  data?: string;
  downloadUrl?: string;
  size?: number;
  type?: GoogleDriveFileDtoType;
  createdAt?: string;
  updatedAt?: string;
}

export interface GoogleDrivePagedResponse {
  kind?: string;
  items?: PagedResponseDtoGoogleDriveFileDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface PagedResponseDtoGoogleDriveFileDto {
  items?: GoogleDriveFileDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  kind?: string;
}

export interface CalendarEventResponse {
  kind?: string;
  items?: CalendarEventDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface EmailParticipant {
  email?: string;
  name?: string;
}

export interface EmailThreadDto {
  messageIds?: string[];
  subject?: string;
  snippet?: string;
  participants?: EmailParticipant[];
}

export interface EmailThreadResponse {
  kind?: string;
  items?: EmailThreadDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ContactDto {
  id?: string;
  displayName?: string;
  emails?: ContactEmail[];
  jobTitle?: string;
  managerName?: string;
  middleName?: string;
  nickname?: string;
  suffix?: string;
  givenName?: string;
  surname?: string;
}

export interface ContactEmail {
  email?: string;
  type?: string;
}

export interface ContactResponse {
  kind?: string;
  items?: ContactDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AskJourneyAnswerResponse {
  kind?: string;
  items?: AskJourneyAnswerDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type AppNotificationDtoNamespace =
  (typeof AppNotificationDtoNamespace)[keyof typeof AppNotificationDtoNamespace];

export const AppNotificationDtoNamespace = {
  general: 'general',
  actionPlan: 'actionPlan',
  meetings: 'meetings',
  connect: 'connect'
} as const;

export type AppNotificationDtoStatus =
  (typeof AppNotificationDtoStatus)[keyof typeof AppNotificationDtoStatus];

export const AppNotificationDtoStatus = {
  read: 'read',
  unread: 'unread'
} as const;

export interface AppNotificationDto {
  id?: string;
  namespace?: AppNotificationDtoNamespace;
  status?: AppNotificationDtoStatus;
  title?: string;
  description?: string;
  link?: string;
  userId?: string;
  createdAt?: string;
}

export interface AppNotificationResponse {
  kind?: string;
  items?: AppNotificationDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface AgentChatHistoryDto {
  messages?: ChatMessageDto[];
}

export interface AgentChatHistoryResponse {
  kind?: string;
  items?: AgentChatHistoryDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type ChatMessageDtoType = (typeof ChatMessageDtoType)[keyof typeof ChatMessageDtoType];

export const ChatMessageDtoType = {
  human: 'human',
  ai: 'ai'
} as const;

export interface ChatMessageDto {
  message?: string;
  type?: ChatMessageDtoType;
}

export interface ActionPlanSuggestionResponse {
  kind?: string;
  items?: ActionPlanSuggestionsDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export interface ActionPlanSuggestionsDto {
  suggestions?: string[];
}

export interface LastUpdatedInitiativeDto {
  id: string;
  title?: string;
  description?: string;
  lastUpdatedAt?: string;
}

export interface LastUpdatedInitiativeResponse {
  kind?: string;
  items?: LastUpdatedInitiativeDto[];
  count?: number;
  pagination?: Pagination;
  errors?: Error[];
}

export type GenerateDownloadUrlParams = {
  key: string;
};

export type UpdateUserPhotoBody = {
  photo: Blob;
};

export type DeleteActionPlanObjectiveParams = {
  deleteMetric?: boolean;
};

export type DuplicateActionPlanObjectiveParams = {
  boardId?: string;
  businessArea?: string;
};

export type DeleteActionPlanInitiativeParams = {
  deleteMetric?: boolean;
};

export type DuplicateActionPlanInitiativeParams = {
  objectiveId?: string;
};

export type UpdateAccountLogoBody = {
  logo: Blob;
};

export type ListWhiteboardsParams = {
  linkedType?: string;
  linkedId?: string;
};

export type SearchSharedWorkspacePointsParams = {
  type?: string;
  includeResolved?: boolean;
};

export type ListAllSpaceMeetingNotesParams = {
  spaceId: string;
};

export type ListGoogleDriveFilesParams = {
  folderName?: string;
};

export type UploadGoogleDriveFileParams = {
  folderName?: string;
};

export type UploadGoogleDriveFileBody = {
  file: Blob;
};

export type ListNotesParams = {
  from?: number;
  to?: number;
};

export type ListModulesPrioritizationParams = {
  businessArea: string;
};

export type GetModulesMetadataParams = {
  businessArea?: string;
  moduleIds?: string;
};

export type ListModuleIdeasParams = {
  moduleId?: string;
  businessArea?: string;
};

export type GenerateUploadUrlParams = {
  key: string;
};

export type DeleteFileParams = {
  key: string;
};

export type ListTasksParams = {
  status?: string;
  sourceId?: string;
  from?: number;
  to?: number;
};

export type ListStrategicPlansParams = {
  year?: string;
  timeFrame?: ListStrategicPlansTimeFrame;
};

export type ListStrategicPlansTimeFrame =
  (typeof ListStrategicPlansTimeFrame)[keyof typeof ListStrategicPlansTimeFrame];

export const ListStrategicPlansTimeFrame = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const;

export type GetSharedMeetingParams = {
  meetingId?: string;
  calendarEventId?: string;
};

export type ListGoalsParams = {
  from?: number;
  to?: number;
};

export type GenerateDelegateMessageParams = {
  delegateType: string;
};

export type ListUsersParams = {
  includeStatus?: boolean;
};

export type CreateUserParams = {
  assigneeUser?: boolean;
};

export type UploadMetricValuesBody = {
  file: Blob;
};

export type UploadMetricTargetsBody = {
  file: Blob;
};

export type ListMetricDefinitionsParams = {
  nonActionPlan?: boolean;
  includeArchived?: boolean;
};

export type ListDataProvidersParams = {
  isOwnedByUser?: boolean;
};

export type ListConnectionsParams = {
  provider?: string;
};

export type ListPostsParams = {
  limit?: number;
};

export type ListCommentsParams = {
  postId: string;
};

export type ForgotPasswordParams = {
  sender?: string;
};

export type ListAgentThreadsParams = {
  sourceId?: string;
};

export type ListActionPlanObjectivesParams = {
  businessArea?: string;
  type?: string;
  includeArchived?: boolean;
};

export type SearchActionPlanObjectivesParams = {
  includeArchived?: boolean;
};

export type SearchActionPlanDetailedObjectivesParams = {
  includeArchived: boolean;
};

export type ListActionPlanInitiativesParams = {
  objectiveId?: string;
  includeArchived?: boolean;
  objectiveIds?: string;
};

export type SearchActionPlanInitiativesParams = {
  includeArchived?: boolean;
};

export type SearchActionPlanInitiativeDetailedParams = {
  includeArchived?: boolean;
};

export type ListActionPlanBoardsParams = {
  includeArchived?: boolean;
};

export type ListActionPlanActionItemsParams = {
  initiativeId?: string;
  sprint?: string;
  from?: number;
  to?: number;
  includeArchived?: boolean;
  userIds?: string;
  initiativeIds?: string;
  teamIds?: string;
  sourceSpaceId?: string;
};

export type SearchActionPlanActionItemsParams = {
  includeArchived?: boolean;
};

export type ListWhiteboardsIdsParams = {
  linkedType?: string;
  linkedId?: string;
};

export type ListSharedWorkspacePointsParams = {
  status?: string;
};

export type GetSharedWorkspaceMeetingMediaParams = {
  mediaType: string;
};

export type ListModulesAnalysisParams = {
  businessArea: string;
};

export type ListSharedMeetingsInfoParams = {
  from: number;
  to: number;
};

export type GetNextQuickActionsParams = {
  count: number;
};

export type ListCalendarMeetingsParams = {
  from?: number;
  to?: number;
  calendarEventId?: string;
};

export type ListMeetingsInfoParams = {
  from: number;
  to: number;
};

export type AggregateMetricDataPointsParams = {
  period: string;
  summarize?: string;
};

export type GetMeetingConnectionParams = {
  id?: string;
};

export type GetMeetingMediaParams = {
  type: string;
};

export type FetchGoogleCalendarEventsParams = {
  recurringMetadata: boolean;
};

export type FetchUpcomingGoogleCalendarEventParams = {
  userId?: string;
};

export type ListDataSourceFieldMappingsParams = {
  providerType?: string;
};

export type ListDataSourceTypesParams = {
  providerType?: string;
};

export type GetDataProviderLatestRunsParams = {
  type: string;
};

export type ListHubspotContactsParams = {
  offset?: number;
  limit?: number;
  query?: string;
};

export type ListHubspotCompaniesParams = {
  offset?: number;
  limit?: number;
  query?: string;
};

export type ListPagedGoogleDriveFilesParams = {
  parentId?: string;
  search?: string;
  page?: number;
  size?: number;
};

export type ListEventsParams = {
  from?: number;
  to?: number;
};

export type GetEventMeetingMediaParams = {
  type: string;
};

export type VerifySignUpParams = {
  token: string;
};

export type ListAppNotificationsParams = {
  unreadOnly?: boolean;
};

export type ListAgentOperationsParams = {
  sourceId?: string;
};

export type GetActionPlanDetailedObjectiveParams = {
  includeArchived?: boolean;
};

export type ListActionPlanDetailedObjectivesParams = {
  businessArea?: string;
  type?: string;
  boardId?: string;
  includeArchived?: boolean;
  ownerIds?: string;
  objectiveIds?: string;
};

export type GetInitiativeSuggestionParams = {
  objectiveId: string;
};

export type GetActionItemsSuggestionParams = {
  initiativeId: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get shared workspace
 */
export const getSharedWorkspace = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceResponse>(
    { url: `/workspace/sharedWorkspace/${id}`, method: 'GET', signal },
    options
  );

export const getGetSharedWorkspaceQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/${id}`] as const;

export const getGetSharedWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspace>>,
  TError = SharedWorkspaceResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspace>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedWorkspaceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWorkspace>>> = ({ signal }) =>
    getSharedWorkspace(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspace>>
>;
export type GetSharedWorkspaceQueryError = SharedWorkspaceResponse;

export function useGetSharedWorkspace<
  TData = Awaited<ReturnType<typeof getSharedWorkspace>>,
  TError = SharedWorkspaceResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspace>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspace>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspace<
  TData = Awaited<ReturnType<typeof getSharedWorkspace>>,
  TError = SharedWorkspaceResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspace>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspace>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspace<
  TData = Awaited<ReturnType<typeof getSharedWorkspace>>,
  TError = SharedWorkspaceResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspace>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get shared workspace
 */

export function useGetSharedWorkspace<
  TData = Awaited<ReturnType<typeof getSharedWorkspace>>,
  TError = SharedWorkspaceResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspace>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update shared workspace
 */
export const updateSharedWorkspace = (
  id: string,
  sharedWorkspaceDto: SharedWorkspaceDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceDto
    },
    options
  );

export const getUpdateSharedWorkspaceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSharedWorkspace>>,
    TError,
    { id: string; data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSharedWorkspace>>,
  TError,
  { id: string; data: SharedWorkspaceDto },
  TContext
> => {
  const mutationKey = ['updateSharedWorkspace'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSharedWorkspace>>,
    { id: string; data: SharedWorkspaceDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateSharedWorkspace(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSharedWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSharedWorkspace>>
>;
export type UpdateSharedWorkspaceMutationBody = SharedWorkspaceDto;
export type UpdateSharedWorkspaceMutationError = unknown;

/**
 * @summary Update shared workspace
 */
export const useUpdateSharedWorkspace = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSharedWorkspace>>,
    TError,
    { id: string; data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSharedWorkspace>>,
  TError,
  { id: string; data: SharedWorkspaceDto },
  TContext
> => {
  const mutationOptions = getUpdateSharedWorkspaceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete shared workspace
 */
export const deleteSharedWorkspace = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/workspace/sharedWorkspace/${id}`, method: 'DELETE' }, options);

export const getDeleteSharedWorkspaceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspace>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspace>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspace'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspace>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedWorkspace(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspace>>
>;

export type DeleteSharedWorkspaceMutationError = unknown;

/**
 * @summary Delete shared workspace
 */
export const useDeleteSharedWorkspace = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspace>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspace>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspaceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch shared workspace
 */
export const patchSharedWorkspace = (
  id: string,
  sharedWorkspaceDto: SharedWorkspaceDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceDto
    },
    options
  );

export const getPatchSharedWorkspaceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspace>>,
    TError,
    { id: string; data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspace>>,
  TError,
  { id: string; data: SharedWorkspaceDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspace'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspace>>,
    { id: string; data: SharedWorkspaceDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSharedWorkspace(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspace>>
>;
export type PatchSharedWorkspaceMutationBody = SharedWorkspaceDto;
export type PatchSharedWorkspaceMutationError = unknown;

/**
 * @summary Patch shared workspace
 */
export const usePatchSharedWorkspace = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspace>>,
    TError,
    { id: string; data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspace>>,
  TError,
  { id: string; data: SharedWorkspaceDto },
  TContext
> => {
  const mutationOptions = getPatchSharedWorkspaceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary End a shared workspace meeting
 */
export const endSharedWorkspaceMeeting = (
  id: string,
  meetingId: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/${id}/meeting/${meetingId}/end`, method: 'PUT' },
    options
  );

export const getEndSharedWorkspaceMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string },
  TContext
> => {
  const mutationKey = ['endSharedWorkspaceMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>,
    { id: string; meetingId: string }
  > = props => {
    const { id, meetingId } = props ?? {};

    return endSharedWorkspaceMeeting(id, meetingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndSharedWorkspaceMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>
>;

export type EndSharedWorkspaceMeetingMutationError = unknown;

/**
 * @summary End a shared workspace meeting
 */
export const useEndSharedWorkspaceMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof endSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string },
  TContext
> => {
  const mutationOptions = getEndSharedWorkspaceMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update shared workspace point
 */
export const updateSharedWorkspacePoint = (
  id: string,
  sharedWorkspacePointDto: SharedWorkspacePointDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/point/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspacePointDto
    },
    options
  );

export const getUpdateSharedWorkspacePointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSharedWorkspacePoint>>,
    TError,
    { id: string; data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSharedWorkspacePoint>>,
  TError,
  { id: string; data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationKey = ['updateSharedWorkspacePoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSharedWorkspacePoint>>,
    { id: string; data: SharedWorkspacePointDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateSharedWorkspacePoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSharedWorkspacePointMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSharedWorkspacePoint>>
>;
export type UpdateSharedWorkspacePointMutationBody = SharedWorkspacePointDto;
export type UpdateSharedWorkspacePointMutationError = unknown;

/**
 * @summary Update shared workspace point
 */
export const useUpdateSharedWorkspacePoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSharedWorkspacePoint>>,
    TError,
    { id: string; data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSharedWorkspacePoint>>,
  TError,
  { id: string; data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationOptions = getUpdateSharedWorkspacePointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete shared workspace point
 */
export const deleteSharedWorkspacePoint = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/point/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteSharedWorkspacePointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspacePoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedWorkspacePoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspacePointMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>
>;

export type DeleteSharedWorkspacePointMutationError = unknown;

/**
 * @summary Delete shared workspace point
 */
export const useDeleteSharedWorkspacePoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspacePoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspacePointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch shared workspace point
 */
export const patchSharedWorkspacePoint = (
  id: string,
  sharedWorkspacePointDto: SharedWorkspacePointDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/point/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspacePointDto
    },
    options
  );

export const getPatchSharedWorkspacePointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspacePoint>>,
    TError,
    { id: string; data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspacePoint>>,
  TError,
  { id: string; data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspacePoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspacePoint>>,
    { id: string; data: SharedWorkspacePointDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSharedWorkspacePoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspacePointMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspacePoint>>
>;
export type PatchSharedWorkspacePointMutationBody = SharedWorkspacePointDto;
export type PatchSharedWorkspacePointMutationError = unknown;

/**
 * @summary Patch shared workspace point
 */
export const usePatchSharedWorkspacePoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspacePoint>>,
    TError,
    { id: string; data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspacePoint>>,
  TError,
  { id: string; data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationOptions = getPatchSharedWorkspacePointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Module data
 */
export const getModuleData = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleResponse>(
    { url: `/workspace/module/${id}`, method: 'GET', signal },
    options
  );

export const getGetModuleDataQueryKey = (id: string) => [`/workspace/module/${id}`] as const;

export const getGetModuleDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleData>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleData>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleDataQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleData>>> = ({ signal }) =>
    getModuleData(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleDataQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleData>>>;
export type GetModuleDataQueryError = ModuleResponse;

export function useGetModuleData<
  TData = Awaited<ReturnType<typeof getModuleData>>,
  TError = ModuleResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleData>>,
          TError,
          Awaited<ReturnType<typeof getModuleData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleData<
  TData = Awaited<ReturnType<typeof getModuleData>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleData>>,
          TError,
          Awaited<ReturnType<typeof getModuleData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleData<
  TData = Awaited<ReturnType<typeof getModuleData>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleData>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module data
 */

export function useGetModuleData<
  TData = Awaited<ReturnType<typeof getModuleData>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleData>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleDataQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Module data
 */
export const updateModuleData = (
  id: string,
  updateModuleRequest: UpdateModuleRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateModuleRequest
    },
    options
  );

export const getUpdateModuleDataMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleData>>,
    TError,
    { id: string; data: UpdateModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModuleData>>,
  TError,
  { id: string; data: UpdateModuleRequest },
  TContext
> => {
  const mutationKey = ['updateModuleData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleData>>,
    { id: string; data: UpdateModuleRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateModuleData(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModuleDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModuleData>>
>;
export type UpdateModuleDataMutationBody = UpdateModuleRequest;
export type UpdateModuleDataMutationError = unknown;

/**
 * @summary Update Module data
 */
export const useUpdateModuleData = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleData>>,
    TError,
    { id: string; data: UpdateModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModuleData>>,
  TError,
  { id: string; data: UpdateModuleRequest },
  TContext
> => {
  const mutationOptions = getUpdateModuleDataMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Module analysis
 */
export const updateModuleAnalysis = (
  id: string,
  moduleAnalysisDto: ModuleAnalysisDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/${id}/analysis`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: moduleAnalysisDto
    },
    options
  );

export const getUpdateModuleAnalysisMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleAnalysis>>,
    TError,
    { id: string; data: ModuleAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModuleAnalysis>>,
  TError,
  { id: string; data: ModuleAnalysisDto },
  TContext
> => {
  const mutationKey = ['updateModuleAnalysis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleAnalysis>>,
    { id: string; data: ModuleAnalysisDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateModuleAnalysis(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModuleAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModuleAnalysis>>
>;
export type UpdateModuleAnalysisMutationBody = ModuleAnalysisDto;
export type UpdateModuleAnalysisMutationError = unknown;

/**
 * @summary Update Module analysis
 */
export const useUpdateModuleAnalysis = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleAnalysis>>,
    TError,
    { id: string; data: ModuleAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModuleAnalysis>>,
  TError,
  { id: string; data: ModuleAnalysisDto },
  TContext
> => {
  const mutationOptions = getUpdateModuleAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate download file url
 */
export const generateDownloadUrl = (
  name: string,
  params: GenerateDownloadUrlParams,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<FileResponse>(
    { url: `/workspace/file/${name}/download`, method: 'PUT', params },
    options
  );

export const getGenerateDownloadUrlMutationOptions = <
  TError = FileResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDownloadUrl>>,
    TError,
    { name: string; params: GenerateDownloadUrlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDownloadUrl>>,
  TError,
  { name: string; params: GenerateDownloadUrlParams },
  TContext
> => {
  const mutationKey = ['generateDownloadUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDownloadUrl>>,
    { name: string; params: GenerateDownloadUrlParams }
  > = props => {
    const { name, params } = props ?? {};

    return generateDownloadUrl(name, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDownloadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDownloadUrl>>
>;

export type GenerateDownloadUrlMutationError = FileResponse;

/**
 * @summary Generate download file url
 */
export const useGenerateDownloadUrl = <TError = FileResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDownloadUrl>>,
    TError,
    { name: string; params: GenerateDownloadUrlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateDownloadUrl>>,
  TError,
  { name: string; params: GenerateDownloadUrlParams },
  TContext
> => {
  const mutationOptions = getGenerateDownloadUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update business Area rating
 */
export const updateBusinessAreaRating = (
  businessArea: string,
  updateRatingRequest: UpdateRatingRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/businessArea/${businessArea}/rating`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateRatingRequest
    },
    options
  );

export const getUpdateBusinessAreaRatingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusinessAreaRating>>,
    TError,
    { businessArea: string; data: UpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBusinessAreaRating>>,
  TError,
  { businessArea: string; data: UpdateRatingRequest },
  TContext
> => {
  const mutationKey = ['updateBusinessAreaRating'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBusinessAreaRating>>,
    { businessArea: string; data: UpdateRatingRequest }
  > = props => {
    const { businessArea, data } = props ?? {};

    return updateBusinessAreaRating(businessArea, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBusinessAreaRatingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBusinessAreaRating>>
>;
export type UpdateBusinessAreaRatingMutationBody = UpdateRatingRequest;
export type UpdateBusinessAreaRatingMutationError = unknown;

/**
 * @summary Update business Area rating
 */
export const useUpdateBusinessAreaRating = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusinessAreaRating>>,
    TError,
    { businessArea: string; data: UpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBusinessAreaRating>>,
  TError,
  { businessArea: string; data: UpdateRatingRequest },
  TContext
> => {
  const mutationOptions = getUpdateBusinessAreaRatingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update module rating
 */
export const updateModuleRating = (
  businessArea: string,
  moduleKey: string,
  updateRatingRequest: UpdateRatingRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/businessArea/${businessArea}/module/${moduleKey}/rating`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateRatingRequest
    },
    options
  );

export const getUpdateModuleRatingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleRating>>,
    TError,
    { businessArea: string; moduleKey: string; data: UpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateModuleRating>>,
  TError,
  { businessArea: string; moduleKey: string; data: UpdateRatingRequest },
  TContext
> => {
  const mutationKey = ['updateModuleRating'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleRating>>,
    { businessArea: string; moduleKey: string; data: UpdateRatingRequest }
  > = props => {
    const { businessArea, moduleKey, data } = props ?? {};

    return updateModuleRating(businessArea, moduleKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateModuleRatingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModuleRating>>
>;
export type UpdateModuleRatingMutationBody = UpdateRatingRequest;
export type UpdateModuleRatingMutationError = unknown;

/**
 * @summary Update module rating
 */
export const useUpdateModuleRating = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateModuleRating>>,
    TError,
    { businessArea: string; moduleKey: string; data: UpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateModuleRating>>,
  TError,
  { businessArea: string; moduleKey: string; data: UpdateRatingRequest },
  TContext
> => {
  const mutationOptions = getUpdateModuleRatingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update custom Business Area
 */
export const updateCustomBusinessArea = (
  id: string,
  customBusinessAreaRequest: CustomBusinessAreaRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/businessArea/metadata/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: customBusinessAreaRequest
    },
    options
  );

export const getUpdateCustomBusinessAreaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomBusinessArea>>,
    TError,
    { id: string; data: CustomBusinessAreaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomBusinessArea>>,
  TError,
  { id: string; data: CustomBusinessAreaRequest },
  TContext
> => {
  const mutationKey = ['updateCustomBusinessArea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomBusinessArea>>,
    { id: string; data: CustomBusinessAreaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateCustomBusinessArea(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomBusinessAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomBusinessArea>>
>;
export type UpdateCustomBusinessAreaMutationBody = CustomBusinessAreaRequest;
export type UpdateCustomBusinessAreaMutationError = unknown;

/**
 * @summary Update custom Business Area
 */
export const useUpdateCustomBusinessArea = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomBusinessArea>>,
    TError,
    { id: string; data: CustomBusinessAreaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomBusinessArea>>,
  TError,
  { id: string; data: CustomBusinessAreaRequest },
  TContext
> => {
  const mutationOptions = getUpdateCustomBusinessAreaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete custom Business Area
 */
export const deleteCustomBusinessArea = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/businessArea/metadata/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteCustomBusinessAreaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomBusinessArea>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomBusinessArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteCustomBusinessArea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomBusinessArea>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteCustomBusinessArea(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomBusinessAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomBusinessArea>>
>;

export type DeleteCustomBusinessAreaMutationError = unknown;

/**
 * @summary Delete custom Business Area
 */
export const useDeleteCustomBusinessArea = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomBusinessArea>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomBusinessArea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteCustomBusinessAreaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Workflow
 */
export const getWorkflow = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<WorkflowResponse>({ url: `/workflow/${id}`, method: 'GET', signal }, options);

export const getGetWorkflowQueryKey = (id: string) => [`/workflow/${id}`] as const;

export const getGetWorkflowQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkflow>>,
  TError = WorkflowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkflowQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflow>>> = ({ signal }) =>
    getWorkflow(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkflow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkflowQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflow>>>;
export type GetWorkflowQueryError = WorkflowResponse;

export function useGetWorkflow<
  TData = Awaited<ReturnType<typeof getWorkflow>>,
  TError = WorkflowResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkflow<
  TData = Awaited<ReturnType<typeof getWorkflow>>,
  TError = WorkflowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflow>>,
          TError,
          Awaited<ReturnType<typeof getWorkflow>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkflow<
  TData = Awaited<ReturnType<typeof getWorkflow>>,
  TError = WorkflowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workflow
 */

export function useGetWorkflow<
  TData = Awaited<ReturnType<typeof getWorkflow>>,
  TError = WorkflowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWorkflowQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Workflow
 */
export const updateWorkflow = (
  id: string,
  workflowDto: WorkflowDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workflow/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: workflowDto
    },
    options
  );

export const getUpdateWorkflowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkflow>>,
    TError,
    { id: string; data: WorkflowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWorkflow>>,
  TError,
  { id: string; data: WorkflowDto },
  TContext
> => {
  const mutationKey = ['updateWorkflow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWorkflow>>,
    { id: string; data: WorkflowDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateWorkflow(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflow>>>;
export type UpdateWorkflowMutationBody = WorkflowDto;
export type UpdateWorkflowMutationError = unknown;

/**
 * @summary Update Workflow
 */
export const useUpdateWorkflow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWorkflow>>,
    TError,
    { id: string; data: WorkflowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWorkflow>>,
  TError,
  { id: string; data: WorkflowDto },
  TContext
> => {
  const mutationOptions = getUpdateWorkflowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Workflow
 */
export const deleteWorkflow = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workflow/${id}`, method: 'DELETE' }, options);

export const getDeleteWorkflowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkflow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkflow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteWorkflow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkflow>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteWorkflow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflow>>>;

export type DeleteWorkflowMutationError = unknown;

/**
 * @summary Delete Workflow
 */
export const useDeleteWorkflow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkflow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkflow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteWorkflowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Workflow
 */
export const patchWorkflow = (
  id: string,
  workflowDto: WorkflowDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workflow/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: workflowDto
    },
    options
  );

export const getPatchWorkflowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkflow>>,
    TError,
    { id: string; data: WorkflowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchWorkflow>>,
  TError,
  { id: string; data: WorkflowDto },
  TContext
> => {
  const mutationKey = ['patchWorkflow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchWorkflow>>,
    { id: string; data: WorkflowDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchWorkflow(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof patchWorkflow>>>;
export type PatchWorkflowMutationBody = WorkflowDto;
export type PatchWorkflowMutationError = unknown;

/**
 * @summary Patch Workflow
 */
export const usePatchWorkflow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWorkflow>>,
    TError,
    { id: string; data: WorkflowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchWorkflow>>,
  TError,
  { id: string; data: WorkflowDto },
  TContext
> => {
  const mutationOptions = getPatchWorkflowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Task
 */
export const updateTask = (
  id: string,
  taskDto: TaskDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/task/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: taskDto
    },
    options
  );

export const getUpdateTaskMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: TaskDto },
  TContext
> => {
  const mutationKey = ['updateTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { id: string; data: TaskDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>;
export type UpdateTaskMutationBody = TaskDto;
export type UpdateTaskMutationError = unknown;

/**
 * @summary Update Task
 */
export const useUpdateTask = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: TaskDto },
  TContext
> => {
  const mutationOptions = getUpdateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Task
 */
export const deleteTask = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/task/${id}`, method: 'DELETE' }, options);

export const getDeleteTaskMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTask>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>;

export type DeleteTaskMutationError = unknown;

/**
 * @summary Delete Task
 */
export const useDeleteTask = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteTask>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Task
 */
export const patchTask = (
  id: string,
  taskDto: TaskDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/task/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: taskDto
    },
    options
  );

export const getPatchTaskMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTask>>,
    TError,
    { id: string; data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchTask>>,
  TError,
  { id: string; data: TaskDto },
  TContext
> => {
  const mutationKey = ['patchTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchTask>>,
    { id: string; data: TaskDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchTaskMutationResult = NonNullable<Awaited<ReturnType<typeof patchTask>>>;
export type PatchTaskMutationBody = TaskDto;
export type PatchTaskMutationError = unknown;

/**
 * @summary Patch Task
 */
export const usePatchTask = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTask>>,
    TError,
    { id: string; data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchTask>>,
  TError,
  { id: string; data: TaskDto },
  TContext
> => {
  const mutationOptions = getPatchTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add Task to Agenda
 */
export const addTaskToAgenda = (
  id: string,
  addToAgendaRequest: AddToAgendaRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/task/${id}/addToAgenda`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: addToAgendaRequest
    },
    options
  );

export const getAddTaskToAgendaMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskToAgenda>>,
    TError,
    { id: string; data: AddToAgendaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTaskToAgenda>>,
  TError,
  { id: string; data: AddToAgendaRequest },
  TContext
> => {
  const mutationKey = ['addTaskToAgenda'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTaskToAgenda>>,
    { id: string; data: AddToAgendaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return addTaskToAgenda(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTaskToAgendaMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTaskToAgenda>>
>;
export type AddTaskToAgendaMutationBody = AddToAgendaRequest;
export type AddTaskToAgendaMutationError = unknown;

/**
 * @summary Add Task to Agenda
 */
export const useAddTaskToAgenda = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTaskToAgenda>>,
    TError,
    { id: string; data: AddToAgendaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addTaskToAgenda>>,
  TError,
  { id: string; data: AddToAgendaRequest },
  TContext
> => {
  const mutationOptions = getAddTaskToAgendaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Strategic Plan
 */
export const getStrategicPlan = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<StrategicPlanResponse>(
    { url: `/workbench/strategy/plan/${id}`, method: 'GET', signal },
    options
  );

export const getGetStrategicPlanQueryKey = (id: string) =>
  [`/workbench/strategy/plan/${id}`] as const;

export const getGetStrategicPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getStrategicPlan>>,
  TError = StrategicPlanResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStrategicPlan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStrategicPlanQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStrategicPlan>>> = ({ signal }) =>
    getStrategicPlan(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStrategicPlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStrategicPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getStrategicPlan>>>;
export type GetStrategicPlanQueryError = StrategicPlanResponse;

export function useGetStrategicPlan<
  TData = Awaited<ReturnType<typeof getStrategicPlan>>,
  TError = StrategicPlanResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStrategicPlan>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStrategicPlan>>,
          TError,
          Awaited<ReturnType<typeof getStrategicPlan>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStrategicPlan<
  TData = Awaited<ReturnType<typeof getStrategicPlan>>,
  TError = StrategicPlanResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStrategicPlan>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStrategicPlan>>,
          TError,
          Awaited<ReturnType<typeof getStrategicPlan>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStrategicPlan<
  TData = Awaited<ReturnType<typeof getStrategicPlan>>,
  TError = StrategicPlanResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStrategicPlan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Strategic Plan
 */

export function useGetStrategicPlan<
  TData = Awaited<ReturnType<typeof getStrategicPlan>>,
  TError = StrategicPlanResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStrategicPlan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetStrategicPlanQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Strategic Plan
 */
export const updateStrategicPlan = (
  id: string,
  strategicPlanDto: StrategicPlanDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/strategy/plan/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: strategicPlanDto
    },
    options
  );

export const getUpdateStrategicPlanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStrategicPlan>>,
    TError,
    { id: string; data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStrategicPlan>>,
  TError,
  { id: string; data: StrategicPlanDto },
  TContext
> => {
  const mutationKey = ['updateStrategicPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStrategicPlan>>,
    { id: string; data: StrategicPlanDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateStrategicPlan(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStrategicPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStrategicPlan>>
>;
export type UpdateStrategicPlanMutationBody = StrategicPlanDto;
export type UpdateStrategicPlanMutationError = unknown;

/**
 * @summary Update Strategic Plan
 */
export const useUpdateStrategicPlan = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStrategicPlan>>,
    TError,
    { id: string; data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStrategicPlan>>,
  TError,
  { id: string; data: StrategicPlanDto },
  TContext
> => {
  const mutationOptions = getUpdateStrategicPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Strategic Plan
 */
export const deleteStrategicPlan = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/strategy/plan/${id}`, method: 'DELETE' }, options);

export const getDeleteStrategicPlanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStrategicPlan>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStrategicPlan>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteStrategicPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStrategicPlan>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteStrategicPlan(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStrategicPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStrategicPlan>>
>;

export type DeleteStrategicPlanMutationError = unknown;

/**
 * @summary Delete Strategic Plan
 */
export const useDeleteStrategicPlan = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStrategicPlan>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStrategicPlan>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteStrategicPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Strategic Plan
 */
export const patchStrategicPlan = (
  id: string,
  strategicPlanDto: StrategicPlanDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/strategy/plan/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: strategicPlanDto
    },
    options
  );

export const getPatchStrategicPlanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchStrategicPlan>>,
    TError,
    { id: string; data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchStrategicPlan>>,
  TError,
  { id: string; data: StrategicPlanDto },
  TContext
> => {
  const mutationKey = ['patchStrategicPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchStrategicPlan>>,
    { id: string; data: StrategicPlanDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchStrategicPlan(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchStrategicPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchStrategicPlan>>
>;
export type PatchStrategicPlanMutationBody = StrategicPlanDto;
export type PatchStrategicPlanMutationError = unknown;

/**
 * @summary Patch Strategic Plan
 */
export const usePatchStrategicPlan = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchStrategicPlan>>,
    TError,
    { id: string; data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchStrategicPlan>>,
  TError,
  { id: string; data: StrategicPlanDto },
  TContext
> => {
  const mutationOptions = getPatchStrategicPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Snooze Quick Action
 */
export const snoozeQuickAction = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/quickAction/${id}/snooze`, method: 'PUT' }, options);

export const getSnoozeQuickActionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snoozeQuickAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof snoozeQuickAction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['snoozeQuickAction'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof snoozeQuickAction>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return snoozeQuickAction(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SnoozeQuickActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof snoozeQuickAction>>
>;

export type SnoozeQuickActionMutationError = unknown;

/**
 * @summary Snooze Quick Action
 */
export const useSnoozeQuickAction = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snoozeQuickAction>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof snoozeQuickAction>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getSnoozeQuickActionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Goal
 */
export const updateGoal = (
  id: string,
  goalDto: GoalDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/goal/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: goalDto
    },
    options
  );

export const getUpdateGoalMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoal>>,
    TError,
    { id: string; data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoal>>,
  TError,
  { id: string; data: GoalDto },
  TContext
> => {
  const mutationKey = ['updateGoal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoal>>,
    { id: string; data: GoalDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateGoal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoal>>>;
export type UpdateGoalMutationBody = GoalDto;
export type UpdateGoalMutationError = unknown;

/**
 * @summary Update Goal
 */
export const useUpdateGoal = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoal>>,
    TError,
    { id: string; data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGoal>>,
  TError,
  { id: string; data: GoalDto },
  TContext
> => {
  const mutationOptions = getUpdateGoalMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Goal
 */
export const deleteGoal = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/goal/${id}`, method: 'DELETE' }, options);

export const getDeleteGoalMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoal>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteGoal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGoal>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteGoal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGoalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGoal>>>;

export type DeleteGoalMutationError = unknown;

/**
 * @summary Delete Goal
 */
export const useDeleteGoal = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteGoal>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteGoalMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Goal
 */
export const patchGoal = (
  id: string,
  goalDto: GoalDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/goal/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: goalDto
    },
    options
  );

export const getPatchGoalMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchGoal>>,
    TError,
    { id: string; data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchGoal>>,
  TError,
  { id: string; data: GoalDto },
  TContext
> => {
  const mutationKey = ['patchGoal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchGoal>>,
    { id: string; data: GoalDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchGoal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchGoalMutationResult = NonNullable<Awaited<ReturnType<typeof patchGoal>>>;
export type PatchGoalMutationBody = GoalDto;
export type PatchGoalMutationError = unknown;

/**
 * @summary Patch Goal
 */
export const usePatchGoal = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchGoal>>,
    TError,
    { id: string; data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchGoal>>,
  TError,
  { id: string; data: GoalDto },
  TContext
> => {
  const mutationOptions = getPatchGoalMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Checklist
 */
export const updateChecklist = (
  id: string,
  checklistDto: ChecklistDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/checklist/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: checklistDto
    },
    options
  );

export const getUpdateChecklistMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChecklist>>,
    TError,
    { id: string; data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChecklist>>,
  TError,
  { id: string; data: ChecklistDto },
  TContext
> => {
  const mutationKey = ['updateChecklist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChecklist>>,
    { id: string; data: ChecklistDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateChecklist(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChecklistMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChecklist>>
>;
export type UpdateChecklistMutationBody = ChecklistDto;
export type UpdateChecklistMutationError = unknown;

/**
 * @summary Update Checklist
 */
export const useUpdateChecklist = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChecklist>>,
    TError,
    { id: string; data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChecklist>>,
  TError,
  { id: string; data: ChecklistDto },
  TContext
> => {
  const mutationOptions = getUpdateChecklistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Checklist
 */
export const deleteChecklist = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/checklist/${id}`, method: 'DELETE' }, options);

export const getDeleteChecklistMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChecklist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChecklist>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteChecklist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChecklist>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteChecklist(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChecklistMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChecklist>>
>;

export type DeleteChecklistMutationError = unknown;

/**
 * @summary Delete Checklist
 */
export const useDeleteChecklist = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChecklist>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChecklist>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteChecklistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Checklist
 */
export const patchChecklist = (
  id: string,
  checklistDto: ChecklistDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/checklist/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: checklistDto
    },
    options
  );

export const getPatchChecklistMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchChecklist>>,
    TError,
    { id: string; data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchChecklist>>,
  TError,
  { id: string; data: ChecklistDto },
  TContext
> => {
  const mutationKey = ['patchChecklist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchChecklist>>,
    { id: string; data: ChecklistDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchChecklist(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof patchChecklist>>>;
export type PatchChecklistMutationBody = ChecklistDto;
export type PatchChecklistMutationError = unknown;

/**
 * @summary Patch Checklist
 */
export const usePatchChecklist = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchChecklist>>,
    TError,
    { id: string; data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchChecklist>>,
  TError,
  { id: string; data: ChecklistDto },
  TContext
> => {
  const mutationOptions = getPatchChecklistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update user
 */
export const updateUser = (
  id: string,
  updateUserRequest: UpdateUserRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/user/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserRequest
    },
    options
  );

export const getUpdateUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: string; data: UpdateUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: string; data: UpdateUserRequest },
  TContext
> => {
  const mutationKey = ['updateUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { id: string; data: UpdateUserRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>;
export type UpdateUserMutationBody = UpdateUserRequest;
export type UpdateUserMutationError = unknown;

/**
 * @summary Update user
 */
export const useUpdateUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: string; data: UpdateUserRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: string; data: UpdateUserRequest },
  TContext
> => {
  const mutationOptions = getUpdateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete user
 */
export const deleteUser = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/user/${id}`, method: 'DELETE' }, options);

export const getDeleteUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>;

export type DeleteUserMutationError = unknown;

/**
 * @summary Delete user
 */
export const useDeleteUser = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteUser>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send user invite email
 */
export const sendInviteEmail = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/user/${id}/sendInviteEmail`, method: 'PUT' }, options);

export const getSendInviteEmailMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInviteEmail>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInviteEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['sendInviteEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInviteEmail>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return sendInviteEmail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInviteEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInviteEmail>>
>;

export type SendInviteEmailMutationError = unknown;

/**
 * @summary Send user invite email
 */
export const useSendInviteEmail = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInviteEmail>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendInviteEmail>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getSendInviteEmailMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update user photo
 */
export const updateUserPhoto = (
  id: string,
  updateUserPhotoBody: UpdateUserPhotoBody,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/user/${id}/photo`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserPhotoBody
    },
    options
  );

export const getUpdateUserPhotoMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPhoto>>,
    TError,
    { id: string; data: UpdateUserPhotoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserPhoto>>,
  TError,
  { id: string; data: UpdateUserPhotoBody },
  TContext
> => {
  const mutationKey = ['updateUserPhoto'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserPhoto>>,
    { id: string; data: UpdateUserPhotoBody }
  > = props => {
    const { id, data } = props ?? {};

    return updateUserPhoto(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserPhoto>>
>;
export type UpdateUserPhotoMutationBody = UpdateUserPhotoBody;
export type UpdateUserPhotoMutationError = unknown;

/**
 * @summary Update user photo
 */
export const useUpdateUserPhoto = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPhoto>>,
    TError,
    { id: string; data: UpdateUserPhotoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserPhoto>>,
  TError,
  { id: string; data: UpdateUserPhotoBody },
  TContext
> => {
  const mutationOptions = getUpdateUserPhotoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update user mfa
 */
export const updateUserMfa = (
  id: string,
  updateUserMfaRequest: UpdateUserMfaRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/user/${id}/mfa`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserMfaRequest
    },
    options
  );

export const getUpdateUserMfaMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserMfa>>,
    TError,
    { id: string; data: UpdateUserMfaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserMfa>>,
  TError,
  { id: string; data: UpdateUserMfaRequest },
  TContext
> => {
  const mutationKey = ['updateUserMfa'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserMfa>>,
    { id: string; data: UpdateUserMfaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateUserMfa(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMfaMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserMfa>>>;
export type UpdateUserMfaMutationBody = UpdateUserMfaRequest;
export type UpdateUserMfaMutationError = unknown;

/**
 * @summary Update user mfa
 */
export const useUpdateUserMfa = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserMfa>>,
    TError,
    { id: string; data: UpdateUserMfaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserMfa>>,
  TError,
  { id: string; data: UpdateUserMfaRequest },
  TContext
> => {
  const mutationOptions = getUpdateUserMfaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update role
 */
export const updateRole = (
  id: string,
  roleDto: RoleDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/role/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: roleDto
    },
    options
  );

export const getUpdateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRole>>,
    TError,
    { id: string; data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  { id: string; data: RoleDto },
  TContext
> => {
  const mutationKey = ['updateRole'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRole>>,
    { id: string; data: RoleDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateRole(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>;
export type UpdateRoleMutationBody = RoleDto;
export type UpdateRoleMutationError = unknown;

/**
 * @summary Update role
 */
export const useUpdateRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRole>>,
    TError,
    { id: string; data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRole>>,
  TError,
  { id: string; data: RoleDto },
  TContext
> => {
  const mutationOptions = getUpdateRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete role
 */
export const deleteRole = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/role/${id}`, method: 'DELETE' }, options);

export const getDeleteRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRole>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRole>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteRole'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRole>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteRole(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>;

export type DeleteRoleMutationError = unknown;

/**
 * @summary Delete role
 */
export const useDeleteRole = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRole>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteRole>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get metric definition
 */
export const getMetricDefinition = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDefinitionResponse>(
    { url: `/metric/definition/${id}`, method: 'GET', signal },
    options
  );

export const getGetMetricDefinitionQueryKey = (id: string) => [`/metric/definition/${id}`] as const;

export const getGetMetricDefinitionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMetricDefinition>>,
  TError = MetricDefinitionResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMetricDefinition>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMetricDefinitionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricDefinition>>> = ({ signal }) =>
    getMetricDefinition(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMetricDefinition>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMetricDefinitionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMetricDefinition>>
>;
export type GetMetricDefinitionQueryError = MetricDefinitionResponse;

export function useGetMetricDefinition<
  TData = Awaited<ReturnType<typeof getMetricDefinition>>,
  TError = MetricDefinitionResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMetricDefinition>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetricDefinition>>,
          TError,
          Awaited<ReturnType<typeof getMetricDefinition>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMetricDefinition<
  TData = Awaited<ReturnType<typeof getMetricDefinition>>,
  TError = MetricDefinitionResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMetricDefinition>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetricDefinition>>,
          TError,
          Awaited<ReturnType<typeof getMetricDefinition>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMetricDefinition<
  TData = Awaited<ReturnType<typeof getMetricDefinition>>,
  TError = MetricDefinitionResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMetricDefinition>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get metric definition
 */

export function useGetMetricDefinition<
  TData = Awaited<ReturnType<typeof getMetricDefinition>>,
  TError = MetricDefinitionResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMetricDefinition>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMetricDefinitionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update metric definition
 */
export const updateMetricDefinition = (
  id: string,
  metricDefinitionDto: MetricDefinitionDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/definition/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: metricDefinitionDto
    },
    options
  );

export const getUpdateMetricDefinitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMetricDefinition>>,
    TError,
    { id: string; data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMetricDefinition>>,
  TError,
  { id: string; data: MetricDefinitionDto },
  TContext
> => {
  const mutationKey = ['updateMetricDefinition'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMetricDefinition>>,
    { id: string; data: MetricDefinitionDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateMetricDefinition(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMetricDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMetricDefinition>>
>;
export type UpdateMetricDefinitionMutationBody = MetricDefinitionDto;
export type UpdateMetricDefinitionMutationError = unknown;

/**
 * @summary Update metric definition
 */
export const useUpdateMetricDefinition = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMetricDefinition>>,
    TError,
    { id: string; data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMetricDefinition>>,
  TError,
  { id: string; data: MetricDefinitionDto },
  TContext
> => {
  const mutationOptions = getUpdateMetricDefinitionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete metric definition
 */
export const deleteMetricDefinition = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/metric/definition/${id}`, method: 'DELETE' }, options);

export const getDeleteMetricDefinitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetricDefinition>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMetricDefinition>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMetricDefinition'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMetricDefinition>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMetricDefinition(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMetricDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMetricDefinition>>
>;

export type DeleteMetricDefinitionMutationError = unknown;

/**
 * @summary Delete metric definition
 */
export const useDeleteMetricDefinition = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetricDefinition>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMetricDefinition>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMetricDefinitionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch metric definition
 */
export const patchMetricDefinition = (
  id: string,
  metricDefinitionDto: MetricDefinitionDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/definition/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: metricDefinitionDto
    },
    options
  );

export const getPatchMetricDefinitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetricDefinition>>,
    TError,
    { id: string; data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMetricDefinition>>,
  TError,
  { id: string; data: MetricDefinitionDto },
  TContext
> => {
  const mutationKey = ['patchMetricDefinition'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMetricDefinition>>,
    { id: string; data: MetricDefinitionDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMetricDefinition(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMetricDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMetricDefinition>>
>;
export type PatchMetricDefinitionMutationBody = MetricDefinitionDto;
export type PatchMetricDefinitionMutationError = unknown;

/**
 * @summary Patch metric definition
 */
export const usePatchMetricDefinition = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetricDefinition>>,
    TError,
    { id: string; data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMetricDefinition>>,
  TError,
  { id: string; data: MetricDefinitionDto },
  TContext
> => {
  const mutationOptions = getPatchMetricDefinitionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Calc metric definition progress
 */
export const calcMetricDefinitionProgress = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<MetricDefinitionProgressResponse>(
    { url: `/metric/definition/${id}/progress`, method: 'PUT' },
    options
  );

export const getCalcMetricDefinitionProgressMutationOptions = <
  TError = MetricDefinitionProgressResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calcMetricDefinitionProgress>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calcMetricDefinitionProgress>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['calcMetricDefinitionProgress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calcMetricDefinitionProgress>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return calcMetricDefinitionProgress(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalcMetricDefinitionProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof calcMetricDefinitionProgress>>
>;

export type CalcMetricDefinitionProgressMutationError = MetricDefinitionProgressResponse;

/**
 * @summary Calc metric definition progress
 */
export const useCalcMetricDefinitionProgress = <
  TError = MetricDefinitionProgressResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calcMetricDefinitionProgress>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof calcMetricDefinitionProgress>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCalcMetricDefinitionProgressMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Reset metric integration
 */
export const resetMetricDefinitionIntegration = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/metric/definition/${id}/integration/reset`, method: 'PUT' },
    options
  );

export const getResetMetricDefinitionIntegrationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['resetMetricDefinitionIntegration'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return resetMetricDefinitionIntegration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetMetricDefinitionIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>
>;

export type ResetMetricDefinitionIntegrationMutationError = unknown;

/**
 * @summary Reset metric integration
 */
export const useResetMetricDefinitionIntegration = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetMetricDefinitionIntegration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getResetMetricDefinitionIntegrationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List metric definition data points
 */
export const listMetricDataPoints = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDataPointResponse>(
    { url: `/metric/definition/${id}/dataPoint`, method: 'GET', signal },
    options
  );

export const getListMetricDataPointsQueryKey = (id: string) =>
  [`/metric/definition/${id}/dataPoint`] as const;

export const getListMetricDataPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMetricDataPoints>>,
  TError = MetricDataPointResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricDataPointsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetricDataPoints>>> = ({ signal }) =>
    listMetricDataPoints(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMetricDataPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMetricDataPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMetricDataPoints>>
>;
export type ListMetricDataPointsQueryError = MetricDataPointResponse;

export function useListMetricDataPoints<
  TData = Awaited<ReturnType<typeof listMetricDataPoints>>,
  TError = MetricDataPointResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDataPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetricDataPoints>>,
          TError,
          Awaited<ReturnType<typeof listMetricDataPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricDataPoints<
  TData = Awaited<ReturnType<typeof listMetricDataPoints>>,
  TError = MetricDataPointResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDataPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetricDataPoints>>,
          TError,
          Awaited<ReturnType<typeof listMetricDataPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricDataPoints<
  TData = Awaited<ReturnType<typeof listMetricDataPoints>>,
  TError = MetricDataPointResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List metric definition data points
 */

export function useListMetricDataPoints<
  TData = Awaited<ReturnType<typeof listMetricDataPoints>>,
  TError = MetricDataPointResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMetricDataPointsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Calc metric definition data points
 */
export const calcMetricDefinitionDataPoints = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<MetricDataPointResponse>(
    { url: `/metric/definition/${id}/dataPoint`, method: 'PUT' },
    options
  );

export const getCalcMetricDefinitionDataPointsMutationOptions = <
  TError = MetricDataPointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['calcMetricDefinitionDataPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return calcMetricDefinitionDataPoints(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalcMetricDefinitionDataPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>
>;

export type CalcMetricDefinitionDataPointsMutationError = MetricDataPointResponse;

/**
 * @summary Calc metric definition data points
 */
export const useCalcMetricDefinitionDataPoints = <
  TError = MetricDataPointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof calcMetricDefinitionDataPoints>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCalcMetricDefinitionDataPointsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update meeting topics
 */
export const updateMeetingTopics = (
  meetingId: string,
  updateMeetingTopicsRequest: UpdateMeetingTopicsRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/${meetingId}/topic`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeetingTopicsRequest
    },
    options
  );

export const getUpdateMeetingTopicsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingTopics>>,
    TError,
    { meetingId: string; data: UpdateMeetingTopicsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingTopics>>,
  TError,
  { meetingId: string; data: UpdateMeetingTopicsRequest },
  TContext
> => {
  const mutationKey = ['updateMeetingTopics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingTopics>>,
    { meetingId: string; data: UpdateMeetingTopicsRequest }
  > = props => {
    const { meetingId, data } = props ?? {};

    return updateMeetingTopics(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingTopicsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingTopics>>
>;
export type UpdateMeetingTopicsMutationBody = UpdateMeetingTopicsRequest;
export type UpdateMeetingTopicsMutationError = unknown;

/**
 * @summary Update meeting topics
 */
export const useUpdateMeetingTopics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingTopics>>,
    TError,
    { meetingId: string; data: UpdateMeetingTopicsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingTopics>>,
  TError,
  { meetingId: string; data: UpdateMeetingTopicsRequest },
  TContext
> => {
  const mutationOptions = getUpdateMeetingTopicsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send meeting followup
 */
export const sendMeetingFollowUps = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/meeting/${meetingId}/sendFollowUp`, method: 'PUT' }, options);

export const getSendMeetingFollowUpsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMeetingFollowUps>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMeetingFollowUps>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationKey = ['sendMeetingFollowUps'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMeetingFollowUps>>,
    { meetingId: string }
  > = props => {
    const { meetingId } = props ?? {};

    return sendMeetingFollowUps(meetingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMeetingFollowUpsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMeetingFollowUps>>
>;

export type SendMeetingFollowUpsMutationError = unknown;

/**
 * @summary Send meeting followup
 */
export const useSendMeetingFollowUps = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMeetingFollowUps>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMeetingFollowUps>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationOptions = getSendMeetingFollowUpsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update meeting notes
 */
export const updateMeetingNotes = (
  meetingId: string,
  updateMeetingNotesRequest: UpdateMeetingNotesRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/${meetingId}/note`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeetingNotesRequest
    },
    options
  );

export const getUpdateMeetingNotesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingNotes>>,
    TError,
    { meetingId: string; data: UpdateMeetingNotesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingNotes>>,
  TError,
  { meetingId: string; data: UpdateMeetingNotesRequest },
  TContext
> => {
  const mutationKey = ['updateMeetingNotes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingNotes>>,
    { meetingId: string; data: UpdateMeetingNotesRequest }
  > = props => {
    const { meetingId, data } = props ?? {};

    return updateMeetingNotes(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingNotes>>
>;
export type UpdateMeetingNotesMutationBody = UpdateMeetingNotesRequest;
export type UpdateMeetingNotesMutationError = unknown;

/**
 * @summary Update meeting notes
 */
export const useUpdateMeetingNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingNotes>>,
    TError,
    { meetingId: string; data: UpdateMeetingNotesRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingNotes>>,
  TError,
  { meetingId: string; data: UpdateMeetingNotesRequest },
  TContext
> => {
  const mutationOptions = getUpdateMeetingNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update meeting insights
 */
export const updateMeetingInsights = (
  meetingId: string,
  updateMeetingInsightsRequest: UpdateMeetingInsightsRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/${meetingId}/insight`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeetingInsightsRequest
    },
    options
  );

export const getUpdateMeetingInsightsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingInsights>>,
    TError,
    { meetingId: string; data: UpdateMeetingInsightsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingInsights>>,
  TError,
  { meetingId: string; data: UpdateMeetingInsightsRequest },
  TContext
> => {
  const mutationKey = ['updateMeetingInsights'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingInsights>>,
    { meetingId: string; data: UpdateMeetingInsightsRequest }
  > = props => {
    const { meetingId, data } = props ?? {};

    return updateMeetingInsights(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingInsightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingInsights>>
>;
export type UpdateMeetingInsightsMutationBody = UpdateMeetingInsightsRequest;
export type UpdateMeetingInsightsMutationError = unknown;

/**
 * @summary Update meeting insights
 */
export const useUpdateMeetingInsights = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingInsights>>,
    TError,
    { meetingId: string; data: UpdateMeetingInsightsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingInsights>>,
  TError,
  { meetingId: string; data: UpdateMeetingInsightsRequest },
  TContext
> => {
  const mutationOptions = getUpdateMeetingInsightsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update meeting followup
 */
export const updateMeetingFollowUp = (
  meetingId: string,
  updateMeetingFollowUpRequest: UpdateMeetingFollowUpRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/${meetingId}/followup`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMeetingFollowUpRequest
    },
    options
  );

export const getUpdateMeetingFollowUpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingFollowUp>>,
    TError,
    { meetingId: string; data: UpdateMeetingFollowUpRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMeetingFollowUp>>,
  TError,
  { meetingId: string; data: UpdateMeetingFollowUpRequest },
  TContext
> => {
  const mutationKey = ['updateMeetingFollowUp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMeetingFollowUp>>,
    { meetingId: string; data: UpdateMeetingFollowUpRequest }
  > = props => {
    const { meetingId, data } = props ?? {};

    return updateMeetingFollowUp(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeetingFollowUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMeetingFollowUp>>
>;
export type UpdateMeetingFollowUpMutationBody = UpdateMeetingFollowUpRequest;
export type UpdateMeetingFollowUpMutationError = unknown;

/**
 * @summary Update meeting followup
 */
export const useUpdateMeetingFollowUp = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMeetingFollowUp>>,
    TError,
    { meetingId: string; data: UpdateMeetingFollowUpRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMeetingFollowUp>>,
  TError,
  { meetingId: string; data: UpdateMeetingFollowUpRequest },
  TContext
> => {
  const mutationOptions = getUpdateMeetingFollowUpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary End a meeting
 */
export const endMeeting = (meetingId: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/meeting/${meetingId}/end`, method: 'PUT' }, options);

export const getEndMeetingMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endMeeting>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endMeeting>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationKey = ['endMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endMeeting>>,
    { meetingId: string }
  > = props => {
    const { meetingId } = props ?? {};

    return endMeeting(meetingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof endMeeting>>>;

export type EndMeetingMutationError = unknown;

/**
 * @summary End a meeting
 */
export const useEndMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endMeeting>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof endMeeting>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationOptions = getEndMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Cancel meeting bot
 */
export const cancelMeetingBot = (
  cancelBotRequest: CancelBotRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/bot/cancel`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: cancelBotRequest
    },
    options
  );

export const getCancelMeetingBotMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMeetingBot>>,
    TError,
    { data: CancelBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMeetingBot>>,
  TError,
  { data: CancelBotRequest },
  TContext
> => {
  const mutationKey = ['cancelMeetingBot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMeetingBot>>,
    { data: CancelBotRequest }
  > = props => {
    const { data } = props ?? {};

    return cancelMeetingBot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMeetingBotMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMeetingBot>>
>;
export type CancelMeetingBotMutationBody = CancelBotRequest;
export type CancelMeetingBotMutationError = unknown;

/**
 * @summary Cancel meeting bot
 */
export const useCancelMeetingBot = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMeetingBot>>,
    TError,
    { data: CancelBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMeetingBot>>,
  TError,
  { data: CancelBotRequest },
  TContext
> => {
  const mutationOptions = getCancelMeetingBotMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk cancel meeting bots
 */
export const bulkCancelMeetingBot = (
  bulkCancelMeetingBotRequest: BulkCancelMeetingBotRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/bot/cancel/bulk`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: bulkCancelMeetingBotRequest
    },
    options
  );

export const getBulkCancelMeetingBotMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCancelMeetingBot>>,
    TError,
    { data: BulkCancelMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCancelMeetingBot>>,
  TError,
  { data: BulkCancelMeetingBotRequest },
  TContext
> => {
  const mutationKey = ['bulkCancelMeetingBot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCancelMeetingBot>>,
    { data: BulkCancelMeetingBotRequest }
  > = props => {
    const { data } = props ?? {};

    return bulkCancelMeetingBot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCancelMeetingBotMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCancelMeetingBot>>
>;
export type BulkCancelMeetingBotMutationBody = BulkCancelMeetingBotRequest;
export type BulkCancelMeetingBotMutationError = unknown;

/**
 * @summary Bulk cancel meeting bots
 */
export const useBulkCancelMeetingBot = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCancelMeetingBot>>,
    TError,
    { data: BulkCancelMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkCancelMeetingBot>>,
  TError,
  { data: BulkCancelMeetingBotRequest },
  TContext
> => {
  const mutationOptions = getBulkCancelMeetingBotMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Trigger data source collect
 */
export const collectDataSource = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/integration/dataSource/${id}/collect`, method: 'PUT' }, options);

export const getCollectDataSourceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectDataSource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectDataSource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['collectDataSource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectDataSource>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return collectDataSource(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectDataSource>>
>;

export type CollectDataSourceMutationError = unknown;

/**
 * @summary Trigger data source collect
 */
export const useCollectDataSource = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectDataSource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectDataSource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCollectDataSourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Regenerate post answer
 */
export const regenerateAnswer = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/forum/post/${id}/regenerate`, method: 'PUT' }, options);

export const getRegenerateAnswerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAnswer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateAnswer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['regenerateAnswer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateAnswer>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return regenerateAnswer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateAnswer>>
>;

export type RegenerateAnswerMutationError = unknown;

/**
 * @summary Regenerate post answer
 */
export const useRegenerateAnswer = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateAnswer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateAnswer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRegenerateAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Event
 */
export const getEvent = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarEventResponse>(
    { url: `/calendar/event/${id}`, method: 'GET', signal },
    options
  );

export const getGetEventQueryKey = (id: string) => [`/calendar/event/${id}`] as const;

export const getGetEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = CalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) =>
    getEvent(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>;
export type GetEventQueryError = CalendarEventResponse;

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = CalendarEventResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = CalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = CalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Event
 */

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = CalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Event
 */
export const updateEvent = (
  id: string,
  updateCalendarEventRequest: UpdateCalendarEventRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/calendar/event/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCalendarEventRequest
    },
    options
  );

export const getUpdateEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent>>,
    TError,
    { id: string; data: UpdateCalendarEventRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { id: string; data: UpdateCalendarEventRequest },
  TContext
> => {
  const mutationKey = ['updateEvent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEvent>>,
    { id: string; data: UpdateCalendarEventRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateEvent(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvent>>>;
export type UpdateEventMutationBody = UpdateCalendarEventRequest;
export type UpdateEventMutationError = unknown;

/**
 * @summary Update Event
 */
export const useUpdateEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEvent>>,
    TError,
    { id: string; data: UpdateCalendarEventRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEvent>>,
  TError,
  { id: string; data: UpdateCalendarEventRequest },
  TContext
> => {
  const mutationOptions = getUpdateEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update answer rating
 */
export const updateAnswerRating = (
  answerId: string,
  askJourneyUpdateRatingRequest: AskJourneyUpdateRatingRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/ask/answer/${answerId}/rating`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: askJourneyUpdateRatingRequest
    },
    options
  );

export const getUpdateAnswerRatingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnswerRating>>,
    TError,
    { answerId: string; data: AskJourneyUpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAnswerRating>>,
  TError,
  { answerId: string; data: AskJourneyUpdateRatingRequest },
  TContext
> => {
  const mutationKey = ['updateAnswerRating'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAnswerRating>>,
    { answerId: string; data: AskJourneyUpdateRatingRequest }
  > = props => {
    const { answerId, data } = props ?? {};

    return updateAnswerRating(answerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAnswerRatingMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAnswerRating>>
>;
export type UpdateAnswerRatingMutationBody = AskJourneyUpdateRatingRequest;
export type UpdateAnswerRatingMutationError = unknown;

/**
 * @summary Update answer rating
 */
export const useUpdateAnswerRating = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnswerRating>>,
    TError,
    { answerId: string; data: AskJourneyUpdateRatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAnswerRating>>,
  TError,
  { answerId: string; data: AskJourneyUpdateRatingRequest },
  TContext
> => {
  const mutationOptions = getUpdateAnswerRatingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update notification status
 */
export const updateNotificationStatus = (
  id: string,
  updateAppNotificationStatusRequest: UpdateAppNotificationStatusRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/appNotification/${id}/status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAppNotificationStatusRequest
    },
    options
  );

export const getUpdateNotificationStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationStatus>>,
    TError,
    { id: string; data: UpdateAppNotificationStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationStatus>>,
  TError,
  { id: string; data: UpdateAppNotificationStatusRequest },
  TContext
> => {
  const mutationKey = ['updateNotificationStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationStatus>>,
    { id: string; data: UpdateAppNotificationStatusRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateNotificationStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationStatus>>
>;
export type UpdateNotificationStatusMutationBody = UpdateAppNotificationStatusRequest;
export type UpdateNotificationStatusMutationError = unknown;

/**
 * @summary Update notification status
 */
export const useUpdateNotificationStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationStatus>>,
    TError,
    { id: string; data: UpdateAppNotificationStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationStatus>>,
  TError,
  { id: string; data: UpdateAppNotificationStatusRequest },
  TContext
> => {
  const mutationOptions = getUpdateNotificationStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk update notifications status
 */
export const bulkUpdateNotificationsStatus = (
  updateAppNotificationStatusRequest: UpdateAppNotificationStatusRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/appNotification/status/bulk`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAppNotificationStatusRequest
    },
    options
  );

export const getBulkUpdateNotificationsStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>,
    TError,
    { data: UpdateAppNotificationStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>,
  TError,
  { data: UpdateAppNotificationStatusRequest },
  TContext
> => {
  const mutationKey = ['bulkUpdateNotificationsStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>,
    { data: UpdateAppNotificationStatusRequest }
  > = props => {
    const { data } = props ?? {};

    return bulkUpdateNotificationsStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateNotificationsStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>
>;
export type BulkUpdateNotificationsStatusMutationBody = UpdateAppNotificationStatusRequest;
export type BulkUpdateNotificationsStatusMutationError = unknown;

/**
 * @summary Bulk update notifications status
 */
export const useBulkUpdateNotificationsStatus = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>,
    TError,
    { data: UpdateAppNotificationStatusRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateNotificationsStatus>>,
  TError,
  { data: UpdateAppNotificationStatusRequest },
  TContext
> => {
  const mutationOptions = getBulkUpdateNotificationsStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update Thread
 */
export const updateChecklist1 = (
  id: string,
  threadDto: ThreadDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/agent/thread/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: threadDto
    },
    options
  );

export const getUpdateChecklist1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChecklist1>>,
    TError,
    { id: string; data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChecklist1>>,
  TError,
  { id: string; data: ThreadDto },
  TContext
> => {
  const mutationKey = ['updateChecklist1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChecklist1>>,
    { id: string; data: ThreadDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateChecklist1(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChecklist1MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChecklist1>>
>;
export type UpdateChecklist1MutationBody = ThreadDto;
export type UpdateChecklist1MutationError = unknown;

/**
 * @summary Update Thread
 */
export const useUpdateChecklist1 = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChecklist1>>,
    TError,
    { id: string; data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChecklist1>>,
  TError,
  { id: string; data: ThreadDto },
  TContext
> => {
  const mutationOptions = getUpdateChecklist1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch agent thread
 */
export const patchThread = (
  id: string,
  threadDto: ThreadDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/agent/thread/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: threadDto
    },
    options
  );

export const getPatchThreadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchThread>>,
    TError,
    { id: string; data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchThread>>,
  TError,
  { id: string; data: ThreadDto },
  TContext
> => {
  const mutationKey = ['patchThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchThread>>,
    { id: string; data: ThreadDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchThread(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchThreadMutationResult = NonNullable<Awaited<ReturnType<typeof patchThread>>>;
export type PatchThreadMutationBody = ThreadDto;
export type PatchThreadMutationError = unknown;

/**
 * @summary Patch agent thread
 */
export const usePatchThread = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchThread>>,
    TError,
    { id: string; data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchThread>>,
  TError,
  { id: string; data: ThreadDto },
  TContext
> => {
  const mutationOptions = getPatchThreadMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get objective
 */
export const getActionPlanObjective = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveResponse>(
    { url: `/actionPlan/objective/${id}`, method: 'GET', signal },
    options
  );

export const getGetActionPlanObjectiveQueryKey = (id: string) =>
  [`/actionPlan/objective/${id}`] as const;

export const getGetActionPlanObjectiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionPlanObjective>>,
  TError = ActionPlanObjectiveResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionPlanObjectiveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionPlanObjective>>> = ({ signal }) =>
    getActionPlanObjective(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionPlanObjective>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionPlanObjectiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionPlanObjective>>
>;
export type GetActionPlanObjectiveQueryError = ActionPlanObjectiveResponse;

export function useGetActionPlanObjective<
  TData = Awaited<ReturnType<typeof getActionPlanObjective>>,
  TError = ActionPlanObjectiveResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanObjective>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanObjective>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanObjective>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanObjective<
  TData = Awaited<ReturnType<typeof getActionPlanObjective>>,
  TError = ActionPlanObjectiveResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanObjective>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanObjective>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanObjective>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanObjective<
  TData = Awaited<ReturnType<typeof getActionPlanObjective>>,
  TError = ActionPlanObjectiveResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get objective
 */

export function useGetActionPlanObjective<
  TData = Awaited<ReturnType<typeof getActionPlanObjective>>,
  TError = ActionPlanObjectiveResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActionPlanObjectiveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update objective
 */
export const updateActionPlanObjective = (
  id: string,
  actionPlanObjectiveDto: ActionPlanObjectiveDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/objective/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanObjectiveDto
    },
    options
  );

export const getUpdateActionPlanObjectiveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanObjective>>,
    TError,
    { id: string; data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionPlanObjective>>,
  TError,
  { id: string; data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationKey = ['updateActionPlanObjective'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionPlanObjective>>,
    { id: string; data: ActionPlanObjectiveDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateActionPlanObjective(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionPlanObjectiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionPlanObjective>>
>;
export type UpdateActionPlanObjectiveMutationBody = ActionPlanObjectiveDto;
export type UpdateActionPlanObjectiveMutationError = unknown;

/**
 * @summary Update objective
 */
export const useUpdateActionPlanObjective = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanObjective>>,
    TError,
    { id: string; data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateActionPlanObjective>>,
  TError,
  { id: string; data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationOptions = getUpdateActionPlanObjectiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete objective
 */
export const deleteActionPlanObjective = (
  id: string,
  params?: DeleteActionPlanObjectiveParams,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/actionPlan/objective/${id}`, method: 'DELETE', params }, options);

export const getDeleteActionPlanObjectiveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanObjective>>,
    TError,
    { id: string; params?: DeleteActionPlanObjectiveParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanObjective>>,
  TError,
  { id: string; params?: DeleteActionPlanObjectiveParams },
  TContext
> => {
  const mutationKey = ['deleteActionPlanObjective'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanObjective>>,
    { id: string; params?: DeleteActionPlanObjectiveParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteActionPlanObjective(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanObjectiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanObjective>>
>;

export type DeleteActionPlanObjectiveMutationError = unknown;

/**
 * @summary Delete objective
 */
export const useDeleteActionPlanObjective = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanObjective>>,
    TError,
    { id: string; params?: DeleteActionPlanObjectiveParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanObjective>>,
  TError,
  { id: string; params?: DeleteActionPlanObjectiveParams },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanObjectiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch objective
 */
export const patchActionPlanObjective = (
  id: string,
  actionPlanObjectiveDto: ActionPlanObjectiveDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/objective/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanObjectiveDto
    },
    options
  );

export const getPatchActionPlanObjectiveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanObjective>>,
    TError,
    { id: string; data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanObjective>>,
  TError,
  { id: string; data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanObjective'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanObjective>>,
    { id: string; data: ActionPlanObjectiveDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanObjective(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanObjectiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanObjective>>
>;
export type PatchActionPlanObjectiveMutationBody = ActionPlanObjectiveDto;
export type PatchActionPlanObjectiveMutationError = unknown;

/**
 * @summary Patch objective
 */
export const usePatchActionPlanObjective = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanObjective>>,
    TError,
    { id: string; data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanObjective>>,
  TError,
  { id: string; data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanObjectiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Duplicate objective
 */
export const duplicateActionPlanObjective = (
  id: string,
  params?: DuplicateActionPlanObjectiveParams,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/actionPlan/objective/${id}/duplicate`, method: 'PUT', params },
    options
  );

export const getDuplicateActionPlanObjectiveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateActionPlanObjective>>,
    TError,
    { id: string; params?: DuplicateActionPlanObjectiveParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateActionPlanObjective>>,
  TError,
  { id: string; params?: DuplicateActionPlanObjectiveParams },
  TContext
> => {
  const mutationKey = ['duplicateActionPlanObjective'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateActionPlanObjective>>,
    { id: string; params?: DuplicateActionPlanObjectiveParams }
  > = props => {
    const { id, params } = props ?? {};

    return duplicateActionPlanObjective(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateActionPlanObjectiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateActionPlanObjective>>
>;

export type DuplicateActionPlanObjectiveMutationError = unknown;

/**
 * @summary Duplicate objective
 */
export const useDuplicateActionPlanObjective = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateActionPlanObjective>>,
    TError,
    { id: string; params?: DuplicateActionPlanObjectiveParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof duplicateActionPlanObjective>>,
  TError,
  { id: string; params?: DuplicateActionPlanObjectiveParams },
  TContext
> => {
  const mutationOptions = getDuplicateActionPlanObjectiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get initiative
 */
export const getActionPlanInitiative = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeResponse>(
    { url: `/actionPlan/initiative/${id}`, method: 'GET', signal },
    options
  );

export const getGetActionPlanInitiativeQueryKey = (id: string) =>
  [`/actionPlan/initiative/${id}`] as const;

export const getGetActionPlanInitiativeQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionPlanInitiative>>,
  TError = ActionPlanInitiativeResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInitiative>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionPlanInitiativeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionPlanInitiative>>> = ({
    signal
  }) => getActionPlanInitiative(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionPlanInitiative>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionPlanInitiativeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionPlanInitiative>>
>;
export type GetActionPlanInitiativeQueryError = ActionPlanInitiativeResponse;

export function useGetActionPlanInitiative<
  TData = Awaited<ReturnType<typeof getActionPlanInitiative>>,
  TError = ActionPlanInitiativeResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInitiative>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanInitiative>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanInitiative>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanInitiative<
  TData = Awaited<ReturnType<typeof getActionPlanInitiative>>,
  TError = ActionPlanInitiativeResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInitiative>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanInitiative>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanInitiative>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanInitiative<
  TData = Awaited<ReturnType<typeof getActionPlanInitiative>>,
  TError = ActionPlanInitiativeResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInitiative>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get initiative
 */

export function useGetActionPlanInitiative<
  TData = Awaited<ReturnType<typeof getActionPlanInitiative>>,
  TError = ActionPlanInitiativeResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInitiative>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActionPlanInitiativeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update initiative
 */
export const updateActionPlanInitiative = (
  id: string,
  actionPlanInitiativeDto: ActionPlanInitiativeDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/initiative/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanInitiativeDto
    },
    options
  );

export const getUpdateActionPlanInitiativeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanInitiative>>,
    TError,
    { id: string; data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionPlanInitiative>>,
  TError,
  { id: string; data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationKey = ['updateActionPlanInitiative'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionPlanInitiative>>,
    { id: string; data: ActionPlanInitiativeDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateActionPlanInitiative(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionPlanInitiativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionPlanInitiative>>
>;
export type UpdateActionPlanInitiativeMutationBody = ActionPlanInitiativeDto;
export type UpdateActionPlanInitiativeMutationError = unknown;

/**
 * @summary Update initiative
 */
export const useUpdateActionPlanInitiative = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanInitiative>>,
    TError,
    { id: string; data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateActionPlanInitiative>>,
  TError,
  { id: string; data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationOptions = getUpdateActionPlanInitiativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete initiative
 */
export const deleteActionPlanInitiative = (
  id: string,
  params?: DeleteActionPlanInitiativeParams,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/actionPlan/initiative/${id}`, method: 'DELETE', params }, options);

export const getDeleteActionPlanInitiativeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanInitiative>>,
    TError,
    { id: string; params?: DeleteActionPlanInitiativeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanInitiative>>,
  TError,
  { id: string; params?: DeleteActionPlanInitiativeParams },
  TContext
> => {
  const mutationKey = ['deleteActionPlanInitiative'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanInitiative>>,
    { id: string; params?: DeleteActionPlanInitiativeParams }
  > = props => {
    const { id, params } = props ?? {};

    return deleteActionPlanInitiative(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanInitiativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanInitiative>>
>;

export type DeleteActionPlanInitiativeMutationError = unknown;

/**
 * @summary Delete initiative
 */
export const useDeleteActionPlanInitiative = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanInitiative>>,
    TError,
    { id: string; params?: DeleteActionPlanInitiativeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanInitiative>>,
  TError,
  { id: string; params?: DeleteActionPlanInitiativeParams },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanInitiativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch initiative
 */
export const patchActionPlanInitiative = (
  id: string,
  actionPlanInitiativeDto: ActionPlanInitiativeDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/initiative/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanInitiativeDto
    },
    options
  );

export const getPatchActionPlanInitiativeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanInitiative>>,
    TError,
    { id: string; data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanInitiative>>,
  TError,
  { id: string; data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanInitiative'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanInitiative>>,
    { id: string; data: ActionPlanInitiativeDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanInitiative(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanInitiativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanInitiative>>
>;
export type PatchActionPlanInitiativeMutationBody = ActionPlanInitiativeDto;
export type PatchActionPlanInitiativeMutationError = unknown;

/**
 * @summary Patch initiative
 */
export const usePatchActionPlanInitiative = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanInitiative>>,
    TError,
    { id: string; data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanInitiative>>,
  TError,
  { id: string; data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanInitiativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Duplicate initiative
 */
export const duplicateActionPlanInitiative = (
  id: string,
  params?: DuplicateActionPlanInitiativeParams,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/actionPlan/initiative/${id}/duplicate`, method: 'PUT', params },
    options
  );

export const getDuplicateActionPlanInitiativeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateActionPlanInitiative>>,
    TError,
    { id: string; params?: DuplicateActionPlanInitiativeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateActionPlanInitiative>>,
  TError,
  { id: string; params?: DuplicateActionPlanInitiativeParams },
  TContext
> => {
  const mutationKey = ['duplicateActionPlanInitiative'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateActionPlanInitiative>>,
    { id: string; params?: DuplicateActionPlanInitiativeParams }
  > = props => {
    const { id, params } = props ?? {};

    return duplicateActionPlanInitiative(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateActionPlanInitiativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateActionPlanInitiative>>
>;

export type DuplicateActionPlanInitiativeMutationError = unknown;

/**
 * @summary Duplicate initiative
 */
export const useDuplicateActionPlanInitiative = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateActionPlanInitiative>>,
    TError,
    { id: string; params?: DuplicateActionPlanInitiativeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof duplicateActionPlanInitiative>>,
  TError,
  { id: string; params?: DuplicateActionPlanInitiativeParams },
  TContext
> => {
  const mutationOptions = getDuplicateActionPlanInitiativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update board
 */
export const updateActionPlanBoard = (
  id: string,
  actionPlanBoardDto: ActionPlanBoardDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/board/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanBoardDto
    },
    options
  );

export const getUpdateActionPlanBoardMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanBoard>>,
    TError,
    { id: string; data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionPlanBoard>>,
  TError,
  { id: string; data: ActionPlanBoardDto },
  TContext
> => {
  const mutationKey = ['updateActionPlanBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionPlanBoard>>,
    { id: string; data: ActionPlanBoardDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateActionPlanBoard(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionPlanBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionPlanBoard>>
>;
export type UpdateActionPlanBoardMutationBody = ActionPlanBoardDto;
export type UpdateActionPlanBoardMutationError = unknown;

/**
 * @summary Update board
 */
export const useUpdateActionPlanBoard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanBoard>>,
    TError,
    { id: string; data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateActionPlanBoard>>,
  TError,
  { id: string; data: ActionPlanBoardDto },
  TContext
> => {
  const mutationOptions = getUpdateActionPlanBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete  action item
 */
export const deleteActionPlanBoard = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/actionPlan/board/${id}`, method: 'DELETE' }, options);

export const getDeleteActionPlanBoardMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanBoard>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanBoard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteActionPlanBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanBoard>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteActionPlanBoard(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanBoard>>
>;

export type DeleteActionPlanBoardMutationError = unknown;

/**
 * @summary Delete  action item
 */
export const useDeleteActionPlanBoard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanBoard>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanBoard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch board
 */
export const patchActionPlanBoard = (
  id: string,
  actionPlanBoardDto: ActionPlanBoardDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/board/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanBoardDto
    },
    options
  );

export const getPatchActionPlanBoardMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanBoard>>,
    TError,
    { id: string; data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanBoard>>,
  TError,
  { id: string; data: ActionPlanBoardDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanBoard>>,
    { id: string; data: ActionPlanBoardDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanBoard(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanBoard>>
>;
export type PatchActionPlanBoardMutationBody = ActionPlanBoardDto;
export type PatchActionPlanBoardMutationError = unknown;

/**
 * @summary Patch board
 */
export const usePatchActionPlanBoard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanBoard>>,
    TError,
    { id: string; data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanBoard>>,
  TError,
  { id: string; data: ActionPlanBoardDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update action item
 */
export const updateActionPlanActionItem = (
  id: string,
  actionPlanActionItemDto: ActionPlanActionItemDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/actionItem/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanActionItemDto
    },
    options
  );

export const getUpdateActionPlanActionItemMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanActionItem>>,
    TError,
    { id: string; data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateActionPlanActionItem>>,
  TError,
  { id: string; data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationKey = ['updateActionPlanActionItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateActionPlanActionItem>>,
    { id: string; data: ActionPlanActionItemDto }
  > = props => {
    const { id, data } = props ?? {};

    return updateActionPlanActionItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateActionPlanActionItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateActionPlanActionItem>>
>;
export type UpdateActionPlanActionItemMutationBody = ActionPlanActionItemDto;
export type UpdateActionPlanActionItemMutationError = unknown;

/**
 * @summary Update action item
 */
export const useUpdateActionPlanActionItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateActionPlanActionItem>>,
    TError,
    { id: string; data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateActionPlanActionItem>>,
  TError,
  { id: string; data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationOptions = getUpdateActionPlanActionItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete  action item
 */
export const deleteActionPlanActionItem = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/actionPlan/actionItem/${id}`, method: 'DELETE' }, options);

export const getDeleteActionPlanActionItemMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanActionItem>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanActionItem>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteActionPlanActionItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanActionItem>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteActionPlanActionItem(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanActionItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanActionItem>>
>;

export type DeleteActionPlanActionItemMutationError = unknown;

/**
 * @summary Delete  action item
 */
export const useDeleteActionPlanActionItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanActionItem>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanActionItem>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanActionItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch  action item
 */
export const patchActionPlanActionItem = (
  id: string,
  actionPlanActionItemDto: ActionPlanActionItemDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/actionItem/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanActionItemDto
    },
    options
  );

export const getPatchActionPlanActionItemMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanActionItem>>,
    TError,
    { id: string; data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanActionItem>>,
  TError,
  { id: string; data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanActionItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanActionItem>>,
    { id: string; data: ActionPlanActionItemDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanActionItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanActionItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanActionItem>>
>;
export type PatchActionPlanActionItemMutationBody = ActionPlanActionItemDto;
export type PatchActionPlanActionItemMutationError = unknown;

/**
 * @summary Patch  action item
 */
export const usePatchActionPlanActionItem = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanActionItem>>,
    TError,
    { id: string; data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanActionItem>>,
  TError,
  { id: string; data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanActionItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update account logo
 */
export const updateAccountLogo = (
  updateAccountLogoBody: UpdateAccountLogoBody,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/account/logo`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAccountLogoBody
    },
    options
  );

export const getUpdateAccountLogoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountLogo>>,
    TError,
    { data: UpdateAccountLogoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccountLogo>>,
  TError,
  { data: UpdateAccountLogoBody },
  TContext
> => {
  const mutationKey = ['updateAccountLogo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccountLogo>>,
    { data: UpdateAccountLogoBody }
  > = props => {
    const { data } = props ?? {};

    return updateAccountLogo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountLogo>>
>;
export type UpdateAccountLogoMutationBody = UpdateAccountLogoBody;
export type UpdateAccountLogoMutationError = unknown;

/**
 * @summary Update account logo
 */
export const useUpdateAccountLogo = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountLogo>>,
    TError,
    { data: UpdateAccountLogoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountLogo>>,
  TError,
  { data: UpdateAccountLogoBody },
  TContext
> => {
  const mutationOptions = getUpdateAccountLogoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List whiteboards
 */
export const listWhiteboards = (
  params?: ListWhiteboardsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<WhiteboardResponse>(
    { url: `/workspace/whiteboard`, method: 'GET', params, signal },
    options
  );

export const getListWhiteboardsQueryKey = (params?: ListWhiteboardsParams) =>
  [`/workspace/whiteboard`, ...(params ? [params] : [])] as const;

export const getListWhiteboardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWhiteboards>>,
  TError = WhiteboardResponse
>(
  params?: ListWhiteboardsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboards>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWhiteboardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhiteboards>>> = ({ signal }) =>
    listWhiteboards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWhiteboards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWhiteboardsQueryResult = NonNullable<Awaited<ReturnType<typeof listWhiteboards>>>;
export type ListWhiteboardsQueryError = WhiteboardResponse;

export function useListWhiteboards<
  TData = Awaited<ReturnType<typeof listWhiteboards>>,
  TError = WhiteboardResponse
>(
  params: undefined | ListWhiteboardsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboards>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhiteboards>>,
          TError,
          Awaited<ReturnType<typeof listWhiteboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWhiteboards<
  TData = Awaited<ReturnType<typeof listWhiteboards>>,
  TError = WhiteboardResponse
>(
  params?: ListWhiteboardsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboards>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhiteboards>>,
          TError,
          Awaited<ReturnType<typeof listWhiteboards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWhiteboards<
  TData = Awaited<ReturnType<typeof listWhiteboards>>,
  TError = WhiteboardResponse
>(
  params?: ListWhiteboardsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboards>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List whiteboards
 */

export function useListWhiteboards<
  TData = Awaited<ReturnType<typeof listWhiteboards>>,
  TError = WhiteboardResponse
>(
  params?: ListWhiteboardsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboards>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListWhiteboardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create whiteboard
 */
export const createWhiteboard = (
  whiteboardDto: WhiteboardDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<WhiteboardResponse>(
    {
      url: `/workspace/whiteboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: whiteboardDto,
      signal
    },
    options
  );

export const getCreateWhiteboardMutationOptions = <
  TError = WhiteboardResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWhiteboard>>,
    TError,
    { data: WhiteboardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWhiteboard>>,
  TError,
  { data: WhiteboardDto },
  TContext
> => {
  const mutationKey = ['createWhiteboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWhiteboard>>,
    { data: WhiteboardDto }
  > = props => {
    const { data } = props ?? {};

    return createWhiteboard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWhiteboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWhiteboard>>
>;
export type CreateWhiteboardMutationBody = WhiteboardDto;
export type CreateWhiteboardMutationError = WhiteboardResponse;

/**
 * @summary Create whiteboard
 */
export const useCreateWhiteboard = <TError = WhiteboardResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWhiteboard>>,
    TError,
    { data: WhiteboardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWhiteboard>>,
  TError,
  { data: WhiteboardDto },
  TContext
> => {
  const mutationOptions = getCreateWhiteboardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Account Tags
 */
export const getAccountTags = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<AccountTagsResponse>({ url: `/workspace/tag`, method: 'GET', signal }, options);

export const getGetAccountTagsQueryKey = () => [`/workspace/tag`] as const;

export const getGetAccountTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountTags>>,
  TError = AccountTagsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountTags>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountTags>>> = ({ signal }) =>
    getAccountTags(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountTags>>>;
export type GetAccountTagsQueryError = AccountTagsResponse;

export function useGetAccountTags<
  TData = Awaited<ReturnType<typeof getAccountTags>>,
  TError = AccountTagsResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountTags>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAccountTags>>,
        TError,
        Awaited<ReturnType<typeof getAccountTags>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccountTags<
  TData = Awaited<ReturnType<typeof getAccountTags>>,
  TError = AccountTagsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountTags>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAccountTags>>,
        TError,
        Awaited<ReturnType<typeof getAccountTags>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccountTags<
  TData = Awaited<ReturnType<typeof getAccountTags>>,
  TError = AccountTagsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountTags>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Account Tags
 */

export function useGetAccountTags<
  TData = Awaited<ReturnType<typeof getAccountTags>>,
  TError = AccountTagsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountTags>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAccountTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add Account Tags
 */
export const addAccountTags = (
  accountTagsDto: AccountTagsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/workspace/tag`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: accountTagsDto,
      signal
    },
    options
  );

export const getAddAccountTagsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAccountTags>>,
    TError,
    { data: AccountTagsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAccountTags>>,
  TError,
  { data: AccountTagsDto },
  TContext
> => {
  const mutationKey = ['addAccountTags'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAccountTags>>,
    { data: AccountTagsDto }
  > = props => {
    const { data } = props ?? {};

    return addAccountTags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAccountTagsMutationResult = NonNullable<Awaited<ReturnType<typeof addAccountTags>>>;
export type AddAccountTagsMutationBody = AccountTagsDto;
export type AddAccountTagsMutationError = unknown;

/**
 * @summary Add Account Tags
 */
export const useAddAccountTags = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAccountTags>>,
    TError,
    { data: AccountTagsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addAccountTags>>,
  TError,
  { data: AccountTagsDto },
  TContext
> => {
  const mutationOptions = getAddAccountTagsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List shared workspaces
 */
export const listSharedWorkspaces = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceResponse>(
    { url: `/workspace/sharedWorkspace`, method: 'GET', signal },
    options
  );

export const getListSharedWorkspacesQueryKey = () => [`/workspace/sharedWorkspace`] as const;

export const getListSharedWorkspacesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedWorkspaces>>,
  TError = SharedWorkspaceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaces>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedWorkspacesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedWorkspaces>>> = ({ signal }) =>
    listSharedWorkspaces(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedWorkspaces>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedWorkspacesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedWorkspaces>>
>;
export type ListSharedWorkspacesQueryError = SharedWorkspaceResponse;

export function useListSharedWorkspaces<
  TData = Awaited<ReturnType<typeof listSharedWorkspaces>>,
  TError = SharedWorkspaceResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaces>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listSharedWorkspaces>>,
        TError,
        Awaited<ReturnType<typeof listSharedWorkspaces>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaces<
  TData = Awaited<ReturnType<typeof listSharedWorkspaces>>,
  TError = SharedWorkspaceResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaces>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listSharedWorkspaces>>,
        TError,
        Awaited<ReturnType<typeof listSharedWorkspaces>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaces<
  TData = Awaited<ReturnType<typeof listSharedWorkspaces>>,
  TError = SharedWorkspaceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaces>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List shared workspaces
 */

export function useListSharedWorkspaces<
  TData = Awaited<ReturnType<typeof listSharedWorkspaces>>,
  TError = SharedWorkspaceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaces>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedWorkspacesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create shared workspace
 */
export const createSharedWorkspace = (
  sharedWorkspaceDto: SharedWorkspaceDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceResponse>(
    {
      url: `/workspace/sharedWorkspace`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceDto,
      signal
    },
    options
  );

export const getCreateSharedWorkspaceMutationOptions = <
  TError = SharedWorkspaceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspace>>,
    TError,
    { data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSharedWorkspace>>,
  TError,
  { data: SharedWorkspaceDto },
  TContext
> => {
  const mutationKey = ['createSharedWorkspace'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSharedWorkspace>>,
    { data: SharedWorkspaceDto }
  > = props => {
    const { data } = props ?? {};

    return createSharedWorkspace(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSharedWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSharedWorkspace>>
>;
export type CreateSharedWorkspaceMutationBody = SharedWorkspaceDto;
export type CreateSharedWorkspaceMutationError = SharedWorkspaceResponse;

/**
 * @summary Create shared workspace
 */
export const useCreateSharedWorkspace = <
  TError = SharedWorkspaceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspace>>,
    TError,
    { data: SharedWorkspaceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSharedWorkspace>>,
  TError,
  { data: SharedWorkspaceDto },
  TContext
> => {
  const mutationOptions = getCreateSharedWorkspaceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search shared workspaces points
 */
export const searchSharedWorkspacePoints = (
  id: string,
  searchEntityRequest: SearchEntityRequest,
  params?: SearchSharedWorkspacePointsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointResponse>(
    {
      url: `/workspace/sharedWorkspace/${id}/point/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      params,
      signal
    },
    options
  );

export const getSearchSharedWorkspacePointsMutationOptions = <
  TError = SharedWorkspacePointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchSharedWorkspacePoints>>,
    TError,
    { id: string; data: SearchEntityRequest; params?: SearchSharedWorkspacePointsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchSharedWorkspacePoints>>,
  TError,
  { id: string; data: SearchEntityRequest; params?: SearchSharedWorkspacePointsParams },
  TContext
> => {
  const mutationKey = ['searchSharedWorkspacePoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchSharedWorkspacePoints>>,
    { id: string; data: SearchEntityRequest; params?: SearchSharedWorkspacePointsParams }
  > = props => {
    const { id, data, params } = props ?? {};

    return searchSharedWorkspacePoints(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchSharedWorkspacePointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchSharedWorkspacePoints>>
>;
export type SearchSharedWorkspacePointsMutationBody = SearchEntityRequest;
export type SearchSharedWorkspacePointsMutationError = SharedWorkspacePointResponse;

/**
 * @summary Search shared workspaces points
 */
export const useSearchSharedWorkspacePoints = <
  TError = SharedWorkspacePointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchSharedWorkspacePoints>>,
    TError,
    { id: string; data: SearchEntityRequest; params?: SearchSharedWorkspacePointsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchSharedWorkspacePoints>>,
  TError,
  { id: string; data: SearchEntityRequest; params?: SearchSharedWorkspacePointsParams },
  TContext
> => {
  const mutationOptions = getSearchSharedWorkspacePointsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Start a shared workspace meeting
 */
export const startSharedWorkspaceMeeting = (
  id: string,
  startMeetingRequest: StartMeetingRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingResponse>(
    {
      url: `/workspace/sharedWorkspace/${id}/meeting/start`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: startMeetingRequest,
      signal
    },
    options
  );

export const getStartSharedWorkspaceMeetingMutationOptions = <
  TError = SharedWorkspaceMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>,
    TError,
    { id: string; data: StartMeetingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>,
  TError,
  { id: string; data: StartMeetingRequest },
  TContext
> => {
  const mutationKey = ['startSharedWorkspaceMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>,
    { id: string; data: StartMeetingRequest }
  > = props => {
    const { id, data } = props ?? {};

    return startSharedWorkspaceMeeting(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartSharedWorkspaceMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>
>;
export type StartSharedWorkspaceMeetingMutationBody = StartMeetingRequest;
export type StartSharedWorkspaceMeetingMutationError = SharedWorkspaceMeetingResponse;

/**
 * @summary Start a shared workspace meeting
 */
export const useStartSharedWorkspaceMeeting = <
  TError = SharedWorkspaceMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>,
    TError,
    { id: string; data: StartMeetingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startSharedWorkspaceMeeting>>,
  TError,
  { id: string; data: StartMeetingRequest },
  TContext
> => {
  const mutationOptions = getStartSharedWorkspaceMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create shared workspace update
 */
export const createSharedWorkspaceUpdate = (
  sharedWorkspaceUpdateDto: SharedWorkspaceUpdateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceUpdateResponse>(
    {
      url: `/workspace/sharedWorkspace/update`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceUpdateDto,
      signal
    },
    options
  );

export const getCreateSharedWorkspaceUpdateMutationOptions = <
  TError = SharedWorkspaceUpdateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>,
    TError,
    { data: SharedWorkspaceUpdateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>,
  TError,
  { data: SharedWorkspaceUpdateDto },
  TContext
> => {
  const mutationKey = ['createSharedWorkspaceUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>,
    { data: SharedWorkspaceUpdateDto }
  > = props => {
    const { data } = props ?? {};

    return createSharedWorkspaceUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSharedWorkspaceUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>
>;
export type CreateSharedWorkspaceUpdateMutationBody = SharedWorkspaceUpdateDto;
export type CreateSharedWorkspaceUpdateMutationError = SharedWorkspaceUpdateResponse;

/**
 * @summary Create shared workspace update
 */
export const useCreateSharedWorkspaceUpdate = <
  TError = SharedWorkspaceUpdateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>,
    TError,
    { data: SharedWorkspaceUpdateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSharedWorkspaceUpdate>>,
  TError,
  { data: SharedWorkspaceUpdateDto },
  TContext
> => {
  const mutationOptions = getCreateSharedWorkspaceUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search shared workspaces
 */
export const searchSharedWorkspaces = (
  searchEntityRequest: SearchEntityRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceResponse>(
    {
      url: `/workspace/sharedWorkspace/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      signal
    },
    options
  );

export const getSearchSharedWorkspacesMutationOptions = <
  TError = SharedWorkspaceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchSharedWorkspaces>>,
    TError,
    { data: SearchEntityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchSharedWorkspaces>>,
  TError,
  { data: SearchEntityRequest },
  TContext
> => {
  const mutationKey = ['searchSharedWorkspaces'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchSharedWorkspaces>>,
    { data: SearchEntityRequest }
  > = props => {
    const { data } = props ?? {};

    return searchSharedWorkspaces(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchSharedWorkspacesMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchSharedWorkspaces>>
>;
export type SearchSharedWorkspacesMutationBody = SearchEntityRequest;
export type SearchSharedWorkspacesMutationError = SharedWorkspaceResponse;

/**
 * @summary Search shared workspaces
 */
export const useSearchSharedWorkspaces = <
  TError = SharedWorkspaceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchSharedWorkspaces>>,
    TError,
    { data: SearchEntityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchSharedWorkspaces>>,
  TError,
  { data: SearchEntityRequest },
  TContext
> => {
  const mutationOptions = getSearchSharedWorkspacesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create shared workspace point
 */
export const createSharedWorkspacePoint = (
  sharedWorkspacePointDto: SharedWorkspacePointDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointResponse>(
    {
      url: `/workspace/sharedWorkspace/point`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspacePointDto,
      signal
    },
    options
  );

export const getCreateSharedWorkspacePointMutationOptions = <
  TError = SharedWorkspacePointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspacePoint>>,
    TError,
    { data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSharedWorkspacePoint>>,
  TError,
  { data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationKey = ['createSharedWorkspacePoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSharedWorkspacePoint>>,
    { data: SharedWorkspacePointDto }
  > = props => {
    const { data } = props ?? {};

    return createSharedWorkspacePoint(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSharedWorkspacePointMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSharedWorkspacePoint>>
>;
export type CreateSharedWorkspacePointMutationBody = SharedWorkspacePointDto;
export type CreateSharedWorkspacePointMutationError = SharedWorkspacePointResponse;

/**
 * @summary Create shared workspace point
 */
export const useCreateSharedWorkspacePoint = <
  TError = SharedWorkspacePointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspacePoint>>,
    TError,
    { data: SharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSharedWorkspacePoint>>,
  TError,
  { data: SharedWorkspacePointDto },
  TContext
> => {
  const mutationOptions = getCreateSharedWorkspacePointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add starred point
 */
export const addSharedWorkspaceStarredPoint = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/point/${id}/starred`, method: 'POST', signal },
    options
  );

export const getAddSharedWorkspaceStarredPointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['addSharedWorkspaceStarredPoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return addSharedWorkspaceStarredPoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSharedWorkspaceStarredPointMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>
>;

export type AddSharedWorkspaceStarredPointMutationError = unknown;

/**
 * @summary Add starred point
 */
export const useAddSharedWorkspaceStarredPoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSharedWorkspaceStarredPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAddSharedWorkspaceStarredPointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Remove starred point
 */
export const removeSharedWorkspaceStarredPoint = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/point/${id}/starred`, method: 'DELETE' },
    options
  );

export const getRemoveSharedWorkspaceStarredPointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['removeSharedWorkspaceStarredPoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return removeSharedWorkspaceStarredPoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveSharedWorkspaceStarredPointMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>
>;

export type RemoveSharedWorkspaceStarredPointMutationError = unknown;

/**
 * @summary Remove starred point
 */
export const useRemoveSharedWorkspaceStarredPoint = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeSharedWorkspaceStarredPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getRemoveSharedWorkspaceStarredPointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create shared workspace point comment
 */
export const createSharedWorkspacePointComment = (
  sharedWorkspacePointCommentDto: SharedWorkspacePointCommentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointCommentResponse>(
    {
      url: `/workspace/sharedWorkspace/point/comment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspacePointCommentDto,
      signal
    },
    options
  );

export const getCreateSharedWorkspacePointCommentMutationOptions = <
  TError = SharedWorkspacePointCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspacePointComment>>,
    TError,
    { data: SharedWorkspacePointCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSharedWorkspacePointComment>>,
  TError,
  { data: SharedWorkspacePointCommentDto },
  TContext
> => {
  const mutationKey = ['createSharedWorkspacePointComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSharedWorkspacePointComment>>,
    { data: SharedWorkspacePointCommentDto }
  > = props => {
    const { data } = props ?? {};

    return createSharedWorkspacePointComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSharedWorkspacePointCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSharedWorkspacePointComment>>
>;
export type CreateSharedWorkspacePointCommentMutationBody = SharedWorkspacePointCommentDto;
export type CreateSharedWorkspacePointCommentMutationError = SharedWorkspacePointCommentResponse;

/**
 * @summary Create shared workspace point comment
 */
export const useCreateSharedWorkspacePointComment = <
  TError = SharedWorkspacePointCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedWorkspacePointComment>>,
    TError,
    { data: SharedWorkspacePointCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSharedWorkspacePointComment>>,
  TError,
  { data: SharedWorkspacePointCommentDto },
  TContext
> => {
  const mutationOptions = getCreateSharedWorkspacePointCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Shared Workspace meeting flows
 */
export const listMeetingFlows = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFlowResponse>(
    { url: `/workspace/sharedWorkspace/meetingFlow`, method: 'GET', signal },
    options
  );

export const getListMeetingFlowsQueryKey = () =>
  [`/workspace/sharedWorkspace/meetingFlow`] as const;

export const getListMeetingFlowsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingFlows>>,
  TError = MeetingFlowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingFlowsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingFlows>>> = ({ signal }) =>
    listMeetingFlows(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingFlows>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingFlowsQueryResult = NonNullable<Awaited<ReturnType<typeof listMeetingFlows>>>;
export type ListMeetingFlowsQueryError = MeetingFlowResponse;

export function useListMeetingFlows<
  TData = Awaited<ReturnType<typeof listMeetingFlows>>,
  TError = MeetingFlowResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlows>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingFlows>>,
        TError,
        Awaited<ReturnType<typeof listMeetingFlows>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingFlows<
  TData = Awaited<ReturnType<typeof listMeetingFlows>>,
  TError = MeetingFlowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlows>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingFlows>>,
        TError,
        Awaited<ReturnType<typeof listMeetingFlows>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingFlows<
  TData = Awaited<ReturnType<typeof listMeetingFlows>>,
  TError = MeetingFlowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Shared Workspace meeting flows
 */

export function useListMeetingFlows<
  TData = Awaited<ReturnType<typeof listMeetingFlows>>,
  TError = MeetingFlowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingFlowsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create meeting flow
 */
export const createMeetingFlow = (
  meetingFlowDto: MeetingFlowDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFlowResponse>(
    {
      url: `/workspace/sharedWorkspace/meetingFlow`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingFlowDto,
      signal
    },
    options
  );

export const getCreateMeetingFlowMutationOptions = <
  TError = MeetingFlowResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFlow>>,
    TError,
    { data: MeetingFlowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingFlow>>,
  TError,
  { data: MeetingFlowDto },
  TContext
> => {
  const mutationKey = ['createMeetingFlow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingFlow>>,
    { data: MeetingFlowDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingFlow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingFlow>>
>;
export type CreateMeetingFlowMutationBody = MeetingFlowDto;
export type CreateMeetingFlowMutationError = MeetingFlowResponse;

/**
 * @summary Create meeting flow
 */
export const useCreateMeetingFlow = <TError = MeetingFlowResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFlow>>,
    TError,
    { data: MeetingFlowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingFlow>>,
  TError,
  { data: MeetingFlowDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingFlowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List meeting flow templates
 */
export const listMeetingFlowTemplates = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFlowTemplateResponse>(
    { url: `/workspace/sharedWorkspace/meetingFlowTemplate`, method: 'GET', signal },
    options
  );

export const getListMeetingFlowTemplatesQueryKey = () =>
  [`/workspace/sharedWorkspace/meetingFlowTemplate`] as const;

export const getListMeetingFlowTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
  TError = MeetingFlowTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlowTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingFlowTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingFlowTemplates>>> = ({
    signal
  }) => listMeetingFlowTemplates(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingFlowTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMeetingFlowTemplates>>
>;
export type ListMeetingFlowTemplatesQueryError = MeetingFlowTemplateResponse;

export function useListMeetingFlowTemplates<
  TData = Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
  TError = MeetingFlowTemplateResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlowTemplates>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
        TError,
        Awaited<ReturnType<typeof listMeetingFlowTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingFlowTemplates<
  TData = Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
  TError = MeetingFlowTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlowTemplates>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
        TError,
        Awaited<ReturnType<typeof listMeetingFlowTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingFlowTemplates<
  TData = Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
  TError = MeetingFlowTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlowTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List meeting flow templates
 */

export function useListMeetingFlowTemplates<
  TData = Awaited<ReturnType<typeof listMeetingFlowTemplates>>,
  TError = MeetingFlowTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingFlowTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingFlowTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create meeting flow template
 */
export const createMeetingFlowTemplate = (
  meetingFlowTemplateDto: MeetingFlowTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFlowTemplateResponse>(
    {
      url: `/workspace/sharedWorkspace/meetingFlowTemplate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingFlowTemplateDto,
      signal
    },
    options
  );

export const getCreateMeetingFlowTemplateMutationOptions = <
  TError = MeetingFlowTemplateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFlowTemplate>>,
    TError,
    { data: MeetingFlowTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingFlowTemplate>>,
  TError,
  { data: MeetingFlowTemplateDto },
  TContext
> => {
  const mutationKey = ['createMeetingFlowTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingFlowTemplate>>,
    { data: MeetingFlowTemplateDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingFlowTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingFlowTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingFlowTemplate>>
>;
export type CreateMeetingFlowTemplateMutationBody = MeetingFlowTemplateDto;
export type CreateMeetingFlowTemplateMutationError = MeetingFlowTemplateResponse;

/**
 * @summary Create meeting flow template
 */
export const useCreateMeetingFlowTemplate = <
  TError = MeetingFlowTemplateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFlowTemplate>>,
    TError,
    { data: MeetingFlowTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingFlowTemplate>>,
  TError,
  { data: MeetingFlowTemplateDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingFlowTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all space meeting notes
 */
export const listAllSpaceMeetingNotes = (
  params: ListAllSpaceMeetingNotesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingNoteResponse>(
    { url: `/workspace/sharedWorkspace/meeting/note`, method: 'GET', params, signal },
    options
  );

export const getListAllSpaceMeetingNotesQueryKey = (params: ListAllSpaceMeetingNotesParams) =>
  [`/workspace/sharedWorkspace/meeting/note`, ...(params ? [params] : [])] as const;

export const getListAllSpaceMeetingNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  params: ListAllSpaceMeetingNotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllSpaceMeetingNotesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>> = ({
    signal
  }) => listAllSpaceMeetingNotes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllSpaceMeetingNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>
>;
export type ListAllSpaceMeetingNotesQueryError = SharedWorkspaceMeetingNoteResponse;

export function useListAllSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  params: ListAllSpaceMeetingNotesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
          TError,
          Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  params: ListAllSpaceMeetingNotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
          TError,
          Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  params: ListAllSpaceMeetingNotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all space meeting notes
 */

export function useListAllSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  params: ListAllSpaceMeetingNotesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllSpaceMeetingNotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create meeting note
 */
export const createSpaceMeetingNote = (
  sharedWorkspaceMeetingNoteDto: SharedWorkspaceMeetingNoteDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingNoteResponse>(
    {
      url: `/workspace/sharedWorkspace/meeting/note`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceMeetingNoteDto,
      signal
    },
    options
  );

export const getCreateSpaceMeetingNoteMutationOptions = <
  TError = SharedWorkspaceMeetingNoteResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceMeetingNote>>,
    TError,
    { data: SharedWorkspaceMeetingNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSpaceMeetingNote>>,
  TError,
  { data: SharedWorkspaceMeetingNoteDto },
  TContext
> => {
  const mutationKey = ['createSpaceMeetingNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSpaceMeetingNote>>,
    { data: SharedWorkspaceMeetingNoteDto }
  > = props => {
    const { data } = props ?? {};

    return createSpaceMeetingNote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSpaceMeetingNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSpaceMeetingNote>>
>;
export type CreateSpaceMeetingNoteMutationBody = SharedWorkspaceMeetingNoteDto;
export type CreateSpaceMeetingNoteMutationError = SharedWorkspaceMeetingNoteResponse;

/**
 * @summary Create meeting note
 */
export const useCreateSpaceMeetingNote = <
  TError = SharedWorkspaceMeetingNoteResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSpaceMeetingNote>>,
    TError,
    { data: SharedWorkspaceMeetingNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSpaceMeetingNote>>,
  TError,
  { data: SharedWorkspaceMeetingNoteDto },
  TContext
> => {
  const mutationOptions = getCreateSpaceMeetingNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create meeting activity
 */
export const createMeetingActivity = (
  sharedWorkspaceMeetingActivityDto: SharedWorkspaceMeetingActivityDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingActivityResponse>(
    {
      url: `/workspace/sharedWorkspace/meeting/activity`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceMeetingActivityDto,
      signal
    },
    options
  );

export const getCreateMeetingActivityMutationOptions = <
  TError = SharedWorkspaceMeetingActivityResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingActivity>>,
    TError,
    { data: SharedWorkspaceMeetingActivityDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingActivity>>,
  TError,
  { data: SharedWorkspaceMeetingActivityDto },
  TContext
> => {
  const mutationKey = ['createMeetingActivity'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingActivity>>,
    { data: SharedWorkspaceMeetingActivityDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingActivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingActivity>>
>;
export type CreateMeetingActivityMutationBody = SharedWorkspaceMeetingActivityDto;
export type CreateMeetingActivityMutationError = SharedWorkspaceMeetingActivityResponse;

/**
 * @summary Create meeting activity
 */
export const useCreateMeetingActivity = <
  TError = SharedWorkspaceMeetingActivityResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingActivity>>,
    TError,
    { data: SharedWorkspaceMeetingActivityDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingActivity>>,
  TError,
  { data: SharedWorkspaceMeetingActivityDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all resources
 */
export const listResources = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ResourceResponse>({ url: `/workspace/resource`, method: 'GET', signal }, options);

export const getListResourcesQueryKey = () => [`/workspace/resource`] as const;

export const getListResourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ResourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListResourcesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listResources>>> = ({ signal }) =>
    listResources(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListResourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listResources>>>;
export type ListResourcesQueryError = ResourceResponse;

export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ResourceResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listResources>>,
        TError,
        Awaited<ReturnType<typeof listResources>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ResourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listResources>>,
        TError,
        Awaited<ReturnType<typeof listResources>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ResourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all resources
 */

export function useListResources<
  TData = Awaited<ReturnType<typeof listResources>>,
  TError = ResourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listResources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListResourcesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create resource
 */
export const createResource = (
  resourceDto: ResourceDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ResourceResponse>(
    {
      url: `/workspace/resource`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resourceDto,
      signal
    },
    options
  );

export const getCreateResourceMutationOptions = <
  TError = ResourceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResource>>,
    TError,
    { data: ResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createResource>>,
  TError,
  { data: ResourceDto },
  TContext
> => {
  const mutationKey = ['createResource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createResource>>,
    { data: ResourceDto }
  > = props => {
    const { data } = props ?? {};

    return createResource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createResource>>>;
export type CreateResourceMutationBody = ResourceDto;
export type CreateResourceMutationError = ResourceResponse;

/**
 * @summary Create resource
 */
export const useCreateResource = <TError = ResourceResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResource>>,
    TError,
    { data: ResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createResource>>,
  TError,
  { data: ResourceDto },
  TContext
> => {
  const mutationOptions = getCreateResourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List google drive files
 */
export const listGoogleDriveFiles = (
  params?: ListGoogleDriveFilesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DriveFileResponse>(
    { url: `/workspace/resource/drive/file`, method: 'GET', params, signal },
    options
  );

export const getListGoogleDriveFilesQueryKey = (params?: ListGoogleDriveFilesParams) =>
  [`/workspace/resource/drive/file`, ...(params ? [params] : [])] as const;

export const getListGoogleDriveFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listGoogleDriveFiles>>,
  TError = DriveFileResponse
>(
  params?: ListGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGoogleDriveFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoogleDriveFiles>>> = ({ signal }) =>
    listGoogleDriveFiles(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGoogleDriveFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGoogleDriveFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGoogleDriveFiles>>
>;
export type ListGoogleDriveFilesQueryError = DriveFileResponse;

export function useListGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listGoogleDriveFiles>>,
  TError = DriveFileResponse
>(
  params: undefined | ListGoogleDriveFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listGoogleDriveFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleDriveFiles>>,
          TError,
          Awaited<ReturnType<typeof listGoogleDriveFiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listGoogleDriveFiles>>,
  TError = DriveFileResponse
>(
  params?: ListGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listGoogleDriveFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoogleDriveFiles>>,
          TError,
          Awaited<ReturnType<typeof listGoogleDriveFiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listGoogleDriveFiles>>,
  TError = DriveFileResponse
>(
  params?: ListGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List google drive files
 */

export function useListGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listGoogleDriveFiles>>,
  TError = DriveFileResponse
>(
  params?: ListGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListGoogleDriveFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create google drive file
 */
export const createGoogleDriveFile = (
  createGoogleDriveFileRequest: CreateGoogleDriveFileRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ResourceResponse>(
    {
      url: `/workspace/resource/drive/file`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createGoogleDriveFileRequest,
      signal
    },
    options
  );

export const getCreateGoogleDriveFileMutationOptions = <
  TError = ResourceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoogleDriveFile>>,
    TError,
    { data: CreateGoogleDriveFileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoogleDriveFile>>,
  TError,
  { data: CreateGoogleDriveFileRequest },
  TContext
> => {
  const mutationKey = ['createGoogleDriveFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoogleDriveFile>>,
    { data: CreateGoogleDriveFileRequest }
  > = props => {
    const { data } = props ?? {};

    return createGoogleDriveFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoogleDriveFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoogleDriveFile>>
>;
export type CreateGoogleDriveFileMutationBody = CreateGoogleDriveFileRequest;
export type CreateGoogleDriveFileMutationError = ResourceResponse;

/**
 * @summary Create google drive file
 */
export const useCreateGoogleDriveFile = <TError = ResourceResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoogleDriveFile>>,
    TError,
    { data: CreateGoogleDriveFileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoogleDriveFile>>,
  TError,
  { data: CreateGoogleDriveFileRequest },
  TContext
> => {
  const mutationOptions = getCreateGoogleDriveFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Upload google drive file
 */
export const uploadGoogleDriveFile = (
  uploadGoogleDriveFileBody: UploadGoogleDriveFileBody,
  params?: UploadGoogleDriveFileParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/workspace/resource/drive/file/upload`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadGoogleDriveFileBody,
      params,
      signal
    },
    options
  );

export const getUploadGoogleDriveFileMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGoogleDriveFile>>,
    TError,
    { data: UploadGoogleDriveFileBody; params?: UploadGoogleDriveFileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadGoogleDriveFile>>,
  TError,
  { data: UploadGoogleDriveFileBody; params?: UploadGoogleDriveFileParams },
  TContext
> => {
  const mutationKey = ['uploadGoogleDriveFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadGoogleDriveFile>>,
    { data: UploadGoogleDriveFileBody; params?: UploadGoogleDriveFileParams }
  > = props => {
    const { data, params } = props ?? {};

    return uploadGoogleDriveFile(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadGoogleDriveFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadGoogleDriveFile>>
>;
export type UploadGoogleDriveFileMutationBody = UploadGoogleDriveFileBody;
export type UploadGoogleDriveFileMutationError = unknown;

/**
 * @summary Upload google drive file
 */
export const useUploadGoogleDriveFile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGoogleDriveFile>>,
    TError,
    { data: UploadGoogleDriveFileBody; params?: UploadGoogleDriveFileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadGoogleDriveFile>>,
  TError,
  { data: UploadGoogleDriveFileBody; params?: UploadGoogleDriveFileParams },
  TContext
> => {
  const mutationOptions = getUploadGoogleDriveFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all notes
 */
export const listNotes = (
  params?: ListNotesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<NoteResponse>({ url: `/workspace/note`, method: 'GET', params, signal }, options);

export const getListNotesQueryKey = (params?: ListNotesParams) =>
  [`/workspace/note`, ...(params ? [params] : [])] as const;

export const getListNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotes>>,
  TError = NoteResponse
>(
  params?: ListNotesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotes>>> = ({ signal }) =>
    listNotes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotes>>>;
export type ListNotesQueryError = NoteResponse;

export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = NoteResponse>(
  params: undefined | ListNotesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotes>>,
          TError,
          Awaited<ReturnType<typeof listNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = NoteResponse>(
  params?: ListNotesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotes>>,
          TError,
          Awaited<ReturnType<typeof listNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = NoteResponse>(
  params?: ListNotesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all notes
 */

export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = NoteResponse>(
  params?: ListNotesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create note
 */
export const createNote = (
  noteDto: NoteDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<NoteResponse>(
    {
      url: `/workspace/note`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: noteDto,
      signal
    },
    options
  );

export const getCreateNoteMutationOptions = <TError = NoteResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    { data: NoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { data: NoteDto },
  TContext
> => {
  const mutationKey = ['createNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNote>>,
    { data: NoteDto }
  > = props => {
    const { data } = props ?? {};

    return createNote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createNote>>>;
export type CreateNoteMutationBody = NoteDto;
export type CreateNoteMutationError = NoteResponse;

/**
 * @summary Create note
 */
export const useCreateNote = <TError = NoteResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNote>>,
    TError,
    { data: NoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createNote>>,
  TError,
  { data: NoteDto },
  TContext
> => {
  const mutationOptions = getCreateNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Module playbook
 */
export const getModulePlaybook = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModulePlaybookResponse>(
    { url: `/workspace/module/${id}/playbook`, method: 'GET', signal },
    options
  );

export const getGetModulePlaybookQueryKey = (id: string) =>
  [`/workspace/module/${id}/playbook`] as const;

export const getGetModulePlaybookQueryOptions = <
  TData = Awaited<ReturnType<typeof getModulePlaybook>>,
  TError = ModulePlaybookResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulePlaybook>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModulePlaybookQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModulePlaybook>>> = ({ signal }) =>
    getModulePlaybook(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModulePlaybook>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModulePlaybookQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModulePlaybook>>
>;
export type GetModulePlaybookQueryError = ModulePlaybookResponse;

export function useGetModulePlaybook<
  TData = Awaited<ReturnType<typeof getModulePlaybook>>,
  TError = ModulePlaybookResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulePlaybook>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModulePlaybook>>,
          TError,
          Awaited<ReturnType<typeof getModulePlaybook>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulePlaybook<
  TData = Awaited<ReturnType<typeof getModulePlaybook>>,
  TError = ModulePlaybookResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulePlaybook>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModulePlaybook>>,
          TError,
          Awaited<ReturnType<typeof getModulePlaybook>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulePlaybook<
  TData = Awaited<ReturnType<typeof getModulePlaybook>>,
  TError = ModulePlaybookResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulePlaybook>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module playbook
 */

export function useGetModulePlaybook<
  TData = Awaited<ReturnType<typeof getModulePlaybook>>,
  TError = ModulePlaybookResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulePlaybook>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModulePlaybookQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Module playbook
 */
export const createModulePlaybookLevel = (
  id: string,
  createModulePlaybookRequest: CreateModulePlaybookRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModulePlaybookResponse>(
    {
      url: `/workspace/module/${id}/playbook`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createModulePlaybookRequest,
      signal
    },
    options
  );

export const getCreateModulePlaybookLevelMutationOptions = <
  TError = ModulePlaybookResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePlaybookLevel>>,
    TError,
    { id: string; data: CreateModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModulePlaybookLevel>>,
  TError,
  { id: string; data: CreateModulePlaybookRequest },
  TContext
> => {
  const mutationKey = ['createModulePlaybookLevel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModulePlaybookLevel>>,
    { id: string; data: CreateModulePlaybookRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createModulePlaybookLevel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModulePlaybookLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModulePlaybookLevel>>
>;
export type CreateModulePlaybookLevelMutationBody = CreateModulePlaybookRequest;
export type CreateModulePlaybookLevelMutationError = ModulePlaybookResponse;

/**
 * @summary Create Module playbook
 */
export const useCreateModulePlaybookLevel = <
  TError = ModulePlaybookResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePlaybookLevel>>,
    TError,
    { id: string; data: CreateModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModulePlaybookLevel>>,
  TError,
  { id: string; data: CreateModulePlaybookRequest },
  TContext
> => {
  const mutationOptions = getCreateModulePlaybookLevelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create Module playbook step
 */
export const createModulePlaybookStep = (
  id: string,
  createModulePlaybookRequest: CreateModulePlaybookRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModulePlaybookDto>(
    {
      url: `/workspace/module/${id}/playbook/step`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createModulePlaybookRequest,
      signal
    },
    options
  );

export const getCreateModulePlaybookStepMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePlaybookStep>>,
    TError,
    { id: string; data: CreateModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModulePlaybookStep>>,
  TError,
  { id: string; data: CreateModulePlaybookRequest },
  TContext
> => {
  const mutationKey = ['createModulePlaybookStep'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModulePlaybookStep>>,
    { id: string; data: CreateModulePlaybookRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createModulePlaybookStep(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModulePlaybookStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModulePlaybookStep>>
>;
export type CreateModulePlaybookStepMutationBody = CreateModulePlaybookRequest;
export type CreateModulePlaybookStepMutationError = unknown;

/**
 * @summary Create Module playbook step
 */
export const useCreateModulePlaybookStep = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePlaybookStep>>,
    TError,
    { id: string; data: CreateModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModulePlaybookStep>>,
  TError,
  { id: string; data: CreateModulePlaybookRequest },
  TContext
> => {
  const mutationOptions = getCreateModulePlaybookStepMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Module prioritization
 */
export const listModulesPrioritization = (
  params: ListModulesPrioritizationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModulePrioritizationResponse>(
    { url: `/workspace/module/prioritization`, method: 'GET', params, signal },
    options
  );

export const getListModulesPrioritizationQueryKey = (params: ListModulesPrioritizationParams) =>
  [`/workspace/module/prioritization`, ...(params ? [params] : [])] as const;

export const getListModulesPrioritizationQueryOptions = <
  TData = Awaited<ReturnType<typeof listModulesPrioritization>>,
  TError = ModulePrioritizationResponse
>(
  params: ListModulesPrioritizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesPrioritization>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModulesPrioritizationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModulesPrioritization>>> = ({
    signal
  }) => listModulesPrioritization(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModulesPrioritization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModulesPrioritizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModulesPrioritization>>
>;
export type ListModulesPrioritizationQueryError = ModulePrioritizationResponse;

export function useListModulesPrioritization<
  TData = Awaited<ReturnType<typeof listModulesPrioritization>>,
  TError = ModulePrioritizationResponse
>(
  params: ListModulesPrioritizationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesPrioritization>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesPrioritization>>,
          TError,
          Awaited<ReturnType<typeof listModulesPrioritization>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModulesPrioritization<
  TData = Awaited<ReturnType<typeof listModulesPrioritization>>,
  TError = ModulePrioritizationResponse
>(
  params: ListModulesPrioritizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesPrioritization>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesPrioritization>>,
          TError,
          Awaited<ReturnType<typeof listModulesPrioritization>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModulesPrioritization<
  TData = Awaited<ReturnType<typeof listModulesPrioritization>>,
  TError = ModulePrioritizationResponse
>(
  params: ListModulesPrioritizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesPrioritization>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Module prioritization
 */

export function useListModulesPrioritization<
  TData = Awaited<ReturnType<typeof listModulesPrioritization>>,
  TError = ModulePrioritizationResponse
>(
  params: ListModulesPrioritizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesPrioritization>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListModulesPrioritizationQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Module prioritization
 */
export const createModulePrioritization = (
  modulePrioritizationDto: ModulePrioritizationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModulePrioritizationResponse>(
    {
      url: `/workspace/module/prioritization`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: modulePrioritizationDto,
      signal
    },
    options
  );

export const getCreateModulePrioritizationMutationOptions = <
  TError = ModulePrioritizationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePrioritization>>,
    TError,
    { data: ModulePrioritizationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModulePrioritization>>,
  TError,
  { data: ModulePrioritizationDto },
  TContext
> => {
  const mutationKey = ['createModulePrioritization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModulePrioritization>>,
    { data: ModulePrioritizationDto }
  > = props => {
    const { data } = props ?? {};

    return createModulePrioritization(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModulePrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModulePrioritization>>
>;
export type CreateModulePrioritizationMutationBody = ModulePrioritizationDto;
export type CreateModulePrioritizationMutationError = ModulePrioritizationResponse;

/**
 * @summary Create Module prioritization
 */
export const useCreateModulePrioritization = <
  TError = ModulePrioritizationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModulePrioritization>>,
    TError,
    { data: ModulePrioritizationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModulePrioritization>>,
  TError,
  { data: ModulePrioritizationDto },
  TContext
> => {
  const mutationOptions = getCreateModulePrioritizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Modules metadata
 */
export const getModulesMetadata = (
  params?: GetModulesMetadataParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleMetadataResponse>(
    { url: `/workspace/module/metadata`, method: 'GET', params, signal },
    options
  );

export const getGetModulesMetadataQueryKey = (params?: GetModulesMetadataParams) =>
  [`/workspace/module/metadata`, ...(params ? [params] : [])] as const;

export const getGetModulesMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof getModulesMetadata>>,
  TError = ModuleMetadataResponse
>(
  params?: GetModulesMetadataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesMetadata>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModulesMetadataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModulesMetadata>>> = ({ signal }) =>
    getModulesMetadata(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModulesMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModulesMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModulesMetadata>>
>;
export type GetModulesMetadataQueryError = ModuleMetadataResponse;

export function useGetModulesMetadata<
  TData = Awaited<ReturnType<typeof getModulesMetadata>>,
  TError = ModuleMetadataResponse
>(
  params: undefined | GetModulesMetadataParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesMetadata>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModulesMetadata>>,
          TError,
          Awaited<ReturnType<typeof getModulesMetadata>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulesMetadata<
  TData = Awaited<ReturnType<typeof getModulesMetadata>>,
  TError = ModuleMetadataResponse
>(
  params?: GetModulesMetadataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModulesMetadata>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModulesMetadata>>,
          TError,
          Awaited<ReturnType<typeof getModulesMetadata>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulesMetadata<
  TData = Awaited<ReturnType<typeof getModulesMetadata>>,
  TError = ModuleMetadataResponse
>(
  params?: GetModulesMetadataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesMetadata>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Modules metadata
 */

export function useGetModulesMetadata<
  TData = Awaited<ReturnType<typeof getModulesMetadata>>,
  TError = ModuleMetadataResponse
>(
  params?: GetModulesMetadataParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesMetadata>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModulesMetadataQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create custom module
 */
export const createCustomModule = (
  customModuleRequest: CustomModuleRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleMetadataResponse>(
    {
      url: `/workspace/module/metadata`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: customModuleRequest,
      signal
    },
    options
  );

export const getCreateCustomModuleMutationOptions = <
  TError = ModuleMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomModule>>,
    TError,
    { data: CustomModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomModule>>,
  TError,
  { data: CustomModuleRequest },
  TContext
> => {
  const mutationKey = ['createCustomModule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomModule>>,
    { data: CustomModuleRequest }
  > = props => {
    const { data } = props ?? {};

    return createCustomModule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomModuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomModule>>
>;
export type CreateCustomModuleMutationBody = CustomModuleRequest;
export type CreateCustomModuleMutationError = ModuleMetadataResponse;

/**
 * @summary Create custom module
 */
export const useCreateCustomModule = <
  TError = ModuleMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomModule>>,
    TError,
    { data: CustomModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomModule>>,
  TError,
  { data: CustomModuleRequest },
  TContext
> => {
  const mutationOptions = getCreateCustomModuleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Module ideas
 */
export const listModuleIdeas = (
  params?: ListModuleIdeasParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleIdeaResponse>(
    { url: `/workspace/module/idea`, method: 'GET', params, signal },
    options
  );

export const getListModuleIdeasQueryKey = (params?: ListModuleIdeasParams) =>
  [`/workspace/module/idea`, ...(params ? [params] : [])] as const;

export const getListModuleIdeasQueryOptions = <
  TData = Awaited<ReturnType<typeof listModuleIdeas>>,
  TError = ModuleIdeaResponse
>(
  params?: ListModuleIdeasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleIdeas>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModuleIdeasQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModuleIdeas>>> = ({ signal }) =>
    listModuleIdeas(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModuleIdeas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModuleIdeasQueryResult = NonNullable<Awaited<ReturnType<typeof listModuleIdeas>>>;
export type ListModuleIdeasQueryError = ModuleIdeaResponse;

export function useListModuleIdeas<
  TData = Awaited<ReturnType<typeof listModuleIdeas>>,
  TError = ModuleIdeaResponse
>(
  params: undefined | ListModuleIdeasParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleIdeas>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModuleIdeas>>,
          TError,
          Awaited<ReturnType<typeof listModuleIdeas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModuleIdeas<
  TData = Awaited<ReturnType<typeof listModuleIdeas>>,
  TError = ModuleIdeaResponse
>(
  params?: ListModuleIdeasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleIdeas>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModuleIdeas>>,
          TError,
          Awaited<ReturnType<typeof listModuleIdeas>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModuleIdeas<
  TData = Awaited<ReturnType<typeof listModuleIdeas>>,
  TError = ModuleIdeaResponse
>(
  params?: ListModuleIdeasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleIdeas>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Module ideas
 */

export function useListModuleIdeas<
  TData = Awaited<ReturnType<typeof listModuleIdeas>>,
  TError = ModuleIdeaResponse
>(
  params?: ListModuleIdeasParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleIdeas>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListModuleIdeasQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Module idea
 */
export const createModuleIdea = (
  moduleIdeaDto: ModuleIdeaDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleIdeaResponse>(
    {
      url: `/workspace/module/idea`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: moduleIdeaDto,
      signal
    },
    options
  );

export const getCreateModuleIdeaMutationOptions = <
  TError = ModuleIdeaResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModuleIdea>>,
    TError,
    { data: ModuleIdeaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModuleIdea>>,
  TError,
  { data: ModuleIdeaDto },
  TContext
> => {
  const mutationKey = ['createModuleIdea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModuleIdea>>,
    { data: ModuleIdeaDto }
  > = props => {
    const { data } = props ?? {};

    return createModuleIdea(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModuleIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createModuleIdea>>
>;
export type CreateModuleIdeaMutationBody = ModuleIdeaDto;
export type CreateModuleIdeaMutationError = ModuleIdeaResponse;

/**
 * @summary Create Module idea
 */
export const useCreateModuleIdea = <TError = ModuleIdeaResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModuleIdea>>,
    TError,
    { data: ModuleIdeaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createModuleIdea>>,
  TError,
  { data: ModuleIdeaDto },
  TContext
> => {
  const mutationOptions = getCreateModuleIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Upload file url
 */
export const generateUploadFileUrl = (
  uploadFileRequest: UploadFileRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<FileUploadResponse>(
    {
      url: `/workspace/file`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadFileRequest,
      signal
    },
    options
  );

export const getGenerateUploadFileUrlMutationOptions = <
  TError = FileUploadResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadFileUrl>>,
    TError,
    { data: UploadFileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadFileUrl>>,
  TError,
  { data: UploadFileRequest },
  TContext
> => {
  const mutationKey = ['generateUploadFileUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadFileUrl>>,
    { data: UploadFileRequest }
  > = props => {
    const { data } = props ?? {};

    return generateUploadFileUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadFileUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUploadFileUrl>>
>;
export type GenerateUploadFileUrlMutationBody = UploadFileRequest;
export type GenerateUploadFileUrlMutationError = FileUploadResponse;

/**
 * @summary Generate Upload file url
 */
export const useGenerateUploadFileUrl = <
  TError = FileUploadResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadFileUrl>>,
    TError,
    { data: UploadFileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadFileUrl>>,
  TError,
  { data: UploadFileRequest },
  TContext
> => {
  const mutationOptions = getGenerateUploadFileUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Upload url
 */
export const generateUploadUrl = (
  name: string,
  params: GenerateUploadUrlParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<FileUploadResponse>(
    { url: `/workspace/file/${name}`, method: 'POST', params, signal },
    options
  );

export const getGenerateUploadUrlMutationOptions = <
  TError = FileUploadResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    TError,
    { name: string; params: GenerateUploadUrlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  { name: string; params: GenerateUploadUrlParams },
  TContext
> => {
  const mutationKey = ['generateUploadUrl'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    { name: string; params: GenerateUploadUrlParams }
  > = props => {
    const { name, params } = props ?? {};

    return generateUploadUrl(name, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateUploadUrl>>
>;

export type GenerateUploadUrlMutationError = FileUploadResponse;

/**
 * @summary Generate Upload url
 */
export const useGenerateUploadUrl = <TError = FileUploadResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrl>>,
    TError,
    { name: string; params: GenerateUploadUrlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadUrl>>,
  TError,
  { name: string; params: GenerateUploadUrlParams },
  TContext
> => {
  const mutationOptions = getGenerateUploadUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete file
 */
export const deleteFile = (
  name: string,
  params: DeleteFileParams,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/workspace/file/${name}`, method: 'DELETE', params }, options);

export const getDeleteFileMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { name: string; params: DeleteFileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { name: string; params: DeleteFileParams },
  TContext
> => {
  const mutationKey = ['deleteFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    { name: string; params: DeleteFileParams }
  > = props => {
    const { name, params } = props ?? {};

    return deleteFile(name, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFile>>>;

export type DeleteFileMutationError = unknown;

/**
 * @summary Delete file
 */
export const useDeleteFile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { name: string; params: DeleteFileParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { name: string; params: DeleteFileParams },
  TContext
> => {
  const mutationOptions = getDeleteFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List business Areas metadata
 */
export const listBusinessAreaMetadata = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<BusinessAreaMetadataResponse>(
    { url: `/workspace/businessArea/metadata`, method: 'GET', signal },
    options
  );

export const getListBusinessAreaMetadataQueryKey = () =>
  [`/workspace/businessArea/metadata`] as const;

export const getListBusinessAreaMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
  TError = BusinessAreaMetadataResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaMetadata>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBusinessAreaMetadataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBusinessAreaMetadata>>> = ({
    signal
  }) => listBusinessAreaMetadata(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBusinessAreaMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBusinessAreaMetadata>>
>;
export type ListBusinessAreaMetadataQueryError = BusinessAreaMetadataResponse;

export function useListBusinessAreaMetadata<
  TData = Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
  TError = BusinessAreaMetadataResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaMetadata>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
        TError,
        Awaited<ReturnType<typeof listBusinessAreaMetadata>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBusinessAreaMetadata<
  TData = Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
  TError = BusinessAreaMetadataResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaMetadata>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
        TError,
        Awaited<ReturnType<typeof listBusinessAreaMetadata>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBusinessAreaMetadata<
  TData = Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
  TError = BusinessAreaMetadataResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaMetadata>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List business Areas metadata
 */

export function useListBusinessAreaMetadata<
  TData = Awaited<ReturnType<typeof listBusinessAreaMetadata>>,
  TError = BusinessAreaMetadataResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaMetadata>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBusinessAreaMetadataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create custom Business Area
 */
export const createCustomBusinessArea = (
  customBusinessAreaRequest: CustomBusinessAreaRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<BusinessAreaMetadataResponse>(
    {
      url: `/workspace/businessArea/metadata`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: customBusinessAreaRequest,
      signal
    },
    options
  );

export const getCreateCustomBusinessAreaMutationOptions = <
  TError = BusinessAreaMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomBusinessArea>>,
    TError,
    { data: CustomBusinessAreaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomBusinessArea>>,
  TError,
  { data: CustomBusinessAreaRequest },
  TContext
> => {
  const mutationKey = ['createCustomBusinessArea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomBusinessArea>>,
    { data: CustomBusinessAreaRequest }
  > = props => {
    const { data } = props ?? {};

    return createCustomBusinessArea(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomBusinessAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomBusinessArea>>
>;
export type CreateCustomBusinessAreaMutationBody = CustomBusinessAreaRequest;
export type CreateCustomBusinessAreaMutationError = BusinessAreaMetadataResponse;

/**
 * @summary Create custom Business Area
 */
export const useCreateCustomBusinessArea = <
  TError = BusinessAreaMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomBusinessArea>>,
    TError,
    { data: CustomBusinessAreaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomBusinessArea>>,
  TError,
  { data: CustomBusinessAreaRequest },
  TContext
> => {
  const mutationOptions = getCreateCustomBusinessAreaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Workflows
 */
export const listWorkflows = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<WorkflowResponse>({ url: `/workflow`, method: 'GET', signal }, options);

export const getListWorkflowsQueryKey = () => [`/workflow`] as const;

export const getListWorkflowsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkflows>>,
  TError = WorkflowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWorkflowsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkflows>>> = ({ signal }) =>
    listWorkflows(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkflows>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkflows>>>;
export type ListWorkflowsQueryError = WorkflowResponse;

export function useListWorkflows<
  TData = Awaited<ReturnType<typeof listWorkflows>>,
  TError = WorkflowResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listWorkflows>>,
        TError,
        Awaited<ReturnType<typeof listWorkflows>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkflows<
  TData = Awaited<ReturnType<typeof listWorkflows>>,
  TError = WorkflowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listWorkflows>>,
        TError,
        Awaited<ReturnType<typeof listWorkflows>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkflows<
  TData = Awaited<ReturnType<typeof listWorkflows>>,
  TError = WorkflowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workflows
 */

export function useListWorkflows<
  TData = Awaited<ReturnType<typeof listWorkflows>>,
  TError = WorkflowResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkflows>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListWorkflowsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Workflow
 */
export const createWorkflow = (
  workflowCreateRequest: WorkflowCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<WorkflowResponse>(
    {
      url: `/workflow`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: workflowCreateRequest,
      signal
    },
    options
  );

export const getCreateWorkflowMutationOptions = <
  TError = WorkflowResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkflow>>,
    TError,
    { data: WorkflowCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkflow>>,
  TError,
  { data: WorkflowCreateRequest },
  TContext
> => {
  const mutationKey = ['createWorkflow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkflow>>,
    { data: WorkflowCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return createWorkflow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkflow>>>;
export type CreateWorkflowMutationBody = WorkflowCreateRequest;
export type CreateWorkflowMutationError = WorkflowResponse;

/**
 * @summary Create Workflow
 */
export const useCreateWorkflow = <TError = WorkflowResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkflow>>,
    TError,
    { data: WorkflowCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWorkflow>>,
  TError,
  { data: WorkflowCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateWorkflowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Test Workflow
 */
export const testWorkflow = (
  workflowTriggerEventDto: WorkflowTriggerEventDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<WorkflowTestResultDto>(
    {
      url: `/workflow/test`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: workflowTriggerEventDto,
      signal
    },
    options
  );

export const getTestWorkflowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWorkflow>>,
    TError,
    { data: WorkflowTriggerEventDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testWorkflow>>,
  TError,
  { data: WorkflowTriggerEventDto },
  TContext
> => {
  const mutationKey = ['testWorkflow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testWorkflow>>,
    { data: WorkflowTriggerEventDto }
  > = props => {
    const { data } = props ?? {};

    return testWorkflow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestWorkflowMutationResult = NonNullable<Awaited<ReturnType<typeof testWorkflow>>>;
export type TestWorkflowMutationBody = WorkflowTriggerEventDto;
export type TestWorkflowMutationError = unknown;

/**
 * @summary Test Workflow
 */
export const useTestWorkflow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testWorkflow>>,
    TError,
    { data: WorkflowTriggerEventDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testWorkflow>>,
  TError,
  { data: WorkflowTriggerEventDto },
  TContext
> => {
  const mutationOptions = getTestWorkflowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Tasks
 */
export const listTasks = (
  params?: ListTasksParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<TaskResponse>({ url: `/workbench/task`, method: 'GET', params, signal }, options);

export const getListTasksQueryKey = (params?: ListTasksParams) =>
  [`/workbench/task`, ...(params ? [params] : [])] as const;

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = TaskResponse
>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({ signal }) =>
    listTasks(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listTasks>>>;
export type ListTasksQueryError = TaskResponse;

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = TaskResponse>(
  params: undefined | ListTasksParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = TaskResponse>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTasks>>,
          TError,
          Awaited<ReturnType<typeof listTasks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = TaskResponse>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Tasks
 */

export function useListTasks<TData = Awaited<ReturnType<typeof listTasks>>, TError = TaskResponse>(
  params?: ListTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTasks>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Task
 */
export const createTask = (
  taskDto: TaskDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<TaskResponse>(
    {
      url: `/workbench/task`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: taskDto,
      signal
    },
    options
  );

export const getCreateTaskMutationOptions = <TError = TaskResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: TaskDto },
  TContext
> => {
  const mutationKey = ['createTask'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: TaskDto }
  > = props => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>;
export type CreateTaskMutationBody = TaskDto;
export type CreateTaskMutationError = TaskResponse;

/**
 * @summary Create Task
 */
export const useCreateTask = <TError = TaskResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: TaskDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: TaskDto },
  TContext
> => {
  const mutationOptions = getCreateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Strategic Plans
 */
export const listStrategicPlans = (
  params?: ListStrategicPlansParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<StrategicPlanResponse>(
    { url: `/workbench/strategy/plan`, method: 'GET', params, signal },
    options
  );

export const getListStrategicPlansQueryKey = (params?: ListStrategicPlansParams) =>
  [`/workbench/strategy/plan`, ...(params ? [params] : [])] as const;

export const getListStrategicPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listStrategicPlans>>,
  TError = StrategicPlanResponse
>(
  params?: ListStrategicPlansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStrategicPlans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStrategicPlansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStrategicPlans>>> = ({ signal }) =>
    listStrategicPlans(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStrategicPlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListStrategicPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStrategicPlans>>
>;
export type ListStrategicPlansQueryError = StrategicPlanResponse;

export function useListStrategicPlans<
  TData = Awaited<ReturnType<typeof listStrategicPlans>>,
  TError = StrategicPlanResponse
>(
  params: undefined | ListStrategicPlansParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStrategicPlans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStrategicPlans>>,
          TError,
          Awaited<ReturnType<typeof listStrategicPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListStrategicPlans<
  TData = Awaited<ReturnType<typeof listStrategicPlans>>,
  TError = StrategicPlanResponse
>(
  params?: ListStrategicPlansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listStrategicPlans>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStrategicPlans>>,
          TError,
          Awaited<ReturnType<typeof listStrategicPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListStrategicPlans<
  TData = Awaited<ReturnType<typeof listStrategicPlans>>,
  TError = StrategicPlanResponse
>(
  params?: ListStrategicPlansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStrategicPlans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Strategic Plans
 */

export function useListStrategicPlans<
  TData = Awaited<ReturnType<typeof listStrategicPlans>>,
  TError = StrategicPlanResponse
>(
  params?: ListStrategicPlansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listStrategicPlans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListStrategicPlansQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Strategic Plan
 */
export const createStrategicPlan = (
  strategicPlanDto: StrategicPlanDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<StrategicPlanResponse>(
    {
      url: `/workbench/strategy/plan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: strategicPlanDto,
      signal
    },
    options
  );

export const getCreateStrategicPlanMutationOptions = <
  TError = StrategicPlanResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStrategicPlan>>,
    TError,
    { data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStrategicPlan>>,
  TError,
  { data: StrategicPlanDto },
  TContext
> => {
  const mutationKey = ['createStrategicPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStrategicPlan>>,
    { data: StrategicPlanDto }
  > = props => {
    const { data } = props ?? {};

    return createStrategicPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStrategicPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStrategicPlan>>
>;
export type CreateStrategicPlanMutationBody = StrategicPlanDto;
export type CreateStrategicPlanMutationError = StrategicPlanResponse;

/**
 * @summary Create Strategic Plan
 */
export const useCreateStrategicPlan = <
  TError = StrategicPlanResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStrategicPlan>>,
    TError,
    { data: StrategicPlanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStrategicPlan>>,
  TError,
  { data: StrategicPlanDto },
  TContext
> => {
  const mutationOptions = getCreateStrategicPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Shared Meeting
 */
export const getSharedMeeting = (
  params?: GetSharedMeetingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedMeetingResponse>(
    { url: `/workbench/sharedMeeting`, method: 'GET', params, signal },
    options
  );

export const getGetSharedMeetingQueryKey = (params?: GetSharedMeetingParams) =>
  [`/workbench/sharedMeeting`, ...(params ? [params] : [])] as const;

export const getGetSharedMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedMeeting>>,
  TError = SharedMeetingResponse
>(
  params?: GetSharedMeetingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedMeetingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedMeeting>>> = ({ signal }) =>
    getSharedMeeting(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedMeetingQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedMeeting>>>;
export type GetSharedMeetingQueryError = SharedMeetingResponse;

export function useGetSharedMeeting<
  TData = Awaited<ReturnType<typeof getSharedMeeting>>,
  TError = SharedMeetingResponse
>(
  params: undefined | GetSharedMeetingParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedMeeting>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedMeeting<
  TData = Awaited<ReturnType<typeof getSharedMeeting>>,
  TError = SharedMeetingResponse
>(
  params?: GetSharedMeetingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedMeeting>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedMeeting<
  TData = Awaited<ReturnType<typeof getSharedMeeting>>,
  TError = SharedMeetingResponse
>(
  params?: GetSharedMeetingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Shared Meeting
 */

export function useGetSharedMeeting<
  TData = Awaited<ReturnType<typeof getSharedMeeting>>,
  TError = SharedMeetingResponse
>(
  params?: GetSharedMeetingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedMeetingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Shared Meeting
 */
export const createSharedMeeting = (
  sharedMeetingDto: SharedMeetingDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedMeetingResponse>(
    {
      url: `/workbench/sharedMeeting`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sharedMeetingDto,
      signal
    },
    options
  );

export const getCreateSharedMeetingMutationOptions = <
  TError = SharedMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedMeeting>>,
    TError,
    { data: SharedMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSharedMeeting>>,
  TError,
  { data: SharedMeetingDto },
  TContext
> => {
  const mutationKey = ['createSharedMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSharedMeeting>>,
    { data: SharedMeetingDto }
  > = props => {
    const { data } = props ?? {};

    return createSharedMeeting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSharedMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSharedMeeting>>
>;
export type CreateSharedMeetingMutationBody = SharedMeetingDto;
export type CreateSharedMeetingMutationError = SharedMeetingResponse;

/**
 * @summary Create Shared Meeting
 */
export const useCreateSharedMeeting = <
  TError = SharedMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSharedMeeting>>,
    TError,
    { data: SharedMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSharedMeeting>>,
  TError,
  { data: SharedMeetingDto },
  TContext
> => {
  const mutationOptions = getCreateSharedMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Quick Actions
 */
export const listQuickActions = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<QuickActionResponse>(
    { url: `/workbench/quickAction`, method: 'GET', signal },
    options
  );

export const getListQuickActionsQueryKey = () => [`/workbench/quickAction`] as const;

export const getListQuickActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listQuickActions>>,
  TError = QuickActionResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuickActions>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListQuickActionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuickActions>>> = ({ signal }) =>
    listQuickActions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listQuickActions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListQuickActionsQueryResult = NonNullable<Awaited<ReturnType<typeof listQuickActions>>>;
export type ListQuickActionsQueryError = QuickActionResponse;

export function useListQuickActions<
  TData = Awaited<ReturnType<typeof listQuickActions>>,
  TError = QuickActionResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuickActions>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listQuickActions>>,
        TError,
        Awaited<ReturnType<typeof listQuickActions>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListQuickActions<
  TData = Awaited<ReturnType<typeof listQuickActions>>,
  TError = QuickActionResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuickActions>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listQuickActions>>,
        TError,
        Awaited<ReturnType<typeof listQuickActions>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListQuickActions<
  TData = Awaited<ReturnType<typeof listQuickActions>>,
  TError = QuickActionResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuickActions>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Quick Actions
 */

export function useListQuickActions<
  TData = Awaited<ReturnType<typeof listQuickActions>>,
  TError = QuickActionResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuickActions>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListQuickActionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Quick Action
 */
export const createQuickAction = (
  quickActionDto: QuickActionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<QuickActionResponse>(
    {
      url: `/workbench/quickAction`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quickActionDto,
      signal
    },
    options
  );

export const getCreateQuickActionMutationOptions = <
  TError = QuickActionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuickAction>>,
    TError,
    { data: QuickActionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuickAction>>,
  TError,
  { data: QuickActionDto },
  TContext
> => {
  const mutationKey = ['createQuickAction'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuickAction>>,
    { data: QuickActionDto }
  > = props => {
    const { data } = props ?? {};

    return createQuickAction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuickActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuickAction>>
>;
export type CreateQuickActionMutationBody = QuickActionDto;
export type CreateQuickActionMutationError = QuickActionResponse;

/**
 * @summary Create Quick Action
 */
export const useCreateQuickAction = <TError = QuickActionResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuickAction>>,
    TError,
    { data: QuickActionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuickAction>>,
  TError,
  { data: QuickActionDto },
  TContext
> => {
  const mutationOptions = getCreateQuickActionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List Meetings Templates
 */
export const listMeetingsTemplates = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingTemplateResponse>(
    { url: `/workbench/meetingTemplate`, method: 'GET', signal },
    options
  );

export const getListMeetingsTemplatesQueryKey = () => [`/workbench/meetingTemplate`] as const;

export const getListMeetingsTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingsTemplates>>,
  TError = MeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingsTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingsTemplates>>> = ({ signal }) =>
    listMeetingsTemplates(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingsTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingsTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMeetingsTemplates>>
>;
export type ListMeetingsTemplatesQueryError = MeetingTemplateResponse;

export function useListMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listMeetingsTemplates>>,
  TError = MeetingTemplateResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingsTemplates>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingsTemplates>>,
        TError,
        Awaited<ReturnType<typeof listMeetingsTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listMeetingsTemplates>>,
  TError = MeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingsTemplates>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetingsTemplates>>,
        TError,
        Awaited<ReturnType<typeof listMeetingsTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listMeetingsTemplates>>,
  TError = MeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Meetings Templates
 */

export function useListMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listMeetingsTemplates>>,
  TError = MeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingsTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Meeting Template
 */
export const createMeetingTemplate = (
  meetingTemplateDto: MeetingTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingTemplateResponse>(
    {
      url: `/workbench/meetingTemplate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingTemplateDto,
      signal
    },
    options
  );

export const getCreateMeetingTemplateMutationOptions = <
  TError = MeetingTemplateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingTemplate>>,
    TError,
    { data: MeetingTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingTemplate>>,
  TError,
  { data: MeetingTemplateDto },
  TContext
> => {
  const mutationKey = ['createMeetingTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingTemplate>>,
    { data: MeetingTemplateDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingTemplate>>
>;
export type CreateMeetingTemplateMutationBody = MeetingTemplateDto;
export type CreateMeetingTemplateMutationError = MeetingTemplateResponse;

/**
 * @summary Create Meeting Template
 */
export const useCreateMeetingTemplate = <
  TError = MeetingTemplateResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingTemplate>>,
    TError,
    { data: MeetingTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingTemplate>>,
  TError,
  { data: MeetingTemplateDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List goals
 */
export const listGoals = (
  params?: ListGoalsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoalResponse>({ url: `/workbench/goal`, method: 'GET', params, signal }, options);

export const getListGoalsQueryKey = (params?: ListGoalsParams) =>
  [`/workbench/goal`, ...(params ? [params] : [])] as const;

export const getListGoalsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGoals>>,
  TError = GoalResponse
>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGoalsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGoals>>> = ({ signal }) =>
    listGoals(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGoals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof listGoals>>>;
export type ListGoalsQueryError = GoalResponse;

export function useListGoals<TData = Awaited<ReturnType<typeof listGoals>>, TError = GoalResponse>(
  params: undefined | ListGoalsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoals>>,
          TError,
          Awaited<ReturnType<typeof listGoals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoals<TData = Awaited<ReturnType<typeof listGoals>>, TError = GoalResponse>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listGoals>>,
          TError,
          Awaited<ReturnType<typeof listGoals>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListGoals<TData = Awaited<ReturnType<typeof listGoals>>, TError = GoalResponse>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List goals
 */

export function useListGoals<TData = Awaited<ReturnType<typeof listGoals>>, TError = GoalResponse>(
  params?: ListGoalsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listGoals>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListGoalsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Goal
 */
export const createGoal = (
  goalDto: GoalDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoalResponse>(
    {
      url: `/workbench/goal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: goalDto,
      signal
    },
    options
  );

export const getCreateGoalMutationOptions = <TError = GoalResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoal>>,
    TError,
    { data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoal>>,
  TError,
  { data: GoalDto },
  TContext
> => {
  const mutationKey = ['createGoal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoal>>,
    { data: GoalDto }
  > = props => {
    const { data } = props ?? {};

    return createGoal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createGoal>>>;
export type CreateGoalMutationBody = GoalDto;
export type CreateGoalMutationError = GoalResponse;

/**
 * @summary Create Goal
 */
export const useCreateGoal = <TError = GoalResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoal>>,
    TError,
    { data: GoalDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoal>>,
  TError,
  { data: GoalDto },
  TContext
> => {
  const mutationOptions = getCreateGoalMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Task Delegate Message
 */
export const generateDelegateMessage = (
  delegateRequestDto: DelegateRequestDto,
  params: GenerateDelegateMessageParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DelegateMessageResponse>(
    {
      url: `/workbench/delegate/message`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: delegateRequestDto,
      params,
      signal
    },
    options
  );

export const getGenerateDelegateMessageMutationOptions = <
  TError = DelegateMessageResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDelegateMessage>>,
    TError,
    { data: DelegateRequestDto; params: GenerateDelegateMessageParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDelegateMessage>>,
  TError,
  { data: DelegateRequestDto; params: GenerateDelegateMessageParams },
  TContext
> => {
  const mutationKey = ['generateDelegateMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDelegateMessage>>,
    { data: DelegateRequestDto; params: GenerateDelegateMessageParams }
  > = props => {
    const { data, params } = props ?? {};

    return generateDelegateMessage(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDelegateMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDelegateMessage>>
>;
export type GenerateDelegateMessageMutationBody = DelegateRequestDto;
export type GenerateDelegateMessageMutationError = DelegateMessageResponse;

/**
 * @summary Generate Task Delegate Message
 */
export const useGenerateDelegateMessage = <
  TError = DelegateMessageResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDelegateMessage>>,
    TError,
    { data: DelegateRequestDto; params: GenerateDelegateMessageParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateDelegateMessage>>,
  TError,
  { data: DelegateRequestDto; params: GenerateDelegateMessageParams },
  TContext
> => {
  const mutationOptions = getGenerateDelegateMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Task Delegate Follow Up Message
 */
export const generateDelegateFollowUpMessage = (
  delegateFollowUpRequestDto: DelegateFollowUpRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DelegateFollowUpResponse>(
    {
      url: `/workbench/delegate/followUp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: delegateFollowUpRequestDto,
      signal
    },
    options
  );

export const getGenerateDelegateFollowUpMessageMutationOptions = <
  TError = DelegateFollowUpResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>,
    TError,
    { data: DelegateFollowUpRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>,
  TError,
  { data: DelegateFollowUpRequestDto },
  TContext
> => {
  const mutationKey = ['generateDelegateFollowUpMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>,
    { data: DelegateFollowUpRequestDto }
  > = props => {
    const { data } = props ?? {};

    return generateDelegateFollowUpMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateDelegateFollowUpMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>
>;
export type GenerateDelegateFollowUpMessageMutationBody = DelegateFollowUpRequestDto;
export type GenerateDelegateFollowUpMessageMutationError = DelegateFollowUpResponse;

/**
 * @summary Generate Task Delegate Follow Up Message
 */
export const useGenerateDelegateFollowUpMessage = <
  TError = DelegateFollowUpResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>,
    TError,
    { data: DelegateFollowUpRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateDelegateFollowUpMessage>>,
  TError,
  { data: DelegateFollowUpRequestDto },
  TContext
> => {
  const mutationOptions = getGenerateDelegateFollowUpMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List checklists
 */
export const listChecklists = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ChecklistResponse>(
    { url: `/workbench/checklist`, method: 'GET', signal },
    options
  );

export const getListChecklistsQueryKey = () => [`/workbench/checklist`] as const;

export const getListChecklistsQueryOptions = <
  TData = Awaited<ReturnType<typeof listChecklists>>,
  TError = ChecklistResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChecklists>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListChecklistsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChecklists>>> = ({ signal }) =>
    listChecklists(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChecklists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListChecklistsQueryResult = NonNullable<Awaited<ReturnType<typeof listChecklists>>>;
export type ListChecklistsQueryError = ChecklistResponse;

export function useListChecklists<
  TData = Awaited<ReturnType<typeof listChecklists>>,
  TError = ChecklistResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChecklists>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listChecklists>>,
        TError,
        Awaited<ReturnType<typeof listChecklists>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListChecklists<
  TData = Awaited<ReturnType<typeof listChecklists>>,
  TError = ChecklistResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChecklists>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listChecklists>>,
        TError,
        Awaited<ReturnType<typeof listChecklists>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListChecklists<
  TData = Awaited<ReturnType<typeof listChecklists>>,
  TError = ChecklistResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChecklists>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List checklists
 */

export function useListChecklists<
  TData = Awaited<ReturnType<typeof listChecklists>>,
  TError = ChecklistResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listChecklists>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListChecklistsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Checklist
 */
export const createChecklist = (
  checklistDto: ChecklistDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ChecklistResponse>(
    {
      url: `/workbench/checklist`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: checklistDto,
      signal
    },
    options
  );

export const getCreateChecklistMutationOptions = <
  TError = ChecklistResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChecklist>>,
    TError,
    { data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChecklist>>,
  TError,
  { data: ChecklistDto },
  TContext
> => {
  const mutationKey = ['createChecklist'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChecklist>>,
    { data: ChecklistDto }
  > = props => {
    const { data } = props ?? {};

    return createChecklist(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChecklistMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChecklist>>
>;
export type CreateChecklistMutationBody = ChecklistDto;
export type CreateChecklistMutationError = ChecklistResponse;

/**
 * @summary Create Checklist
 */
export const useCreateChecklist = <TError = ChecklistResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChecklist>>,
    TError,
    { data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChecklist>>,
  TError,
  { data: ChecklistDto },
  TContext
> => {
  const mutationOptions = getCreateChecklistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List users
 */
export const listUsers = (
  params?: ListUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<AccountUserResponse>({ url: `/user`, method: 'GET', params, signal }, options);

export const getListUsersQueryKey = (params?: ListUsersParams) =>
  [`/user`, ...(params ? [params] : [])] as const;

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = AccountUserResponse
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) =>
    listUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>;
export type ListUsersQueryError = AccountUserResponse;

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = AccountUserResponse
>(
  params: undefined | ListUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = AccountUserResponse
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = AccountUserResponse
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List users
 */

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = AccountUserResponse
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create user
 */
export const createUser = (
  createUserRequest: CreateUserRequest,
  params?: CreateUserParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AccountUserResponse>(
    {
      url: `/user`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createUserRequest,
      params,
      signal
    },
    options
  );

export const getCreateUserMutationOptions = <
  TError = AccountUserResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: CreateUserRequest; params?: CreateUserParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: CreateUserRequest; params?: CreateUserParams },
  TContext
> => {
  const mutationKey = ['createUser'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { data: CreateUserRequest; params?: CreateUserParams }
  > = props => {
    const { data, params } = props ?? {};

    return createUser(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>;
export type CreateUserMutationBody = CreateUserRequest;
export type CreateUserMutationError = AccountUserResponse;

/**
 * @summary Create user
 */
export const useCreateUser = <TError = AccountUserResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: CreateUserRequest; params?: CreateUserParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: CreateUserRequest; params?: CreateUserParams },
  TContext
> => {
  const mutationOptions = getCreateUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List teams
 */
export const listTeams = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) =>
  customInstance<TeamResponse>({ url: `/team`, method: 'GET', signal }, options);

export const getListTeamsQueryKey = () => [`/team`] as const;

export const getListTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTeamsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({ signal }) =>
    listTeams(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeams>>>;
export type ListTeamsQueryError = TeamResponse;

export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = TeamResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listTeams>>,
        TError,
        Awaited<ReturnType<typeof listTeams>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listTeams>>,
        TError,
        Awaited<ReturnType<typeof listTeams>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List teams
 */

export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListTeamsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary create team
 */
export const createTeam = (
  teamDto: TeamDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<TeamResponse>(
    {
      url: `/team`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: teamDto,
      signal
    },
    options
  );

export const getCreateTeamMutationOptions = <TError = TeamResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeam>>,
    TError,
    { data: TeamDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { data: TeamDto },
  TContext
> => {
  const mutationKey = ['createTeam'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeam>>,
    { data: TeamDto }
  > = props => {
    const { data } = props ?? {};

    return createTeam(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>;
export type CreateTeamMutationBody = TeamDto;
export type CreateTeamMutationError = TeamResponse;

/**
 * @summary create team
 */
export const useCreateTeam = <TError = TeamResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeam>>,
    TError,
    { data: TeamDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { data: TeamDto },
  TContext
> => {
  const mutationOptions = getCreateTeamMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send contact us message
 */
export const sendContactUsMessage = (
  contactUsRequest: ContactUsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/support/contactUs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: contactUsRequest,
      signal
    },
    options
  );

export const getSendContactUsMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendContactUsMessage>>,
    TError,
    { data: ContactUsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendContactUsMessage>>,
  TError,
  { data: ContactUsRequest },
  TContext
> => {
  const mutationKey = ['sendContactUsMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendContactUsMessage>>,
    { data: ContactUsRequest }
  > = props => {
    const { data } = props ?? {};

    return sendContactUsMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendContactUsMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendContactUsMessage>>
>;
export type SendContactUsMessageMutationBody = ContactUsRequest;
export type SendContactUsMessageMutationError = unknown;

/**
 * @summary Send contact us message
 */
export const useSendContactUsMessage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendContactUsMessage>>,
    TError,
    { data: ContactUsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendContactUsMessage>>,
  TError,
  { data: ContactUsRequest },
  TContext
> => {
  const mutationOptions = getSendContactUsMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List roles
 */
export const listRoles = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) =>
  customInstance<RoleResponse>({ url: `/role`, method: 'GET', signal }, options);

export const getListRolesQueryKey = () => [`/role`] as const;

export const getListRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRoles>>,
  TError = RoleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRolesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoles>>> = ({ signal }) =>
    listRoles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listRoles>>>;
export type ListRolesQueryError = RoleResponse;

export function useListRoles<
  TData = Awaited<ReturnType<typeof listRoles>>,
  TError = RoleResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listRoles>>,
        TError,
        Awaited<ReturnType<typeof listRoles>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRoles<
  TData = Awaited<ReturnType<typeof listRoles>>,
  TError = RoleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listRoles>>,
        TError,
        Awaited<ReturnType<typeof listRoles>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRoles<
  TData = Awaited<ReturnType<typeof listRoles>>,
  TError = RoleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List roles
 */

export function useListRoles<
  TData = Awaited<ReturnType<typeof listRoles>>,
  TError = RoleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listRoles>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListRolesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create role
 */
export const createRole = (
  roleDto: RoleDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<RoleResponse>(
    {
      url: `/role`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: roleDto,
      signal
    },
    options
  );

export const getCreateRoleMutationOptions = <TError = RoleResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRole>>,
    TError,
    { data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRole>>,
  TError,
  { data: RoleDto },
  TContext
> => {
  const mutationKey = ['createRole'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRole>>,
    { data: RoleDto }
  > = props => {
    const { data } = props ?? {};

    return createRole(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>;
export type CreateRoleMutationBody = RoleDto;
export type CreateRoleMutationError = RoleResponse;

/**
 * @summary Create role
 */
export const useCreateRole = <TError = RoleResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRole>>,
    TError,
    { data: RoleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRole>>,
  TError,
  { data: RoleDto },
  TContext
> => {
  const mutationOptions = getCreateRoleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all metrics
 */
export const listMetrics = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<MetricResponse>({ url: `/metric`, method: 'GET', signal }, options);

export const getListMetricsQueryKey = () => [`/metric`] as const;

export const getListMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = MetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetrics>>> = ({ signal }) =>
    listMetrics(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetrics>>>;
export type ListMetricsQueryError = MetricResponse;

export function useListMetrics<
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = MetricResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetrics>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMetrics>>,
        TError,
        Awaited<ReturnType<typeof listMetrics>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetrics<
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = MetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetrics>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMetrics>>,
        TError,
        Awaited<ReturnType<typeof listMetrics>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetrics<
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = MetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all metrics
 */

export function useListMetrics<
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = MetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMetricsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create metric
 */
export const createMetric = (
  metricDto: MetricDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricResponse>(
    {
      url: `/metric`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metricDto,
      signal
    },
    options
  );

export const getCreateMetricMutationOptions = <
  TError = MetricResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetric>>,
    TError,
    { data: MetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMetric>>,
  TError,
  { data: MetricDto },
  TContext
> => {
  const mutationKey = ['createMetric'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMetric>>,
    { data: MetricDto }
  > = props => {
    const { data } = props ?? {};

    return createMetric(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMetricMutationResult = NonNullable<Awaited<ReturnType<typeof createMetric>>>;
export type CreateMetricMutationBody = MetricDto;
export type CreateMetricMutationError = MetricResponse;

/**
 * @summary Create metric
 */
export const useCreateMetric = <TError = MetricResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetric>>,
    TError,
    { data: MetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMetric>>,
  TError,
  { data: MetricDto },
  TContext
> => {
  const mutationOptions = getCreateMetricMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary upload metric values
 */
export const uploadMetricValues = (
  id: string,
  uploadMetricValuesBody: UploadMetricValuesBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<RegistrationResponse>(
    {
      url: `/metric/${id}/value`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadMetricValuesBody,
      signal
    },
    options
  );

export const getUploadMetricValuesMutationOptions = <
  TError = RegistrationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadMetricValues>>,
    TError,
    { id: string; data: UploadMetricValuesBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadMetricValues>>,
  TError,
  { id: string; data: UploadMetricValuesBody },
  TContext
> => {
  const mutationKey = ['uploadMetricValues'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadMetricValues>>,
    { id: string; data: UploadMetricValuesBody }
  > = props => {
    const { id, data } = props ?? {};

    return uploadMetricValues(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadMetricValuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadMetricValues>>
>;
export type UploadMetricValuesMutationBody = UploadMetricValuesBody;
export type UploadMetricValuesMutationError = RegistrationResponse;

/**
 * @summary upload metric values
 */
export const useUploadMetricValues = <TError = RegistrationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadMetricValues>>,
    TError,
    { id: string; data: UploadMetricValuesBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadMetricValues>>,
  TError,
  { id: string; data: UploadMetricValuesBody },
  TContext
> => {
  const mutationOptions = getUploadMetricValuesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary upload metric targets
 */
export const uploadMetricTargets = (
  id: string,
  uploadMetricTargetsBody: UploadMetricTargetsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<RegistrationResponse>(
    {
      url: `/metric/${id}/target`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadMetricTargetsBody,
      signal
    },
    options
  );

export const getUploadMetricTargetsMutationOptions = <
  TError = RegistrationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadMetricTargets>>,
    TError,
    { id: string; data: UploadMetricTargetsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadMetricTargets>>,
  TError,
  { id: string; data: UploadMetricTargetsBody },
  TContext
> => {
  const mutationKey = ['uploadMetricTargets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadMetricTargets>>,
    { id: string; data: UploadMetricTargetsBody }
  > = props => {
    const { id, data } = props ?? {};

    return uploadMetricTargets(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadMetricTargetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadMetricTargets>>
>;
export type UploadMetricTargetsMutationBody = UploadMetricTargetsBody;
export type UploadMetricTargetsMutationError = RegistrationResponse;

/**
 * @summary upload metric targets
 */
export const useUploadMetricTargets = <
  TError = RegistrationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadMetricTargets>>,
    TError,
    { id: string; data: UploadMetricTargetsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadMetricTargets>>,
  TError,
  { id: string; data: UploadMetricTargetsBody },
  TContext
> => {
  const mutationOptions = getUploadMetricTargetsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all metric definitions
 */
export const listMetricDefinitions = (
  params?: ListMetricDefinitionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDefinitionResponse>(
    { url: `/metric/definition`, method: 'GET', params, signal },
    options
  );

export const getListMetricDefinitionsQueryKey = (params?: ListMetricDefinitionsParams) =>
  [`/metric/definition`, ...(params ? [params] : [])] as const;

export const getListMetricDefinitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMetricDefinitions>>,
  TError = MetricDefinitionResponse
>(
  params?: ListMetricDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDefinitions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricDefinitionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetricDefinitions>>> = ({ signal }) =>
    listMetricDefinitions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMetricDefinitions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMetricDefinitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMetricDefinitions>>
>;
export type ListMetricDefinitionsQueryError = MetricDefinitionResponse;

export function useListMetricDefinitions<
  TData = Awaited<ReturnType<typeof listMetricDefinitions>>,
  TError = MetricDefinitionResponse
>(
  params: undefined | ListMetricDefinitionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDefinitions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetricDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listMetricDefinitions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricDefinitions<
  TData = Awaited<ReturnType<typeof listMetricDefinitions>>,
  TError = MetricDefinitionResponse
>(
  params?: ListMetricDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDefinitions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetricDefinitions>>,
          TError,
          Awaited<ReturnType<typeof listMetricDefinitions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricDefinitions<
  TData = Awaited<ReturnType<typeof listMetricDefinitions>>,
  TError = MetricDefinitionResponse
>(
  params?: ListMetricDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDefinitions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all metric definitions
 */

export function useListMetricDefinitions<
  TData = Awaited<ReturnType<typeof listMetricDefinitions>>,
  TError = MetricDefinitionResponse
>(
  params?: ListMetricDefinitionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMetricDefinitions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMetricDefinitionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create metric definition
 */
export const createMetricDefinition = (
  metricDefinitionDto: MetricDefinitionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDefinitionResponse>(
    {
      url: `/metric/definition`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: metricDefinitionDto,
      signal
    },
    options
  );

export const getCreateMetricDefinitionMutationOptions = <
  TError = MetricDefinitionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetricDefinition>>,
    TError,
    { data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMetricDefinition>>,
  TError,
  { data: MetricDefinitionDto },
  TContext
> => {
  const mutationKey = ['createMetricDefinition'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMetricDefinition>>,
    { data: MetricDefinitionDto }
  > = props => {
    const { data } = props ?? {};

    return createMetricDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMetricDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMetricDefinition>>
>;
export type CreateMetricDefinitionMutationBody = MetricDefinitionDto;
export type CreateMetricDefinitionMutationError = MetricDefinitionResponse;

/**
 * @summary Create metric definition
 */
export const useCreateMetricDefinition = <
  TError = MetricDefinitionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetricDefinition>>,
    TError,
    { data: MetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMetricDefinition>>,
  TError,
  { data: MetricDefinitionDto },
  TContext
> => {
  const mutationOptions = getCreateMetricDefinitionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search metric definitions
 */
export const searchMetricDefinitions = (
  searchEntityRequest: SearchEntityRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDefinitionResponse>(
    {
      url: `/metric/definition/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      signal
    },
    options
  );

export const getSearchMetricDefinitionsMutationOptions = <
  TError = MetricDefinitionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMetricDefinitions>>,
    TError,
    { data: SearchEntityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMetricDefinitions>>,
  TError,
  { data: SearchEntityRequest },
  TContext
> => {
  const mutationKey = ['searchMetricDefinitions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMetricDefinitions>>,
    { data: SearchEntityRequest }
  > = props => {
    const { data } = props ?? {};

    return searchMetricDefinitions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMetricDefinitionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMetricDefinitions>>
>;
export type SearchMetricDefinitionsMutationBody = SearchEntityRequest;
export type SearchMetricDefinitionsMutationError = MetricDefinitionResponse;

/**
 * @summary Search metric definitions
 */
export const useSearchMetricDefinitions = <
  TError = MetricDefinitionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMetricDefinitions>>,
    TError,
    { data: SearchEntityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchMetricDefinitions>>,
  TError,
  { data: SearchEntityRequest },
  TContext
> => {
  const mutationOptions = getSearchMetricDefinitionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get metric definitions progress
 */
export const getMetricDefinitionsProgress = (
  searchMetricsRequest: SearchMetricsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDefinitionProgressResponse>(
    {
      url: `/metric/definition/progress`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchMetricsRequest,
      signal
    },
    options
  );

export const getGetMetricDefinitionsProgressMutationOptions = <
  TError = MetricDefinitionProgressResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getMetricDefinitionsProgress>>,
    TError,
    { data: SearchMetricsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getMetricDefinitionsProgress>>,
  TError,
  { data: SearchMetricsRequest },
  TContext
> => {
  const mutationKey = ['getMetricDefinitionsProgress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getMetricDefinitionsProgress>>,
    { data: SearchMetricsRequest }
  > = props => {
    const { data } = props ?? {};

    return getMetricDefinitionsProgress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetMetricDefinitionsProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof getMetricDefinitionsProgress>>
>;
export type GetMetricDefinitionsProgressMutationBody = SearchMetricsRequest;
export type GetMetricDefinitionsProgressMutationError = MetricDefinitionProgressResponse;

/**
 * @summary Get metric definitions progress
 */
export const useGetMetricDefinitionsProgress = <
  TError = MetricDefinitionProgressResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getMetricDefinitionsProgress>>,
    TError,
    { data: SearchMetricsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getMetricDefinitionsProgress>>,
  TError,
  { data: SearchMetricsRequest },
  TContext
> => {
  const mutationOptions = getGetMetricDefinitionsProgressMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create metric data points
 */
export const createMetricDataPoints = (
  bulkMetricDataPointsRequest: BulkMetricDataPointsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricDataPointResponse>(
    {
      url: `/metric/dataPoint/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkMetricDataPointsRequest,
      signal
    },
    options
  );

export const getCreateMetricDataPointsMutationOptions = <
  TError = MetricDataPointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetricDataPoints>>,
    TError,
    { data: BulkMetricDataPointsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMetricDataPoints>>,
  TError,
  { data: BulkMetricDataPointsRequest },
  TContext
> => {
  const mutationKey = ['createMetricDataPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMetricDataPoints>>,
    { data: BulkMetricDataPointsRequest }
  > = props => {
    const { data } = props ?? {};

    return createMetricDataPoints(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMetricDataPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMetricDataPoints>>
>;
export type CreateMetricDataPointsMutationBody = BulkMetricDataPointsRequest;
export type CreateMetricDataPointsMutationError = MetricDataPointResponse;

/**
 * @summary Create metric data points
 */
export const useCreateMetricDataPoints = <
  TError = MetricDataPointResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMetricDataPoints>>,
    TError,
    { data: BulkMetricDataPointsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMetricDataPoints>>,
  TError,
  { data: BulkMetricDataPointsRequest },
  TContext
> => {
  const mutationOptions = getCreateMetricDataPointsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all meetings
 */
export const listMeetings = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<MeetingResponse>({ url: `/meeting`, method: 'GET', signal }, options);

export const getListMeetingsQueryKey = () => [`/meeting`] as const;

export const getListMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetings>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetings>>> = ({ signal }) =>
    listMeetings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingsQueryResult = NonNullable<Awaited<ReturnType<typeof listMeetings>>>;
export type ListMeetingsQueryError = MeetingResponse;

export function useListMeetings<
  TData = Awaited<ReturnType<typeof listMeetings>>,
  TError = MeetingResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetings>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetings>>,
        TError,
        Awaited<ReturnType<typeof listMeetings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetings<
  TData = Awaited<ReturnType<typeof listMeetings>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetings>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMeetings>>,
        TError,
        Awaited<ReturnType<typeof listMeetings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetings<
  TData = Awaited<ReturnType<typeof listMeetings>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all meetings
 */

export function useListMeetings<
  TData = Awaited<ReturnType<typeof listMeetings>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a meeting
 */
export const startMeeting = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<LiveMeetingResponse>({ url: `/meeting`, method: 'POST', signal }, options);

export const getStartMeetingMutationOptions = <
  TError = LiveMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof startMeeting>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof startMeeting>>, TError, void, TContext> => {
  const mutationKey = ['startMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMeeting>>, void> = () =>
    startMeeting(requestOptions);

  return { mutationFn, ...mutationOptions };
};

export type StartMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof startMeeting>>>;

export type StartMeetingMutationError = LiveMeetingResponse;

/**
 * @summary Start a meeting
 */
export const useStartMeeting = <TError = LiveMeetingResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof startMeeting>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof startMeeting>>, TError, void, TContext> => {
  const mutationOptions = getStartMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search Meetings
 */
export const searchMeetings = (
  searchRequest: SearchRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingDetailsResponse>(
    {
      url: `/meeting/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchRequest,
      signal
    },
    options
  );

export const getSearchMeetingsMutationOptions = <
  TError = MeetingDetailsResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMeetings>>,
    TError,
    { data: SearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMeetings>>,
  TError,
  { data: SearchRequest },
  TContext
> => {
  const mutationKey = ['searchMeetings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMeetings>>,
    { data: SearchRequest }
  > = props => {
    const { data } = props ?? {};

    return searchMeetings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMeetingsMutationResult = NonNullable<Awaited<ReturnType<typeof searchMeetings>>>;
export type SearchMeetingsMutationBody = SearchRequest;
export type SearchMeetingsMutationError = MeetingDetailsResponse;

/**
 * @summary Search Meetings
 */
export const useSearchMeetings = <TError = MeetingDetailsResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMeetings>>,
    TError,
    { data: SearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchMeetings>>,
  TError,
  { data: SearchRequest },
  TContext
> => {
  const mutationOptions = getSearchMeetingsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List scheduled meetings
 */
export const listScheduledMeetings = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ScheduledMeetingResponse>(
    { url: `/meeting/scheduled`, method: 'GET', signal },
    options
  );

export const getListScheduledMeetingsQueryKey = () => [`/meeting/scheduled`] as const;

export const getListScheduledMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listScheduledMeetings>>,
  TError = ScheduledMeetingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listScheduledMeetings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScheduledMeetingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScheduledMeetings>>> = ({ signal }) =>
    listScheduledMeetings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScheduledMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListScheduledMeetingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScheduledMeetings>>
>;
export type ListScheduledMeetingsQueryError = ScheduledMeetingResponse;

export function useListScheduledMeetings<
  TData = Awaited<ReturnType<typeof listScheduledMeetings>>,
  TError = ScheduledMeetingResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listScheduledMeetings>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listScheduledMeetings>>,
        TError,
        Awaited<ReturnType<typeof listScheduledMeetings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListScheduledMeetings<
  TData = Awaited<ReturnType<typeof listScheduledMeetings>>,
  TError = ScheduledMeetingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listScheduledMeetings>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listScheduledMeetings>>,
        TError,
        Awaited<ReturnType<typeof listScheduledMeetings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListScheduledMeetings<
  TData = Awaited<ReturnType<typeof listScheduledMeetings>>,
  TError = ScheduledMeetingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listScheduledMeetings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List scheduled meetings
 */

export function useListScheduledMeetings<
  TData = Awaited<ReturnType<typeof listScheduledMeetings>>,
  TError = ScheduledMeetingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listScheduledMeetings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListScheduledMeetingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create scheduled meeting
 */
export const createScheduledMeeting = (
  scheduledMeetingDto: ScheduledMeetingDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ScheduledMeetingResponse>(
    {
      url: `/meeting/scheduled`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scheduledMeetingDto,
      signal
    },
    options
  );

export const getCreateScheduledMeetingMutationOptions = <
  TError = ScheduledMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScheduledMeeting>>,
    TError,
    { data: ScheduledMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScheduledMeeting>>,
  TError,
  { data: ScheduledMeetingDto },
  TContext
> => {
  const mutationKey = ['createScheduledMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScheduledMeeting>>,
    { data: ScheduledMeetingDto }
  > = props => {
    const { data } = props ?? {};

    return createScheduledMeeting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScheduledMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createScheduledMeeting>>
>;
export type CreateScheduledMeetingMutationBody = ScheduledMeetingDto;
export type CreateScheduledMeetingMutationError = ScheduledMeetingResponse;

/**
 * @summary Create scheduled meeting
 */
export const useCreateScheduledMeeting = <
  TError = ScheduledMeetingResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScheduledMeeting>>,
    TError,
    { data: ScheduledMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createScheduledMeeting>>,
  TError,
  { data: ScheduledMeetingDto },
  TContext
> => {
  const mutationOptions = getCreateScheduledMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create meeting feedback
 */
export const createMeetingFeedback = (
  meetingFeedbackDto: MeetingFeedbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFeedbackResponse>(
    {
      url: `/meeting/feedback`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingFeedbackDto,
      signal
    },
    options
  );

export const getCreateMeetingFeedbackMutationOptions = <
  TError = MeetingFeedbackResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFeedback>>,
    TError,
    { data: MeetingFeedbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingFeedback>>,
  TError,
  { data: MeetingFeedbackDto },
  TContext
> => {
  const mutationKey = ['createMeetingFeedback'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingFeedback>>,
    { data: MeetingFeedbackDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingFeedback>>
>;
export type CreateMeetingFeedbackMutationBody = MeetingFeedbackDto;
export type CreateMeetingFeedbackMutationError = MeetingFeedbackResponse;

/**
 * @summary Create meeting feedback
 */
export const useCreateMeetingFeedback = <
  TError = MeetingFeedbackResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingFeedback>>,
    TError,
    { data: MeetingFeedbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingFeedback>>,
  TError,
  { data: MeetingFeedbackDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingFeedbackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Launch meeting bot
 */
export const launchMeetingBot = (
  launchMeetingBotRequest: LaunchMeetingBotRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/meeting/bot`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: launchMeetingBotRequest,
      signal
    },
    options
  );

export const getLaunchMeetingBotMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof launchMeetingBot>>,
    TError,
    { data: LaunchMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof launchMeetingBot>>,
  TError,
  { data: LaunchMeetingBotRequest },
  TContext
> => {
  const mutationKey = ['launchMeetingBot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof launchMeetingBot>>,
    { data: LaunchMeetingBotRequest }
  > = props => {
    const { data } = props ?? {};

    return launchMeetingBot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LaunchMeetingBotMutationResult = NonNullable<
  Awaited<ReturnType<typeof launchMeetingBot>>
>;
export type LaunchMeetingBotMutationBody = LaunchMeetingBotRequest;
export type LaunchMeetingBotMutationError = unknown;

/**
 * @summary Launch meeting bot
 */
export const useLaunchMeetingBot = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof launchMeetingBot>>,
    TError,
    { data: LaunchMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof launchMeetingBot>>,
  TError,
  { data: LaunchMeetingBotRequest },
  TContext
> => {
  const mutationOptions = getLaunchMeetingBotMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search meeting bots
 */
export const searchMeetingBots = (
  searchMeetingBotsRequest: SearchMeetingBotsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingBotResponse>(
    {
      url: `/meeting/bot/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchMeetingBotsRequest,
      signal
    },
    options
  );

export const getSearchMeetingBotsMutationOptions = <
  TError = MeetingBotResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMeetingBots>>,
    TError,
    { data: SearchMeetingBotsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMeetingBots>>,
  TError,
  { data: SearchMeetingBotsRequest },
  TContext
> => {
  const mutationKey = ['searchMeetingBots'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMeetingBots>>,
    { data: SearchMeetingBotsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchMeetingBots(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMeetingBotsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMeetingBots>>
>;
export type SearchMeetingBotsMutationBody = SearchMeetingBotsRequest;
export type SearchMeetingBotsMutationError = MeetingBotResponse;

/**
 * @summary Search meeting bots
 */
export const useSearchMeetingBots = <TError = MeetingBotResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMeetingBots>>,
    TError,
    { data: SearchMeetingBotsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchMeetingBots>>,
  TError,
  { data: SearchMeetingBotsRequest },
  TContext
> => {
  const mutationOptions = getSearchMeetingBotsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Schedule meeting bots
 */
export const scheduleMeetingBot = (
  scheduleMeetingBotRequest: ScheduleMeetingBotRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingBotResponse>(
    {
      url: `/meeting/bot/schedule`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scheduleMeetingBotRequest,
      signal
    },
    options
  );

export const getScheduleMeetingBotMutationOptions = <
  TError = MeetingBotResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleMeetingBot>>,
    TError,
    { data: ScheduleMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleMeetingBot>>,
  TError,
  { data: ScheduleMeetingBotRequest },
  TContext
> => {
  const mutationKey = ['scheduleMeetingBot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleMeetingBot>>,
    { data: ScheduleMeetingBotRequest }
  > = props => {
    const { data } = props ?? {};

    return scheduleMeetingBot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleMeetingBotMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleMeetingBot>>
>;
export type ScheduleMeetingBotMutationBody = ScheduleMeetingBotRequest;
export type ScheduleMeetingBotMutationError = MeetingBotResponse;

/**
 * @summary Schedule meeting bots
 */
export const useScheduleMeetingBot = <TError = MeetingBotResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleMeetingBot>>,
    TError,
    { data: ScheduleMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scheduleMeetingBot>>,
  TError,
  { data: ScheduleMeetingBotRequest },
  TContext
> => {
  const mutationOptions = getScheduleMeetingBotMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk schedule meeting bots
 */
export const bulkScheduleMeetingBot = (
  bulkScheduleMeetingBotRequest: BulkScheduleMeetingBotRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingBotResponse>(
    {
      url: `/meeting/bot/schedule/bulk`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkScheduleMeetingBotRequest,
      signal
    },
    options
  );

export const getBulkScheduleMeetingBotMutationOptions = <
  TError = MeetingBotResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkScheduleMeetingBot>>,
    TError,
    { data: BulkScheduleMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkScheduleMeetingBot>>,
  TError,
  { data: BulkScheduleMeetingBotRequest },
  TContext
> => {
  const mutationKey = ['bulkScheduleMeetingBot'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkScheduleMeetingBot>>,
    { data: BulkScheduleMeetingBotRequest }
  > = props => {
    const { data } = props ?? {};

    return bulkScheduleMeetingBot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkScheduleMeetingBotMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkScheduleMeetingBot>>
>;
export type BulkScheduleMeetingBotMutationBody = BulkScheduleMeetingBotRequest;
export type BulkScheduleMeetingBotMutationError = MeetingBotResponse;

/**
 * @summary Bulk schedule meeting bots
 */
export const useBulkScheduleMeetingBot = <
  TError = MeetingBotResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkScheduleMeetingBot>>,
    TError,
    { data: BulkScheduleMeetingBotRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkScheduleMeetingBot>>,
  TError,
  { data: BulkScheduleMeetingBotRequest },
  TContext
> => {
  const mutationOptions = getBulkScheduleMeetingBotMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Analyze meeting
 */
export const analyzeMeeting = (
  meetingAnalysisRequestDto: MeetingAnalysisRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AgentOperationResponse>(
    {
      url: `/meeting/analyze`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingAnalysisRequestDto,
      signal
    },
    options
  );

export const getAnalyzeMeetingMutationOptions = <
  TError = AgentOperationResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeMeeting>>,
    TError,
    { data: MeetingAnalysisRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeMeeting>>,
  TError,
  { data: MeetingAnalysisRequestDto },
  TContext
> => {
  const mutationKey = ['analyzeMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeMeeting>>,
    { data: MeetingAnalysisRequestDto }
  > = props => {
    const { data } = props ?? {};

    return analyzeMeeting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeMeeting>>>;
export type AnalyzeMeetingMutationBody = MeetingAnalysisRequestDto;
export type AnalyzeMeetingMutationError = AgentOperationResponse;

/**
 * @summary Analyze meeting
 */
export const useAnalyzeMeeting = <TError = AgentOperationResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeMeeting>>,
    TError,
    { data: MeetingAnalysisRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeMeeting>>,
  TError,
  { data: MeetingAnalysisRequestDto },
  TContext
> => {
  const mutationOptions = getAnalyzeMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get next meeting agenda
 */
export const getNextMeetingAgenda = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAgendaResponse>({ url: `/meeting/agenda`, method: 'GET', signal }, options);

export const getGetNextMeetingAgendaQueryKey = () => [`/meeting/agenda`] as const;

export const getGetNextMeetingAgendaQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextMeetingAgenda>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNextMeetingAgendaQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextMeetingAgenda>>> = ({ signal }) =>
    getNextMeetingAgenda(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextMeetingAgenda>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNextMeetingAgendaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNextMeetingAgenda>>
>;
export type GetNextMeetingAgendaQueryError = MeetingAgendaResponse;

export function useGetNextMeetingAgenda<
  TData = Awaited<ReturnType<typeof getNextMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextMeetingAgenda>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getNextMeetingAgenda>>,
        TError,
        Awaited<ReturnType<typeof getNextMeetingAgenda>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextMeetingAgenda<
  TData = Awaited<ReturnType<typeof getNextMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNextMeetingAgenda>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getNextMeetingAgenda>>,
        TError,
        Awaited<ReturnType<typeof getNextMeetingAgenda>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextMeetingAgenda<
  TData = Awaited<ReturnType<typeof getNextMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextMeetingAgenda>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get next meeting agenda
 */

export function useGetNextMeetingAgenda<
  TData = Awaited<ReturnType<typeof getNextMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextMeetingAgenda>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNextMeetingAgendaQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create meeting agenda
 */
export const createMeetingAgenda = (
  meetingAgendaDto: MeetingAgendaDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAgendaResponse>(
    {
      url: `/meeting/agenda`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: meetingAgendaDto,
      signal
    },
    options
  );

export const getCreateMeetingAgendaMutationOptions = <
  TError = MeetingAgendaResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingAgenda>>,
    TError,
    { data: MeetingAgendaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMeetingAgenda>>,
  TError,
  { data: MeetingAgendaDto },
  TContext
> => {
  const mutationKey = ['createMeetingAgenda'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMeetingAgenda>>,
    { data: MeetingAgendaDto }
  > = props => {
    const { data } = props ?? {};

    return createMeetingAgenda(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMeetingAgendaMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMeetingAgenda>>
>;
export type CreateMeetingAgendaMutationBody = MeetingAgendaDto;
export type CreateMeetingAgendaMutationError = MeetingAgendaResponse;

/**
 * @summary Create meeting agenda
 */
export const useCreateMeetingAgenda = <
  TError = MeetingAgendaResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMeetingAgenda>>,
    TError,
    { data: MeetingAgendaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMeetingAgenda>>,
  TError,
  { data: MeetingAgendaDto },
  TContext
> => {
  const mutationOptions = getCreateMeetingAgendaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List account data source
 */
export const listDataSources = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DataSourceResponse>(
    { url: `/integration/dataSource`, method: 'GET', signal },
    options
  );

export const getListDataSourcesQueryKey = () => [`/integration/dataSource`] as const;

export const getListDataSourcesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = DataSourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataSourcesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataSources>>> = ({ signal }) =>
    listDataSources(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataSources>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof listDataSources>>>;
export type ListDataSourcesQueryError = DataSourceResponse;

export function useListDataSources<
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = DataSourceResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listDataSources>>,
        TError,
        Awaited<ReturnType<typeof listDataSources>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSources<
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = DataSourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listDataSources>>,
        TError,
        Awaited<ReturnType<typeof listDataSources>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSources<
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = DataSourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List account data source
 */

export function useListDataSources<
  TData = Awaited<ReturnType<typeof listDataSources>>,
  TError = DataSourceResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataSources>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListDataSourcesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create account data source
 */
export const createDataSource = (
  dataSourceDto: DataSourceDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DataSourceResponse>(
    {
      url: `/integration/dataSource`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dataSourceDto,
      signal
    },
    options
  );

export const getCreateDataSourceMutationOptions = <
  TError = DataSourceResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDataSource>>,
    TError,
    { data: DataSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDataSource>>,
  TError,
  { data: DataSourceDto },
  TContext
> => {
  const mutationKey = ['createDataSource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDataSource>>,
    { data: DataSourceDto }
  > = props => {
    const { data } = props ?? {};

    return createDataSource(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDataSource>>
>;
export type CreateDataSourceMutationBody = DataSourceDto;
export type CreateDataSourceMutationError = DataSourceResponse;

/**
 * @summary Create account data source
 */
export const useCreateDataSource = <TError = DataSourceResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDataSource>>,
    TError,
    { data: DataSourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDataSource>>,
  TError,
  { data: DataSourceDto },
  TContext
> => {
  const mutationOptions = getCreateDataSourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List account data providers
 */
export const listDataProviders = (
  params?: ListDataProvidersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    { url: `/integration/dataProvider`, method: 'GET', params, signal },
    options
  );

export const getListDataProvidersQueryKey = (params?: ListDataProvidersParams) =>
  [`/integration/dataProvider`, ...(params ? [params] : [])] as const;

export const getListDataProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataProviders>>,
  TError = IntegrationDataProviderResponse
>(
  params?: ListDataProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProviders>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataProvidersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataProviders>>> = ({ signal }) =>
    listDataProviders(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDataProviders>>
>;
export type ListDataProvidersQueryError = IntegrationDataProviderResponse;

export function useListDataProviders<
  TData = Awaited<ReturnType<typeof listDataProviders>>,
  TError = IntegrationDataProviderResponse
>(
  params: undefined | ListDataProvidersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProviders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProviders>>,
          TError,
          Awaited<ReturnType<typeof listDataProviders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataProviders<
  TData = Awaited<ReturnType<typeof listDataProviders>>,
  TError = IntegrationDataProviderResponse
>(
  params?: ListDataProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProviders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProviders>>,
          TError,
          Awaited<ReturnType<typeof listDataProviders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataProviders<
  TData = Awaited<ReturnType<typeof listDataProviders>>,
  TError = IntegrationDataProviderResponse
>(
  params?: ListDataProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProviders>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List account data providers
 */

export function useListDataProviders<
  TData = Awaited<ReturnType<typeof listDataProviders>>,
  TError = IntegrationDataProviderResponse
>(
  params?: ListDataProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProviders>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListDataProvidersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create account data provider
 */
export const createDataProvider = (
  accountDataProviderRequest: AccountDataProviderRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    {
      url: `/integration/dataProvider`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: accountDataProviderRequest,
      signal
    },
    options
  );

export const getCreateDataProviderMutationOptions = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDataProvider>>,
    TError,
    { data: AccountDataProviderRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDataProvider>>,
  TError,
  { data: AccountDataProviderRequest },
  TContext
> => {
  const mutationKey = ['createDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDataProvider>>,
    { data: AccountDataProviderRequest }
  > = props => {
    const { data } = props ?? {};

    return createDataProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDataProvider>>
>;
export type CreateDataProviderMutationBody = AccountDataProviderRequest;
export type CreateDataProviderMutationError = IntegrationDataProviderResponse;

/**
 * @summary Create account data provider
 */
export const useCreateDataProvider = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDataProvider>>,
    TError,
    { data: AccountDataProviderRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDataProvider>>,
  TError,
  { data: AccountDataProviderRequest },
  TContext
> => {
  const mutationOptions = getCreateDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create quickbooks data provider
 */
export const createQuickBooksDataProvider = (
  quickBooksDataProviderCreateRequest: QuickBooksDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    {
      url: `/integration/dataProvider/quickBooks`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quickBooksDataProviderCreateRequest,
      signal
    },
    options
  );

export const getCreateQuickBooksDataProviderMutationOptions = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuickBooksDataProvider>>,
    TError,
    { data: QuickBooksDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuickBooksDataProvider>>,
  TError,
  { data: QuickBooksDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['createQuickBooksDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuickBooksDataProvider>>,
    { data: QuickBooksDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return createQuickBooksDataProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuickBooksDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuickBooksDataProvider>>
>;
export type CreateQuickBooksDataProviderMutationBody = QuickBooksDataProviderCreateRequest;
export type CreateQuickBooksDataProviderMutationError = IntegrationDataProviderResponse;

/**
 * @summary Create quickbooks data provider
 */
export const useCreateQuickBooksDataProvider = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuickBooksDataProvider>>,
    TError,
    { data: QuickBooksDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuickBooksDataProvider>>,
  TError,
  { data: QuickBooksDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateQuickBooksDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create microsoft data provider
 */
export const createMicrosoftDataProvider = (
  microsoftDataProviderCreateRequest: MicrosoftDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    {
      url: `/integration/dataProvider/microsoft`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: microsoftDataProviderCreateRequest,
      signal
    },
    options
  );

export const getCreateMicrosoftDataProviderMutationOptions = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMicrosoftDataProvider>>,
    TError,
    { data: MicrosoftDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMicrosoftDataProvider>>,
  TError,
  { data: MicrosoftDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['createMicrosoftDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMicrosoftDataProvider>>,
    { data: MicrosoftDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return createMicrosoftDataProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMicrosoftDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMicrosoftDataProvider>>
>;
export type CreateMicrosoftDataProviderMutationBody = MicrosoftDataProviderCreateRequest;
export type CreateMicrosoftDataProviderMutationError = IntegrationDataProviderResponse;

/**
 * @summary Create microsoft data provider
 */
export const useCreateMicrosoftDataProvider = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMicrosoftDataProvider>>,
    TError,
    { data: MicrosoftDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMicrosoftDataProvider>>,
  TError,
  { data: MicrosoftDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateMicrosoftDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create hubspot data provider
 */
export const createHubspotDataProvider = (
  hubspotDataProviderCreateRequest: HubspotDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    {
      url: `/integration/dataProvider/hubspot`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: hubspotDataProviderCreateRequest,
      signal
    },
    options
  );

export const getCreateHubspotDataProviderMutationOptions = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHubspotDataProvider>>,
    TError,
    { data: HubspotDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHubspotDataProvider>>,
  TError,
  { data: HubspotDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['createHubspotDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHubspotDataProvider>>,
    { data: HubspotDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return createHubspotDataProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHubspotDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHubspotDataProvider>>
>;
export type CreateHubspotDataProviderMutationBody = HubspotDataProviderCreateRequest;
export type CreateHubspotDataProviderMutationError = IntegrationDataProviderResponse;

/**
 * @summary Create hubspot data provider
 */
export const useCreateHubspotDataProvider = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHubspotDataProvider>>,
    TError,
    { data: HubspotDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createHubspotDataProvider>>,
  TError,
  { data: HubspotDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateHubspotDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create google data provider
 */
export const createGoogleDataProvider = (
  googleDataProviderCreateRequest: GoogleDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IntegrationDataProviderResponse>(
    {
      url: `/integration/dataProvider/google`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: googleDataProviderCreateRequest,
      signal
    },
    options
  );

export const getCreateGoogleDataProviderMutationOptions = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoogleDataProvider>>,
    TError,
    { data: GoogleDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoogleDataProvider>>,
  TError,
  { data: GoogleDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['createGoogleDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoogleDataProvider>>,
    { data: GoogleDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return createGoogleDataProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoogleDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoogleDataProvider>>
>;
export type CreateGoogleDataProviderMutationBody = GoogleDataProviderCreateRequest;
export type CreateGoogleDataProviderMutationError = IntegrationDataProviderResponse;

/**
 * @summary Create google data provider
 */
export const useCreateGoogleDataProvider = <
  TError = IntegrationDataProviderResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoogleDataProvider>>,
    TError,
    { data: GoogleDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoogleDataProvider>>,
  TError,
  { data: GoogleDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateGoogleDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List connections
 */
export const listConnections = (
  params?: ListConnectionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UnifiedConnectionResponse>(
    { url: `/integration/connection`, method: 'GET', params, signal },
    options
  );

export const getListConnectionsQueryKey = (params?: ListConnectionsParams) =>
  [`/integration/connection`, ...(params ? [params] : [])] as const;

export const getListConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = UnifiedConnectionResponse
>(
  params?: ListConnectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListConnectionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnections>>> = ({ signal }) =>
    listConnections(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnections>>>;
export type ListConnectionsQueryError = UnifiedConnectionResponse;

export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = UnifiedConnectionResponse
>(
  params: undefined | ListConnectionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = UnifiedConnectionResponse
>(
  params?: ListConnectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = UnifiedConnectionResponse
>(
  params?: ListConnectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List connections
 */

export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = UnifiedConnectionResponse
>(
  params?: ListConnectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListConnectionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create connection
 */
export const createConnection = (
  unifiedConnectionDto: UnifiedConnectionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UnifiedConnectionResponse>(
    {
      url: `/integration/connection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: unifiedConnectionDto,
      signal
    },
    options
  );

export const getCreateConnectionMutationOptions = <
  TError = UnifiedConnectionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConnection>>,
    TError,
    { data: UnifiedConnectionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConnection>>,
  TError,
  { data: UnifiedConnectionDto },
  TContext
> => {
  const mutationKey = ['createConnection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConnection>>,
    { data: UnifiedConnectionDto }
  > = props => {
    const { data } = props ?? {};

    return createConnection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConnection>>
>;
export type CreateConnectionMutationBody = UnifiedConnectionDto;
export type CreateConnectionMutationError = UnifiedConnectionResponse;

/**
 * @summary Create connection
 */
export const useCreateConnection = <
  TError = UnifiedConnectionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConnection>>,
    TError,
    { data: UnifiedConnectionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createConnection>>,
  TError,
  { data: UnifiedConnectionDto },
  TContext
> => {
  const mutationOptions = getCreateConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Authenticate Microsoft
 */
export const authenticateMicrosoft = (
  microsoftDataProviderCreateRequest: MicrosoftDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/integration/auth/microsoft`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: microsoftDataProviderCreateRequest,
      signal
    },
    options
  );

export const getAuthenticateMicrosoftMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authenticateMicrosoft>>,
    TError,
    { data: MicrosoftDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authenticateMicrosoft>>,
  TError,
  { data: MicrosoftDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['authenticateMicrosoft'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authenticateMicrosoft>>,
    { data: MicrosoftDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return authenticateMicrosoft(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticateMicrosoftMutationResult = NonNullable<
  Awaited<ReturnType<typeof authenticateMicrosoft>>
>;
export type AuthenticateMicrosoftMutationBody = MicrosoftDataProviderCreateRequest;
export type AuthenticateMicrosoftMutationError = unknown;

/**
 * @summary Authenticate Microsoft
 */
export const useAuthenticateMicrosoft = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authenticateMicrosoft>>,
    TError,
    { data: MicrosoftDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authenticateMicrosoft>>,
  TError,
  { data: MicrosoftDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getAuthenticateMicrosoftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete microsoft authentication
 */
export const deleteMicrosoftAuthentication = (options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/integration/auth/microsoft`, method: 'DELETE' }, options);

export const getDeleteMicrosoftAuthenticationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMicrosoftAuthentication'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>,
    void
  > = () => deleteMicrosoftAuthentication(requestOptions);

  return { mutationFn, ...mutationOptions };
};

export type DeleteMicrosoftAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>
>;

export type DeleteMicrosoftAuthenticationMutationError = unknown;

/**
 * @summary Delete microsoft authentication
 */
export const useDeleteMicrosoftAuthentication = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMicrosoftAuthentication>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMicrosoftAuthenticationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Authenticate Google
 */
export const authenticateGoogle = (
  googleDataProviderCreateRequest: GoogleDataProviderCreateRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/integration/auth/google`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: googleDataProviderCreateRequest,
      signal
    },
    options
  );

export const getAuthenticateGoogleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authenticateGoogle>>,
    TError,
    { data: GoogleDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authenticateGoogle>>,
  TError,
  { data: GoogleDataProviderCreateRequest },
  TContext
> => {
  const mutationKey = ['authenticateGoogle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authenticateGoogle>>,
    { data: GoogleDataProviderCreateRequest }
  > = props => {
    const { data } = props ?? {};

    return authenticateGoogle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticateGoogleMutationResult = NonNullable<
  Awaited<ReturnType<typeof authenticateGoogle>>
>;
export type AuthenticateGoogleMutationBody = GoogleDataProviderCreateRequest;
export type AuthenticateGoogleMutationError = unknown;

/**
 * @summary Authenticate Google
 */
export const useAuthenticateGoogle = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authenticateGoogle>>,
    TError,
    { data: GoogleDataProviderCreateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authenticateGoogle>>,
  TError,
  { data: GoogleDataProviderCreateRequest },
  TContext
> => {
  const mutationOptions = getAuthenticateGoogleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete google authentication
 */
export const deleteGoogleAuthentication = (options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/integration/auth/google`, method: 'DELETE' }, options);

export const getDeleteGoogleAuthenticationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoogleAuthentication>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoogleAuthentication>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteGoogleAuthentication'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGoogleAuthentication>>,
    void
  > = () => deleteGoogleAuthentication(requestOptions);

  return { mutationFn, ...mutationOptions };
};

export type DeleteGoogleAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGoogleAuthentication>>
>;

export type DeleteGoogleAuthenticationMutationError = unknown;

/**
 * @summary Delete google authentication
 */
export const useDeleteGoogleAuthentication = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoogleAuthentication>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoogleAuthentication>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteGoogleAuthenticationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create engagement
 */
export const createHubspotEngagement = (
  crmEventDto: CrmEventDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CrmEventResponse>(
    {
      url: `/hubspot/engagement`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: crmEventDto,
      signal
    },
    options
  );

export const getCreateHubspotEngagementMutationOptions = <
  TError = CrmEventResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHubspotEngagement>>,
    TError,
    { data: CrmEventDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createHubspotEngagement>>,
  TError,
  { data: CrmEventDto },
  TContext
> => {
  const mutationKey = ['createHubspotEngagement'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createHubspotEngagement>>,
    { data: CrmEventDto }
  > = props => {
    const { data } = props ?? {};

    return createHubspotEngagement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateHubspotEngagementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createHubspotEngagement>>
>;
export type CreateHubspotEngagementMutationBody = CrmEventDto;
export type CreateHubspotEngagementMutationError = CrmEventResponse;

/**
 * @summary Create engagement
 */
export const useCreateHubspotEngagement = <
  TError = CrmEventResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createHubspotEngagement>>,
    TError,
    { data: CrmEventDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createHubspotEngagement>>,
  TError,
  { data: CrmEventDto },
  TContext
> => {
  const mutationOptions = getCreateHubspotEngagementMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List saved posts
 */
export const getSavedPosts = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SavedPostsResponse>({ url: `/forum/savedPosts`, method: 'GET', signal }, options);

export const getGetSavedPostsQueryKey = () => [`/forum/savedPosts`] as const;

export const getGetSavedPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSavedPosts>>,
  TError = SavedPostsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPosts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSavedPostsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSavedPosts>>> = ({ signal }) =>
    getSavedPosts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSavedPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSavedPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getSavedPosts>>>;
export type GetSavedPostsQueryError = SavedPostsResponse;

export function useGetSavedPosts<
  TData = Awaited<ReturnType<typeof getSavedPosts>>,
  TError = SavedPostsResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPosts>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSavedPosts>>,
        TError,
        Awaited<ReturnType<typeof getSavedPosts>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSavedPosts<
  TData = Awaited<ReturnType<typeof getSavedPosts>>,
  TError = SavedPostsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPosts>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getSavedPosts>>,
        TError,
        Awaited<ReturnType<typeof getSavedPosts>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSavedPosts<
  TData = Awaited<ReturnType<typeof getSavedPosts>>,
  TError = SavedPostsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPosts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List saved posts
 */

export function useGetSavedPosts<
  TData = Awaited<ReturnType<typeof getSavedPosts>>,
  TError = SavedPostsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSavedPosts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSavedPostsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create saved posts
 */
export const createSavedPosts = (
  savedPostsDto: SavedPostsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SavedPostsResponse>(
    {
      url: `/forum/savedPosts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: savedPostsDto,
      signal
    },
    options
  );

export const getCreateSavedPostsMutationOptions = <
  TError = SavedPostsResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSavedPosts>>,
    TError,
    { data: SavedPostsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSavedPosts>>,
  TError,
  { data: SavedPostsDto },
  TContext
> => {
  const mutationKey = ['createSavedPosts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSavedPosts>>,
    { data: SavedPostsDto }
  > = props => {
    const { data } = props ?? {};

    return createSavedPosts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSavedPostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSavedPosts>>
>;
export type CreateSavedPostsMutationBody = SavedPostsDto;
export type CreateSavedPostsMutationError = SavedPostsResponse;

/**
 * @summary Create saved posts
 */
export const useCreateSavedPosts = <TError = SavedPostsResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSavedPosts>>,
    TError,
    { data: SavedPostsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSavedPosts>>,
  TError,
  { data: SavedPostsDto },
  TContext
> => {
  const mutationOptions = getCreateSavedPostsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch saved posts
 */
export const patchSavedPosts = (
  savedPostsDto: SavedPostsDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/forum/savedPosts`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: savedPostsDto
    },
    options
  );

export const getPatchSavedPostsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSavedPosts>>,
    TError,
    { data: SavedPostsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSavedPosts>>,
  TError,
  { data: SavedPostsDto },
  TContext
> => {
  const mutationKey = ['patchSavedPosts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSavedPosts>>,
    { data: SavedPostsDto }
  > = props => {
    const { data } = props ?? {};

    return patchSavedPosts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSavedPostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSavedPosts>>
>;
export type PatchSavedPostsMutationBody = SavedPostsDto;
export type PatchSavedPostsMutationError = unknown;

/**
 * @summary Patch saved posts
 */
export const usePatchSavedPosts = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSavedPosts>>,
    TError,
    { data: SavedPostsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSavedPosts>>,
  TError,
  { data: SavedPostsDto },
  TContext
> => {
  const mutationOptions = getPatchSavedPostsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List posts
 */
export const listPosts = (
  params?: ListPostsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<PostResponse>({ url: `/forum/post`, method: 'GET', params, signal }, options);

export const getListPostsQueryKey = (params?: ListPostsParams) =>
  [`/forum/post`, ...(params ? [params] : [])] as const;

export const getListPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPosts>>,
  TError = PostResponse
>(
  params?: ListPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPosts>>> = ({ signal }) =>
    listPosts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listPosts>>>;
export type ListPostsQueryError = PostResponse;

export function useListPosts<TData = Awaited<ReturnType<typeof listPosts>>, TError = PostResponse>(
  params: undefined | ListPostsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPosts>>,
          TError,
          Awaited<ReturnType<typeof listPosts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPosts<TData = Awaited<ReturnType<typeof listPosts>>, TError = PostResponse>(
  params?: ListPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPosts>>,
          TError,
          Awaited<ReturnType<typeof listPosts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPosts<TData = Awaited<ReturnType<typeof listPosts>>, TError = PostResponse>(
  params?: ListPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List posts
 */

export function useListPosts<TData = Awaited<ReturnType<typeof listPosts>>, TError = PostResponse>(
  params?: ListPostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPosts>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create post
 */
export const createPost = (
  postDto: PostDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<PostResponse>(
    {
      url: `/forum/post`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: postDto,
      signal
    },
    options
  );

export const getCreatePostMutationOptions = <TError = PostResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPost>>,
    TError,
    { data: PostDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPost>>,
  TError,
  { data: PostDto },
  TContext
> => {
  const mutationKey = ['createPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPost>>,
    { data: PostDto }
  > = props => {
    const { data } = props ?? {};

    return createPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePostMutationResult = NonNullable<Awaited<ReturnType<typeof createPost>>>;
export type CreatePostMutationBody = PostDto;
export type CreatePostMutationError = PostResponse;

/**
 * @summary Create post
 */
export const useCreatePost = <TError = PostResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPost>>,
    TError,
    { data: PostDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPost>>,
  TError,
  { data: PostDto },
  TContext
> => {
  const mutationOptions = getCreatePostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List comments
 */
export const listComments = (
  params: ListCommentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CommentResponse>(
    { url: `/forum/comment`, method: 'GET', params, signal },
    options
  );

export const getListCommentsQueryKey = (params: ListCommentsParams) =>
  [`/forum/comment`, ...(params ? [params] : [])] as const;

export const getListCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = CommentResponse
>(
  params: ListCommentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCommentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listComments>>> = ({ signal }) =>
    listComments(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof listComments>>>;
export type ListCommentsQueryError = CommentResponse;

export function useListComments<
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = CommentResponse
>(
  params: ListCommentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listComments>>,
          TError,
          Awaited<ReturnType<typeof listComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListComments<
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = CommentResponse
>(
  params: ListCommentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listComments>>,
          TError,
          Awaited<ReturnType<typeof listComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListComments<
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = CommentResponse
>(
  params: ListCommentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List comments
 */

export function useListComments<
  TData = Awaited<ReturnType<typeof listComments>>,
  TError = CommentResponse
>(
  params: ListCommentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listComments>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCommentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create comment
 */
export const createComment = (
  commentDto: CommentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CommentResponse>(
    {
      url: `/forum/comment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: commentDto,
      signal
    },
    options
  );

export const getCreateCommentMutationOptions = <
  TError = CommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { data: CommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { data: CommentDto },
  TContext
> => {
  const mutationKey = ['createComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createComment>>,
    { data: CommentDto }
  > = props => {
    const { data } = props ?? {};

    return createComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createComment>>>;
export type CreateCommentMutationBody = CommentDto;
export type CreateCommentMutationError = CommentResponse;

/**
 * @summary Create comment
 */
export const useCreateComment = <TError = CommentResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createComment>>,
    TError,
    { data: CommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createComment>>,
  TError,
  { data: CommentDto },
  TContext
> => {
  const mutationOptions = getCreateCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send Email message
 */
export const sendEmailMessage = (
  sendEmailRequest: SendEmailRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailMessageResponse>(
    {
      url: `/calendar/email/send`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sendEmailRequest,
      signal
    },
    options
  );

export const getSendEmailMessageMutationOptions = <
  TError = EmailMessageResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailMessage>>,
    TError,
    { data: SendEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEmailMessage>>,
  TError,
  { data: SendEmailRequest },
  TContext
> => {
  const mutationKey = ['sendEmailMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEmailMessage>>,
    { data: SendEmailRequest }
  > = props => {
    const { data } = props ?? {};

    return sendEmailMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEmailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendEmailMessage>>
>;
export type SendEmailMessageMutationBody = SendEmailRequest;
export type SendEmailMessageMutationError = EmailMessageResponse;

/**
 * @summary Send Email message
 */
export const useSendEmailMessage = <TError = EmailMessageResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailMessage>>,
    TError,
    { data: SendEmailRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendEmailMessage>>,
  TError,
  { data: SendEmailRequest },
  TContext
> => {
  const mutationOptions = getSendEmailMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Email Message
 */
export const generateEmailMessage = (
  generateEmailMessageRequest: GenerateEmailMessageRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailMessageSuggestionResponse>(
    {
      url: `/calendar/email/generate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateEmailMessageRequest,
      signal
    },
    options
  );

export const getGenerateEmailMessageMutationOptions = <
  TError = EmailMessageSuggestionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailMessage>>,
    TError,
    { data: GenerateEmailMessageRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateEmailMessage>>,
  TError,
  { data: GenerateEmailMessageRequest },
  TContext
> => {
  const mutationKey = ['generateEmailMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateEmailMessage>>,
    { data: GenerateEmailMessageRequest }
  > = props => {
    const { data } = props ?? {};

    return generateEmailMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateEmailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateEmailMessage>>
>;
export type GenerateEmailMessageMutationBody = GenerateEmailMessageRequest;
export type GenerateEmailMessageMutationError = EmailMessageSuggestionResponse;

/**
 * @summary Generate Email Message
 */
export const useGenerateEmailMessage = <
  TError = EmailMessageSuggestionResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailMessage>>,
    TError,
    { data: GenerateEmailMessageRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateEmailMessage>>,
  TError,
  { data: GenerateEmailMessageRequest },
  TContext
> => {
  const mutationOptions = getGenerateEmailMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sign up
 */
export const signUp = (
  signUpRequest: SignUpRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SignInResponse>(
    {
      url: `/auth/signUp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signUpRequest,
      signal
    },
    options
  );

export const getSignUpMutationOptions = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    { data: SignUpRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  { data: SignUpRequest },
  TContext
> => {
  const mutationKey = ['signUp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signUp>>,
    { data: SignUpRequest }
  > = props => {
    const { data } = props ?? {};

    return signUp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignUpMutationResult = NonNullable<Awaited<ReturnType<typeof signUp>>>;
export type SignUpMutationBody = SignUpRequest;
export type SignUpMutationError = SignInResponse;

/**
 * @summary Sign up
 */
export const useSignUp = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signUp>>,
    TError,
    { data: SignUpRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signUp>>,
  TError,
  { data: SignUpRequest },
  TContext
> => {
  const mutationOptions = getSignUpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sign out
 */
export const signOut = (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) =>
  customInstance<void>({ url: `/auth/signOut`, method: 'POST', signal }, options);

export const getSignOutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext> => {
  const mutationKey = ['signOut'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () =>
    signOut(requestOptions);

  return { mutationFn, ...mutationOptions };
};

export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>;

export type SignOutMutationError = unknown;

/**
 * @summary Sign out
 */
export const useSignOut = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext>;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof signOut>>, TError, void, TContext> => {
  const mutationOptions = getSignOutMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sign in
 */
export const signIn = (
  signInRequest: SignInRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SignInResponse>(
    {
      url: `/auth/signIn`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signInRequest,
      signal
    },
    options
  );

export const getSignInMutationOptions = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signIn>>,
    TError,
    { data: SignInRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signIn>>,
  TError,
  { data: SignInRequest },
  TContext
> => {
  const mutationKey = ['signIn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signIn>>,
    { data: SignInRequest }
  > = props => {
    const { data } = props ?? {};

    return signIn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>;
export type SignInMutationBody = SignInRequest;
export type SignInMutationError = SignInResponse;

/**
 * @summary Sign in
 */
export const useSignIn = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signIn>>,
    TError,
    { data: SignInRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signIn>>,
  TError,
  { data: SignInRequest },
  TContext
> => {
  const mutationOptions = getSignInMutationOptions(options);

  return useMutation(mutationOptions);
};

export const signInRefresh = (
  signInRefreshRequest: SignInRefreshRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SignInResponse>(
    {
      url: `/auth/signIn/refresh`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signInRefreshRequest,
      signal
    },
    options
  );

export const getSignInRefreshMutationOptions = <
  TError = SignInResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInRefresh>>,
    TError,
    { data: SignInRefreshRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInRefresh>>,
  TError,
  { data: SignInRefreshRequest },
  TContext
> => {
  const mutationKey = ['signInRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInRefresh>>,
    { data: SignInRefreshRequest }
  > = props => {
    const { data } = props ?? {};

    return signInRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof signInRefresh>>>;
export type SignInRefreshMutationBody = SignInRefreshRequest;
export type SignInRefreshMutationError = SignInResponse;

export const useSignInRefresh = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInRefresh>>,
    TError,
    { data: SignInRefreshRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signInRefresh>>,
  TError,
  { data: SignInRefreshRequest },
  TContext
> => {
  const mutationOptions = getSignInRefreshMutationOptions(options);

  return useMutation(mutationOptions);
};

export const resetPassword = (
  resetPasswordRequest: ResetPasswordRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/auth/resetPassword`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: resetPasswordRequest,
      signal
    },
    options
  );

export const getResetPasswordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: ResetPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  const mutationKey = ['resetPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    { data: ResetPasswordRequest }
  > = props => {
    const { data } = props ?? {};

    return resetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>;
export type ResetPasswordMutationBody = ResetPasswordRequest;
export type ResetPasswordMutationError = unknown;

export const useResetPassword = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: ResetPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  const mutationOptions = getResetPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary MFA Sign in
 */
export const mfaSignIn = (
  signInMfaRequest: SignInMfaRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SignInResponse>(
    {
      url: `/auth/mfaSignIn`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: signInMfaRequest,
      signal
    },
    options
  );

export const getMfaSignInMutationOptions = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mfaSignIn>>,
    TError,
    { data: SignInMfaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mfaSignIn>>,
  TError,
  { data: SignInMfaRequest },
  TContext
> => {
  const mutationKey = ['mfaSignIn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mfaSignIn>>,
    { data: SignInMfaRequest }
  > = props => {
    const { data } = props ?? {};

    return mfaSignIn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MfaSignInMutationResult = NonNullable<Awaited<ReturnType<typeof mfaSignIn>>>;
export type MfaSignInMutationBody = SignInMfaRequest;
export type MfaSignInMutationError = SignInResponse;

/**
 * @summary MFA Sign in
 */
export const useMfaSignIn = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mfaSignIn>>,
    TError,
    { data: SignInMfaRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mfaSignIn>>,
  TError,
  { data: SignInMfaRequest },
  TContext
> => {
  const mutationOptions = getMfaSignInMutationOptions(options);

  return useMutation(mutationOptions);
};

export const forgotPassword = (
  forgotPasswordRequest: ForgotPasswordRequest,
  params?: ForgotPasswordParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/auth/forgotPassword`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: forgotPasswordRequest,
      params,
      signal
    },
    options
  );

export const getForgotPasswordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: ForgotPasswordRequest; params?: ForgotPasswordParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: ForgotPasswordRequest; params?: ForgotPasswordParams },
  TContext
> => {
  const mutationKey = ['forgotPassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    { data: ForgotPasswordRequest; params?: ForgotPasswordParams }
  > = props => {
    const { data, params } = props ?? {};

    return forgotPassword(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>;
export type ForgotPasswordMutationBody = ForgotPasswordRequest;
export type ForgotPasswordMutationError = unknown;

export const useForgotPassword = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: ForgotPasswordRequest; params?: ForgotPasswordParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: ForgotPasswordRequest; params?: ForgotPasswordParams },
  TContext
> => {
  const mutationOptions = getForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const changePassword = (
  changePasswordRequest: ChangePasswordRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/auth/changePassword`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changePasswordRequest,
      signal
    },
    options
  );

export const getChangePasswordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationKey = ['changePassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: ChangePasswordRequest }
  > = props => {
    const { data } = props ?? {};

    return changePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>;
export type ChangePasswordMutationBody = ChangePasswordRequest;
export type ChangePasswordMutationError = unknown;

export const useChangePassword = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationOptions = getChangePasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const accountSignIn = (
  accountSignInRequest: AccountSignInRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SignInResponse>(
    {
      url: `/auth/accountSignIn`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: accountSignInRequest,
      signal
    },
    options
  );

export const getAccountSignInMutationOptions = <
  TError = SignInResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountSignIn>>,
    TError,
    { data: AccountSignInRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountSignIn>>,
  TError,
  { data: AccountSignInRequest },
  TContext
> => {
  const mutationKey = ['accountSignIn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountSignIn>>,
    { data: AccountSignInRequest }
  > = props => {
    const { data } = props ?? {};

    return accountSignIn(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountSignInMutationResult = NonNullable<Awaited<ReturnType<typeof accountSignIn>>>;
export type AccountSignInMutationBody = AccountSignInRequest;
export type AccountSignInMutationError = SignInResponse;

export const useAccountSignIn = <TError = SignInResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountSignIn>>,
    TError,
    { data: AccountSignInRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountSignIn>>,
  TError,
  { data: AccountSignInRequest },
  TContext
> => {
  const mutationOptions = getAccountSignInMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Ask Journey
 */
export const askJourney = (
  askJourneyRequest: AskJourneyRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AskJourneyResponse>(
    {
      url: `/ask`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: askJourneyRequest,
      signal
    },
    options
  );

export const getAskJourneyMutationOptions = <
  TError = AskJourneyResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof askJourney>>,
    TError,
    { data: AskJourneyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof askJourney>>,
  TError,
  { data: AskJourneyRequest },
  TContext
> => {
  const mutationKey = ['askJourney'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof askJourney>>,
    { data: AskJourneyRequest }
  > = props => {
    const { data } = props ?? {};

    return askJourney(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AskJourneyMutationResult = NonNullable<Awaited<ReturnType<typeof askJourney>>>;
export type AskJourneyMutationBody = AskJourneyRequest;
export type AskJourneyMutationError = AskJourneyResponse;

/**
 * @summary Ask Journey
 */
export const useAskJourney = <TError = AskJourneyResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof askJourney>>,
    TError,
    { data: AskJourneyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof askJourney>>,
  TError,
  { data: AskJourneyRequest },
  TContext
> => {
  const mutationOptions = getAskJourneyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create answer
 */
export const createAnswer = (
  askJourneyAnswerDto: AskJourneyAnswerDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<void>(
    {
      url: `/ask/answer`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: askJourneyAnswerDto,
      signal
    },
    options
  );

export const getCreateAnswerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnswer>>,
    TError,
    { data: AskJourneyAnswerDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAnswer>>,
  TError,
  { data: AskJourneyAnswerDto },
  TContext
> => {
  const mutationKey = ['createAnswer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnswer>>,
    { data: AskJourneyAnswerDto }
  > = props => {
    const { data } = props ?? {};

    return createAnswer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof createAnswer>>>;
export type CreateAnswerMutationBody = AskJourneyAnswerDto;
export type CreateAnswerMutationError = unknown;

/**
 * @summary Create answer
 */
export const useCreateAnswer = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnswer>>,
    TError,
    { data: AskJourneyAnswerDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAnswer>>,
  TError,
  { data: AskJourneyAnswerDto },
  TContext
> => {
  const mutationOptions = getCreateAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all agent threads
 */
export const listAgentThreads = (
  params?: ListAgentThreadsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ThreadResponse>({ url: `/agent/thread`, method: 'GET', params, signal }, options);

export const getListAgentThreadsQueryKey = (params?: ListAgentThreadsParams) =>
  [`/agent/thread`, ...(params ? [params] : [])] as const;

export const getListAgentThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentThreads>>,
  TError = ThreadResponse
>(
  params?: ListAgentThreadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentThreads>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentThreadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentThreads>>> = ({ signal }) =>
    listAgentThreads(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentThreads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentThreads>>>;
export type ListAgentThreadsQueryError = ThreadResponse;

export function useListAgentThreads<
  TData = Awaited<ReturnType<typeof listAgentThreads>>,
  TError = ThreadResponse
>(
  params: undefined | ListAgentThreadsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentThreads>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listAgentThreads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentThreads<
  TData = Awaited<ReturnType<typeof listAgentThreads>>,
  TError = ThreadResponse
>(
  params?: ListAgentThreadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentThreads>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listAgentThreads>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentThreads<
  TData = Awaited<ReturnType<typeof listAgentThreads>>,
  TError = ThreadResponse
>(
  params?: ListAgentThreadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentThreads>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all agent threads
 */

export function useListAgentThreads<
  TData = Awaited<ReturnType<typeof listAgentThreads>>,
  TError = ThreadResponse
>(
  params?: ListAgentThreadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentThreads>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentThreadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create agent thread
 */
export const createAgentThread = (
  threadDto: ThreadDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ThreadResponse>(
    {
      url: `/agent/thread`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: threadDto,
      signal
    },
    options
  );

export const getCreateAgentThreadMutationOptions = <
  TError = ThreadResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgentThread>>,
    TError,
    { data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAgentThread>>,
  TError,
  { data: ThreadDto },
  TContext
> => {
  const mutationKey = ['createAgentThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAgentThread>>,
    { data: ThreadDto }
  > = props => {
    const { data } = props ?? {};

    return createAgentThread(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAgentThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAgentThread>>
>;
export type CreateAgentThreadMutationBody = ThreadDto;
export type CreateAgentThreadMutationError = ThreadResponse;

/**
 * @summary Create agent thread
 */
export const useCreateAgentThread = <TError = ThreadResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAgentThread>>,
    TError,
    { data: ThreadDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAgentThread>>,
  TError,
  { data: ThreadDto },
  TContext
> => {
  const mutationOptions = getCreateAgentThreadMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate agent thread title
 */
export const generateAgentThreadTitle = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ThreadTitleResponse>(
    { url: `/agent/thread/${id}/title`, method: 'POST', signal },
    options
  );

export const getGenerateAgentThreadTitleMutationOptions = <
  TError = ThreadTitleResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAgentThreadTitle>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAgentThreadTitle>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['generateAgentThreadTitle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAgentThreadTitle>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return generateAgentThreadTitle(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAgentThreadTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAgentThreadTitle>>
>;

export type GenerateAgentThreadTitleMutationError = ThreadTitleResponse;

/**
 * @summary Generate agent thread title
 */
export const useGenerateAgentThreadTitle = <
  TError = ThreadTitleResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAgentThreadTitle>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateAgentThreadTitle>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getGenerateAgentThreadTitleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Strategic Plan
 */
export const generateStrategicPlan = (
  strategicPlanRequestDto: StrategicPlanRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<StrategicPlanGenerateResultResponse>(
    {
      url: `/agent/strategy/plan/generate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: strategicPlanRequestDto,
      signal
    },
    options
  );

export const getGenerateStrategicPlanMutationOptions = <
  TError = StrategicPlanGenerateResultResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateStrategicPlan>>,
    TError,
    { data: StrategicPlanRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateStrategicPlan>>,
  TError,
  { data: StrategicPlanRequestDto },
  TContext
> => {
  const mutationKey = ['generateStrategicPlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateStrategicPlan>>,
    { data: StrategicPlanRequestDto }
  > = props => {
    const { data } = props ?? {};

    return generateStrategicPlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateStrategicPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateStrategicPlan>>
>;
export type GenerateStrategicPlanMutationBody = StrategicPlanRequestDto;
export type GenerateStrategicPlanMutationError = StrategicPlanGenerateResultResponse;

/**
 * @summary Generate Strategic Plan
 */
export const useGenerateStrategicPlan = <
  TError = StrategicPlanGenerateResultResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateStrategicPlan>>,
    TError,
    { data: StrategicPlanRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateStrategicPlan>>,
  TError,
  { data: StrategicPlanRequestDto },
  TContext
> => {
  const mutationOptions = getGenerateStrategicPlanMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate Email Respond Message
 */
export const generateEmailRespond = (
  emailRespondRequestDto: EmailRespondRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailRespondResponse>(
    {
      url: `/agent/email/respond`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: emailRespondRequestDto,
      signal
    },
    options
  );

export const getGenerateEmailRespondMutationOptions = <
  TError = EmailRespondResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailRespond>>,
    TError,
    { data: EmailRespondRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateEmailRespond>>,
  TError,
  { data: EmailRespondRequestDto },
  TContext
> => {
  const mutationKey = ['generateEmailRespond'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateEmailRespond>>,
    { data: EmailRespondRequestDto }
  > = props => {
    const { data } = props ?? {};

    return generateEmailRespond(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateEmailRespondMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateEmailRespond>>
>;
export type GenerateEmailRespondMutationBody = EmailRespondRequestDto;
export type GenerateEmailRespondMutationError = EmailRespondResponse;

/**
 * @summary Generate Email Respond Message
 */
export const useGenerateEmailRespond = <
  TError = EmailRespondResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateEmailRespond>>,
    TError,
    { data: EmailRespondRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateEmailRespond>>,
  TError,
  { data: EmailRespondRequestDto },
  TContext
> => {
  const mutationOptions = getGenerateEmailRespondMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send chat request to askMeAnything agent
 */
export const streamAskMeAnythingChat = (
  userAgentInputDto: UserAgentInputDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<unknown>(
    {
      url: `/agent/askMeAnything/chat`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userAgentInputDto,
      signal
    },
    options
  );

export const getStreamAskMeAnythingChatMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof streamAskMeAnythingChat>>,
    TError,
    { data: UserAgentInputDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof streamAskMeAnythingChat>>,
  TError,
  { data: UserAgentInputDto },
  TContext
> => {
  const mutationKey = ['streamAskMeAnythingChat'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof streamAskMeAnythingChat>>,
    { data: UserAgentInputDto }
  > = props => {
    const { data } = props ?? {};

    return streamAskMeAnythingChat(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StreamAskMeAnythingChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof streamAskMeAnythingChat>>
>;
export type StreamAskMeAnythingChatMutationBody = UserAgentInputDto;
export type StreamAskMeAnythingChatMutationError = unknown;

/**
 * @summary Send chat request to askMeAnything agent
 */
export const useStreamAskMeAnythingChat = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof streamAskMeAnythingChat>>,
    TError,
    { data: UserAgentInputDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof streamAskMeAnythingChat>>,
  TError,
  { data: UserAgentInputDto },
  TContext
> => {
  const mutationOptions = getStreamAskMeAnythingChatMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List objectives
 */
export const listActionPlanObjectives = (
  params?: ListActionPlanObjectivesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveResponse>(
    { url: `/actionPlan/objective`, method: 'GET', params, signal },
    options
  );

export const getListActionPlanObjectivesQueryKey = (params?: ListActionPlanObjectivesParams) =>
  [`/actionPlan/objective`, ...(params ? [params] : [])] as const;

export const getListActionPlanObjectivesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanObjectives>>,
  TError = ActionPlanObjectiveResponse
>(
  params?: ListActionPlanObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionPlanObjectivesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanObjectives>>> = ({
    signal
  }) => listActionPlanObjectives(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanObjectives>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanObjectivesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanObjectives>>
>;
export type ListActionPlanObjectivesQueryError = ActionPlanObjectiveResponse;

export function useListActionPlanObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanObjectives>>,
  TError = ActionPlanObjectiveResponse
>(
  params: undefined | ListActionPlanObjectivesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectives>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanObjectives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanObjectives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanObjectives>>,
  TError = ActionPlanObjectiveResponse
>(
  params?: ListActionPlanObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectives>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanObjectives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanObjectives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanObjectives>>,
  TError = ActionPlanObjectiveResponse
>(
  params?: ListActionPlanObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List objectives
 */

export function useListActionPlanObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanObjectives>>,
  TError = ActionPlanObjectiveResponse
>(
  params?: ListActionPlanObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanObjectivesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create objective
 */
export const createActionPlanObjective = (
  actionPlanObjectiveDto: ActionPlanObjectiveDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveResponse>(
    {
      url: `/actionPlan/objective`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanObjectiveDto,
      signal
    },
    options
  );

export const getCreateActionPlanObjectiveMutationOptions = <
  TError = ActionPlanObjectiveResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanObjective>>,
    TError,
    { data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanObjective>>,
  TError,
  { data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationKey = ['createActionPlanObjective'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanObjective>>,
    { data: ActionPlanObjectiveDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanObjective(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanObjectiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanObjective>>
>;
export type CreateActionPlanObjectiveMutationBody = ActionPlanObjectiveDto;
export type CreateActionPlanObjectiveMutationError = ActionPlanObjectiveResponse;

/**
 * @summary Create objective
 */
export const useCreateActionPlanObjective = <
  TError = ActionPlanObjectiveResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanObjective>>,
    TError,
    { data: ActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanObjective>>,
  TError,
  { data: ActionPlanObjectiveDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanObjectiveMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search objectives
 */
export const searchActionPlanObjectives = (
  searchEntityRequest: SearchEntityRequest,
  params?: SearchActionPlanObjectivesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveResponse>(
    {
      url: `/actionPlan/objective/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      params,
      signal
    },
    options
  );

export const getSearchActionPlanObjectivesMutationOptions = <
  TError = ActionPlanObjectiveResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanObjectives>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanObjectivesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanObjectives>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanObjectivesParams },
  TContext
> => {
  const mutationKey = ['searchActionPlanObjectives'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanObjectives>>,
    { data: SearchEntityRequest; params?: SearchActionPlanObjectivesParams }
  > = props => {
    const { data, params } = props ?? {};

    return searchActionPlanObjectives(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanObjectivesMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanObjectives>>
>;
export type SearchActionPlanObjectivesMutationBody = SearchEntityRequest;
export type SearchActionPlanObjectivesMutationError = ActionPlanObjectiveResponse;

/**
 * @summary Search objectives
 */
export const useSearchActionPlanObjectives = <
  TError = ActionPlanObjectiveResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanObjectives>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanObjectivesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanObjectives>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanObjectivesParams },
  TContext
> => {
  const mutationOptions = getSearchActionPlanObjectivesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search objectives detailed
 */
export const searchActionPlanDetailedObjectives = (
  searchEntityRequest: SearchEntityRequest,
  params: SearchActionPlanDetailedObjectivesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveDetailedResponse>(
    {
      url: `/actionPlan/objective/detailed/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      params,
      signal
    },
    options
  );

export const getSearchActionPlanDetailedObjectivesMutationOptions = <
  TError = ActionPlanObjectiveDetailedResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>,
    TError,
    { data: SearchEntityRequest; params: SearchActionPlanDetailedObjectivesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>,
  TError,
  { data: SearchEntityRequest; params: SearchActionPlanDetailedObjectivesParams },
  TContext
> => {
  const mutationKey = ['searchActionPlanDetailedObjectives'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>,
    { data: SearchEntityRequest; params: SearchActionPlanDetailedObjectivesParams }
  > = props => {
    const { data, params } = props ?? {};

    return searchActionPlanDetailedObjectives(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanDetailedObjectivesMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>
>;
export type SearchActionPlanDetailedObjectivesMutationBody = SearchEntityRequest;
export type SearchActionPlanDetailedObjectivesMutationError = ActionPlanObjectiveDetailedResponse;

/**
 * @summary Search objectives detailed
 */
export const useSearchActionPlanDetailedObjectives = <
  TError = ActionPlanObjectiveDetailedResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>,
    TError,
    { data: SearchEntityRequest; params: SearchActionPlanDetailedObjectivesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanDetailedObjectives>>,
  TError,
  { data: SearchEntityRequest; params: SearchActionPlanDetailedObjectivesParams },
  TContext
> => {
  const mutationOptions = getSearchActionPlanDetailedObjectivesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create objective comment
 */
export const createActionPlanObjectiveComment = (
  actionPlanObjectiveCommentDto: ActionPlanObjectiveCommentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveCommentResponse>(
    {
      url: `/actionPlan/objective/comment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanObjectiveCommentDto,
      signal
    },
    options
  );

export const getCreateActionPlanObjectiveCommentMutationOptions = <
  TError = ActionPlanObjectiveCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanObjectiveComment>>,
    TError,
    { data: ActionPlanObjectiveCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanObjectiveComment>>,
  TError,
  { data: ActionPlanObjectiveCommentDto },
  TContext
> => {
  const mutationKey = ['createActionPlanObjectiveComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanObjectiveComment>>,
    { data: ActionPlanObjectiveCommentDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanObjectiveComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanObjectiveCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanObjectiveComment>>
>;
export type CreateActionPlanObjectiveCommentMutationBody = ActionPlanObjectiveCommentDto;
export type CreateActionPlanObjectiveCommentMutationError = ActionPlanObjectiveCommentResponse;

/**
 * @summary Create objective comment
 */
export const useCreateActionPlanObjectiveComment = <
  TError = ActionPlanObjectiveCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanObjectiveComment>>,
    TError,
    { data: ActionPlanObjectiveCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanObjectiveComment>>,
  TError,
  { data: ActionPlanObjectiveCommentDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanObjectiveCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search objective comments
 */
export const searchActionPlanObjectiveComments = (
  searchCommentsRequest: SearchCommentsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveDetailedCommentResponse>(
    {
      url: `/actionPlan/objective/comment/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchCommentsRequest,
      signal
    },
    options
  );

export const getSearchActionPlanObjectiveCommentsMutationOptions = <
  TError = ActionPlanObjectiveDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationKey = ['searchActionPlanObjectiveComments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>,
    { data: SearchCommentsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchActionPlanObjectiveComments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanObjectiveCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>
>;
export type SearchActionPlanObjectiveCommentsMutationBody = SearchCommentsRequest;
export type SearchActionPlanObjectiveCommentsMutationError =
  ActionPlanObjectiveDetailedCommentResponse;

/**
 * @summary Search objective comments
 */
export const useSearchActionPlanObjectiveComments = <
  TError = ActionPlanObjectiveDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanObjectiveComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationOptions = getSearchActionPlanObjectiveCommentsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary search metric metadata
 */
export const searchMetricsMetadata = (
  searchMetricMetadataRequest: SearchMetricMetadataRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanMetricMetadataResponse>(
    {
      url: `/actionPlan/metadata/metric/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchMetricMetadataRequest,
      signal
    },
    options
  );

export const getSearchMetricsMetadataMutationOptions = <
  TError = ActionPlanMetricMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMetricsMetadata>>,
    TError,
    { data: SearchMetricMetadataRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMetricsMetadata>>,
  TError,
  { data: SearchMetricMetadataRequest },
  TContext
> => {
  const mutationKey = ['searchMetricsMetadata'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMetricsMetadata>>,
    { data: SearchMetricMetadataRequest }
  > = props => {
    const { data } = props ?? {};

    return searchMetricsMetadata(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMetricsMetadataMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMetricsMetadata>>
>;
export type SearchMetricsMetadataMutationBody = SearchMetricMetadataRequest;
export type SearchMetricsMetadataMutationError = ActionPlanMetricMetadataResponse;

/**
 * @summary search metric metadata
 */
export const useSearchMetricsMetadata = <
  TError = ActionPlanMetricMetadataResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMetricsMetadata>>,
    TError,
    { data: SearchMetricMetadataRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchMetricsMetadata>>,
  TError,
  { data: SearchMetricMetadataRequest },
  TContext
> => {
  const mutationOptions = getSearchMetricsMetadataMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List initiatives
 */
export const listActionPlanInitiatives = (
  params?: ListActionPlanInitiativesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeResponse>(
    { url: `/actionPlan/initiative`, method: 'GET', params, signal },
    options
  );

export const getListActionPlanInitiativesQueryKey = (params?: ListActionPlanInitiativesParams) =>
  [`/actionPlan/initiative`, ...(params ? [params] : [])] as const;

export const getListActionPlanInitiativesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanInitiatives>>,
  TError = ActionPlanInitiativeResponse
>(
  params?: ListActionPlanInitiativesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiatives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionPlanInitiativesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanInitiatives>>> = ({
    signal
  }) => listActionPlanInitiatives(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanInitiatives>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanInitiativesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanInitiatives>>
>;
export type ListActionPlanInitiativesQueryError = ActionPlanInitiativeResponse;

export function useListActionPlanInitiatives<
  TData = Awaited<ReturnType<typeof listActionPlanInitiatives>>,
  TError = ActionPlanInitiativeResponse
>(
  params: undefined | ListActionPlanInitiativesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiatives>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanInitiatives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanInitiatives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanInitiatives<
  TData = Awaited<ReturnType<typeof listActionPlanInitiatives>>,
  TError = ActionPlanInitiativeResponse
>(
  params?: ListActionPlanInitiativesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiatives>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanInitiatives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanInitiatives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanInitiatives<
  TData = Awaited<ReturnType<typeof listActionPlanInitiatives>>,
  TError = ActionPlanInitiativeResponse
>(
  params?: ListActionPlanInitiativesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiatives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List initiatives
 */

export function useListActionPlanInitiatives<
  TData = Awaited<ReturnType<typeof listActionPlanInitiatives>>,
  TError = ActionPlanInitiativeResponse
>(
  params?: ListActionPlanInitiativesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiatives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanInitiativesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create initiative
 */
export const createActionPlanInitiative = (
  actionPlanInitiativeDto: ActionPlanInitiativeDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeResponse>(
    {
      url: `/actionPlan/initiative`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanInitiativeDto,
      signal
    },
    options
  );

export const getCreateActionPlanInitiativeMutationOptions = <
  TError = ActionPlanInitiativeResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanInitiative>>,
    TError,
    { data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanInitiative>>,
  TError,
  { data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationKey = ['createActionPlanInitiative'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanInitiative>>,
    { data: ActionPlanInitiativeDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanInitiative(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanInitiativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanInitiative>>
>;
export type CreateActionPlanInitiativeMutationBody = ActionPlanInitiativeDto;
export type CreateActionPlanInitiativeMutationError = ActionPlanInitiativeResponse;

/**
 * @summary Create initiative
 */
export const useCreateActionPlanInitiative = <
  TError = ActionPlanInitiativeResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanInitiative>>,
    TError,
    { data: ActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanInitiative>>,
  TError,
  { data: ActionPlanInitiativeDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanInitiativeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search initiatives
 */
export const searchActionPlanInitiatives = (
  searchEntityRequest: SearchEntityRequest,
  params?: SearchActionPlanInitiativesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeResponse>(
    {
      url: `/actionPlan/initiative/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      params,
      signal
    },
    options
  );

export const getSearchActionPlanInitiativesMutationOptions = <
  TError = ActionPlanInitiativeResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiatives>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanInitiativesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanInitiatives>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanInitiativesParams },
  TContext
> => {
  const mutationKey = ['searchActionPlanInitiatives'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanInitiatives>>,
    { data: SearchEntityRequest; params?: SearchActionPlanInitiativesParams }
  > = props => {
    const { data, params } = props ?? {};

    return searchActionPlanInitiatives(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanInitiativesMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanInitiatives>>
>;
export type SearchActionPlanInitiativesMutationBody = SearchEntityRequest;
export type SearchActionPlanInitiativesMutationError = ActionPlanInitiativeResponse;

/**
 * @summary Search initiatives
 */
export const useSearchActionPlanInitiatives = <
  TError = ActionPlanInitiativeResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiatives>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanInitiativesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanInitiatives>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanInitiativesParams },
  TContext
> => {
  const mutationOptions = getSearchActionPlanInitiativesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search detailed initiatives
 */
export const searchActionPlanInitiativeDetailed = (
  searchDetailedInitiativeRequest: SearchDetailedInitiativeRequest,
  params?: SearchActionPlanInitiativeDetailedParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeDetailedResponse>(
    {
      url: `/actionPlan/initiative/detailed/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchDetailedInitiativeRequest,
      params,
      signal
    },
    options
  );

export const getSearchActionPlanInitiativeDetailedMutationOptions = <
  TError = ActionPlanInitiativeDetailedResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>,
    TError,
    { data: SearchDetailedInitiativeRequest; params?: SearchActionPlanInitiativeDetailedParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>,
  TError,
  { data: SearchDetailedInitiativeRequest; params?: SearchActionPlanInitiativeDetailedParams },
  TContext
> => {
  const mutationKey = ['searchActionPlanInitiativeDetailed'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>,
    { data: SearchDetailedInitiativeRequest; params?: SearchActionPlanInitiativeDetailedParams }
  > = props => {
    const { data, params } = props ?? {};

    return searchActionPlanInitiativeDetailed(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanInitiativeDetailedMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>
>;
export type SearchActionPlanInitiativeDetailedMutationBody = SearchDetailedInitiativeRequest;
export type SearchActionPlanInitiativeDetailedMutationError = ActionPlanInitiativeDetailedResponse;

/**
 * @summary Search detailed initiatives
 */
export const useSearchActionPlanInitiativeDetailed = <
  TError = ActionPlanInitiativeDetailedResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>,
    TError,
    { data: SearchDetailedInitiativeRequest; params?: SearchActionPlanInitiativeDetailedParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanInitiativeDetailed>>,
  TError,
  { data: SearchDetailedInitiativeRequest; params?: SearchActionPlanInitiativeDetailedParams },
  TContext
> => {
  const mutationOptions = getSearchActionPlanInitiativeDetailedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create initiative comment
 */
export const createActionPlanInitiativeComment = (
  actionPlanInitiativeCommentDto: ActionPlanInitiativeCommentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeCommentResponse>(
    {
      url: `/actionPlan/initiative/comment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanInitiativeCommentDto,
      signal
    },
    options
  );

export const getCreateActionPlanInitiativeCommentMutationOptions = <
  TError = ActionPlanInitiativeCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanInitiativeComment>>,
    TError,
    { data: ActionPlanInitiativeCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanInitiativeComment>>,
  TError,
  { data: ActionPlanInitiativeCommentDto },
  TContext
> => {
  const mutationKey = ['createActionPlanInitiativeComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanInitiativeComment>>,
    { data: ActionPlanInitiativeCommentDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanInitiativeComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanInitiativeCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanInitiativeComment>>
>;
export type CreateActionPlanInitiativeCommentMutationBody = ActionPlanInitiativeCommentDto;
export type CreateActionPlanInitiativeCommentMutationError = ActionPlanInitiativeCommentResponse;

/**
 * @summary Create initiative comment
 */
export const useCreateActionPlanInitiativeComment = <
  TError = ActionPlanInitiativeCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanInitiativeComment>>,
    TError,
    { data: ActionPlanInitiativeCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanInitiativeComment>>,
  TError,
  { data: ActionPlanInitiativeCommentDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanInitiativeCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search initiative comments
 */
export const searchActionPlanInitiativeComments = (
  searchCommentsRequest: SearchCommentsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeDetailedCommentResponse>(
    {
      url: `/actionPlan/initiative/comment/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchCommentsRequest,
      signal
    },
    options
  );

export const getSearchActionPlanInitiativeCommentsMutationOptions = <
  TError = ActionPlanInitiativeDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationKey = ['searchActionPlanInitiativeComments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>,
    { data: SearchCommentsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchActionPlanInitiativeComments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanInitiativeCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>
>;
export type SearchActionPlanInitiativeCommentsMutationBody = SearchCommentsRequest;
export type SearchActionPlanInitiativeCommentsMutationError =
  ActionPlanInitiativeDetailedCommentResponse;

/**
 * @summary Search initiative comments
 */
export const useSearchActionPlanInitiativeComments = <
  TError = ActionPlanInitiativeDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanInitiativeComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationOptions = getSearchActionPlanInitiativeCommentsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List boards
 */
export const listActionPlanBoards = (
  params?: ListActionPlanBoardsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanBoardResponse>(
    { url: `/actionPlan/board`, method: 'GET', params, signal },
    options
  );

export const getListActionPlanBoardsQueryKey = (params?: ListActionPlanBoardsParams) =>
  [`/actionPlan/board`, ...(params ? [params] : [])] as const;

export const getListActionPlanBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanBoards>>,
  TError = ActionPlanBoardResponse
>(
  params?: ListActionPlanBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionPlanBoardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanBoards>>> = ({ signal }) =>
    listActionPlanBoards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanBoards>>
>;
export type ListActionPlanBoardsQueryError = ActionPlanBoardResponse;

export function useListActionPlanBoards<
  TData = Awaited<ReturnType<typeof listActionPlanBoards>>,
  TError = ActionPlanBoardResponse
>(
  params: undefined | ListActionPlanBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanBoards>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanBoards>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanBoards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanBoards<
  TData = Awaited<ReturnType<typeof listActionPlanBoards>>,
  TError = ActionPlanBoardResponse
>(
  params?: ListActionPlanBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanBoards>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanBoards>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanBoards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanBoards<
  TData = Awaited<ReturnType<typeof listActionPlanBoards>>,
  TError = ActionPlanBoardResponse
>(
  params?: ListActionPlanBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List boards
 */

export function useListActionPlanBoards<
  TData = Awaited<ReturnType<typeof listActionPlanBoards>>,
  TError = ActionPlanBoardResponse
>(
  params?: ListActionPlanBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create board
 */
export const createActionPlanBoard = (
  actionPlanBoardDto: ActionPlanBoardDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanBoardResponse>(
    {
      url: `/actionPlan/board`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanBoardDto,
      signal
    },
    options
  );

export const getCreateActionPlanBoardMutationOptions = <
  TError = ActionPlanBoardResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanBoard>>,
    TError,
    { data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanBoard>>,
  TError,
  { data: ActionPlanBoardDto },
  TContext
> => {
  const mutationKey = ['createActionPlanBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanBoard>>,
    { data: ActionPlanBoardDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanBoard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanBoard>>
>;
export type CreateActionPlanBoardMutationBody = ActionPlanBoardDto;
export type CreateActionPlanBoardMutationError = ActionPlanBoardResponse;

/**
 * @summary Create board
 */
export const useCreateActionPlanBoard = <
  TError = ActionPlanBoardResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanBoard>>,
    TError,
    { data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanBoard>>,
  TError,
  { data: ActionPlanBoardDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List action items
 */
export const listActionPlanActionItems = (
  params?: ListActionPlanActionItemsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemResponse>(
    { url: `/actionPlan/actionItem`, method: 'GET', params, signal },
    options
  );

export const getListActionPlanActionItemsQueryKey = (params?: ListActionPlanActionItemsParams) =>
  [`/actionPlan/actionItem`, ...(params ? [params] : [])] as const;

export const getListActionPlanActionItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanActionItems>>,
  TError = ActionPlanActionItemResponse
>(
  params?: ListActionPlanActionItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItems>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionPlanActionItemsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanActionItems>>> = ({
    signal
  }) => listActionPlanActionItems(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanActionItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanActionItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanActionItems>>
>;
export type ListActionPlanActionItemsQueryError = ActionPlanActionItemResponse;

export function useListActionPlanActionItems<
  TData = Awaited<ReturnType<typeof listActionPlanActionItems>>,
  TError = ActionPlanActionItemResponse
>(
  params: undefined | ListActionPlanActionItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanActionItems>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanActionItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanActionItems<
  TData = Awaited<ReturnType<typeof listActionPlanActionItems>>,
  TError = ActionPlanActionItemResponse
>(
  params?: ListActionPlanActionItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanActionItems>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanActionItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanActionItems<
  TData = Awaited<ReturnType<typeof listActionPlanActionItems>>,
  TError = ActionPlanActionItemResponse
>(
  params?: ListActionPlanActionItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItems>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List action items
 */

export function useListActionPlanActionItems<
  TData = Awaited<ReturnType<typeof listActionPlanActionItems>>,
  TError = ActionPlanActionItemResponse
>(
  params?: ListActionPlanActionItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItems>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanActionItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create action item
 */
export const createActionPlanActionItem = (
  actionPlanActionItemDto: ActionPlanActionItemDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemResponse>(
    {
      url: `/actionPlan/actionItem`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanActionItemDto,
      signal
    },
    options
  );

export const getCreateActionPlanActionItemMutationOptions = <
  TError = ActionPlanActionItemResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanActionItem>>,
    TError,
    { data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanActionItem>>,
  TError,
  { data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationKey = ['createActionPlanActionItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanActionItem>>,
    { data: ActionPlanActionItemDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanActionItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanActionItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanActionItem>>
>;
export type CreateActionPlanActionItemMutationBody = ActionPlanActionItemDto;
export type CreateActionPlanActionItemMutationError = ActionPlanActionItemResponse;

/**
 * @summary Create action item
 */
export const useCreateActionPlanActionItem = <
  TError = ActionPlanActionItemResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanActionItem>>,
    TError,
    { data: ActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanActionItem>>,
  TError,
  { data: ActionPlanActionItemDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanActionItemMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search action items
 */
export const searchActionPlanActionItems = (
  searchEntityRequest: SearchEntityRequest,
  params?: SearchActionPlanActionItemsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemResponse>(
    {
      url: `/actionPlan/actionItem/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchEntityRequest,
      params,
      signal
    },
    options
  );

export const getSearchActionPlanActionItemsMutationOptions = <
  TError = ActionPlanActionItemResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanActionItems>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanActionItemsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanActionItems>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanActionItemsParams },
  TContext
> => {
  const mutationKey = ['searchActionPlanActionItems'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanActionItems>>,
    { data: SearchEntityRequest; params?: SearchActionPlanActionItemsParams }
  > = props => {
    const { data, params } = props ?? {};

    return searchActionPlanActionItems(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanActionItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanActionItems>>
>;
export type SearchActionPlanActionItemsMutationBody = SearchEntityRequest;
export type SearchActionPlanActionItemsMutationError = ActionPlanActionItemResponse;

/**
 * @summary Search action items
 */
export const useSearchActionPlanActionItems = <
  TError = ActionPlanActionItemResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanActionItems>>,
    TError,
    { data: SearchEntityRequest; params?: SearchActionPlanActionItemsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanActionItems>>,
  TError,
  { data: SearchEntityRequest; params?: SearchActionPlanActionItemsParams },
  TContext
> => {
  const mutationOptions = getSearchActionPlanActionItemsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create action item comment
 */
export const createActionPlanActionItemComment = (
  actionPlanActionItemCommentDto: ActionPlanActionItemCommentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemCommentResponse>(
    {
      url: `/actionPlan/actionItem/comment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanActionItemCommentDto,
      signal
    },
    options
  );

export const getCreateActionPlanActionItemCommentMutationOptions = <
  TError = ActionPlanActionItemCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanActionItemComment>>,
    TError,
    { data: ActionPlanActionItemCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionPlanActionItemComment>>,
  TError,
  { data: ActionPlanActionItemCommentDto },
  TContext
> => {
  const mutationKey = ['createActionPlanActionItemComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionPlanActionItemComment>>,
    { data: ActionPlanActionItemCommentDto }
  > = props => {
    const { data } = props ?? {};

    return createActionPlanActionItemComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateActionPlanActionItemCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionPlanActionItemComment>>
>;
export type CreateActionPlanActionItemCommentMutationBody = ActionPlanActionItemCommentDto;
export type CreateActionPlanActionItemCommentMutationError = ActionPlanActionItemCommentResponse;

/**
 * @summary Create action item comment
 */
export const useCreateActionPlanActionItemComment = <
  TError = ActionPlanActionItemCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionPlanActionItemComment>>,
    TError,
    { data: ActionPlanActionItemCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createActionPlanActionItemComment>>,
  TError,
  { data: ActionPlanActionItemCommentDto },
  TContext
> => {
  const mutationOptions = getCreateActionPlanActionItemCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search action items comments
 */
export const searchActionPlanActionItemComments = (
  searchCommentsRequest: SearchCommentsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemDetailedCommentResponse>(
    {
      url: `/actionPlan/actionItem/comment/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: searchCommentsRequest,
      signal
    },
    options
  );

export const getSearchActionPlanActionItemCommentsMutationOptions = <
  TError = ActionPlanActionItemDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanActionItemComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchActionPlanActionItemComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationKey = ['searchActionPlanActionItemComments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchActionPlanActionItemComments>>,
    { data: SearchCommentsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchActionPlanActionItemComments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchActionPlanActionItemCommentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchActionPlanActionItemComments>>
>;
export type SearchActionPlanActionItemCommentsMutationBody = SearchCommentsRequest;
export type SearchActionPlanActionItemCommentsMutationError =
  ActionPlanActionItemDetailedCommentResponse;

/**
 * @summary Search action items comments
 */
export const useSearchActionPlanActionItemComments = <
  TError = ActionPlanActionItemDetailedCommentResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchActionPlanActionItemComments>>,
    TError,
    { data: SearchCommentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof searchActionPlanActionItemComments>>,
  TError,
  { data: SearchCommentsRequest },
  TContext
> => {
  const mutationOptions = getSearchActionPlanActionItemCommentsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get whiteboard
 */
export const getWhiteboard = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<WhiteboardResponse>(
    { url: `/workspace/whiteboard/${id}`, method: 'GET', signal },
    options
  );

export const getGetWhiteboardQueryKey = (id: string) => [`/workspace/whiteboard/${id}`] as const;

export const getGetWhiteboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhiteboard>>,
  TError = WhiteboardResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhiteboard>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWhiteboardQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhiteboard>>> = ({ signal }) =>
    getWhiteboard(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWhiteboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWhiteboardQueryResult = NonNullable<Awaited<ReturnType<typeof getWhiteboard>>>;
export type GetWhiteboardQueryError = WhiteboardResponse;

export function useGetWhiteboard<
  TData = Awaited<ReturnType<typeof getWhiteboard>>,
  TError = WhiteboardResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhiteboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhiteboard>>,
          TError,
          Awaited<ReturnType<typeof getWhiteboard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWhiteboard<
  TData = Awaited<ReturnType<typeof getWhiteboard>>,
  TError = WhiteboardResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhiteboard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhiteboard>>,
          TError,
          Awaited<ReturnType<typeof getWhiteboard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWhiteboard<
  TData = Awaited<ReturnType<typeof getWhiteboard>>,
  TError = WhiteboardResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhiteboard>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get whiteboard
 */

export function useGetWhiteboard<
  TData = Awaited<ReturnType<typeof getWhiteboard>>,
  TError = WhiteboardResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhiteboard>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWhiteboardQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete whiteboard
 */
export const deleteWhiteboard = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workspace/whiteboard/${id}`, method: 'DELETE' }, options);

export const getDeleteWhiteboardMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhiteboard>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWhiteboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteWhiteboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWhiteboard>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteWhiteboard(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWhiteboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWhiteboard>>
>;

export type DeleteWhiteboardMutationError = unknown;

/**
 * @summary Delete whiteboard
 */
export const useDeleteWhiteboard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWhiteboard>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWhiteboard>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteWhiteboardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch whiteboard
 */
export const patchWhiteboard = (
  id: string,
  whiteboardDto: WhiteboardDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/whiteboard/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: whiteboardDto
    },
    options
  );

export const getPatchWhiteboardMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWhiteboard>>,
    TError,
    { id: string; data: WhiteboardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchWhiteboard>>,
  TError,
  { id: string; data: WhiteboardDto },
  TContext
> => {
  const mutationKey = ['patchWhiteboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchWhiteboard>>,
    { id: string; data: WhiteboardDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchWhiteboard(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchWhiteboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchWhiteboard>>
>;
export type PatchWhiteboardMutationBody = WhiteboardDto;
export type PatchWhiteboardMutationError = unknown;

/**
 * @summary Patch whiteboard
 */
export const usePatchWhiteboard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchWhiteboard>>,
    TError,
    { id: string; data: WhiteboardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchWhiteboard>>,
  TError,
  { id: string; data: WhiteboardDto },
  TContext
> => {
  const mutationOptions = getPatchWhiteboardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get shared workspace meeting
 */
export const getSharedWorkspaceMeeting = (
  id: string,
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingResponse>(
    { url: `/workspace/sharedWorkspace/${id}/meeting/${meetingId}`, method: 'GET', signal },
    options
  );

export const getGetSharedWorkspaceMeetingQueryKey = (id: string, meetingId: string) =>
  [`/workspace/sharedWorkspace/${id}/meeting/${meetingId}`] as const;

export const getGetSharedWorkspaceMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedWorkspaceMeetingQueryKey(id, meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>> = ({
    signal
  }) => getSharedWorkspaceMeeting(id, meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && meetingId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceMeetingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>
>;
export type GetSharedWorkspaceMeetingQueryError = SharedWorkspaceMeetingResponse;

export function useGetSharedWorkspaceMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get shared workspace meeting
 */

export function useGetSharedWorkspaceMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceMeetingQueryOptions(id, meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete shared workspace meeting
 */
export const deleteSharedWorkspaceMeeting = (
  id: string,
  meetingId: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/${id}/meeting/${meetingId}`, method: 'DELETE' },
    options
  );

export const getDeleteSharedWorkspaceMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspaceMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>,
    { id: string; meetingId: string }
  > = props => {
    const { id, meetingId } = props ?? {};

    return deleteSharedWorkspaceMeeting(id, meetingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspaceMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>
>;

export type DeleteSharedWorkspaceMeetingMutationError = unknown;

/**
 * @summary Delete shared workspace meeting
 */
export const useDeleteSharedWorkspaceMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspaceMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch shared workspace meeting
 */
export const patchSharedWorkspaceMeeting = (
  id: string,
  meetingId: string,
  sharedWorkspaceMeetingDto: SharedWorkspaceMeetingDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/${id}/meeting/${meetingId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceMeetingDto
    },
    options
  );

export const getPatchSharedWorkspaceMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string; data: SharedWorkspaceMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string; data: SharedWorkspaceMeetingDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspaceMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>,
    { id: string; meetingId: string; data: SharedWorkspaceMeetingDto }
  > = props => {
    const { id, meetingId, data } = props ?? {};

    return patchSharedWorkspaceMeeting(id, meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspaceMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>
>;
export type PatchSharedWorkspaceMeetingMutationBody = SharedWorkspaceMeetingDto;
export type PatchSharedWorkspaceMeetingMutationError = unknown;

/**
 * @summary Patch shared workspace meeting
 */
export const usePatchSharedWorkspaceMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>,
    TError,
    { id: string; meetingId: string; data: SharedWorkspaceMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeeting>>,
  TError,
  { id: string; meetingId: string; data: SharedWorkspaceMeetingDto },
  TContext
> => {
  const mutationOptions = getPatchSharedWorkspaceMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete shared workspace update
 */
export const deleteSharedWorkspaceUpdate = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/update/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteSharedWorkspaceUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspaceUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedWorkspaceUpdate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspaceUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>
>;

export type DeleteSharedWorkspaceUpdateMutationError = unknown;

/**
 * @summary Delete shared workspace update
 */
export const useDeleteSharedWorkspaceUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspaceUpdate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspaceUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch shared workspace update
 */
export const patchSharedWorkspaceUpdate = (
  id: string,
  sharedWorkspaceUpdateDto: SharedWorkspaceUpdateDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/update/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceUpdateDto
    },
    options
  );

export const getPatchSharedWorkspaceUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>,
    TError,
    { id: string; data: SharedWorkspaceUpdateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>,
  TError,
  { id: string; data: SharedWorkspaceUpdateDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspaceUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>,
    { id: string; data: SharedWorkspaceUpdateDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSharedWorkspaceUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspaceUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>
>;
export type PatchSharedWorkspaceUpdateMutationBody = SharedWorkspaceUpdateDto;
export type PatchSharedWorkspaceUpdateMutationError = unknown;

/**
 * @summary Patch shared workspace update
 */
export const usePatchSharedWorkspaceUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>,
    TError,
    { id: string; data: SharedWorkspaceUpdateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspaceUpdate>>,
  TError,
  { id: string; data: SharedWorkspaceUpdateDto },
  TContext
> => {
  const mutationOptions = getPatchSharedWorkspaceUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete shared workspace point comment
 */
export const deleteSharedWorkspacePointComment = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/point/comment/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteSharedWorkspacePointCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspacePointComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedWorkspacePointComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspacePointCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>
>;

export type DeleteSharedWorkspacePointCommentMutationError = unknown;

/**
 * @summary Delete shared workspace point comment
 */
export const useDeleteSharedWorkspacePointComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspacePointComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspacePointCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch shared workspace point comment
 */
export const patchSharedWorkspacePointComment = (
  id: string,
  sharedWorkspacePointCommentDto: SharedWorkspacePointCommentDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/point/comment/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspacePointCommentDto
    },
    options
  );

export const getPatchSharedWorkspacePointCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>,
    TError,
    { id: string; data: SharedWorkspacePointCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>,
  TError,
  { id: string; data: SharedWorkspacePointCommentDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspacePointComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>,
    { id: string; data: SharedWorkspacePointCommentDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSharedWorkspacePointComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspacePointCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>
>;
export type PatchSharedWorkspacePointCommentMutationBody = SharedWorkspacePointCommentDto;
export type PatchSharedWorkspacePointCommentMutationError = unknown;

/**
 * @summary Patch shared workspace point comment
 */
export const usePatchSharedWorkspacePointComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>,
    TError,
    { id: string; data: SharedWorkspacePointCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspacePointComment>>,
  TError,
  { id: string; data: SharedWorkspacePointCommentDto },
  TContext
> => {
  const mutationOptions = getPatchSharedWorkspacePointCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch shared workspace points
 */
export const bulkPatchSharedWorkspacePoints = (
  bulkPatchRequestSharedWorkspacePointDto: BulkPatchRequestSharedWorkspacePointDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/point/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestSharedWorkspacePointDto
    },
    options
  );

export const getBulkPatchSharedWorkspacePointsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>,
    TError,
    { data: BulkPatchRequestSharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>,
  TError,
  { data: BulkPatchRequestSharedWorkspacePointDto },
  TContext
> => {
  const mutationKey = ['bulkPatchSharedWorkspacePoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>,
    { data: BulkPatchRequestSharedWorkspacePointDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchSharedWorkspacePoints(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchSharedWorkspacePointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>
>;
export type BulkPatchSharedWorkspacePointsMutationBody = BulkPatchRequestSharedWorkspacePointDto;
export type BulkPatchSharedWorkspacePointsMutationError = unknown;

/**
 * @summary Bulk Patch shared workspace points
 */
export const useBulkPatchSharedWorkspacePoints = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>,
    TError,
    { data: BulkPatchRequestSharedWorkspacePointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchSharedWorkspacePoints>>,
  TError,
  { data: BulkPatchRequestSharedWorkspacePointDto },
  TContext
> => {
  const mutationOptions = getBulkPatchSharedWorkspacePointsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete meeting flow template
 */
export const deleteMeetingFlowTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/meetingFlowTemplate/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteMeetingFlowTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMeetingFlowTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMeetingFlowTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingFlowTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>
>;

export type DeleteMeetingFlowTemplateMutationError = unknown;

/**
 * @summary Delete meeting flow template
 */
export const useDeleteMeetingFlowTemplate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeetingFlowTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMeetingFlowTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch meeting flow template
 */
export const patchMeetingFlowTemplate = (
  id: string,
  meetingFlowTemplateDto: MeetingFlowTemplateDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/meetingFlowTemplate/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingFlowTemplateDto
    },
    options
  );

export const getPatchMeetingFlowTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingFlowTemplate>>,
    TError,
    { id: string; data: MeetingFlowTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMeetingFlowTemplate>>,
  TError,
  { id: string; data: MeetingFlowTemplateDto },
  TContext
> => {
  const mutationKey = ['patchMeetingFlowTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMeetingFlowTemplate>>,
    { id: string; data: MeetingFlowTemplateDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMeetingFlowTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMeetingFlowTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMeetingFlowTemplate>>
>;
export type PatchMeetingFlowTemplateMutationBody = MeetingFlowTemplateDto;
export type PatchMeetingFlowTemplateMutationError = unknown;

/**
 * @summary Patch meeting flow template
 */
export const usePatchMeetingFlowTemplate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingFlowTemplate>>,
    TError,
    { id: string; data: MeetingFlowTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMeetingFlowTemplate>>,
  TError,
  { id: string; data: MeetingFlowTemplateDto },
  TContext
> => {
  const mutationOptions = getPatchMeetingFlowTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Shared Workspace meeting flow
 */
export const getMeetingFlow = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingFlowResponse>(
    { url: `/workspace/sharedWorkspace/meetingFlow/${id}`, method: 'GET', signal },
    options
  );

export const getGetMeetingFlowQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/meetingFlow/${id}`] as const;

export const getGetMeetingFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingFlow>>,
  TError = MeetingFlowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingFlow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingFlowQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingFlow>>> = ({ signal }) =>
    getMeetingFlow(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingFlow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingFlowQueryResult = NonNullable<Awaited<ReturnType<typeof getMeetingFlow>>>;
export type GetMeetingFlowQueryError = MeetingFlowResponse;

export function useGetMeetingFlow<
  TData = Awaited<ReturnType<typeof getMeetingFlow>>,
  TError = MeetingFlowResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingFlow>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingFlow>>,
          TError,
          Awaited<ReturnType<typeof getMeetingFlow>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingFlow<
  TData = Awaited<ReturnType<typeof getMeetingFlow>>,
  TError = MeetingFlowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingFlow>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingFlow>>,
          TError,
          Awaited<ReturnType<typeof getMeetingFlow>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingFlow<
  TData = Awaited<ReturnType<typeof getMeetingFlow>>,
  TError = MeetingFlowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingFlow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Shared Workspace meeting flow
 */

export function useGetMeetingFlow<
  TData = Awaited<ReturnType<typeof getMeetingFlow>>,
  TError = MeetingFlowResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingFlow>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingFlowQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch meeting flow
 */
export const deleteMeetingFlow = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/meetingFlow/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteMeetingFlowMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeetingFlow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMeetingFlow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeetingFlow>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMeetingFlow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeetingFlow>>
>;

export type DeleteMeetingFlowMutationError = unknown;

/**
 * @summary Patch meeting flow
 */
export const useDeleteMeetingFlow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingFlow>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeetingFlow>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMeetingFlowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch meeting flow
 */
export const patchMeetingFlow = (
  id: string,
  meetingFlowDto: MeetingFlowDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/meetingFlow/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingFlowDto
    },
    options
  );

export const getPatchMeetingFlowMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingFlow>>,
    TError,
    { id: string; data: MeetingFlowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMeetingFlow>>,
  TError,
  { id: string; data: MeetingFlowDto },
  TContext
> => {
  const mutationKey = ['patchMeetingFlow'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMeetingFlow>>,
    { id: string; data: MeetingFlowDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMeetingFlow(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMeetingFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMeetingFlow>>
>;
export type PatchMeetingFlowMutationBody = MeetingFlowDto;
export type PatchMeetingFlowMutationError = unknown;

/**
 * @summary Patch meeting flow
 */
export const usePatchMeetingFlow = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingFlow>>,
    TError,
    { id: string; data: MeetingFlowDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMeetingFlow>>,
  TError,
  { id: string; data: MeetingFlowDto },
  TContext
> => {
  const mutationOptions = getPatchMeetingFlowMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get shared workspace meeting transcription analysis
 */
export const getSharedWorkspaceMeetingTranscriptionAnalysis = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingTranscriptionAnalysisResponse>(
    {
      url: `/workspace/sharedWorkspace/meeting/${meetingId}/analysis/transcript`,
      method: 'GET',
      signal
    },
    options
  );

export const getGetSharedWorkspaceMeetingTranscriptionAnalysisQueryKey = (meetingId: string) =>
  [`/workspace/sharedWorkspace/meeting/${meetingId}/analysis/transcript`] as const;

export const getGetSharedWorkspaceMeetingTranscriptionAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError = MeetingTranscriptionAnalysisResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSharedWorkspaceMeetingTranscriptionAnalysisQueryKey(meetingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>
  > = ({ signal }) =>
    getSharedWorkspaceMeetingTranscriptionAnalysis(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceMeetingTranscriptionAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>
>;
export type GetSharedWorkspaceMeetingTranscriptionAnalysisQueryError =
  MeetingTranscriptionAnalysisResponse;

export function useGetSharedWorkspaceMeetingTranscriptionAnalysis<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError = MeetingTranscriptionAnalysisResponse
>(
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingTranscriptionAnalysis<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError = MeetingTranscriptionAnalysisResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingTranscriptionAnalysis<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError = MeetingTranscriptionAnalysisResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get shared workspace meeting transcription analysis
 */

export function useGetSharedWorkspaceMeetingTranscriptionAnalysis<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError = MeetingTranscriptionAnalysisResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingTranscriptionAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceMeetingTranscriptionAnalysisQueryOptions(
    meetingId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch shared workspace meeting transcription analysis
 */
export const patchSharedWorkspaceMeetingTranscriptionAnalysis = (
  meetingId: string,
  meetingTranscriptionAnalysisDto: MeetingTranscriptionAnalysisDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/meeting/${meetingId}/analysis/transcript`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingTranscriptionAnalysisDto
    },
    options
  );

export const getPatchSharedWorkspaceMeetingTranscriptionAnalysisMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>,
    TError,
    { meetingId: string; data: MeetingTranscriptionAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError,
  { meetingId: string; data: MeetingTranscriptionAnalysisDto },
  TContext
> => {
  const mutationKey = ['patchSharedWorkspaceMeetingTranscriptionAnalysis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>,
    { meetingId: string; data: MeetingTranscriptionAnalysisDto }
  > = props => {
    const { meetingId, data } = props ?? {};

    return patchSharedWorkspaceMeetingTranscriptionAnalysis(meetingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedWorkspaceMeetingTranscriptionAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>
>;
export type PatchSharedWorkspaceMeetingTranscriptionAnalysisMutationBody =
  MeetingTranscriptionAnalysisDto;
export type PatchSharedWorkspaceMeetingTranscriptionAnalysisMutationError = unknown;

/**
 * @summary Patch shared workspace meeting transcription analysis
 */
export const usePatchSharedWorkspaceMeetingTranscriptionAnalysis = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>,
    TError,
    { meetingId: string; data: MeetingTranscriptionAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedWorkspaceMeetingTranscriptionAnalysis>>,
  TError,
  { meetingId: string; data: MeetingTranscriptionAnalysisDto },
  TContext
> => {
  const mutationOptions =
    getPatchSharedWorkspaceMeetingTranscriptionAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete meeting note
 */
export const deleteSpaceMeetingNote = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/meeting/note/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteSpaceMeetingNoteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceMeetingNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSpaceMeetingNote>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSpaceMeetingNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSpaceMeetingNote>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSpaceMeetingNote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSpaceMeetingNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSpaceMeetingNote>>
>;

export type DeleteSpaceMeetingNoteMutationError = unknown;

/**
 * @summary Delete meeting note
 */
export const useDeleteSpaceMeetingNote = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSpaceMeetingNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSpaceMeetingNote>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSpaceMeetingNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch meeting note
 */
export const patchSpaceMeetingNote = (
  id: string,
  sharedWorkspaceMeetingNoteDto: SharedWorkspaceMeetingNoteDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/sharedWorkspace/meeting/note/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedWorkspaceMeetingNoteDto
    },
    options
  );

export const getPatchSpaceMeetingNoteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSpaceMeetingNote>>,
    TError,
    { id: string; data: SharedWorkspaceMeetingNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSpaceMeetingNote>>,
  TError,
  { id: string; data: SharedWorkspaceMeetingNoteDto },
  TContext
> => {
  const mutationKey = ['patchSpaceMeetingNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSpaceMeetingNote>>,
    { id: string; data: SharedWorkspaceMeetingNoteDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSpaceMeetingNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSpaceMeetingNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSpaceMeetingNote>>
>;
export type PatchSpaceMeetingNoteMutationBody = SharedWorkspaceMeetingNoteDto;
export type PatchSpaceMeetingNoteMutationError = unknown;

/**
 * @summary Patch meeting note
 */
export const usePatchSpaceMeetingNote = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSpaceMeetingNote>>,
    TError,
    { id: string; data: SharedWorkspaceMeetingNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSpaceMeetingNote>>,
  TError,
  { id: string; data: SharedWorkspaceMeetingNoteDto },
  TContext
> => {
  const mutationOptions = getPatchSpaceMeetingNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete resource
 */
export const deleteResource = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workspace/resource/${id}`, method: 'DELETE' }, options);

export const getDeleteResourceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteResource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteResource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteResource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteResource>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteResource(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteResourceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResource>>>;

export type DeleteResourceMutationError = unknown;

/**
 * @summary Delete resource
 */
export const useDeleteResource = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteResource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteResource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteResourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch resource
 */
export const patchResource = (
  id: string,
  resourceDto: ResourceDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/resource/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: resourceDto
    },
    options
  );

export const getPatchResourceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchResource>>,
    TError,
    { id: string; data: ResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchResource>>,
  TError,
  { id: string; data: ResourceDto },
  TContext
> => {
  const mutationKey = ['patchResource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchResource>>,
    { id: string; data: ResourceDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchResource(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchResourceMutationResult = NonNullable<Awaited<ReturnType<typeof patchResource>>>;
export type PatchResourceMutationBody = ResourceDto;
export type PatchResourceMutationError = unknown;

/**
 * @summary Patch resource
 */
export const usePatchResource = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchResource>>,
    TError,
    { id: string; data: ResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchResource>>,
  TError,
  { id: string; data: ResourceDto },
  TContext
> => {
  const mutationOptions = getPatchResourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch resources
 */
export const bulkPatchResources = (
  bulkPatchRequestResourceDto: BulkPatchRequestResourceDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/resource/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestResourceDto
    },
    options
  );

export const getBulkPatchResourcesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchResources>>,
    TError,
    { data: BulkPatchRequestResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchResources>>,
  TError,
  { data: BulkPatchRequestResourceDto },
  TContext
> => {
  const mutationKey = ['bulkPatchResources'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchResources>>,
    { data: BulkPatchRequestResourceDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchResources(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchResourcesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchResources>>
>;
export type BulkPatchResourcesMutationBody = BulkPatchRequestResourceDto;
export type BulkPatchResourcesMutationError = unknown;

/**
 * @summary Bulk Patch resources
 */
export const useBulkPatchResources = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchResources>>,
    TError,
    { data: BulkPatchRequestResourceDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchResources>>,
  TError,
  { data: BulkPatchRequestResourceDto },
  TContext
> => {
  const mutationOptions = getBulkPatchResourcesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete note
 */
export const deleteNote = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workspace/note/${id}`, method: 'DELETE' }, options);

export const getDeleteNoteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNote>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNote>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteNote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNote>>>;

export type DeleteNoteMutationError = unknown;

/**
 * @summary Delete note
 */
export const useDeleteNote = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteNote>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch note
 */
export const patchNote = (
  id: string,
  noteDto: NoteDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/note/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: noteDto
    },
    options
  );

export const getPatchNoteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchNote>>,
    TError,
    { id: string; data: NoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchNote>>,
  TError,
  { id: string; data: NoteDto },
  TContext
> => {
  const mutationKey = ['patchNote'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchNote>>,
    { id: string; data: NoteDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchNoteMutationResult = NonNullable<Awaited<ReturnType<typeof patchNote>>>;
export type PatchNoteMutationBody = NoteDto;
export type PatchNoteMutationError = unknown;

/**
 * @summary Patch note
 */
export const usePatchNote = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchNote>>,
    TError,
    { id: string; data: NoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchNote>>,
  TError,
  { id: string; data: NoteDto },
  TContext
> => {
  const mutationOptions = getPatchNoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch notes
 */
export const bulkPatchNotes = (
  bulkPatchRequestNoteDto: BulkPatchRequestNoteDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/note/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestNoteDto
    },
    options
  );

export const getBulkPatchNotesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchNotes>>,
    TError,
    { data: BulkPatchRequestNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchNotes>>,
  TError,
  { data: BulkPatchRequestNoteDto },
  TContext
> => {
  const mutationKey = ['bulkPatchNotes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchNotes>>,
    { data: BulkPatchRequestNoteDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchNotes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchNotesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkPatchNotes>>>;
export type BulkPatchNotesMutationBody = BulkPatchRequestNoteDto;
export type BulkPatchNotesMutationError = unknown;

/**
 * @summary Bulk Patch notes
 */
export const useBulkPatchNotes = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchNotes>>,
    TError,
    { data: BulkPatchRequestNoteDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchNotes>>,
  TError,
  { data: BulkPatchRequestNoteDto },
  TContext
> => {
  const mutationOptions = getBulkPatchNotesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Module playbook level
 */
export const deleteModulePlaybookLevel = (
  id: string,
  levelId: number,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/module/${id}/playbook/${levelId}`, method: 'DELETE' },
    options
  );

export const getDeleteModulePlaybookLevelMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModulePlaybookLevel>>,
    TError,
    { id: string; levelId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModulePlaybookLevel>>,
  TError,
  { id: string; levelId: number },
  TContext
> => {
  const mutationKey = ['deleteModulePlaybookLevel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModulePlaybookLevel>>,
    { id: string; levelId: number }
  > = props => {
    const { id, levelId } = props ?? {};

    return deleteModulePlaybookLevel(id, levelId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModulePlaybookLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModulePlaybookLevel>>
>;

export type DeleteModulePlaybookLevelMutationError = unknown;

/**
 * @summary Delete Module playbook level
 */
export const useDeleteModulePlaybookLevel = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModulePlaybookLevel>>,
    TError,
    { id: string; levelId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModulePlaybookLevel>>,
  TError,
  { id: string; levelId: number },
  TContext
> => {
  const mutationOptions = getDeleteModulePlaybookLevelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Module playbook level
 */
export const patchModulePlaybookLevel = (
  id: string,
  levelId: number,
  patchModulePlaybookRequest: PatchModulePlaybookRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/${id}/playbook/${levelId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchModulePlaybookRequest
    },
    options
  );

export const getPatchModulePlaybookLevelMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModulePlaybookLevel>>,
    TError,
    { id: string; levelId: number; data: PatchModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchModulePlaybookLevel>>,
  TError,
  { id: string; levelId: number; data: PatchModulePlaybookRequest },
  TContext
> => {
  const mutationKey = ['patchModulePlaybookLevel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchModulePlaybookLevel>>,
    { id: string; levelId: number; data: PatchModulePlaybookRequest }
  > = props => {
    const { id, levelId, data } = props ?? {};

    return patchModulePlaybookLevel(id, levelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchModulePlaybookLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchModulePlaybookLevel>>
>;
export type PatchModulePlaybookLevelMutationBody = PatchModulePlaybookRequest;
export type PatchModulePlaybookLevelMutationError = unknown;

/**
 * @summary Patch Module playbook level
 */
export const usePatchModulePlaybookLevel = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModulePlaybookLevel>>,
    TError,
    { id: string; levelId: number; data: PatchModulePlaybookRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchModulePlaybookLevel>>,
  TError,
  { id: string; levelId: number; data: PatchModulePlaybookRequest },
  TContext
> => {
  const mutationOptions = getPatchModulePlaybookLevelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Module prioritization
 */
export const deleteModulePrioritization = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/module/prioritization/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteModulePrioritizationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModulePrioritization>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModulePrioritization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteModulePrioritization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModulePrioritization>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteModulePrioritization(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModulePrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModulePrioritization>>
>;

export type DeleteModulePrioritizationMutationError = unknown;

/**
 * @summary Delete Module prioritization
 */
export const useDeleteModulePrioritization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModulePrioritization>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModulePrioritization>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteModulePrioritizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Module prioritization
 */
export const patchModulePrioritization = (
  id: string,
  modulePrioritizationDto: ModulePrioritizationDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/prioritization/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: modulePrioritizationDto
    },
    options
  );

export const getPatchModulePrioritizationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModulePrioritization>>,
    TError,
    { id: string; data: ModulePrioritizationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchModulePrioritization>>,
  TError,
  { id: string; data: ModulePrioritizationDto },
  TContext
> => {
  const mutationKey = ['patchModulePrioritization'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchModulePrioritization>>,
    { id: string; data: ModulePrioritizationDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchModulePrioritization(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchModulePrioritizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchModulePrioritization>>
>;
export type PatchModulePrioritizationMutationBody = ModulePrioritizationDto;
export type PatchModulePrioritizationMutationError = unknown;

/**
 * @summary Patch Module prioritization
 */
export const usePatchModulePrioritization = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModulePrioritization>>,
    TError,
    { id: string; data: ModulePrioritizationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchModulePrioritization>>,
  TError,
  { id: string; data: ModulePrioritizationDto },
  TContext
> => {
  const mutationOptions = getPatchModulePrioritizationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete custom module
 */
export const deleteCustomModule = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workspace/module/metadata/${id}`, method: 'DELETE' }, options);

export const getDeleteCustomModuleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomModule>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomModule>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteCustomModule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomModule>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteCustomModule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomModuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomModule>>
>;

export type DeleteCustomModuleMutationError = unknown;

/**
 * @summary Delete custom module
 */
export const useDeleteCustomModule = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomModule>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomModule>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteCustomModuleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch custom module
 */
export const patchCustomModule = (
  id: string,
  customModuleRequest: CustomModuleRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/metadata/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: customModuleRequest
    },
    options
  );

export const getPatchCustomModuleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomModule>>,
    TError,
    { id: string; data: CustomModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCustomModule>>,
  TError,
  { id: string; data: CustomModuleRequest },
  TContext
> => {
  const mutationKey = ['patchCustomModule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCustomModule>>,
    { id: string; data: CustomModuleRequest }
  > = props => {
    const { id, data } = props ?? {};

    return patchCustomModule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchCustomModuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCustomModule>>
>;
export type PatchCustomModuleMutationBody = CustomModuleRequest;
export type PatchCustomModuleMutationError = unknown;

/**
 * @summary Patch custom module
 */
export const usePatchCustomModule = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomModule>>,
    TError,
    { id: string; data: CustomModuleRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchCustomModule>>,
  TError,
  { id: string; data: CustomModuleRequest },
  TContext
> => {
  const mutationOptions = getPatchCustomModuleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Module idea
 */
export const deleteModuleIdea = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workspace/module/idea/${id}`, method: 'DELETE' }, options);

export const getDeleteModuleIdeaMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModuleIdea>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteModuleIdea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteModuleIdea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModuleIdea>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteModuleIdea(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteModuleIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteModuleIdea>>
>;

export type DeleteModuleIdeaMutationError = unknown;

/**
 * @summary Delete Module idea
 */
export const useDeleteModuleIdea = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteModuleIdea>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteModuleIdea>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteModuleIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Module idea
 */
export const patchModuleIdea = (
  id: string,
  moduleIdeaDto: ModuleIdeaDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workspace/module/idea/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: moduleIdeaDto
    },
    options
  );

export const getPatchModuleIdeaMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModuleIdea>>,
    TError,
    { id: string; data: ModuleIdeaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchModuleIdea>>,
  TError,
  { id: string; data: ModuleIdeaDto },
  TContext
> => {
  const mutationKey = ['patchModuleIdea'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchModuleIdea>>,
    { id: string; data: ModuleIdeaDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchModuleIdea(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchModuleIdeaMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchModuleIdea>>
>;
export type PatchModuleIdeaMutationBody = ModuleIdeaDto;
export type PatchModuleIdeaMutationError = unknown;

/**
 * @summary Patch Module idea
 */
export const usePatchModuleIdea = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchModuleIdea>>,
    TError,
    { id: string; data: ModuleIdeaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchModuleIdea>>,
  TError,
  { id: string; data: ModuleIdeaDto },
  TContext
> => {
  const mutationOptions = getPatchModuleIdeaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get User Agents Config
 */
export const getUserAgentsConfig = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UserAgentsConfigResponse>(
    { url: `/workbench/userAgents`, method: 'GET', signal },
    options
  );

export const getGetUserAgentsConfigQueryKey = () => [`/workbench/userAgents`] as const;

export const getGetUserAgentsConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserAgentsConfig>>,
  TError = UserAgentsConfigResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAgentsConfig>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserAgentsConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAgentsConfig>>> = ({ signal }) =>
    getUserAgentsConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserAgentsConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserAgentsConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserAgentsConfig>>
>;
export type GetUserAgentsConfigQueryError = UserAgentsConfigResponse;

export function useGetUserAgentsConfig<
  TData = Awaited<ReturnType<typeof getUserAgentsConfig>>,
  TError = UserAgentsConfigResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAgentsConfig>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserAgentsConfig>>,
        TError,
        Awaited<ReturnType<typeof getUserAgentsConfig>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAgentsConfig<
  TData = Awaited<ReturnType<typeof getUserAgentsConfig>>,
  TError = UserAgentsConfigResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAgentsConfig>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserAgentsConfig>>,
        TError,
        Awaited<ReturnType<typeof getUserAgentsConfig>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserAgentsConfig<
  TData = Awaited<ReturnType<typeof getUserAgentsConfig>>,
  TError = UserAgentsConfigResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAgentsConfig>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get User Agents Config
 */

export function useGetUserAgentsConfig<
  TData = Awaited<ReturnType<typeof getUserAgentsConfig>>,
  TError = UserAgentsConfigResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAgentsConfig>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserAgentsConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch User Agents Config
 */
export const patchUserAgentsConfig = (
  userAgentsConfigDto: UserAgentsConfigDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/userAgents`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: userAgentsConfigDto
    },
    options
  );

export const getPatchUserAgentsConfigMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchUserAgentsConfig>>,
    TError,
    { data: UserAgentsConfigDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchUserAgentsConfig>>,
  TError,
  { data: UserAgentsConfigDto },
  TContext
> => {
  const mutationKey = ['patchUserAgentsConfig'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchUserAgentsConfig>>,
    { data: UserAgentsConfigDto }
  > = props => {
    const { data } = props ?? {};

    return patchUserAgentsConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchUserAgentsConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchUserAgentsConfig>>
>;
export type PatchUserAgentsConfigMutationBody = UserAgentsConfigDto;
export type PatchUserAgentsConfigMutationError = unknown;

/**
 * @summary Patch User Agents Config
 */
export const usePatchUserAgentsConfig = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchUserAgentsConfig>>,
    TError,
    { data: UserAgentsConfigDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchUserAgentsConfig>>,
  TError,
  { data: UserAgentsConfigDto },
  TContext
> => {
  const mutationOptions = getPatchUserAgentsConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Shared Meeting
 */
export const deleteSharedMeeting = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/workbench/sharedMeeting/${id}`, method: 'DELETE' }, options);

export const getDeleteSharedMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedMeeting>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedMeeting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedMeeting>>
>;

export type DeleteSharedMeetingMutationError = unknown;

/**
 * @summary Delete Shared Meeting
 */
export const useDeleteSharedMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Shared Meeting
 */
export const patchSharedMeeting = (
  id: string,
  sharedMeetingDto: SharedMeetingDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/sharedMeeting/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: sharedMeetingDto
    },
    options
  );

export const getPatchSharedMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedMeeting>>,
    TError,
    { id: string; data: SharedMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSharedMeeting>>,
  TError,
  { id: string; data: SharedMeetingDto },
  TContext
> => {
  const mutationKey = ['patchSharedMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSharedMeeting>>,
    { id: string; data: SharedMeetingDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchSharedMeeting(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSharedMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSharedMeeting>>
>;
export type PatchSharedMeetingMutationBody = SharedMeetingDto;
export type PatchSharedMeetingMutationError = unknown;

/**
 * @summary Patch Shared Meeting
 */
export const usePatchSharedMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSharedMeeting>>,
    TError,
    { id: string; data: SharedMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchSharedMeeting>>,
  TError,
  { id: string; data: SharedMeetingDto },
  TContext
> => {
  const mutationOptions = getPatchSharedMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Quick Action
 */
export const patchQuickAction = (
  id: string,
  quickActionDto: QuickActionDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/quickAction/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: quickActionDto
    },
    options
  );

export const getPatchQuickActionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchQuickAction>>,
    TError,
    { id: string; data: QuickActionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchQuickAction>>,
  TError,
  { id: string; data: QuickActionDto },
  TContext
> => {
  const mutationKey = ['patchQuickAction'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchQuickAction>>,
    { id: string; data: QuickActionDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchQuickAction(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchQuickActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchQuickAction>>
>;
export type PatchQuickActionMutationBody = QuickActionDto;
export type PatchQuickActionMutationError = unknown;

/**
 * @summary Patch Quick Action
 */
export const usePatchQuickAction = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchQuickAction>>,
    TError,
    { id: string; data: QuickActionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchQuickAction>>,
  TError,
  { id: string; data: QuickActionDto },
  TContext
> => {
  const mutationOptions = getPatchQuickActionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Meeting Template
 */
export const getMeetingTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingTemplateResponse>(
    { url: `/workbench/meetingTemplate/${id}`, method: 'GET', signal },
    options
  );

export const getGetMeetingTemplateQueryKey = (id: string) =>
  [`/workbench/meetingTemplate/${id}`] as const;

export const getGetMeetingTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingTemplate>>,
  TError = MeetingTemplateResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingTemplate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingTemplateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingTemplate>>> = ({ signal }) =>
    getMeetingTemplate(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingTemplate>>
>;
export type GetMeetingTemplateQueryError = MeetingTemplateResponse;

export function useGetMeetingTemplate<
  TData = Awaited<ReturnType<typeof getMeetingTemplate>>,
  TError = MeetingTemplateResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingTemplate>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingTemplate>>,
          TError,
          Awaited<ReturnType<typeof getMeetingTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingTemplate<
  TData = Awaited<ReturnType<typeof getMeetingTemplate>>,
  TError = MeetingTemplateResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingTemplate>>,
          TError,
          Awaited<ReturnType<typeof getMeetingTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingTemplate<
  TData = Awaited<ReturnType<typeof getMeetingTemplate>>,
  TError = MeetingTemplateResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingTemplate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting Template
 */

export function useGetMeetingTemplate<
  TData = Awaited<ReturnType<typeof getMeetingTemplate>>,
  TError = MeetingTemplateResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingTemplate>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Meeting Template
 */
export const deleteMeetingTemplate = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/workbench/meetingTemplate/${id}`, method: 'DELETE' }, options);

export const getDeleteMeetingTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeetingTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMeetingTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeetingTemplate>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMeetingTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeetingTemplate>>
>;

export type DeleteMeetingTemplateMutationError = unknown;

/**
 * @summary Delete Meeting Template
 */
export const useDeleteMeetingTemplate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeetingTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMeetingTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch Meeting Template
 */
export const patchMeetingTemplate = (
  id: string,
  meetingTemplateDto: MeetingTemplateDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/meetingTemplate/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingTemplateDto
    },
    options
  );

export const getPatchMeetingTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingTemplate>>,
    TError,
    { id: string; data: MeetingTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMeetingTemplate>>,
  TError,
  { id: string; data: MeetingTemplateDto },
  TContext
> => {
  const mutationKey = ['patchMeetingTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMeetingTemplate>>,
    { id: string; data: MeetingTemplateDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMeetingTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMeetingTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMeetingTemplate>>
>;
export type PatchMeetingTemplateMutationBody = MeetingTemplateDto;
export type PatchMeetingTemplateMutationError = unknown;

/**
 * @summary Patch Meeting Template
 */
export const usePatchMeetingTemplate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingTemplate>>,
    TError,
    { id: string; data: MeetingTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMeetingTemplate>>,
  TError,
  { id: string; data: MeetingTemplateDto },
  TContext
> => {
  const mutationOptions = getPatchMeetingTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Meeting
 */
export const getCalendarMeeting = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingResponse>(
    { url: `/workbench/meeting/${id}`, method: 'GET', signal },
    options
  );

export const getGetCalendarMeetingQueryKey = (id: string) => [`/workbench/meeting/${id}`] as const;

export const getGetCalendarMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalendarMeeting>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCalendarMeetingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarMeeting>>> = ({ signal }) =>
    getCalendarMeeting(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCalendarMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarMeetingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalendarMeeting>>
>;
export type GetCalendarMeetingQueryError = CalendarMeetingResponse;

export function useGetCalendarMeeting<
  TData = Awaited<ReturnType<typeof getCalendarMeeting>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeeting>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarMeeting>>,
          TError,
          Awaited<ReturnType<typeof getCalendarMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCalendarMeeting<
  TData = Awaited<ReturnType<typeof getCalendarMeeting>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeeting>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarMeeting>>,
          TError,
          Awaited<ReturnType<typeof getCalendarMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCalendarMeeting<
  TData = Awaited<ReturnType<typeof getCalendarMeeting>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting
 */

export function useGetCalendarMeeting<
  TData = Awaited<ReturnType<typeof getCalendarMeeting>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeeting>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCalendarMeetingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch Meeting
 */
export const patchCalendarMeeting = (
  id: string,
  calendarMeetingDto: CalendarMeetingDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/meeting/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: calendarMeetingDto
    },
    options
  );

export const getPatchCalendarMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCalendarMeeting>>,
    TError,
    { id: string; data: CalendarMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCalendarMeeting>>,
  TError,
  { id: string; data: CalendarMeetingDto },
  TContext
> => {
  const mutationKey = ['patchCalendarMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCalendarMeeting>>,
    { id: string; data: CalendarMeetingDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchCalendarMeeting(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchCalendarMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCalendarMeeting>>
>;
export type PatchCalendarMeetingMutationBody = CalendarMeetingDto;
export type PatchCalendarMeetingMutationError = unknown;

/**
 * @summary Patch Meeting
 */
export const usePatchCalendarMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCalendarMeeting>>,
    TError,
    { id: string; data: CalendarMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchCalendarMeeting>>,
  TError,
  { id: string; data: CalendarMeetingDto },
  TContext
> => {
  const mutationOptions = getPatchCalendarMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Meeting Analysis
 */
export const getMeetingAnalysis = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAnalysisResponse>(
    { url: `/workbench/meeting/analysis/${id}`, method: 'GET', signal },
    options
  );

export const getGetMeetingAnalysisQueryKey = (id: string) =>
  [`/workbench/meeting/analysis/${id}`] as const;

export const getGetMeetingAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingAnalysisQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingAnalysis>>> = ({ signal }) =>
    getMeetingAnalysis(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingAnalysis>>
>;
export type GetMeetingAnalysisQueryError = MeetingAnalysisResponse;

export function useGetMeetingAnalysis<
  TData = Awaited<ReturnType<typeof getMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAnalysis>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAnalysis<
  TData = Awaited<ReturnType<typeof getMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingAnalysis>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAnalysis<
  TData = Awaited<ReturnType<typeof getMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting Analysis
 */

export function useGetMeetingAnalysis<
  TData = Awaited<ReturnType<typeof getMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAnalysis>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch Meeting Analysis
 */
export const patchMeetingAnalysis = (
  id: string,
  meetingAnalysisDto: MeetingAnalysisDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/workbench/meeting/analysis/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingAnalysisDto
    },
    options
  );

export const getPatchMeetingAnalysisMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingAnalysis>>,
    TError,
    { id: string; data: MeetingAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMeetingAnalysis>>,
  TError,
  { id: string; data: MeetingAnalysisDto },
  TContext
> => {
  const mutationKey = ['patchMeetingAnalysis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMeetingAnalysis>>,
    { id: string; data: MeetingAnalysisDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMeetingAnalysis(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMeetingAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMeetingAnalysis>>
>;
export type PatchMeetingAnalysisMutationBody = MeetingAnalysisDto;
export type PatchMeetingAnalysisMutationError = unknown;

/**
 * @summary Patch Meeting Analysis
 */
export const usePatchMeetingAnalysis = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingAnalysis>>,
    TError,
    { id: string; data: MeetingAnalysisDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMeetingAnalysis>>,
  TError,
  { id: string; data: MeetingAnalysisDto },
  TContext
> => {
  const mutationOptions = getPatchMeetingAnalysisMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get team
 */
export const getTeam = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<TeamResponse>({ url: `/team/${id}`, method: 'GET', signal }, options);

export const getGetTeamQueryKey = (id: string) => [`/team/${id}`] as const;

export const getGetTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = TeamResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({ signal }) =>
    getTeam(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeam>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>;
export type GetTeamQueryError = TeamResponse;

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = TeamResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = TeamResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = TeamResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get team
 */

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = TeamResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTeamQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary delete team
 */
export const deleteTeam = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/team/${id}`, method: 'DELETE' }, options);

export const getDeleteTeamMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeam>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeam>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteTeam'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeam>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteTeam(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>;

export type DeleteTeamMutationError = unknown;

/**
 * @summary delete team
 */
export const useDeleteTeam = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeam>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deleteTeam>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteTeamMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary patch team
 */
export const patchTeam = (
  id: string,
  teamDto: TeamDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/team/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: teamDto
    },
    options
  );

export const getPatchTeamMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTeam>>,
    TError,
    { id: string; data: TeamDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchTeam>>,
  TError,
  { id: string; data: TeamDto },
  TContext
> => {
  const mutationKey = ['patchTeam'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchTeam>>,
    { id: string; data: TeamDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchTeam(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchTeamMutationResult = NonNullable<Awaited<ReturnType<typeof patchTeam>>>;
export type PatchTeamMutationBody = TeamDto;
export type PatchTeamMutationError = unknown;

/**
 * @summary patch team
 */
export const usePatchTeam = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTeam>>,
    TError,
    { id: string; data: TeamDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchTeam>>,
  TError,
  { id: string; data: TeamDto },
  TContext
> => {
  const mutationOptions = getPatchTeamMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete metric
 */
export const deleteMetric = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/metric/${id}`, method: 'DELETE' }, options);

export const getDeleteMetricMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetric>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMetric>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMetric'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMetric>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMetric(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMetricMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMetric>>>;

export type DeleteMetricMutationError = unknown;

/**
 * @summary Delete metric
 */
export const useDeleteMetric = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetric>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMetric>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMetricMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch metric
 */
export const patchMetric = (
  id: string,
  metricDto: MetricDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: metricDto
    },
    options
  );

export const getPatchMetricMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetric>>,
    TError,
    { id: string; data: MetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMetric>>,
  TError,
  { id: string; data: MetricDto },
  TContext
> => {
  const mutationKey = ['patchMetric'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMetric>>,
    { id: string; data: MetricDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMetric(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMetricMutationResult = NonNullable<Awaited<ReturnType<typeof patchMetric>>>;
export type PatchMetricMutationBody = MetricDto;
export type PatchMetricMutationError = unknown;

/**
 * @summary Patch metric
 */
export const usePatchMetric = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetric>>,
    TError,
    { id: string; data: MetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMetric>>,
  TError,
  { id: string; data: MetricDto },
  TContext
> => {
  const mutationOptions = getPatchMetricMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get okr metric
 */
export const getOkrMetric = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<OkrMetricResponse>({ url: `/metric/okr/${id}`, method: 'GET', signal }, options);

export const getGetOkrMetricQueryKey = (id: string) => [`/metric/okr/${id}`] as const;

export const getGetOkrMetricQueryOptions = <
  TData = Awaited<ReturnType<typeof getOkrMetric>>,
  TError = OkrMetricResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOkrMetric>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOkrMetricQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOkrMetric>>> = ({ signal }) =>
    getOkrMetric(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOkrMetric>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOkrMetricQueryResult = NonNullable<Awaited<ReturnType<typeof getOkrMetric>>>;
export type GetOkrMetricQueryError = OkrMetricResponse;

export function useGetOkrMetric<
  TData = Awaited<ReturnType<typeof getOkrMetric>>,
  TError = OkrMetricResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOkrMetric>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOkrMetric>>,
          TError,
          Awaited<ReturnType<typeof getOkrMetric>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOkrMetric<
  TData = Awaited<ReturnType<typeof getOkrMetric>>,
  TError = OkrMetricResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOkrMetric>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOkrMetric>>,
          TError,
          Awaited<ReturnType<typeof getOkrMetric>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOkrMetric<
  TData = Awaited<ReturnType<typeof getOkrMetric>>,
  TError = OkrMetricResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOkrMetric>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get okr metric
 */

export function useGetOkrMetric<
  TData = Awaited<ReturnType<typeof getOkrMetric>>,
  TError = OkrMetricResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOkrMetric>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOkrMetricQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete okr metric
 */
export const deleteOkrMetric = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/metric/okr/${id}`, method: 'DELETE' }, options);

export const getDeleteOkrMetricMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOkrMetric>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOkrMetric>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteOkrMetric'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOkrMetric>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteOkrMetric(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOkrMetricMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOkrMetric>>
>;

export type DeleteOkrMetricMutationError = unknown;

/**
 * @summary Delete okr metric
 */
export const useDeleteOkrMetric = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOkrMetric>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOkrMetric>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteOkrMetricMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch okr metric
 */
export const patchOkrMetric = (
  id: string,
  okrMetricDto: OkrMetricDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/okr/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: okrMetricDto
    },
    options
  );

export const getPatchOkrMetricMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOkrMetric>>,
    TError,
    { id: string; data: OkrMetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchOkrMetric>>,
  TError,
  { id: string; data: OkrMetricDto },
  TContext
> => {
  const mutationKey = ['patchOkrMetric'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchOkrMetric>>,
    { id: string; data: OkrMetricDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchOkrMetric(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchOkrMetricMutationResult = NonNullable<Awaited<ReturnType<typeof patchOkrMetric>>>;
export type PatchOkrMetricMutationBody = OkrMetricDto;
export type PatchOkrMetricMutationError = unknown;

/**
 * @summary Patch okr metric
 */
export const usePatchOkrMetric = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchOkrMetric>>,
    TError,
    { id: string; data: OkrMetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchOkrMetric>>,
  TError,
  { id: string; data: OkrMetricDto },
  TContext
> => {
  const mutationOptions = getPatchOkrMetricMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk patch metric definitions
 */
export const bulkPatchMetricDefinitions = (
  bulkPatchRequestMetricDefinitionDto: BulkPatchRequestMetricDefinitionDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/definition/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestMetricDefinitionDto
    },
    options
  );

export const getBulkPatchMetricDefinitionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>,
    TError,
    { data: BulkPatchRequestMetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>,
  TError,
  { data: BulkPatchRequestMetricDefinitionDto },
  TContext
> => {
  const mutationKey = ['bulkPatchMetricDefinitions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>,
    { data: BulkPatchRequestMetricDefinitionDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchMetricDefinitions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchMetricDefinitionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>
>;
export type BulkPatchMetricDefinitionsMutationBody = BulkPatchRequestMetricDefinitionDto;
export type BulkPatchMetricDefinitionsMutationError = unknown;

/**
 * @summary Bulk patch metric definitions
 */
export const useBulkPatchMetricDefinitions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>,
    TError,
    { data: BulkPatchRequestMetricDefinitionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchMetricDefinitions>>,
  TError,
  { data: BulkPatchRequestMetricDefinitionDto },
  TContext
> => {
  const mutationOptions = getBulkPatchMetricDefinitionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete metric definition data points
 */
export const deleteMetricDataPoint = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/metric/dataPoint/${id}`, method: 'DELETE' }, options);

export const getDeleteMetricDataPointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetricDataPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMetricDataPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMetricDataPoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMetricDataPoint>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMetricDataPoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMetricDataPointMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMetricDataPoint>>
>;

export type DeleteMetricDataPointMutationError = unknown;

/**
 * @summary Delete metric definition data points
 */
export const useDeleteMetricDataPoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMetricDataPoint>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMetricDataPoint>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMetricDataPointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch metric definition data point
 */
export const patchMetricDataPoint = (
  id: string,
  metricDataPointDto: MetricDataPointDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/dataPoint/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: metricDataPointDto
    },
    options
  );

export const getPatchMetricDataPointMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetricDataPoint>>,
    TError,
    { id: string; data: MetricDataPointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMetricDataPoint>>,
  TError,
  { id: string; data: MetricDataPointDto },
  TContext
> => {
  const mutationKey = ['patchMetricDataPoint'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMetricDataPoint>>,
    { id: string; data: MetricDataPointDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMetricDataPoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMetricDataPointMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMetricDataPoint>>
>;
export type PatchMetricDataPointMutationBody = MetricDataPointDto;
export type PatchMetricDataPointMutationError = unknown;

/**
 * @summary Patch metric definition data point
 */
export const usePatchMetricDataPoint = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMetricDataPoint>>,
    TError,
    { id: string; data: MetricDataPointDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMetricDataPoint>>,
  TError,
  { id: string; data: MetricDataPointDto },
  TContext
> => {
  const mutationOptions = getPatchMetricDataPointMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch metrics
 */
export const bulkPatchMetrics = (
  bulkPatchRequestMetricDto: BulkPatchRequestMetricDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/metric/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestMetricDto
    },
    options
  );

export const getBulkPatchMetricsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchMetrics>>,
    TError,
    { data: BulkPatchRequestMetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchMetrics>>,
  TError,
  { data: BulkPatchRequestMetricDto },
  TContext
> => {
  const mutationKey = ['bulkPatchMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchMetrics>>,
    { data: BulkPatchRequestMetricDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchMetrics>>
>;
export type BulkPatchMetricsMutationBody = BulkPatchRequestMetricDto;
export type BulkPatchMetricsMutationError = unknown;

/**
 * @summary Bulk Patch metrics
 */
export const useBulkPatchMetrics = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchMetrics>>,
    TError,
    { data: BulkPatchRequestMetricDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchMetrics>>,
  TError,
  { data: BulkPatchRequestMetricDto },
  TContext
> => {
  const mutationOptions = getBulkPatchMetricsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete scheduled meeting
 */
export const deleteScheduledMeeting = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/meeting/scheduled/${id}`, method: 'DELETE' }, options);

export const getDeleteScheduledMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScheduledMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteScheduledMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteScheduledMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteScheduledMeeting>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteScheduledMeeting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScheduledMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteScheduledMeeting>>
>;

export type DeleteScheduledMeetingMutationError = unknown;

/**
 * @summary Delete scheduled meeting
 */
export const useDeleteScheduledMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScheduledMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteScheduledMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteScheduledMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch scheduled meeting
 */
export const patchScheduledMeeting = (
  id: string,
  scheduledMeetingDto: ScheduledMeetingDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/scheduled/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: scheduledMeetingDto
    },
    options
  );

export const getPatchScheduledMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchScheduledMeeting>>,
    TError,
    { id: string; data: ScheduledMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchScheduledMeeting>>,
  TError,
  { id: string; data: ScheduledMeetingDto },
  TContext
> => {
  const mutationKey = ['patchScheduledMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchScheduledMeeting>>,
    { id: string; data: ScheduledMeetingDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchScheduledMeeting(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchScheduledMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchScheduledMeeting>>
>;
export type PatchScheduledMeetingMutationBody = ScheduledMeetingDto;
export type PatchScheduledMeetingMutationError = unknown;

/**
 * @summary Patch scheduled meeting
 */
export const usePatchScheduledMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchScheduledMeeting>>,
    TError,
    { id: string; data: ScheduledMeetingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchScheduledMeeting>>,
  TError,
  { id: string; data: ScheduledMeetingDto },
  TContext
> => {
  const mutationOptions = getPatchScheduledMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete meeting agenda
 */
export const deleteMeetingAgenda = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/meeting/agenda/${id}`, method: 'DELETE' }, options);

export const getDeleteMeetingAgendaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingAgenda>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeetingAgenda>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMeetingAgenda'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeetingAgenda>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteMeetingAgenda(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingAgendaMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMeetingAgenda>>
>;

export type DeleteMeetingAgendaMutationError = unknown;

/**
 * @summary Delete meeting agenda
 */
export const useDeleteMeetingAgenda = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeetingAgenda>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeetingAgenda>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMeetingAgendaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch meeting agenda
 */
export const patchMeetingAgenda = (
  id: string,
  meetingAgendaDto: MeetingAgendaDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/meeting/agenda/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: meetingAgendaDto
    },
    options
  );

export const getPatchMeetingAgendaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingAgenda>>,
    TError,
    { id: string; data: MeetingAgendaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMeetingAgenda>>,
  TError,
  { id: string; data: MeetingAgendaDto },
  TContext
> => {
  const mutationKey = ['patchMeetingAgenda'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMeetingAgenda>>,
    { id: string; data: MeetingAgendaDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchMeetingAgenda(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMeetingAgendaMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMeetingAgenda>>
>;
export type PatchMeetingAgendaMutationBody = MeetingAgendaDto;
export type PatchMeetingAgendaMutationError = unknown;

/**
 * @summary Patch meeting agenda
 */
export const usePatchMeetingAgenda = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMeetingAgenda>>,
    TError,
    { id: string; data: MeetingAgendaDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMeetingAgenda>>,
  TError,
  { id: string; data: MeetingAgendaDto },
  TContext
> => {
  const mutationOptions = getPatchMeetingAgendaMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete account data provider
 */
export const deleteAccountDataProvider = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/integration/dataProvider/${id}`, method: 'DELETE' }, options);

export const getDeleteAccountDataProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountDataProvider>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountDataProvider>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteAccountDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountDataProvider>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteAccountDataProvider(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountDataProvider>>
>;

export type DeleteAccountDataProviderMutationError = unknown;

/**
 * @summary Delete account data provider
 */
export const useDeleteAccountDataProvider = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountDataProvider>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountDataProvider>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteAccountDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch data provider
 */
export const patchDataProvider = (
  id: string,
  partialAccountDataProviderDto: PartialAccountDataProviderDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/integration/dataProvider/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: partialAccountDataProviderDto
    },
    options
  );

export const getPatchDataProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchDataProvider>>,
    TError,
    { id: string; data: PartialAccountDataProviderDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchDataProvider>>,
  TError,
  { id: string; data: PartialAccountDataProviderDto },
  TContext
> => {
  const mutationKey = ['patchDataProvider'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchDataProvider>>,
    { id: string; data: PartialAccountDataProviderDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchDataProvider(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchDataProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchDataProvider>>
>;
export type PatchDataProviderMutationBody = PartialAccountDataProviderDto;
export type PatchDataProviderMutationError = unknown;

/**
 * @summary Patch data provider
 */
export const usePatchDataProvider = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchDataProvider>>,
    TError,
    { id: string; data: PartialAccountDataProviderDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchDataProvider>>,
  TError,
  { id: string; data: PartialAccountDataProviderDto },
  TContext
> => {
  const mutationOptions = getPatchDataProviderMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get post
 */
export const getPost = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<PostResponse>({ url: `/forum/post/${id}`, method: 'GET', signal }, options);

export const getGetPostQueryKey = (id: string) => [`/forum/post/${id}`] as const;

export const getGetPostQueryOptions = <
  TData = Awaited<ReturnType<typeof getPost>>,
  TError = PostResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPostQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPost>>> = ({ signal }) =>
    getPost(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPostQueryResult = NonNullable<Awaited<ReturnType<typeof getPost>>>;
export type GetPostQueryError = PostResponse;

export function useGetPost<TData = Awaited<ReturnType<typeof getPost>>, TError = PostResponse>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPost>>,
          TError,
          Awaited<ReturnType<typeof getPost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPost<TData = Awaited<ReturnType<typeof getPost>>, TError = PostResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPost>>,
          TError,
          Awaited<ReturnType<typeof getPost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPost<TData = Awaited<ReturnType<typeof getPost>>, TError = PostResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get post
 */

export function useGetPost<TData = Awaited<ReturnType<typeof getPost>>, TError = PostResponse>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPost>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPostQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete post
 */
export const deletePost = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/forum/post/${id}`, method: 'DELETE' }, options);

export const getDeletePostMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePost>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deletePost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePost>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deletePost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePostMutationResult = NonNullable<Awaited<ReturnType<typeof deletePost>>>;

export type DeletePostMutationError = unknown;

/**
 * @summary Delete post
 */
export const useDeletePost = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePost>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<Awaited<ReturnType<typeof deletePost>>, TError, { id: string }, TContext> => {
  const mutationOptions = getDeletePostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch post
 */
export const patchPost = (
  id: string,
  postDto: PostDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/forum/post/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: postDto
    },
    options
  );

export const getPatchPostMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchPost>>,
    TError,
    { id: string; data: PostDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchPost>>,
  TError,
  { id: string; data: PostDto },
  TContext
> => {
  const mutationKey = ['patchPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchPost>>,
    { id: string; data: PostDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchPostMutationResult = NonNullable<Awaited<ReturnType<typeof patchPost>>>;
export type PatchPostMutationBody = PostDto;
export type PatchPostMutationError = unknown;

/**
 * @summary Patch post
 */
export const usePatchPost = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchPost>>,
    TError,
    { id: string; data: PostDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchPost>>,
  TError,
  { id: string; data: PostDto },
  TContext
> => {
  const mutationOptions = getPatchPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete comment
 */
export const deleteComment = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/forum/comment/${id}`, method: 'DELETE' }, options);

export const getDeleteCommentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteComment>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComment>>>;

export type DeleteCommentMutationError = unknown;

/**
 * @summary Delete comment
 */
export const useDeleteComment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch comment
 */
export const patchComment = (
  id: string,
  commentDto: CommentDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/forum/comment/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: commentDto
    },
    options
  );

export const getPatchCommentMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchComment>>,
    TError,
    { id: string; data: CommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchComment>>,
  TError,
  { id: string; data: CommentDto },
  TContext
> => {
  const mutationKey = ['patchComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchComment>>,
    { id: string; data: CommentDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchCommentMutationResult = NonNullable<Awaited<ReturnType<typeof patchComment>>>;
export type PatchCommentMutationBody = CommentDto;
export type PatchCommentMutationError = unknown;

/**
 * @summary Patch comment
 */
export const usePatchComment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchComment>>,
    TError,
    { id: string; data: CommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchComment>>,
  TError,
  { id: string; data: CommentDto },
  TContext
> => {
  const mutationOptions = getPatchCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete objective comment
 */
export const deleteActionPlanObjectiveComment = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/actionPlan/objective/comment/${id}`, method: 'DELETE' }, options);

export const getDeleteActionPlanObjectiveCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteActionPlanObjectiveComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteActionPlanObjectiveComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanObjectiveCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>
>;

export type DeleteActionPlanObjectiveCommentMutationError = unknown;

/**
 * @summary Delete objective comment
 */
export const useDeleteActionPlanObjectiveComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanObjectiveComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanObjectiveCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch objective comment
 */
export const patchActionPlanObjectiveComment = (
  id: string,
  actionPlanObjectiveCommentDto: ActionPlanObjectiveCommentDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/objective/comment/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanObjectiveCommentDto
    },
    options
  );

export const getPatchActionPlanObjectiveCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>,
    TError,
    { id: string; data: ActionPlanObjectiveCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>,
  TError,
  { id: string; data: ActionPlanObjectiveCommentDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanObjectiveComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>,
    { id: string; data: ActionPlanObjectiveCommentDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanObjectiveComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanObjectiveCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>
>;
export type PatchActionPlanObjectiveCommentMutationBody = ActionPlanObjectiveCommentDto;
export type PatchActionPlanObjectiveCommentMutationError = unknown;

/**
 * @summary Patch objective comment
 */
export const usePatchActionPlanObjectiveComment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>,
    TError,
    { id: string; data: ActionPlanObjectiveCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanObjectiveComment>>,
  TError,
  { id: string; data: ActionPlanObjectiveCommentDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanObjectiveCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch objectives
 */
export const bulkPatchObjectives = (
  bulkPatchRequestActionPlanObjectiveDto: BulkPatchRequestActionPlanObjectiveDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/objective/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestActionPlanObjectiveDto
    },
    options
  );

export const getBulkPatchObjectivesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchObjectives>>,
    TError,
    { data: BulkPatchRequestActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchObjectives>>,
  TError,
  { data: BulkPatchRequestActionPlanObjectiveDto },
  TContext
> => {
  const mutationKey = ['bulkPatchObjectives'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchObjectives>>,
    { data: BulkPatchRequestActionPlanObjectiveDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchObjectives(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchObjectivesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchObjectives>>
>;
export type BulkPatchObjectivesMutationBody = BulkPatchRequestActionPlanObjectiveDto;
export type BulkPatchObjectivesMutationError = unknown;

/**
 * @summary Bulk Patch objectives
 */
export const useBulkPatchObjectives = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchObjectives>>,
    TError,
    { data: BulkPatchRequestActionPlanObjectiveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchObjectives>>,
  TError,
  { data: BulkPatchRequestActionPlanObjectiveDto },
  TContext
> => {
  const mutationOptions = getBulkPatchObjectivesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete initiative comment
 */
export const deleteActionPlanInitiativeComment = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/actionPlan/initiative/comment/${id}`, method: 'DELETE' }, options);

export const getDeleteActionPlanInitiativeCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteActionPlanInitiativeComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteActionPlanInitiativeComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanInitiativeCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>
>;

export type DeleteActionPlanInitiativeCommentMutationError = unknown;

/**
 * @summary Delete initiative comment
 */
export const useDeleteActionPlanInitiativeComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanInitiativeComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanInitiativeCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch initiative comment
 */
export const patchActionPlanInitiativeComment = (
  id: string,
  actionPlanInitiativeCommentDto: ActionPlanInitiativeCommentDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/initiative/comment/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanInitiativeCommentDto
    },
    options
  );

export const getPatchActionPlanInitiativeCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>,
    TError,
    { id: string; data: ActionPlanInitiativeCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>,
  TError,
  { id: string; data: ActionPlanInitiativeCommentDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanInitiativeComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>,
    { id: string; data: ActionPlanInitiativeCommentDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanInitiativeComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanInitiativeCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>
>;
export type PatchActionPlanInitiativeCommentMutationBody = ActionPlanInitiativeCommentDto;
export type PatchActionPlanInitiativeCommentMutationError = unknown;

/**
 * @summary Patch initiative comment
 */
export const usePatchActionPlanInitiativeComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>,
    TError,
    { id: string; data: ActionPlanInitiativeCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanInitiativeComment>>,
  TError,
  { id: string; data: ActionPlanInitiativeCommentDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanInitiativeCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch initiatives
 */
export const bulkPatchInitiatives = (
  bulkPatchRequestActionPlanInitiativeDto: BulkPatchRequestActionPlanInitiativeDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/initiative/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestActionPlanInitiativeDto
    },
    options
  );

export const getBulkPatchInitiativesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchInitiatives>>,
    TError,
    { data: BulkPatchRequestActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchInitiatives>>,
  TError,
  { data: BulkPatchRequestActionPlanInitiativeDto },
  TContext
> => {
  const mutationKey = ['bulkPatchInitiatives'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchInitiatives>>,
    { data: BulkPatchRequestActionPlanInitiativeDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchInitiatives(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchInitiativesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchInitiatives>>
>;
export type BulkPatchInitiativesMutationBody = BulkPatchRequestActionPlanInitiativeDto;
export type BulkPatchInitiativesMutationError = unknown;

/**
 * @summary Bulk Patch initiatives
 */
export const useBulkPatchInitiatives = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchInitiatives>>,
    TError,
    { data: BulkPatchRequestActionPlanInitiativeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchInitiatives>>,
  TError,
  { data: BulkPatchRequestActionPlanInitiativeDto },
  TContext
> => {
  const mutationOptions = getBulkPatchInitiativesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch main board
 */
export const patchActionPlanMainBoard = (
  actionPlanBoardDto: ActionPlanBoardDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/board/main`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanBoardDto
    },
    options
  );

export const getPatchActionPlanMainBoardMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanMainBoard>>,
    TError,
    { data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanMainBoard>>,
  TError,
  { data: ActionPlanBoardDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanMainBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanMainBoard>>,
    { data: ActionPlanBoardDto }
  > = props => {
    const { data } = props ?? {};

    return patchActionPlanMainBoard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanMainBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanMainBoard>>
>;
export type PatchActionPlanMainBoardMutationBody = ActionPlanBoardDto;
export type PatchActionPlanMainBoardMutationError = unknown;

/**
 * @summary Patch main board
 */
export const usePatchActionPlanMainBoard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanMainBoard>>,
    TError,
    { data: ActionPlanBoardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanMainBoard>>,
  TError,
  { data: ActionPlanBoardDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanMainBoardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete action item comment
 */
export const deleteActionPlanActionItemComment = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/actionPlan/actionItem/comment/${id}`, method: 'DELETE' }, options);

export const getDeleteActionPlanActionItemCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteActionPlanActionItemComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteActionPlanActionItemComment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteActionPlanActionItemCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>
>;

export type DeleteActionPlanActionItemCommentMutationError = unknown;

/**
 * @summary Delete action item comment
 */
export const useDeleteActionPlanActionItemComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteActionPlanActionItemComment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteActionPlanActionItemCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch action item comment
 */
export const patchActionPlanActionItemComment = (
  id: string,
  actionPlanActionItemCommentDto: ActionPlanActionItemCommentDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/actionItem/comment/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: actionPlanActionItemCommentDto
    },
    options
  );

export const getPatchActionPlanActionItemCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanActionItemComment>>,
    TError,
    { id: string; data: ActionPlanActionItemCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchActionPlanActionItemComment>>,
  TError,
  { id: string; data: ActionPlanActionItemCommentDto },
  TContext
> => {
  const mutationKey = ['patchActionPlanActionItemComment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchActionPlanActionItemComment>>,
    { id: string; data: ActionPlanActionItemCommentDto }
  > = props => {
    const { id, data } = props ?? {};

    return patchActionPlanActionItemComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchActionPlanActionItemCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchActionPlanActionItemComment>>
>;
export type PatchActionPlanActionItemCommentMutationBody = ActionPlanActionItemCommentDto;
export type PatchActionPlanActionItemCommentMutationError = unknown;

/**
 * @summary Patch action item comment
 */
export const usePatchActionPlanActionItemComment = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchActionPlanActionItemComment>>,
    TError,
    { id: string; data: ActionPlanActionItemCommentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchActionPlanActionItemComment>>,
  TError,
  { id: string; data: ActionPlanActionItemCommentDto },
  TContext
> => {
  const mutationOptions = getPatchActionPlanActionItemCommentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk Patch actionItems
 */
export const bulkPatchActionItems = (
  bulkPatchRequestActionPlanActionItemDto: BulkPatchRequestActionPlanActionItemDto,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/actionPlan/actionItem/bulk`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: bulkPatchRequestActionPlanActionItemDto
    },
    options
  );

export const getBulkPatchActionItemsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchActionItems>>,
    TError,
    { data: BulkPatchRequestActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkPatchActionItems>>,
  TError,
  { data: BulkPatchRequestActionPlanActionItemDto },
  TContext
> => {
  const mutationKey = ['bulkPatchActionItems'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkPatchActionItems>>,
    { data: BulkPatchRequestActionPlanActionItemDto }
  > = props => {
    const { data } = props ?? {};

    return bulkPatchActionItems(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkPatchActionItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkPatchActionItems>>
>;
export type BulkPatchActionItemsMutationBody = BulkPatchRequestActionPlanActionItemDto;
export type BulkPatchActionItemsMutationError = unknown;

/**
 * @summary Bulk Patch actionItems
 */
export const useBulkPatchActionItems = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkPatchActionItems>>,
    TError,
    { data: BulkPatchRequestActionPlanActionItemDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkPatchActionItems>>,
  TError,
  { data: BulkPatchRequestActionPlanActionItemDto },
  TContext
> => {
  const mutationOptions = getBulkPatchActionItemsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Patch account
 */
export const patchAccount = (
  id: number,
  patchAccountRequest: PatchAccountRequest,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    {
      url: `/account/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: patchAccountRequest
    },
    options
  );

export const getPatchAccountMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAccount>>,
    TError,
    { id: number; data: PatchAccountRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAccount>>,
  TError,
  { id: number; data: PatchAccountRequest },
  TContext
> => {
  const mutationKey = ['patchAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAccount>>,
    { id: number; data: PatchAccountRequest }
  > = props => {
    const { id, data } = props ?? {};

    return patchAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAccountMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccount>>>;
export type PatchAccountMutationBody = PatchAccountRequest;
export type PatchAccountMutationError = unknown;

/**
 * @summary Patch account
 */
export const usePatchAccount = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAccount>>,
    TError,
    { id: number; data: PatchAccountRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchAccount>>,
  TError,
  { id: number; data: PatchAccountRequest },
  TContext
> => {
  const mutationOptions = getPatchAccountMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List whiteboards ids
 */
export const listWhiteboardsIds = (
  params?: ListWhiteboardsIdsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<IdsResponse>(
    { url: `/workspace/whiteboard/id`, method: 'GET', params, signal },
    options
  );

export const getListWhiteboardsIdsQueryKey = (params?: ListWhiteboardsIdsParams) =>
  [`/workspace/whiteboard/id`, ...(params ? [params] : [])] as const;

export const getListWhiteboardsIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWhiteboardsIds>>,
  TError = IdsResponse
>(
  params?: ListWhiteboardsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboardsIds>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWhiteboardsIdsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWhiteboardsIds>>> = ({ signal }) =>
    listWhiteboardsIds(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWhiteboardsIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWhiteboardsIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWhiteboardsIds>>
>;
export type ListWhiteboardsIdsQueryError = IdsResponse;

export function useListWhiteboardsIds<
  TData = Awaited<ReturnType<typeof listWhiteboardsIds>>,
  TError = IdsResponse
>(
  params: undefined | ListWhiteboardsIdsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboardsIds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhiteboardsIds>>,
          TError,
          Awaited<ReturnType<typeof listWhiteboardsIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWhiteboardsIds<
  TData = Awaited<ReturnType<typeof listWhiteboardsIds>>,
  TError = IdsResponse
>(
  params?: ListWhiteboardsIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listWhiteboardsIds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWhiteboardsIds>>,
          TError,
          Awaited<ReturnType<typeof listWhiteboardsIds>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWhiteboardsIds<
  TData = Awaited<ReturnType<typeof listWhiteboardsIds>>,
  TError = IdsResponse
>(
  params?: ListWhiteboardsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboardsIds>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List whiteboards ids
 */

export function useListWhiteboardsIds<
  TData = Awaited<ReturnType<typeof listWhiteboardsIds>>,
  TError = IdsResponse
>(
  params?: ListWhiteboardsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listWhiteboardsIds>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListWhiteboardsIdsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List shared workspace updates
 */
export const listSharedWorkspaceUpdates = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceUpdateResponse>(
    { url: `/workspace/sharedWorkspace/${id}/update`, method: 'GET', signal },
    options
  );

export const getListSharedWorkspaceUpdatesQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/${id}/update`] as const;

export const getListSharedWorkspaceUpdatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
  TError = SharedWorkspaceUpdateResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedWorkspaceUpdatesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>> = ({
    signal
  }) => listSharedWorkspaceUpdates(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedWorkspaceUpdatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>
>;
export type ListSharedWorkspaceUpdatesQueryError = SharedWorkspaceUpdateResponse;

export function useListSharedWorkspaceUpdates<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
  TError = SharedWorkspaceUpdateResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaceUpdates<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
  TError = SharedWorkspaceUpdateResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaceUpdates<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
  TError = SharedWorkspaceUpdateResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List shared workspace updates
 */

export function useListSharedWorkspaceUpdates<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>,
  TError = SharedWorkspaceUpdateResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceUpdates>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedWorkspaceUpdatesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List shared workspace points
 */
export const listSharedWorkspacePoints = (
  id: string,
  params?: ListSharedWorkspacePointsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointResponse>(
    { url: `/workspace/sharedWorkspace/${id}/point`, method: 'GET', params, signal },
    options
  );

export const getListSharedWorkspacePointsQueryKey = (
  id: string,
  params?: ListSharedWorkspacePointsParams
) => [`/workspace/sharedWorkspace/${id}/point`, ...(params ? [params] : [])] as const;

export const getListSharedWorkspacePointsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(
  id: string,
  params?: ListSharedWorkspacePointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedWorkspacePointsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedWorkspacePoints>>> = ({
    signal
  }) => listSharedWorkspacePoints(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedWorkspacePointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedWorkspacePoints>>
>;
export type ListSharedWorkspacePointsQueryError = SharedWorkspacePointResponse;

export function useListSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(
  id: string,
  params: undefined | ListSharedWorkspacePointsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspacePoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(
  id: string,
  params?: ListSharedWorkspacePointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspacePoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(
  id: string,
  params?: ListSharedWorkspacePointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List shared workspace points
 */

export function useListSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(
  id: string,
  params?: ListSharedWorkspacePointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedWorkspacePointsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List shared workspace meetings
 */
export const listSharedWorkspaceMeetings = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingResponse>(
    { url: `/workspace/sharedWorkspace/${id}/meeting`, method: 'GET', signal },
    options
  );

export const getListSharedWorkspaceMeetingsQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/${id}/meeting`] as const;

export const getListSharedWorkspaceMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedWorkspaceMeetingsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>> = ({
    signal
  }) => listSharedWorkspaceMeetings(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedWorkspaceMeetingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>
>;
export type ListSharedWorkspaceMeetingsQueryError = SharedWorkspaceMeetingResponse;

export function useListSharedWorkspaceMeetings<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaceMeetings<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspaceMeetings<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List shared workspace meetings
 */

export function useListSharedWorkspaceMeetings<
  TData = Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspaceMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedWorkspaceMeetingsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get last meeting
 */
export const getSharedWorkspaceLastMeeting = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingResponse>(
    { url: `/workspace/sharedWorkspace/${id}/meeting/last`, method: 'GET', signal },
    options
  );

export const getGetSharedWorkspaceLastMeetingQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/${id}/meeting/last`] as const;

export const getGetSharedWorkspaceLastMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedWorkspaceLastMeetingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>> = ({
    signal
  }) => getSharedWorkspaceLastMeeting(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceLastMeetingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>
>;
export type GetSharedWorkspaceLastMeetingQueryError = SharedWorkspaceMeetingResponse;

export function useGetSharedWorkspaceLastMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceLastMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceLastMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get last meeting
 */

export function useGetSharedWorkspaceLastMeeting<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>,
  TError = SharedWorkspaceMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceLastMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceLastMeetingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List shared workspace point comments
 */
export const listSharedWorkspacePointComments = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointCommentResponse>(
    { url: `/workspace/sharedWorkspace/point/${id}/comment`, method: 'GET', signal },
    options
  );

export const getListSharedWorkspacePointCommentsQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/point/${id}/comment`] as const;

export const getListSharedWorkspacePointCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
  TError = SharedWorkspacePointCommentResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedWorkspacePointCommentsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>> = ({
    signal
  }) => listSharedWorkspacePointComments(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedWorkspacePointCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedWorkspacePointComments>>
>;
export type ListSharedWorkspacePointCommentsQueryError = SharedWorkspacePointCommentResponse;

export function useListSharedWorkspacePointComments<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
  TError = SharedWorkspacePointCommentResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspacePointComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspacePointComments<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
  TError = SharedWorkspacePointCommentResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
          TError,
          Awaited<ReturnType<typeof listSharedWorkspacePointComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedWorkspacePointComments<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
  TError = SharedWorkspacePointCommentResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List shared workspace point comments
 */

export function useListSharedWorkspacePointComments<
  TData = Awaited<ReturnType<typeof listSharedWorkspacePointComments>>,
  TError = SharedWorkspacePointCommentResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedWorkspacePointComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedWorkspacePointCommentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all starred shared workspaces points
 */
export const listStarredSharedWorkspacePoints = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspacePointResponse>(
    { url: `/workspace/sharedWorkspace/point/starred`, method: 'GET', signal },
    options
  );

export const getListStarredSharedWorkspacePointsQueryKey = () =>
  [`/workspace/sharedWorkspace/point/starred`] as const;

export const getListStarredSharedWorkspacePointsQueryOptions = <
  TData = Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStarredSharedWorkspacePointsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>> = ({
    signal
  }) => listStarredSharedWorkspacePoints(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListStarredSharedWorkspacePointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>
>;
export type ListStarredSharedWorkspacePointsQueryError = SharedWorkspacePointResponse;

export function useListStarredSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
        TError,
        Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListStarredSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
        TError,
        Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListStarredSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all starred shared workspaces points
 */

export function useListStarredSharedWorkspacePoints<
  TData = Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>,
  TError = SharedWorkspacePointResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listStarredSharedWorkspacePoints>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListStarredSharedWorkspacePointsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get shared workspace meeting media
 */
export const getSharedWorkspaceMeetingMedia = (
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingMediaResponse>(
    { url: `/workspace/sharedWorkspace/meeting/${meetingId}/media`, method: 'GET', params, signal },
    options
  );

export const getGetSharedWorkspaceMeetingMediaQueryKey = (
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams
) =>
  [`/workspace/sharedWorkspace/meeting/${meetingId}/media`, ...(params ? [params] : [])] as const;

export const getGetSharedWorkspaceMeetingMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSharedWorkspaceMeetingMediaQueryKey(meetingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>> = ({
    signal
  }) => getSharedWorkspaceMeetingMedia(meetingId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceMeetingMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>
>;
export type GetSharedWorkspaceMeetingMediaQueryError = MeetingMediaResponse;

export function useGetSharedWorkspaceMeetingMedia<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingMedia<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingMedia<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get shared workspace meeting media
 */

export function useGetSharedWorkspaceMeetingMedia<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  meetingId: string,
  params: GetSharedWorkspaceMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedWorkspaceMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceMeetingMediaQueryOptions(meetingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting analysis suggestions
 */
export const getSharedWorkspaceMeetingAnalysisSuggestions = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAnalysisSuggestionResponse>(
    {
      url: `/workspace/sharedWorkspace/meeting/${meetingId}/analysis/suggestion`,
      method: 'GET',
      signal
    },
    options
  );

export const getGetSharedWorkspaceMeetingAnalysisSuggestionsQueryKey = (meetingId: string) =>
  [`/workspace/sharedWorkspace/meeting/${meetingId}/analysis/suggestion`] as const;

export const getGetSharedWorkspaceMeetingAnalysisSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
  TError = MeetingAnalysisSuggestionResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSharedWorkspaceMeetingAnalysisSuggestionsQueryKey(meetingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>
  > = ({ signal }) =>
    getSharedWorkspaceMeetingAnalysisSuggestions(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedWorkspaceMeetingAnalysisSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>
>;
export type GetSharedWorkspaceMeetingAnalysisSuggestionsQueryError =
  MeetingAnalysisSuggestionResponse;

export function useGetSharedWorkspaceMeetingAnalysisSuggestions<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
  TError = MeetingAnalysisSuggestionResponse
>(
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingAnalysisSuggestions<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
  TError = MeetingAnalysisSuggestionResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedWorkspaceMeetingAnalysisSuggestions<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
  TError = MeetingAnalysisSuggestionResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting analysis suggestions
 */

export function useGetSharedWorkspaceMeetingAnalysisSuggestions<
  TData = Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
  TError = MeetingAnalysisSuggestionResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSharedWorkspaceMeetingAnalysisSuggestions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedWorkspaceMeetingAnalysisSuggestionsQueryOptions(
    meetingId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List meeting activities
 */
export const listMeetingActivities = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingActivityResponse>(
    { url: `/workspace/sharedWorkspace/meeting/${meetingId}/activity`, method: 'GET', signal },
    options
  );

export const getListMeetingActivitiesQueryKey = (meetingId: string) =>
  [`/workspace/sharedWorkspace/meeting/${meetingId}/activity`] as const;

export const getListMeetingActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingActivities>>,
  TError = SharedWorkspaceMeetingActivityResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingActivities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingActivitiesQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingActivities>>> = ({ signal }) =>
    listMeetingActivities(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMeetingActivities>>
>;
export type ListMeetingActivitiesQueryError = SharedWorkspaceMeetingActivityResponse;

export function useListMeetingActivities<
  TData = Awaited<ReturnType<typeof listMeetingActivities>>,
  TError = SharedWorkspaceMeetingActivityResponse
>(
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingActivities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingActivities>>,
          TError,
          Awaited<ReturnType<typeof listMeetingActivities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingActivities<
  TData = Awaited<ReturnType<typeof listMeetingActivities>>,
  TError = SharedWorkspaceMeetingActivityResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingActivities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingActivities>>,
          TError,
          Awaited<ReturnType<typeof listMeetingActivities>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingActivities<
  TData = Awaited<ReturnType<typeof listMeetingActivities>>,
  TError = SharedWorkspaceMeetingActivityResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingActivities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List meeting activities
 */

export function useListMeetingActivities<
  TData = Awaited<ReturnType<typeof listMeetingActivities>>,
  TError = SharedWorkspaceMeetingActivityResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingActivities>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingActivitiesQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List space meeting notes
 */
export const listSpaceMeetingNotes = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedWorkspaceMeetingNoteResponse>(
    { url: `/workspace/sharedWorkspace/meeting/${id}/note`, method: 'GET', signal },
    options
  );

export const getListSpaceMeetingNotesQueryKey = (id: string) =>
  [`/workspace/sharedWorkspace/meeting/${id}/note`] as const;

export const getListSpaceMeetingNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSpaceMeetingNotesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSpaceMeetingNotes>>> = ({ signal }) =>
    listSpaceMeetingNotes(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSpaceMeetingNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSpaceMeetingNotes>>
>;
export type ListSpaceMeetingNotesQueryError = SharedWorkspaceMeetingNoteResponse;

export function useListSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSpaceMeetingNotes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
          TError,
          Awaited<ReturnType<typeof listSpaceMeetingNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSpaceMeetingNotes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
          TError,
          Awaited<ReturnType<typeof listSpaceMeetingNotes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List space meeting notes
 */

export function useListSpaceMeetingNotes<
  TData = Awaited<ReturnType<typeof listSpaceMeetingNotes>>,
  TError = SharedWorkspaceMeetingNoteResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSpaceMeetingNotes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSpaceMeetingNotesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List workspace calendar event suggestions
 */
export const listWorkspaceCalendarEventSuggestion = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarEventWorkspaceSuggestionResponse>(
    { url: `/workspace/sharedWorkspace/calendar/event/suggestion`, method: 'GET', signal },
    options
  );

export const getListWorkspaceCalendarEventSuggestionQueryKey = () =>
  [`/workspace/sharedWorkspace/calendar/event/suggestion`] as const;

export const getListWorkspaceCalendarEventSuggestionQueryOptions = <
  TData = Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
  TError = CalendarEventWorkspaceSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWorkspaceCalendarEventSuggestionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>
  > = ({ signal }) => listWorkspaceCalendarEventSuggestion(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspaceCalendarEventSuggestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>
>;
export type ListWorkspaceCalendarEventSuggestionQueryError =
  CalendarEventWorkspaceSuggestionResponse;

export function useListWorkspaceCalendarEventSuggestion<
  TData = Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
  TError = CalendarEventWorkspaceSuggestionResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
        TError,
        Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkspaceCalendarEventSuggestion<
  TData = Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
  TError = CalendarEventWorkspaceSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
        TError,
        Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkspaceCalendarEventSuggestion<
  TData = Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
  TError = CalendarEventWorkspaceSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List workspace calendar event suggestions
 */

export function useListWorkspaceCalendarEventSuggestion<
  TData = Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>,
  TError = CalendarEventWorkspaceSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceCalendarEventSuggestion>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListWorkspaceCalendarEventSuggestionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Module example
 */
export const getModuleExample = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleResponse>(
    { url: `/workspace/module/${id}/example`, method: 'GET', signal },
    options
  );

export const getGetModuleExampleQueryKey = (id: string) =>
  [`/workspace/module/${id}/example`] as const;

export const getGetModuleExampleQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleExample>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleExample>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleExampleQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleExample>>> = ({ signal }) =>
    getModuleExample(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleExample>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleExampleQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleExample>>>;
export type GetModuleExampleQueryError = ModuleResponse;

export function useGetModuleExample<
  TData = Awaited<ReturnType<typeof getModuleExample>>,
  TError = ModuleResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleExample>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleExample>>,
          TError,
          Awaited<ReturnType<typeof getModuleExample>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleExample<
  TData = Awaited<ReturnType<typeof getModuleExample>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleExample>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleExample>>,
          TError,
          Awaited<ReturnType<typeof getModuleExample>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleExample<
  TData = Awaited<ReturnType<typeof getModuleExample>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleExample>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module example
 */

export function useGetModuleExample<
  TData = Awaited<ReturnType<typeof getModuleExample>>,
  TError = ModuleResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleExample>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleExampleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Latest used modules
 */
export const getLatestUsedModules = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<LastUsedModuleResponse>(
    { url: `/workspace/module/latest`, method: 'GET', signal },
    options
  );

export const getGetLatestUsedModulesQueryKey = () => [`/workspace/module/latest`] as const;

export const getGetLatestUsedModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestUsedModules>>,
  TError = LastUsedModuleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestUsedModules>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestUsedModulesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestUsedModules>>> = ({ signal }) =>
    getLatestUsedModules(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestUsedModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLatestUsedModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestUsedModules>>
>;
export type GetLatestUsedModulesQueryError = LastUsedModuleResponse;

export function useGetLatestUsedModules<
  TData = Awaited<ReturnType<typeof getLatestUsedModules>>,
  TError = LastUsedModuleResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestUsedModules>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLatestUsedModules>>,
        TError,
        Awaited<ReturnType<typeof getLatestUsedModules>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatestUsedModules<
  TData = Awaited<ReturnType<typeof getLatestUsedModules>>,
  TError = LastUsedModuleResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLatestUsedModules>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLatestUsedModules>>,
        TError,
        Awaited<ReturnType<typeof getLatestUsedModules>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatestUsedModules<
  TData = Awaited<ReturnType<typeof getLatestUsedModules>>,
  TError = LastUsedModuleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestUsedModules>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Latest used modules
 */

export function useGetLatestUsedModules<
  TData = Awaited<ReturnType<typeof getLatestUsedModules>>,
  TError = LastUsedModuleResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestUsedModules>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLatestUsedModulesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Modules analysis
 */
export const listModulesAnalysis = (
  params: ListModulesAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleAnalysisResponse>(
    { url: `/workspace/module/analysis`, method: 'GET', params, signal },
    options
  );

export const getListModulesAnalysisQueryKey = (params: ListModulesAnalysisParams) =>
  [`/workspace/module/analysis`, ...(params ? [params] : [])] as const;

export const getListModulesAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof listModulesAnalysis>>,
  TError = ModuleAnalysisResponse
>(
  params: ListModulesAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModulesAnalysisQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModulesAnalysis>>> = ({ signal }) =>
    listModulesAnalysis(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModulesAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModulesAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModulesAnalysis>>
>;
export type ListModulesAnalysisQueryError = ModuleAnalysisResponse;

export function useListModulesAnalysis<
  TData = Awaited<ReturnType<typeof listModulesAnalysis>>,
  TError = ModuleAnalysisResponse
>(
  params: ListModulesAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesAnalysis>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesAnalysis>>,
          TError,
          Awaited<ReturnType<typeof listModulesAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModulesAnalysis<
  TData = Awaited<ReturnType<typeof listModulesAnalysis>>,
  TError = ModuleAnalysisResponse
>(
  params: ListModulesAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesAnalysis>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesAnalysis>>,
          TError,
          Awaited<ReturnType<typeof listModulesAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModulesAnalysis<
  TData = Awaited<ReturnType<typeof listModulesAnalysis>>,
  TError = ModuleAnalysisResponse
>(
  params: ListModulesAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Modules analysis
 */

export function useListModulesAnalysis<
  TData = Awaited<ReturnType<typeof listModulesAnalysis>>,
  TError = ModuleAnalysisResponse
>(
  params: ListModulesAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModulesAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListModulesAnalysisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get module drive file
 */
export const getModuleDriveFile = (
  businessArea: string,
  moduleKey: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleDriveFileResponse>(
    {
      url: `/workspace/businessArea/${businessArea}/module/${moduleKey}/file`,
      method: 'GET',
      signal
    },
    options
  );

export const getGetModuleDriveFileQueryKey = (businessArea: string, moduleKey: string) =>
  [`/workspace/businessArea/${businessArea}/module/${moduleKey}/file`] as const;

export const getGetModuleDriveFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleDriveFile>>,
  TError = ModuleDriveFileResponse
>(
  businessArea: string,
  moduleKey: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleDriveFileQueryKey(businessArea, moduleKey);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleDriveFile>>> = ({ signal }) =>
    getModuleDriveFile(businessArea, moduleKey, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(businessArea && moduleKey),
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetModuleDriveFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModuleDriveFile>>
>;
export type GetModuleDriveFileQueryError = ModuleDriveFileResponse;

export function useGetModuleDriveFile<
  TData = Awaited<ReturnType<typeof getModuleDriveFile>>,
  TError = ModuleDriveFileResponse
>(
  businessArea: string,
  moduleKey: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleDriveFile>>,
          TError,
          Awaited<ReturnType<typeof getModuleDriveFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleDriveFile<
  TData = Awaited<ReturnType<typeof getModuleDriveFile>>,
  TError = ModuleDriveFileResponse
>(
  businessArea: string,
  moduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleDriveFile>>,
          TError,
          Awaited<ReturnType<typeof getModuleDriveFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleDriveFile<
  TData = Awaited<ReturnType<typeof getModuleDriveFile>>,
  TError = ModuleDriveFileResponse
>(
  businessArea: string,
  moduleKey: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get module drive file
 */

export function useGetModuleDriveFile<
  TData = Awaited<ReturnType<typeof getModuleDriveFile>>,
  TError = ModuleDriveFileResponse
>(
  businessArea: string,
  moduleKey: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleDriveFile>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleDriveFileQueryOptions(businessArea, moduleKey, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List modules rating
 */
export const listModuleRatings = (
  businessArea: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ModuleRatingResponse>(
    { url: `/workspace/businessArea/${businessArea}/module/rating`, method: 'GET', signal },
    options
  );

export const getListModuleRatingsQueryKey = (businessArea: string) =>
  [`/workspace/businessArea/${businessArea}/module/rating`] as const;

export const getListModuleRatingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listModuleRatings>>,
  TError = ModuleRatingResponse
>(
  businessArea: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleRatings>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModuleRatingsQueryKey(businessArea);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModuleRatings>>> = ({ signal }) =>
    listModuleRatings(businessArea, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!businessArea, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModuleRatings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModuleRatingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModuleRatings>>
>;
export type ListModuleRatingsQueryError = ModuleRatingResponse;

export function useListModuleRatings<
  TData = Awaited<ReturnType<typeof listModuleRatings>>,
  TError = ModuleRatingResponse
>(
  businessArea: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleRatings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModuleRatings>>,
          TError,
          Awaited<ReturnType<typeof listModuleRatings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModuleRatings<
  TData = Awaited<ReturnType<typeof listModuleRatings>>,
  TError = ModuleRatingResponse
>(
  businessArea: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleRatings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModuleRatings>>,
          TError,
          Awaited<ReturnType<typeof listModuleRatings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListModuleRatings<
  TData = Awaited<ReturnType<typeof listModuleRatings>>,
  TError = ModuleRatingResponse
>(
  businessArea: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleRatings>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List modules rating
 */

export function useListModuleRatings<
  TData = Awaited<ReturnType<typeof listModuleRatings>>,
  TError = ModuleRatingResponse
>(
  businessArea: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listModuleRatings>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListModuleRatingsQueryOptions(businessArea, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List business Areas rating
 */
export const listBusinessAreaRatings = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<BusinessAreaRatingResponse>(
    { url: `/workspace/businessArea/rating`, method: 'GET', signal },
    options
  );

export const getListBusinessAreaRatingsQueryKey = () => [`/workspace/businessArea/rating`] as const;

export const getListBusinessAreaRatingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listBusinessAreaRatings>>,
  TError = BusinessAreaRatingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaRatings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBusinessAreaRatingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBusinessAreaRatings>>> = ({
    signal
  }) => listBusinessAreaRatings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBusinessAreaRatings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBusinessAreaRatingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBusinessAreaRatings>>
>;
export type ListBusinessAreaRatingsQueryError = BusinessAreaRatingResponse;

export function useListBusinessAreaRatings<
  TData = Awaited<ReturnType<typeof listBusinessAreaRatings>>,
  TError = BusinessAreaRatingResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaRatings>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listBusinessAreaRatings>>,
        TError,
        Awaited<ReturnType<typeof listBusinessAreaRatings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBusinessAreaRatings<
  TData = Awaited<ReturnType<typeof listBusinessAreaRatings>>,
  TError = BusinessAreaRatingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaRatings>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listBusinessAreaRatings>>,
        TError,
        Awaited<ReturnType<typeof listBusinessAreaRatings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBusinessAreaRatings<
  TData = Awaited<ReturnType<typeof listBusinessAreaRatings>>,
  TError = BusinessAreaRatingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaRatings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List business Areas rating
 */

export function useListBusinessAreaRatings<
  TData = Awaited<ReturnType<typeof listBusinessAreaRatings>>,
  TError = BusinessAreaRatingResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listBusinessAreaRatings>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListBusinessAreaRatingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Shared Meeting Data
 */
export const getSharedMeetingData = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedMeetingDataResponse>(
    { url: `/workbench/sharedMeeting/${id}/data`, method: 'GET', signal },
    options
  );

export const getGetSharedMeetingDataQueryKey = (id: string) =>
  [`/workbench/sharedMeeting/${id}/data`] as const;

export const getGetSharedMeetingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedMeetingDataQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedMeetingData>>> = ({ signal }) =>
    getSharedMeetingData(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSharedMeetingData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSharedMeetingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSharedMeetingData>>
>;
export type GetSharedMeetingDataQueryError = SharedMeetingDataResponse;

export function useGetSharedMeetingData<
  TData = Awaited<ReturnType<typeof getSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedMeetingData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedMeetingData>>,
          TError,
          Awaited<ReturnType<typeof getSharedMeetingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedMeetingData<
  TData = Awaited<ReturnType<typeof getSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedMeetingData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedMeetingData>>,
          TError,
          Awaited<ReturnType<typeof getSharedMeetingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSharedMeetingData<
  TData = Awaited<ReturnType<typeof getSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Shared Meeting Data
 */

export function useGetSharedMeetingData<
  TData = Awaited<ReturnType<typeof getSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSharedMeetingDataQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Shared Meeting Data
 */
export const getPublicSharedMeetingData = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<SharedMeetingDataResponse>(
    { url: `/workbench/sharedMeeting/public/${id}/data`, method: 'GET', signal },
    options
  );

export const getGetPublicSharedMeetingDataQueryKey = (id: string) =>
  [`/workbench/sharedMeeting/public/${id}/data`] as const;

export const getGetPublicSharedMeetingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicSharedMeetingDataQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicSharedMeetingData>>> = ({
    signal
  }) => getPublicSharedMeetingData(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPublicSharedMeetingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicSharedMeetingData>>
>;
export type GetPublicSharedMeetingDataQueryError = SharedMeetingDataResponse;

export function useGetPublicSharedMeetingData<
  TData = Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicSharedMeetingData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
          TError,
          Awaited<ReturnType<typeof getPublicSharedMeetingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicSharedMeetingData<
  TData = Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicSharedMeetingData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
          TError,
          Awaited<ReturnType<typeof getPublicSharedMeetingData>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPublicSharedMeetingData<
  TData = Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Shared Meeting Data
 */

export function useGetPublicSharedMeetingData<
  TData = Awaited<ReturnType<typeof getPublicSharedMeetingData>>,
  TError = SharedMeetingDataResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPublicSharedMeetingData>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicSharedMeetingDataQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Shared Meetings info
 */
export const listSharedMeetingsInfo = (
  params: ListSharedMeetingsInfoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingInfoResponse>(
    { url: `/workbench/sharedMeeting/info`, method: 'GET', params, signal },
    options
  );

export const getListSharedMeetingsInfoQueryKey = (params: ListSharedMeetingsInfoParams) =>
  [`/workbench/sharedMeeting/info`, ...(params ? [params] : [])] as const;

export const getListSharedMeetingsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListSharedMeetingsInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedMeetingsInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSharedMeetingsInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedMeetingsInfo>>> = ({ signal }) =>
    listSharedMeetingsInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSharedMeetingsInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSharedMeetingsInfo>>
>;
export type ListSharedMeetingsInfoQueryError = CalendarMeetingInfoResponse;

export function useListSharedMeetingsInfo<
  TData = Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListSharedMeetingsInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedMeetingsInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
          TError,
          Awaited<ReturnType<typeof listSharedMeetingsInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedMeetingsInfo<
  TData = Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListSharedMeetingsInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedMeetingsInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
          TError,
          Awaited<ReturnType<typeof listSharedMeetingsInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSharedMeetingsInfo<
  TData = Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListSharedMeetingsInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedMeetingsInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Shared Meetings info
 */

export function useListSharedMeetingsInfo<
  TData = Awaited<ReturnType<typeof listSharedMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListSharedMeetingsInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSharedMeetingsInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSharedMeetingsInfoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Next Quick Actions
 */
export const getNextQuickActions = (
  params: GetNextQuickActionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<QuickActionResponse>(
    { url: `/workbench/quickAction/next`, method: 'GET', params, signal },
    options
  );

export const getGetNextQuickActionsQueryKey = (params: GetNextQuickActionsParams) =>
  [`/workbench/quickAction/next`, ...(params ? [params] : [])] as const;

export const getGetNextQuickActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextQuickActions>>,
  TError = QuickActionResponse
>(
  params: GetNextQuickActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNextQuickActions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNextQuickActionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextQuickActions>>> = ({ signal }) =>
    getNextQuickActions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextQuickActions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNextQuickActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNextQuickActions>>
>;
export type GetNextQuickActionsQueryError = QuickActionResponse;

export function useGetNextQuickActions<
  TData = Awaited<ReturnType<typeof getNextQuickActions>>,
  TError = QuickActionResponse
>(
  params: GetNextQuickActionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNextQuickActions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextQuickActions>>,
          TError,
          Awaited<ReturnType<typeof getNextQuickActions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextQuickActions<
  TData = Awaited<ReturnType<typeof getNextQuickActions>>,
  TError = QuickActionResponse
>(
  params: GetNextQuickActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNextQuickActions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextQuickActions>>,
          TError,
          Awaited<ReturnType<typeof getNextQuickActions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextQuickActions<
  TData = Awaited<ReturnType<typeof getNextQuickActions>>,
  TError = QuickActionResponse
>(
  params: GetNextQuickActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNextQuickActions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Next Quick Actions
 */

export function useGetNextQuickActions<
  TData = Awaited<ReturnType<typeof getNextQuickActions>>,
  TError = QuickActionResponse
>(
  params: GetNextQuickActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNextQuickActions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNextQuickActionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Meetings
 */
export const listCalendarMeetings = (
  params?: ListCalendarMeetingsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingResponse>(
    { url: `/workbench/meeting`, method: 'GET', params, signal },
    options
  );

export const getListCalendarMeetingsQueryKey = (params?: ListCalendarMeetingsParams) =>
  [`/workbench/meeting`, ...(params ? [params] : [])] as const;

export const getListCalendarMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCalendarMeetings>>,
  TError = CalendarMeetingResponse
>(
  params?: ListCalendarMeetingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCalendarMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCalendarMeetingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarMeetings>>> = ({ signal }) =>
    listCalendarMeetings(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCalendarMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCalendarMeetingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCalendarMeetings>>
>;
export type ListCalendarMeetingsQueryError = CalendarMeetingResponse;

export function useListCalendarMeetings<
  TData = Awaited<ReturnType<typeof listCalendarMeetings>>,
  TError = CalendarMeetingResponse
>(
  params: undefined | ListCalendarMeetingsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCalendarMeetings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarMeetings>>,
          TError,
          Awaited<ReturnType<typeof listCalendarMeetings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendarMeetings<
  TData = Awaited<ReturnType<typeof listCalendarMeetings>>,
  TError = CalendarMeetingResponse
>(
  params?: ListCalendarMeetingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCalendarMeetings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarMeetings>>,
          TError,
          Awaited<ReturnType<typeof listCalendarMeetings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendarMeetings<
  TData = Awaited<ReturnType<typeof listCalendarMeetings>>,
  TError = CalendarMeetingResponse
>(
  params?: ListCalendarMeetingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCalendarMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Meetings
 */

export function useListCalendarMeetings<
  TData = Awaited<ReturnType<typeof listCalendarMeetings>>,
  TError = CalendarMeetingResponse
>(
  params?: ListCalendarMeetingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCalendarMeetings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListCalendarMeetingsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Predefined Meetings Templates
 */
export const listPredefinedMeetingsTemplates = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<PredefinedMeetingTemplateResponse>(
    { url: `/workbench/meetingTemplate/predefined`, method: 'GET', signal },
    options
  );

export const getListPredefinedMeetingsTemplatesQueryKey = () =>
  [`/workbench/meetingTemplate/predefined`] as const;

export const getListPredefinedMeetingsTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
  TError = PredefinedMeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPredefinedMeetingsTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>> = ({
    signal
  }) => listPredefinedMeetingsTemplates(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPredefinedMeetingsTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>
>;
export type ListPredefinedMeetingsTemplatesQueryError = PredefinedMeetingTemplateResponse;

export function useListPredefinedMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
  TError = PredefinedMeetingTemplateResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
        TError,
        Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPredefinedMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
  TError = PredefinedMeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
        TError,
        Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPredefinedMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
  TError = PredefinedMeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Predefined Meetings Templates
 */

export function useListPredefinedMeetingsTemplates<
  TData = Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>,
  TError = PredefinedMeetingTemplateResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPredefinedMeetingsTemplates>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPredefinedMeetingsTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Meeting Info
 */
export const getCalendarMeetingInfo = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingInfoResponse>(
    { url: `/workbench/meeting/${id}/info`, method: 'GET', signal },
    options
  );

export const getGetCalendarMeetingInfoQueryKey = (id: string) =>
  [`/workbench/meeting/${id}/info`] as const;

export const getGetCalendarMeetingInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeetingInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCalendarMeetingInfoQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarMeetingInfo>>> = ({ signal }) =>
    getCalendarMeetingInfo(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarMeetingInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalendarMeetingInfo>>
>;
export type GetCalendarMeetingInfoQueryError = CalendarMeetingInfoResponse;

export function useGetCalendarMeetingInfo<
  TData = Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeetingInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
          TError,
          Awaited<ReturnType<typeof getCalendarMeetingInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCalendarMeetingInfo<
  TData = Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeetingInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
          TError,
          Awaited<ReturnType<typeof getCalendarMeetingInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCalendarMeetingInfo<
  TData = Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeetingInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting Info
 */

export function useGetCalendarMeetingInfo<
  TData = Awaited<ReturnType<typeof getCalendarMeetingInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalendarMeetingInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCalendarMeetingInfoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Meeting Analysis
 */
export const listMeetingAnalysis = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAnalysisResponse>(
    { url: `/workbench/meeting/${id}/analysis`, method: 'GET', signal },
    options
  );

export const getListMeetingAnalysisQueryKey = (id: string) =>
  [`/workbench/meeting/${id}/analysis`] as const;

export const getListMeetingAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingAnalysisQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingAnalysis>>> = ({ signal }) =>
    listMeetingAnalysis(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMeetingAnalysis>>
>;
export type ListMeetingAnalysisQueryError = MeetingAnalysisResponse;

export function useListMeetingAnalysis<
  TData = Awaited<ReturnType<typeof listMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingAnalysis>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingAnalysis>>,
          TError,
          Awaited<ReturnType<typeof listMeetingAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingAnalysis<
  TData = Awaited<ReturnType<typeof listMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingAnalysis>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingAnalysis>>,
          TError,
          Awaited<ReturnType<typeof listMeetingAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingAnalysis<
  TData = Awaited<ReturnType<typeof listMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Meeting Analysis
 */

export function useListMeetingAnalysis<
  TData = Awaited<ReturnType<typeof listMeetingAnalysis>>,
  TError = MeetingAnalysisResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMeetingAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingAnalysisQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Meetings info
 */
export const listMeetingsInfo = (
  params: ListMeetingsInfoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingInfoResponse>(
    { url: `/workbench/meeting/info`, method: 'GET', params, signal },
    options
  );

export const getListMeetingsInfoQueryKey = (params: ListMeetingsInfoParams) =>
  [`/workbench/meeting/info`, ...(params ? [params] : [])] as const;

export const getListMeetingsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof listMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListMeetingsInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingsInfo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMeetingsInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMeetingsInfo>>> = ({ signal }) =>
    listMeetingsInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMeetingsInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMeetingsInfoQueryResult = NonNullable<Awaited<ReturnType<typeof listMeetingsInfo>>>;
export type ListMeetingsInfoQueryError = CalendarMeetingInfoResponse;

export function useListMeetingsInfo<
  TData = Awaited<ReturnType<typeof listMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListMeetingsInfoParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingsInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingsInfo>>,
          TError,
          Awaited<ReturnType<typeof listMeetingsInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingsInfo<
  TData = Awaited<ReturnType<typeof listMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListMeetingsInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingsInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMeetingsInfo>>,
          TError,
          Awaited<ReturnType<typeof listMeetingsInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMeetingsInfo<
  TData = Awaited<ReturnType<typeof listMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListMeetingsInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingsInfo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Meetings info
 */

export function useListMeetingsInfo<
  TData = Awaited<ReturnType<typeof listMeetingsInfo>>,
  TError = CalendarMeetingInfoResponse
>(
  params: ListMeetingsInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMeetingsInfo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMeetingsInfoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Last recurring Meeting
 */
export const getLastRecurringMeeting = (
  calendarMasterEventId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingResponse>(
    {
      url: `/workbench/meeting/calendarMasterEvent/${calendarMasterEventId}/last`,
      method: 'GET',
      signal
    },
    options
  );

export const getGetLastRecurringMeetingQueryKey = (calendarMasterEventId: string) =>
  [`/workbench/meeting/calendarMasterEvent/${calendarMasterEventId}/last`] as const;

export const getGetLastRecurringMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getLastRecurringMeeting>>,
  TError = CalendarMeetingResponse
>(
  calendarMasterEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLastRecurringMeetingQueryKey(calendarMasterEventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastRecurringMeeting>>> = ({
    signal
  }) => getLastRecurringMeeting(calendarMasterEventId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!calendarMasterEventId,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetLastRecurringMeetingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLastRecurringMeeting>>
>;
export type GetLastRecurringMeetingQueryError = CalendarMeetingResponse;

export function useGetLastRecurringMeeting<
  TData = Awaited<ReturnType<typeof getLastRecurringMeeting>>,
  TError = CalendarMeetingResponse
>(
  calendarMasterEventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastRecurringMeeting>>,
          TError,
          Awaited<ReturnType<typeof getLastRecurringMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLastRecurringMeeting<
  TData = Awaited<ReturnType<typeof getLastRecurringMeeting>>,
  TError = CalendarMeetingResponse
>(
  calendarMasterEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastRecurringMeeting>>,
          TError,
          Awaited<ReturnType<typeof getLastRecurringMeeting>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLastRecurringMeeting<
  TData = Awaited<ReturnType<typeof getLastRecurringMeeting>>,
  TError = CalendarMeetingResponse
>(
  calendarMasterEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Last recurring Meeting
 */

export function useGetLastRecurringMeeting<
  TData = Awaited<ReturnType<typeof getLastRecurringMeeting>>,
  TError = CalendarMeetingResponse
>(
  calendarMasterEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLastRecurringMeeting>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLastRecurringMeetingQueryOptions(calendarMasterEventId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Meeting By Calendar Event Id
 */
export const getMeetingByCalendarEventId = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarMeetingResponse>(
    { url: `/workbench/meeting/calendarEvent/${id}`, method: 'GET', signal },
    options
  );

export const getGetMeetingByCalendarEventIdQueryKey = (id: string) =>
  [`/workbench/meeting/calendarEvent/${id}`] as const;

export const getGetMeetingByCalendarEventIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingByCalendarEventIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>> = ({
    signal
  }) => getMeetingByCalendarEventId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingByCalendarEventIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingByCalendarEventId>>
>;
export type GetMeetingByCalendarEventIdQueryError = CalendarMeetingResponse;

export function useGetMeetingByCalendarEventId<
  TData = Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
          TError,
          Awaited<ReturnType<typeof getMeetingByCalendarEventId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingByCalendarEventId<
  TData = Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
          TError,
          Awaited<ReturnType<typeof getMeetingByCalendarEventId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingByCalendarEventId<
  TData = Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting By Calendar Event Id
 */

export function useGetMeetingByCalendarEventId<
  TData = Awaited<ReturnType<typeof getMeetingByCalendarEventId>>,
  TError = CalendarMeetingResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingByCalendarEventId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingByCalendarEventIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user mfa settings
 */
export const getUserMfaSettings = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UserMfaSettingsResponse>(
    { url: `/user/mfaSettings`, method: 'GET', signal },
    options
  );

export const getGetUserMfaSettingsQueryKey = () => [`/user/mfaSettings`] as const;

export const getGetUserMfaSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserMfaSettings>>,
  TError = UserMfaSettingsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaSettings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserMfaSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMfaSettings>>> = ({ signal }) =>
    getUserMfaSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserMfaSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserMfaSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserMfaSettings>>
>;
export type GetUserMfaSettingsQueryError = UserMfaSettingsResponse;

export function useGetUserMfaSettings<
  TData = Awaited<ReturnType<typeof getUserMfaSettings>>,
  TError = UserMfaSettingsResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaSettings>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserMfaSettings>>,
        TError,
        Awaited<ReturnType<typeof getUserMfaSettings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserMfaSettings<
  TData = Awaited<ReturnType<typeof getUserMfaSettings>>,
  TError = UserMfaSettingsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaSettings>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserMfaSettings>>,
        TError,
        Awaited<ReturnType<typeof getUserMfaSettings>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserMfaSettings<
  TData = Awaited<ReturnType<typeof getUserMfaSettings>>,
  TError = UserMfaSettingsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaSettings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user mfa settings
 */

export function useGetUserMfaSettings<
  TData = Awaited<ReturnType<typeof getUserMfaSettings>>,
  TError = UserMfaSettingsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserMfaSettings>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserMfaSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user details
 */
export const getUserDetails = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<UserDetailsResponse>({ url: `/user/details`, method: 'GET', signal }, options);

export const getGetUserDetailsQueryKey = () => [`/user/details`] as const;

export const getGetUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = UserDetailsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserDetailsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserDetails>>> = ({ signal }) =>
    getUserDetails(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserDetails>>>;
export type GetUserDetailsQueryError = UserDetailsResponse;

export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = UserDetailsResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserDetails>>,
        TError,
        Awaited<ReturnType<typeof getUserDetails>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = UserDetailsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUserDetails>>,
        TError,
        Awaited<ReturnType<typeof getUserDetails>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = UserDetailsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user details
 */

export function useGetUserDetails<
  TData = Awaited<ReturnType<typeof getUserDetails>>,
  TError = UserDetailsResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserDetails>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetUserDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List my teams
 */
export const listMyTeams = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<TeamResponse>({ url: `/team/my`, method: 'GET', signal }, options);

export const getListMyTeamsQueryKey = () => [`/team/my`] as const;

export const getListMyTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyTeamsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTeams>>> = ({ signal }) =>
    listMyTeams(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyTeams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyTeams>>>;
export type ListMyTeamsQueryError = TeamResponse;

export function useListMyTeams<
  TData = Awaited<ReturnType<typeof listMyTeams>>,
  TError = TeamResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMyTeams>>,
        TError,
        Awaited<ReturnType<typeof listMyTeams>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyTeams<
  TData = Awaited<ReturnType<typeof listMyTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMyTeams>>,
        TError,
        Awaited<ReturnType<typeof listMyTeams>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyTeams<
  TData = Awaited<ReturnType<typeof listMyTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List my teams
 */

export function useListMyTeams<
  TData = Awaited<ReturnType<typeof listMyTeams>>,
  TError = TeamResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyTeams>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMyTeamsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List metric suggestions
 */
export const listMetricSuggestions = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricSuggestionResponse>(
    { url: `/metric/suggestion`, method: 'GET', signal },
    options
  );

export const getListMetricSuggestionsQueryKey = () => [`/metric/suggestion`] as const;

export const getListMetricSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMetricSuggestions>>,
  TError = MetricSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMetricSuggestions>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricSuggestionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetricSuggestions>>> = ({ signal }) =>
    listMetricSuggestions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMetricSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMetricSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMetricSuggestions>>
>;
export type ListMetricSuggestionsQueryError = MetricSuggestionResponse;

export function useListMetricSuggestions<
  TData = Awaited<ReturnType<typeof listMetricSuggestions>>,
  TError = MetricSuggestionResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMetricSuggestions>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMetricSuggestions>>,
        TError,
        Awaited<ReturnType<typeof listMetricSuggestions>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricSuggestions<
  TData = Awaited<ReturnType<typeof listMetricSuggestions>>,
  TError = MetricSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMetricSuggestions>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listMetricSuggestions>>,
        TError,
        Awaited<ReturnType<typeof listMetricSuggestions>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMetricSuggestions<
  TData = Awaited<ReturnType<typeof listMetricSuggestions>>,
  TError = MetricSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMetricSuggestions>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List metric suggestions
 */

export function useListMetricSuggestions<
  TData = Awaited<ReturnType<typeof listMetricSuggestions>>,
  TError = MetricSuggestionResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listMetricSuggestions>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMetricSuggestionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all okr metrics
 */
export const listOkrMetrics = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<OkrMetricResponse>({ url: `/metric/okr`, method: 'GET', signal }, options);

export const getListOkrMetricsQueryKey = () => [`/metric/okr`] as const;

export const getListOkrMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOkrMetrics>>,
  TError = OkrMetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOkrMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOkrMetricsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOkrMetrics>>> = ({ signal }) =>
    listOkrMetrics(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOkrMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOkrMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof listOkrMetrics>>>;
export type ListOkrMetricsQueryError = OkrMetricResponse;

export function useListOkrMetrics<
  TData = Awaited<ReturnType<typeof listOkrMetrics>>,
  TError = OkrMetricResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOkrMetrics>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listOkrMetrics>>,
        TError,
        Awaited<ReturnType<typeof listOkrMetrics>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOkrMetrics<
  TData = Awaited<ReturnType<typeof listOkrMetrics>>,
  TError = OkrMetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOkrMetrics>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listOkrMetrics>>,
        TError,
        Awaited<ReturnType<typeof listOkrMetrics>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOkrMetrics<
  TData = Awaited<ReturnType<typeof listOkrMetrics>>,
  TError = OkrMetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOkrMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all okr metrics
 */

export function useListOkrMetrics<
  TData = Awaited<ReturnType<typeof listOkrMetrics>>,
  TError = OkrMetricResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listOkrMetrics>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListOkrMetricsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get metric definition aggregated data points
 */
export const aggregateMetricDataPoints = (
  id: string,
  params: AggregateMetricDataPointsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MetricAggregationDataPointResponse>(
    { url: `/metric/definition/${id}/dataPoint/aggregate`, method: 'GET', params, signal },
    options
  );

export const getAggregateMetricDataPointsQueryKey = (
  id: string,
  params: AggregateMetricDataPointsParams
) => [`/metric/definition/${id}/dataPoint/aggregate`, ...(params ? [params] : [])] as const;

export const getAggregateMetricDataPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
  TError = MetricAggregationDataPointResponse
>(
  id: string,
  params: AggregateMetricDataPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregateMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAggregateMetricDataPointsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof aggregateMetricDataPoints>>> = ({
    signal
  }) => aggregateMetricDataPoints(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AggregateMetricDataPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof aggregateMetricDataPoints>>
>;
export type AggregateMetricDataPointsQueryError = MetricAggregationDataPointResponse;

export function useAggregateMetricDataPoints<
  TData = Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
  TError = MetricAggregationDataPointResponse
>(
  id: string,
  params: AggregateMetricDataPointsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregateMetricDataPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
          TError,
          Awaited<ReturnType<typeof aggregateMetricDataPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAggregateMetricDataPoints<
  TData = Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
  TError = MetricAggregationDataPointResponse
>(
  id: string,
  params: AggregateMetricDataPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregateMetricDataPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
          TError,
          Awaited<ReturnType<typeof aggregateMetricDataPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAggregateMetricDataPoints<
  TData = Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
  TError = MetricAggregationDataPointResponse
>(
  id: string,
  params: AggregateMetricDataPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregateMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get metric definition aggregated data points
 */

export function useAggregateMetricDataPoints<
  TData = Awaited<ReturnType<typeof aggregateMetricDataPoints>>,
  TError = MetricAggregationDataPointResponse
>(
  id: string,
  params: AggregateMetricDataPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof aggregateMetricDataPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAggregateMetricDataPointsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting details
 */
export const getMeetingDetails = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingDetailsResponse>(
    { url: `/meeting/${meetingId}`, method: 'GET', signal },
    options
  );

export const getGetMeetingDetailsQueryKey = (meetingId: string) =>
  [`/meeting/${meetingId}`] as const;

export const getGetMeetingDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingDetails>>,
  TError = MeetingDetailsResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingDetails>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingDetailsQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingDetails>>> = ({ signal }) =>
    getMeetingDetails(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingDetails>>
>;
export type GetMeetingDetailsQueryError = MeetingDetailsResponse;

export function useGetMeetingDetails<
  TData = Awaited<ReturnType<typeof getMeetingDetails>>,
  TError = MeetingDetailsResponse
>(
  meetingId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingDetails>>,
          TError,
          Awaited<ReturnType<typeof getMeetingDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingDetails<
  TData = Awaited<ReturnType<typeof getMeetingDetails>>,
  TError = MeetingDetailsResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingDetails>>,
          TError,
          Awaited<ReturnType<typeof getMeetingDetails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingDetails<
  TData = Awaited<ReturnType<typeof getMeetingDetails>>,
  TError = MeetingDetailsResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingDetails>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting details
 */

export function useGetMeetingDetails<
  TData = Awaited<ReturnType<typeof getMeetingDetails>>,
  TError = MeetingDetailsResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingDetails>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingDetailsQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete meeting
 */
export const deleteMeeting = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/meeting/${meetingId}`, method: 'DELETE' }, options);

export const getDeleteMeetingMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeeting>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMeeting>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationKey = ['deleteMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMeeting>>,
    { meetingId: string }
  > = props => {
    const { meetingId } = props ?? {};

    return deleteMeeting(meetingId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeeting>>>;

export type DeleteMeetingMutationError = unknown;

/**
 * @summary Delete meeting
 */
export const useDeleteMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMeeting>>,
    TError,
    { meetingId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMeeting>>,
  TError,
  { meetingId: string },
  TContext
> => {
  const mutationOptions = getDeleteMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get meeting transcript
 */
export const getMeetingTranscript = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingTranscriptResponse>(
    { url: `/meeting/${meetingId}/transcript`, method: 'GET', signal },
    options
  );

export const getGetMeetingTranscriptQueryKey = (meetingId: string) =>
  [`/meeting/${meetingId}/transcript`] as const;

export const getGetMeetingTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingTranscript>>,
  TError = MeetingTranscriptResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingTranscriptQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingTranscript>>> = ({ signal }) =>
    getMeetingTranscript(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingTranscript>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingTranscriptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingTranscript>>
>;
export type GetMeetingTranscriptQueryError = MeetingTranscriptResponse;

export function useGetMeetingTranscript<
  TData = Awaited<ReturnType<typeof getMeetingTranscript>>,
  TError = MeetingTranscriptResponse
>(
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTranscript>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingTranscript>>,
          TError,
          Awaited<ReturnType<typeof getMeetingTranscript>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingTranscript<
  TData = Awaited<ReturnType<typeof getMeetingTranscript>>,
  TError = MeetingTranscriptResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTranscript>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingTranscript>>,
          TError,
          Awaited<ReturnType<typeof getMeetingTranscript>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingTranscript<
  TData = Awaited<ReturnType<typeof getMeetingTranscript>>,
  TError = MeetingTranscriptResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting transcript
 */

export function useGetMeetingTranscript<
  TData = Awaited<ReturnType<typeof getMeetingTranscript>>,
  TError = MeetingTranscriptResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingTranscriptQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting recording
 */
export const getMeetingRecording = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingRecordingResponse>(
    { url: `/meeting/${meetingId}/recording`, method: 'GET', signal },
    options
  );

export const getGetMeetingRecordingQueryKey = (meetingId: string) =>
  [`/meeting/${meetingId}/recording`] as const;

export const getGetMeetingRecordingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingRecording>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingRecording>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingRecordingQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingRecording>>> = ({ signal }) =>
    getMeetingRecording(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingRecording>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingRecordingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingRecording>>
>;
export type GetMeetingRecordingQueryError = MeetingRecordingResponse;

export function useGetMeetingRecording<
  TData = Awaited<ReturnType<typeof getMeetingRecording>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingRecording>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingRecording>>,
          TError,
          Awaited<ReturnType<typeof getMeetingRecording>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingRecording<
  TData = Awaited<ReturnType<typeof getMeetingRecording>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingRecording>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingRecording>>,
          TError,
          Awaited<ReturnType<typeof getMeetingRecording>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingRecording<
  TData = Awaited<ReturnType<typeof getMeetingRecording>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingRecording>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting recording
 */

export function useGetMeetingRecording<
  TData = Awaited<ReturnType<typeof getMeetingRecording>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingRecording>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingRecordingQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting audio
 */
export const getMeetingAudio = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingRecordingResponse>(
    { url: `/meeting/${meetingId}/audio`, method: 'GET', signal },
    options
  );

export const getGetMeetingAudioQueryKey = (meetingId: string) =>
  [`/meeting/${meetingId}/audio`] as const;

export const getGetMeetingAudioQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingAudio>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAudio>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingAudioQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingAudio>>> = ({ signal }) =>
    getMeetingAudio(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingAudio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingAudioQueryResult = NonNullable<Awaited<ReturnType<typeof getMeetingAudio>>>;
export type GetMeetingAudioQueryError = MeetingRecordingResponse;

export function useGetMeetingAudio<
  TData = Awaited<ReturnType<typeof getMeetingAudio>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAudio>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAudio>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAudio>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAudio<
  TData = Awaited<ReturnType<typeof getMeetingAudio>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAudio>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAudio>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAudio>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAudio<
  TData = Awaited<ReturnType<typeof getMeetingAudio>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAudio>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting audio
 */

export function useGetMeetingAudio<
  TData = Awaited<ReturnType<typeof getMeetingAudio>>,
  TError = MeetingRecordingResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAudio>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingAudioQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting agenda
 */
export const getMeetingAgenda = (
  meetingId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingAgendaResponse>(
    { url: `/meeting/${meetingId}/agenda`, method: 'GET', signal },
    options
  );

export const getGetMeetingAgendaQueryKey = (meetingId: string) =>
  [`/meeting/${meetingId}/agenda`] as const;

export const getGetMeetingAgendaQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAgenda>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingAgendaQueryKey(meetingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingAgenda>>> = ({ signal }) =>
    getMeetingAgenda(meetingId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!meetingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingAgenda>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingAgendaQueryResult = NonNullable<Awaited<ReturnType<typeof getMeetingAgenda>>>;
export type GetMeetingAgendaQueryError = MeetingAgendaResponse;

export function useGetMeetingAgenda<
  TData = Awaited<ReturnType<typeof getMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(
  meetingId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAgenda>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAgenda>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAgenda>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAgenda<
  TData = Awaited<ReturnType<typeof getMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAgenda>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingAgenda>>,
          TError,
          Awaited<ReturnType<typeof getMeetingAgenda>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingAgenda<
  TData = Awaited<ReturnType<typeof getMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAgenda>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting agenda
 */

export function useGetMeetingAgenda<
  TData = Awaited<ReturnType<typeof getMeetingAgenda>>,
  TError = MeetingAgendaResponse
>(
  meetingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingAgenda>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingAgendaQueryOptions(meetingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get live meeting
 */
export const getLiveMeeting = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<LiveMeetingResponse>({ url: `/meeting/live`, method: 'GET', signal }, options);

export const getGetLiveMeetingQueryKey = () => [`/meeting/live`] as const;

export const getGetLiveMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getLiveMeeting>>,
  TError = LiveMeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLiveMeetingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiveMeeting>>> = ({ signal }) =>
    getLiveMeeting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLiveMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLiveMeetingQueryResult = NonNullable<Awaited<ReturnType<typeof getLiveMeeting>>>;
export type GetLiveMeetingQueryError = LiveMeetingResponse;

export function useGetLiveMeeting<
  TData = Awaited<ReturnType<typeof getLiveMeeting>>,
  TError = LiveMeetingResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveMeeting>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLiveMeeting>>,
        TError,
        Awaited<ReturnType<typeof getLiveMeeting>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLiveMeeting<
  TData = Awaited<ReturnType<typeof getLiveMeeting>>,
  TError = LiveMeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveMeeting>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLiveMeeting>>,
        TError,
        Awaited<ReturnType<typeof getLiveMeeting>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLiveMeeting<
  TData = Awaited<ReturnType<typeof getLiveMeeting>>,
  TError = LiveMeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get live meeting
 */

export function useGetLiveMeeting<
  TData = Awaited<ReturnType<typeof getLiveMeeting>>,
  TError = LiveMeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiveMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLiveMeetingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get latest meeting
 */
export const getLatestMeeting = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<MeetingResponse>({ url: `/meeting/latest`, method: 'GET', signal }, options);

export const getGetLatestMeetingQueryKey = () => [`/meeting/latest`] as const;

export const getGetLatestMeetingQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestMeeting>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestMeetingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestMeeting>>> = ({ signal }) =>
    getLatestMeeting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestMeeting>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLatestMeetingQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestMeeting>>>;
export type GetLatestMeetingQueryError = MeetingResponse;

export function useGetLatestMeeting<
  TData = Awaited<ReturnType<typeof getLatestMeeting>>,
  TError = MeetingResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestMeeting>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLatestMeeting>>,
        TError,
        Awaited<ReturnType<typeof getLatestMeeting>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatestMeeting<
  TData = Awaited<ReturnType<typeof getLatestMeeting>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestMeeting>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getLatestMeeting>>,
        TError,
        Awaited<ReturnType<typeof getLatestMeeting>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLatestMeeting<
  TData = Awaited<ReturnType<typeof getLatestMeeting>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get latest meeting
 */

export function useGetLatestMeeting<
  TData = Awaited<ReturnType<typeof getLatestMeeting>>,
  TError = MeetingResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestMeeting>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLatestMeetingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get meeting connection
 */
export const getMeetingConnection = (
  params?: GetMeetingConnectionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingConnectionResponse>(
    { url: `/meeting/connection`, method: 'GET', params, signal },
    options
  );

export const getGetMeetingConnectionQueryKey = (params?: GetMeetingConnectionParams) =>
  [`/meeting/connection`, ...(params ? [params] : [])] as const;

export const getGetMeetingConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingConnection>>,
  TError = MeetingConnectionResponse
>(
  params?: GetMeetingConnectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingConnection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingConnectionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingConnection>>> = ({ signal }) =>
    getMeetingConnection(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMeetingConnection>>
>;
export type GetMeetingConnectionQueryError = MeetingConnectionResponse;

export function useGetMeetingConnection<
  TData = Awaited<ReturnType<typeof getMeetingConnection>>,
  TError = MeetingConnectionResponse
>(
  params: undefined | GetMeetingConnectionParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingConnection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingConnection>>,
          TError,
          Awaited<ReturnType<typeof getMeetingConnection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingConnection<
  TData = Awaited<ReturnType<typeof getMeetingConnection>>,
  TError = MeetingConnectionResponse
>(
  params?: GetMeetingConnectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingConnection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingConnection>>,
          TError,
          Awaited<ReturnType<typeof getMeetingConnection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingConnection<
  TData = Awaited<ReturnType<typeof getMeetingConnection>>,
  TError = MeetingConnectionResponse
>(
  params?: GetMeetingConnectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingConnection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get meeting connection
 */

export function useGetMeetingConnection<
  TData = Awaited<ReturnType<typeof getMeetingConnection>>,
  TError = MeetingConnectionResponse
>(
  params?: GetMeetingConnectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMeetingConnection>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingConnectionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Meeting Media
 */
export const getMeetingMedia = (
  id: string,
  params: GetMeetingMediaParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingMediaResponse>(
    { url: `/meeting/bot/${id}/media`, method: 'GET', params, signal },
    options
  );

export const getGetMeetingMediaQueryKey = (id: string, params: GetMeetingMediaParams) =>
  [`/meeting/bot/${id}/media`, ...(params ? [params] : [])] as const;

export const getGetMeetingMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetMeetingMediaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingMedia>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingMediaQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetingMedia>>> = ({ signal }) =>
    getMeetingMedia(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetingMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMeetingMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getMeetingMedia>>>;
export type GetMeetingMediaQueryError = MeetingMediaResponse;

export function useGetMeetingMedia<
  TData = Awaited<ReturnType<typeof getMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetMeetingMediaParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingMedia>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingMedia<
  TData = Awaited<ReturnType<typeof getMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetMeetingMediaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingMedia>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMeetingMedia<
  TData = Awaited<ReturnType<typeof getMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetMeetingMediaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingMedia>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Meeting Media
 */

export function useGetMeetingMedia<
  TData = Awaited<ReturnType<typeof getMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetMeetingMediaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetingMedia>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMeetingMediaQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch google calendar events
 */
export const fetchGoogleCalendarEvents = (
  params: FetchGoogleCalendarEventsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoogleCalendarEventResponse>(
    { url: `/integration/google/calendar/event`, method: 'GET', params, signal },
    options
  );

export const getFetchGoogleCalendarEventsQueryKey = (params: FetchGoogleCalendarEventsParams) =>
  [`/integration/google/calendar/event`, ...(params ? [params] : [])] as const;

export const getFetchGoogleCalendarEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
  TError = GoogleCalendarEventResponse
>(
  params: FetchGoogleCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFetchGoogleCalendarEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>> = ({
    signal
  }) => fetchGoogleCalendarEvents(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchGoogleCalendarEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>
>;
export type FetchGoogleCalendarEventsQueryError = GoogleCalendarEventResponse;

export function useFetchGoogleCalendarEvents<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
  TError = GoogleCalendarEventResponse
>(
  params: FetchGoogleCalendarEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchGoogleCalendarEvents<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
  TError = GoogleCalendarEventResponse
>(
  params: FetchGoogleCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchGoogleCalendarEvents<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
  TError = GoogleCalendarEventResponse
>(
  params: FetchGoogleCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch google calendar events
 */

export function useFetchGoogleCalendarEvents<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>,
  TError = GoogleCalendarEventResponse
>(
  params: FetchGoogleCalendarEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchGoogleCalendarEvents>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFetchGoogleCalendarEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch google calendar recurring event instances
 */
export const fetchUpcomingGoogleCalendarEvent = (
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoogleCalendarEventResponse>(
    { url: `/integration/google/calendar/event/${id}/upcoming`, method: 'GET', params, signal },
    options
  );

export const getFetchUpcomingGoogleCalendarEventQueryKey = (
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams
) => [`/integration/google/calendar/event/${id}/upcoming`, ...(params ? [params] : [])] as const;

export const getFetchUpcomingGoogleCalendarEventQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchUpcomingGoogleCalendarEventQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>> = ({
    signal
  }) => fetchUpcomingGoogleCalendarEvent(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchUpcomingGoogleCalendarEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>
>;
export type FetchUpcomingGoogleCalendarEventQueryError = GoogleCalendarEventResponse;

export function useFetchUpcomingGoogleCalendarEvent<
  TData = Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  params: undefined | FetchUpcomingGoogleCalendarEventParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchUpcomingGoogleCalendarEvent<
  TData = Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
          TError,
          Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchUpcomingGoogleCalendarEvent<
  TData = Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch google calendar recurring event instances
 */

export function useFetchUpcomingGoogleCalendarEvent<
  TData = Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  params?: FetchUpcomingGoogleCalendarEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof fetchUpcomingGoogleCalendarEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFetchUpcomingGoogleCalendarEventQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fetch google calendar recurring event instances
 */
export const fetchGoogleCalendarRecurringEventInstances = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoogleCalendarEventResponse>(
    { url: `/integration/google/calendar/event/${id}/instance`, method: 'GET', signal },
    options
  );

export const getFetchGoogleCalendarRecurringEventInstancesQueryKey = (id: string) =>
  [`/integration/google/calendar/event/${id}/instance`] as const;

export const getFetchGoogleCalendarRecurringEventInstancesQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchGoogleCalendarRecurringEventInstancesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>
  > = ({ signal }) => fetchGoogleCalendarRecurringEventInstances(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FetchGoogleCalendarRecurringEventInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>
>;
export type FetchGoogleCalendarRecurringEventInstancesQueryError = GoogleCalendarEventResponse;

export function useFetchGoogleCalendarRecurringEventInstances<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
          TError,
          Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchGoogleCalendarRecurringEventInstances<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
          TError,
          Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFetchGoogleCalendarRecurringEventInstances<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Fetch google calendar recurring event instances
 */

export function useFetchGoogleCalendarRecurringEventInstances<
  TData = Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
  TError = GoogleCalendarEventResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchGoogleCalendarRecurringEventInstances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFetchGoogleCalendarRecurringEventInstancesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get data source latest run
 */
export const getDataSourceLatestRun = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CollectorLatestRunResponse>(
    { url: `/integration/dataSource/${id}/latestRun`, method: 'GET', signal },
    options
  );

export const getGetDataSourceLatestRunQueryKey = (id: string) =>
  [`/integration/dataSource/${id}/latestRun`] as const;

export const getGetDataSourceLatestRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getDataSourceLatestRun>>,
  TError = CollectorLatestRunResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataSourceLatestRun>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDataSourceLatestRunQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataSourceLatestRun>>> = ({ signal }) =>
    getDataSourceLatestRun(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDataSourceLatestRun>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDataSourceLatestRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDataSourceLatestRun>>
>;
export type GetDataSourceLatestRunQueryError = CollectorLatestRunResponse;

export function useGetDataSourceLatestRun<
  TData = Awaited<ReturnType<typeof getDataSourceLatestRun>>,
  TError = CollectorLatestRunResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataSourceLatestRun>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataSourceLatestRun>>,
          TError,
          Awaited<ReturnType<typeof getDataSourceLatestRun>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDataSourceLatestRun<
  TData = Awaited<ReturnType<typeof getDataSourceLatestRun>>,
  TError = CollectorLatestRunResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataSourceLatestRun>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataSourceLatestRun>>,
          TError,
          Awaited<ReturnType<typeof getDataSourceLatestRun>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDataSourceLatestRun<
  TData = Awaited<ReturnType<typeof getDataSourceLatestRun>>,
  TError = CollectorLatestRunResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataSourceLatestRun>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get data source latest run
 */

export function useGetDataSourceLatestRun<
  TData = Awaited<ReturnType<typeof getDataSourceLatestRun>>,
  TError = CollectorLatestRunResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataSourceLatestRun>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDataSourceLatestRunQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List data source fields mapping
 */
export const listDataSourceFieldMappings = (
  id: string,
  params?: ListDataSourceFieldMappingsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DataSourceFieldMappingResponse>(
    { url: `/integration/dataSource/${id}/fieldMapping`, method: 'GET', params, signal },
    options
  );

export const getListDataSourceFieldMappingsQueryKey = (
  id: string,
  params?: ListDataSourceFieldMappingsParams
) => [`/integration/dataSource/${id}/fieldMapping`, ...(params ? [params] : [])] as const;

export const getListDataSourceFieldMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
  TError = DataSourceFieldMappingResponse
>(
  id: string,
  params?: ListDataSourceFieldMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceFieldMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataSourceFieldMappingsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataSourceFieldMappings>>> = ({
    signal
  }) => listDataSourceFieldMappings(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataSourceFieldMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDataSourceFieldMappings>>
>;
export type ListDataSourceFieldMappingsQueryError = DataSourceFieldMappingResponse;

export function useListDataSourceFieldMappings<
  TData = Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
  TError = DataSourceFieldMappingResponse
>(
  id: string,
  params: undefined | ListDataSourceFieldMappingsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceFieldMappings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
          TError,
          Awaited<ReturnType<typeof listDataSourceFieldMappings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSourceFieldMappings<
  TData = Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
  TError = DataSourceFieldMappingResponse
>(
  id: string,
  params?: ListDataSourceFieldMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceFieldMappings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
          TError,
          Awaited<ReturnType<typeof listDataSourceFieldMappings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSourceFieldMappings<
  TData = Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
  TError = DataSourceFieldMappingResponse
>(
  id: string,
  params?: ListDataSourceFieldMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceFieldMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List data source fields mapping
 */

export function useListDataSourceFieldMappings<
  TData = Awaited<ReturnType<typeof listDataSourceFieldMappings>>,
  TError = DataSourceFieldMappingResponse
>(
  id: string,
  params?: ListDataSourceFieldMappingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceFieldMappings>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListDataSourceFieldMappingsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List data types types
 */
export const listDataSourceTypes = (
  params?: ListDataSourceTypesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<DataSourceTypeResponse>(
    { url: `/integration/dataSource/type`, method: 'GET', params, signal },
    options
  );

export const getListDataSourceTypesQueryKey = (params?: ListDataSourceTypesParams) =>
  [`/integration/dataSource/type`, ...(params ? [params] : [])] as const;

export const getListDataSourceTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDataSourceTypes>>,
  TError = DataSourceTypeResponse
>(
  params?: ListDataSourceTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDataSourceTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataSourceTypes>>> = ({ signal }) =>
    listDataSourceTypes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDataSourceTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataSourceTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDataSourceTypes>>
>;
export type ListDataSourceTypesQueryError = DataSourceTypeResponse;

export function useListDataSourceTypes<
  TData = Awaited<ReturnType<typeof listDataSourceTypes>>,
  TError = DataSourceTypeResponse
>(
  params: undefined | ListDataSourceTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceTypes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataSourceTypes>>,
          TError,
          Awaited<ReturnType<typeof listDataSourceTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSourceTypes<
  TData = Awaited<ReturnType<typeof listDataSourceTypes>>,
  TError = DataSourceTypeResponse
>(
  params?: ListDataSourceTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceTypes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataSourceTypes>>,
          TError,
          Awaited<ReturnType<typeof listDataSourceTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListDataSourceTypes<
  TData = Awaited<ReturnType<typeof listDataSourceTypes>>,
  TError = DataSourceTypeResponse
>(
  params?: ListDataSourceTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List data types types
 */

export function useListDataSourceTypes<
  TData = Awaited<ReturnType<typeof listDataSourceTypes>>,
  TError = DataSourceTypeResponse
>(
  params?: ListDataSourceTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listDataSourceTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListDataSourceTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user calendar connection status
 */
export const isCalendarConnected = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarConnectionStatusResponse>(
    { url: `/integration/dataSource/calendar/connection-status`, method: 'GET', signal },
    options
  );

export const getIsCalendarConnectedQueryKey = () =>
  [`/integration/dataSource/calendar/connection-status`] as const;

export const getIsCalendarConnectedQueryOptions = <
  TData = Awaited<ReturnType<typeof isCalendarConnected>>,
  TError = CalendarConnectionStatusResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isCalendarConnected>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsCalendarConnectedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isCalendarConnected>>> = ({ signal }) =>
    isCalendarConnected(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isCalendarConnected>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsCalendarConnectedQueryResult = NonNullable<
  Awaited<ReturnType<typeof isCalendarConnected>>
>;
export type IsCalendarConnectedQueryError = CalendarConnectionStatusResponse;

export function useIsCalendarConnected<
  TData = Awaited<ReturnType<typeof isCalendarConnected>>,
  TError = CalendarConnectionStatusResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof isCalendarConnected>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof isCalendarConnected>>,
        TError,
        Awaited<ReturnType<typeof isCalendarConnected>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsCalendarConnected<
  TData = Awaited<ReturnType<typeof isCalendarConnected>>,
  TError = CalendarConnectionStatusResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isCalendarConnected>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof isCalendarConnected>>,
        TError,
        Awaited<ReturnType<typeof isCalendarConnected>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIsCalendarConnected<
  TData = Awaited<ReturnType<typeof isCalendarConnected>>,
  TError = CalendarConnectionStatusResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isCalendarConnected>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user calendar connection status
 */

export function useIsCalendarConnected<
  TData = Awaited<ReturnType<typeof isCalendarConnected>>,
  TError = CalendarConnectionStatusResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof isCalendarConnected>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getIsCalendarConnectedQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get data provider latest runs
 */
export const getDataProviderLatestRuns = (
  params: GetDataProviderLatestRunsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CollectorLatestRunResponse>(
    { url: `/integration/dataProvider/latestRun`, method: 'GET', params, signal },
    options
  );

export const getGetDataProviderLatestRunsQueryKey = (params: GetDataProviderLatestRunsParams) =>
  [`/integration/dataProvider/latestRun`, ...(params ? [params] : [])] as const;

export const getGetDataProviderLatestRunsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
  TError = CollectorLatestRunResponse
>(
  params: GetDataProviderLatestRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataProviderLatestRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDataProviderLatestRunsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataProviderLatestRuns>>> = ({
    signal
  }) => getDataProviderLatestRuns(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDataProviderLatestRunsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDataProviderLatestRuns>>
>;
export type GetDataProviderLatestRunsQueryError = CollectorLatestRunResponse;

export function useGetDataProviderLatestRuns<
  TData = Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
  TError = CollectorLatestRunResponse
>(
  params: GetDataProviderLatestRunsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataProviderLatestRuns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
          TError,
          Awaited<ReturnType<typeof getDataProviderLatestRuns>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDataProviderLatestRuns<
  TData = Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
  TError = CollectorLatestRunResponse
>(
  params: GetDataProviderLatestRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataProviderLatestRuns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
          TError,
          Awaited<ReturnType<typeof getDataProviderLatestRuns>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDataProviderLatestRuns<
  TData = Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
  TError = CollectorLatestRunResponse
>(
  params: GetDataProviderLatestRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataProviderLatestRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get data provider latest runs
 */

export function useGetDataProviderLatestRuns<
  TData = Awaited<ReturnType<typeof getDataProviderLatestRuns>>,
  TError = CollectorLatestRunResponse
>(
  params: GetDataProviderLatestRunsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDataProviderLatestRuns>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDataProviderLatestRunsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get connection
 */
export const getConnection = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UnifiedConnectionResponse>(
    { url: `/integration/connection/${id}`, method: 'GET', signal },
    options
  );

export const getGetConnectionQueryKey = (id: string) => [`/integration/connection/${id}`] as const;

export const getGetConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = UnifiedConnectionResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConnectionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnection>>> = ({ signal }) =>
    getConnection(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getConnection>>>;
export type GetConnectionQueryError = UnifiedConnectionResponse;

export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = UnifiedConnectionResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnection>>,
          TError,
          Awaited<ReturnType<typeof getConnection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = UnifiedConnectionResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnection>>,
          TError,
          Awaited<ReturnType<typeof getConnection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = UnifiedConnectionResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get connection
 */

export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = UnifiedConnectionResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConnectionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete connection
 */
export const deleteConnection = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/integration/connection/${id}`, method: 'DELETE' }, options);

export const getDeleteConnectionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConnection>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConnection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteConnection'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConnection>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteConnection(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConnection>>
>;

export type DeleteConnectionMutationError = unknown;

/**
 * @summary Delete connection
 */
export const useDeleteConnection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConnection>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteConnection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user grant
 */
export const getGrantForUser = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<NylasGrantResponse>(
    { url: `/integration/auth/grant`, method: 'GET', signal },
    options
  );

export const getGetGrantForUserQueryKey = () => [`/integration/auth/grant`] as const;

export const getGetGrantForUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getGrantForUser>>,
  TError = NylasGrantResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrantForUser>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGrantForUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrantForUser>>> = ({ signal }) =>
    getGrantForUser(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGrantForUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGrantForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getGrantForUser>>>;
export type GetGrantForUserQueryError = NylasGrantResponse;

export function useGetGrantForUser<
  TData = Awaited<ReturnType<typeof getGrantForUser>>,
  TError = NylasGrantResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrantForUser>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGrantForUser>>,
        TError,
        Awaited<ReturnType<typeof getGrantForUser>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGrantForUser<
  TData = Awaited<ReturnType<typeof getGrantForUser>>,
  TError = NylasGrantResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrantForUser>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getGrantForUser>>,
        TError,
        Awaited<ReturnType<typeof getGrantForUser>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGrantForUser<
  TData = Awaited<ReturnType<typeof getGrantForUser>>,
  TError = NylasGrantResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrantForUser>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user grant
 */

export function useGetGrantForUser<
  TData = Awaited<ReturnType<typeof getGrantForUser>>,
  TError = NylasGrantResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrantForUser>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGrantForUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List contacts
 */
export const listHubspotContacts = (
  params?: ListHubspotContactsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<HubspotContactResponse>(
    { url: `/hubspot/contact`, method: 'GET', params, signal },
    options
  );

export const getListHubspotContactsQueryKey = (params?: ListHubspotContactsParams) =>
  [`/hubspot/contact`, ...(params ? [params] : [])] as const;

export const getListHubspotContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHubspotContacts>>,
  TError = HubspotContactResponse
>(
  params?: ListHubspotContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotContacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHubspotContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHubspotContacts>>> = ({ signal }) =>
    listHubspotContacts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHubspotContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHubspotContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHubspotContacts>>
>;
export type ListHubspotContactsQueryError = HubspotContactResponse;

export function useListHubspotContacts<
  TData = Awaited<ReturnType<typeof listHubspotContacts>>,
  TError = HubspotContactResponse
>(
  params: undefined | ListHubspotContactsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotContacts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHubspotContacts>>,
          TError,
          Awaited<ReturnType<typeof listHubspotContacts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotContacts<
  TData = Awaited<ReturnType<typeof listHubspotContacts>>,
  TError = HubspotContactResponse
>(
  params?: ListHubspotContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotContacts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHubspotContacts>>,
          TError,
          Awaited<ReturnType<typeof listHubspotContacts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotContacts<
  TData = Awaited<ReturnType<typeof listHubspotContacts>>,
  TError = HubspotContactResponse
>(
  params?: ListHubspotContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotContacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List contacts
 */

export function useListHubspotContacts<
  TData = Awaited<ReturnType<typeof listHubspotContacts>>,
  TError = HubspotContactResponse
>(
  params?: ListHubspotContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotContacts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListHubspotContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List companies
 */
export const listHubspotCompanies = (
  params?: ListHubspotCompaniesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<HubspotCompanyResponse>(
    { url: `/hubspot/company`, method: 'GET', params, signal },
    options
  );

export const getListHubspotCompaniesQueryKey = (params?: ListHubspotCompaniesParams) =>
  [`/hubspot/company`, ...(params ? [params] : [])] as const;

export const getListHubspotCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof listHubspotCompanies>>,
  TError = HubspotCompanyResponse
>(
  params?: ListHubspotCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotCompanies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHubspotCompaniesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHubspotCompanies>>> = ({ signal }) =>
    listHubspotCompanies(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHubspotCompanies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHubspotCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHubspotCompanies>>
>;
export type ListHubspotCompaniesQueryError = HubspotCompanyResponse;

export function useListHubspotCompanies<
  TData = Awaited<ReturnType<typeof listHubspotCompanies>>,
  TError = HubspotCompanyResponse
>(
  params: undefined | ListHubspotCompaniesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotCompanies>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHubspotCompanies>>,
          TError,
          Awaited<ReturnType<typeof listHubspotCompanies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotCompanies<
  TData = Awaited<ReturnType<typeof listHubspotCompanies>>,
  TError = HubspotCompanyResponse
>(
  params?: ListHubspotCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotCompanies>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHubspotCompanies>>,
          TError,
          Awaited<ReturnType<typeof listHubspotCompanies>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotCompanies<
  TData = Awaited<ReturnType<typeof listHubspotCompanies>>,
  TError = HubspotCompanyResponse
>(
  params?: ListHubspotCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotCompanies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List companies
 */

export function useListHubspotCompanies<
  TData = Awaited<ReturnType<typeof listHubspotCompanies>>,
  TError = HubspotCompanyResponse
>(
  params?: ListHubspotCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHubspotCompanies>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListHubspotCompaniesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List contacts
 */
export const listPagedGoogleDriveFiles = (
  params?: ListPagedGoogleDriveFilesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<GoogleDrivePagedResponse>(
    { url: `/google/drive/file`, method: 'GET', params, signal },
    options
  );

export const getListPagedGoogleDriveFilesQueryKey = (params?: ListPagedGoogleDriveFilesParams) =>
  [`/google/drive/file`, ...(params ? [params] : [])] as const;

export const getListPagedGoogleDriveFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
  TError = GoogleDrivePagedResponse
>(
  params?: ListPagedGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPagedGoogleDriveFilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>> = ({
    signal
  }) => listPagedGoogleDriveFiles(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPagedGoogleDriveFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>
>;
export type ListPagedGoogleDriveFilesQueryError = GoogleDrivePagedResponse;

export function useListPagedGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
  TError = GoogleDrivePagedResponse
>(
  params: undefined | ListPagedGoogleDriveFilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
          TError,
          Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPagedGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
  TError = GoogleDrivePagedResponse
>(
  params?: ListPagedGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
          TError,
          Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPagedGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
  TError = GoogleDrivePagedResponse
>(
  params?: ListPagedGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List contacts
 */

export function useListPagedGoogleDriveFiles<
  TData = Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>,
  TError = GoogleDrivePagedResponse
>(
  params?: ListPagedGoogleDriveFilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPagedGoogleDriveFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListPagedGoogleDriveFilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Events
 */
export const listEvents = (
  params?: ListEventsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarEventResponse>(
    { url: `/calendar/event`, method: 'GET', params, signal },
    options
  );

export const getListEventsQueryKey = (params?: ListEventsParams) =>
  [`/calendar/event`, ...(params ? [params] : [])] as const;

export const getListEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = CalendarEventResponse
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvents>>> = ({ signal }) =>
    listEvents(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvents>>>;
export type ListEventsQueryError = CalendarEventResponse;

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = CalendarEventResponse
>(
  params: undefined | ListEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = CalendarEventResponse
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvents>>,
          TError,
          Awaited<ReturnType<typeof listEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = CalendarEventResponse
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Events
 */

export function useListEvents<
  TData = Awaited<ReturnType<typeof listEvents>>,
  TError = CalendarEventResponse
>(
  params?: ListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvents>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Event Meeting Media
 */
export const getEventMeetingMedia = (
  id: string,
  params: GetEventMeetingMediaParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<MeetingMediaResponse>(
    { url: `/calendar/event/${id}/media`, method: 'GET', params, signal },
    options
  );

export const getGetEventMeetingMediaQueryKey = (id: string, params: GetEventMeetingMediaParams) =>
  [`/calendar/event/${id}/media`, ...(params ? [params] : [])] as const;

export const getGetEventMeetingMediaQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetEventMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventMeetingMediaQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventMeetingMedia>>> = ({ signal }) =>
    getEventMeetingMedia(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventMeetingMedia>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventMeetingMediaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventMeetingMedia>>
>;
export type GetEventMeetingMediaQueryError = MeetingMediaResponse;

export function useGetEventMeetingMedia<
  TData = Awaited<ReturnType<typeof getEventMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetEventMeetingMediaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventMeetingMedia>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getEventMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventMeetingMedia<
  TData = Awaited<ReturnType<typeof getEventMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetEventMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventMeetingMedia>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventMeetingMedia>>,
          TError,
          Awaited<ReturnType<typeof getEventMeetingMedia>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEventMeetingMedia<
  TData = Awaited<ReturnType<typeof getEventMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetEventMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Event Meeting Media
 */

export function useGetEventMeetingMedia<
  TData = Awaited<ReturnType<typeof getEventMeetingMedia>>,
  TError = MeetingMediaResponse
>(
  id: string,
  params: GetEventMeetingMediaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventMeetingMedia>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEventMeetingMediaQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Next Event
 */
export const getNextEvent = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<CalendarEventResponse>(
    { url: `/calendar/event/next`, method: 'GET', signal },
    options
  );

export const getGetNextEventQueryKey = () => [`/calendar/event/next`] as const;

export const getGetNextEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextEvent>>,
  TError = CalendarEventResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextEvent>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNextEventQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextEvent>>> = ({ signal }) =>
    getNextEvent(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextEvent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNextEventQueryResult = NonNullable<Awaited<ReturnType<typeof getNextEvent>>>;
export type GetNextEventQueryError = CalendarEventResponse;

export function useGetNextEvent<
  TData = Awaited<ReturnType<typeof getNextEvent>>,
  TError = CalendarEventResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextEvent>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getNextEvent>>,
        TError,
        Awaited<ReturnType<typeof getNextEvent>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextEvent<
  TData = Awaited<ReturnType<typeof getNextEvent>>,
  TError = CalendarEventResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextEvent>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getNextEvent>>,
        TError,
        Awaited<ReturnType<typeof getNextEvent>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNextEvent<
  TData = Awaited<ReturnType<typeof getNextEvent>>,
  TError = CalendarEventResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextEvent>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Next Event
 */

export function useGetNextEvent<
  TData = Awaited<ReturnType<typeof getNextEvent>>,
  TError = CalendarEventResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNextEvent>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNextEventQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Email thread
 */
export const getEmailThread = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailThreadResponse>(
    { url: `/calendar/email/thread/${id}`, method: 'GET', signal },
    options
  );

export const getGetEmailThreadQueryKey = (id: string) => [`/calendar/email/thread/${id}`] as const;

export const getGetEmailThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailThread>>,
  TError = EmailThreadResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailThreadQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailThread>>> = ({ signal }) =>
    getEmailThread(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailThread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmailThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailThread>>>;
export type GetEmailThreadQueryError = EmailThreadResponse;

export function useGetEmailThread<
  TData = Awaited<ReturnType<typeof getEmailThread>>,
  TError = EmailThreadResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThread>>,
          TError,
          Awaited<ReturnType<typeof getEmailThread>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailThread<
  TData = Awaited<ReturnType<typeof getEmailThread>>,
  TError = EmailThreadResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThread>>,
          TError,
          Awaited<ReturnType<typeof getEmailThread>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailThread<
  TData = Awaited<ReturnType<typeof getEmailThread>>,
  TError = EmailThreadResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Email thread
 */

export function useGetEmailThread<
  TData = Awaited<ReturnType<typeof getEmailThread>>,
  TError = EmailThreadResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmailThreadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Email thread messages
 */
export const getEmailThreadMessages = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailMessageResponse>(
    { url: `/calendar/email/thread/${id}/message`, method: 'GET', signal },
    options
  );

export const getGetEmailThreadMessagesQueryKey = (id: string) =>
  [`/calendar/email/thread/${id}/message`] as const;

export const getGetEmailThreadMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailThreadMessages>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailThreadMessages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailThreadMessagesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailThreadMessages>>> = ({ signal }) =>
    getEmailThreadMessages(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailThreadMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmailThreadMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailThreadMessages>>
>;
export type GetEmailThreadMessagesQueryError = EmailMessageResponse;

export function useGetEmailThreadMessages<
  TData = Awaited<ReturnType<typeof getEmailThreadMessages>>,
  TError = EmailMessageResponse
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailThreadMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof getEmailThreadMessages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailThreadMessages<
  TData = Awaited<ReturnType<typeof getEmailThreadMessages>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailThreadMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThreadMessages>>,
          TError,
          Awaited<ReturnType<typeof getEmailThreadMessages>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailThreadMessages<
  TData = Awaited<ReturnType<typeof getEmailThreadMessages>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailThreadMessages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Email thread messages
 */

export function useGetEmailThreadMessages<
  TData = Awaited<ReturnType<typeof getEmailThreadMessages>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmailThreadMessages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmailThreadMessagesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Email message
 */
export const getEmailMessage = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<EmailMessageResponse>(
    { url: `/calendar/email/message/${id}`, method: 'GET', signal },
    options
  );

export const getGetEmailMessageQueryKey = (id: string) =>
  [`/calendar/email/message/${id}`] as const;

export const getGetEmailMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailMessage>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailMessageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailMessage>>> = ({ signal }) =>
    getEmailMessage(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailMessage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEmailMessageQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailMessage>>>;
export type GetEmailMessageQueryError = EmailMessageResponse;

export function useGetEmailMessage<
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = EmailMessageResponse
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailMessage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailMessage>>,
          TError,
          Awaited<ReturnType<typeof getEmailMessage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailMessage<
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailMessage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailMessage>>,
          TError,
          Awaited<ReturnType<typeof getEmailMessage>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEmailMessage<
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailMessage>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Email message
 */

export function useGetEmailMessage<
  TData = Awaited<ReturnType<typeof getEmailMessage>>,
  TError = EmailMessageResponse
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailMessage>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmailMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Contacts
 */
export const listContacts = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => customInstance<ContactResponse>({ url: `/calendar/contact`, method: 'GET', signal }, options);

export const getListContactsQueryKey = () => [`/calendar/contact`] as const;

export const getListContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ContactResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContacts>>> = ({ signal }) =>
    listContacts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListContactsQueryResult = NonNullable<Awaited<ReturnType<typeof listContacts>>>;
export type ListContactsQueryError = ContactResponse;

export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ContactResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listContacts>>,
        TError,
        Awaited<ReturnType<typeof listContacts>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ContactResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listContacts>>,
        TError,
        Awaited<ReturnType<typeof listContacts>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ContactResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Contacts
 */

export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ContactResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listContacts>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sign up verification
 */
export const verifySignUp = (
  params: VerifySignUpParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<UserDetailsResponse>(
    { url: `/auth/signUp/verification`, method: 'GET', params, signal },
    options
  );

export const getVerifySignUpQueryKey = (params: VerifySignUpParams) =>
  [`/auth/signUp/verification`, ...(params ? [params] : [])] as const;

export const getVerifySignUpQueryOptions = <
  TData = Awaited<ReturnType<typeof verifySignUp>>,
  TError = UserDetailsResponse
>(
  params: VerifySignUpParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifySignUp>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifySignUpQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifySignUp>>> = ({ signal }) =>
    verifySignUp(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verifySignUp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type VerifySignUpQueryResult = NonNullable<Awaited<ReturnType<typeof verifySignUp>>>;
export type VerifySignUpQueryError = UserDetailsResponse;

export function useVerifySignUp<
  TData = Awaited<ReturnType<typeof verifySignUp>>,
  TError = UserDetailsResponse
>(
  params: VerifySignUpParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifySignUp>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifySignUp>>,
          TError,
          Awaited<ReturnType<typeof verifySignUp>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifySignUp<
  TData = Awaited<ReturnType<typeof verifySignUp>>,
  TError = UserDetailsResponse
>(
  params: VerifySignUpParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifySignUp>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof verifySignUp>>,
          TError,
          Awaited<ReturnType<typeof verifySignUp>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useVerifySignUp<
  TData = Awaited<ReturnType<typeof verifySignUp>>,
  TError = UserDetailsResponse
>(
  params: VerifySignUpParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifySignUp>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sign up verification
 */

export function useVerifySignUp<
  TData = Awaited<ReturnType<typeof verifySignUp>>,
  TError = UserDetailsResponse
>(
  params: VerifySignUpParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof verifySignUp>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getVerifySignUpQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Ask Journey history
 */
export const getAskJourneyHistory = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AskJourneyAnswerResponse>({ url: `/ask/history`, method: 'GET', signal }, options);

export const getGetAskJourneyHistoryQueryKey = () => [`/ask/history`] as const;

export const getGetAskJourneyHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAskJourneyHistory>>,
  TError = AskJourneyAnswerResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAskJourneyHistory>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAskJourneyHistoryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAskJourneyHistory>>> = ({ signal }) =>
    getAskJourneyHistory(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAskJourneyHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAskJourneyHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAskJourneyHistory>>
>;
export type GetAskJourneyHistoryQueryError = AskJourneyAnswerResponse;

export function useGetAskJourneyHistory<
  TData = Awaited<ReturnType<typeof getAskJourneyHistory>>,
  TError = AskJourneyAnswerResponse
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAskJourneyHistory>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAskJourneyHistory>>,
        TError,
        Awaited<ReturnType<typeof getAskJourneyHistory>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAskJourneyHistory<
  TData = Awaited<ReturnType<typeof getAskJourneyHistory>>,
  TError = AskJourneyAnswerResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAskJourneyHistory>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getAskJourneyHistory>>,
        TError,
        Awaited<ReturnType<typeof getAskJourneyHistory>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAskJourneyHistory<
  TData = Awaited<ReturnType<typeof getAskJourneyHistory>>,
  TError = AskJourneyAnswerResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAskJourneyHistory>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Ask Journey history
 */

export function useGetAskJourneyHistory<
  TData = Awaited<ReturnType<typeof getAskJourneyHistory>>,
  TError = AskJourneyAnswerResponse
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAskJourneyHistory>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAskJourneyHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List app notifications
 */
export const listAppNotifications = (
  params?: ListAppNotificationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AppNotificationResponse>(
    { url: `/appNotification`, method: 'GET', params, signal },
    options
  );

export const getListAppNotificationsQueryKey = (params?: ListAppNotificationsParams) =>
  [`/appNotification`, ...(params ? [params] : [])] as const;

export const getListAppNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAppNotifications>>,
  TError = AppNotificationResponse
>(
  params?: ListAppNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAppNotifications>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAppNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppNotifications>>> = ({ signal }) =>
    listAppNotifications(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAppNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAppNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAppNotifications>>
>;
export type ListAppNotificationsQueryError = AppNotificationResponse;

export function useListAppNotifications<
  TData = Awaited<ReturnType<typeof listAppNotifications>>,
  TError = AppNotificationResponse
>(
  params: undefined | ListAppNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAppNotifications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppNotifications>>,
          TError,
          Awaited<ReturnType<typeof listAppNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAppNotifications<
  TData = Awaited<ReturnType<typeof listAppNotifications>>,
  TError = AppNotificationResponse
>(
  params?: ListAppNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAppNotifications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAppNotifications>>,
          TError,
          Awaited<ReturnType<typeof listAppNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAppNotifications<
  TData = Awaited<ReturnType<typeof listAppNotifications>>,
  TError = AppNotificationResponse
>(
  params?: ListAppNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAppNotifications>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List app notifications
 */

export function useListAppNotifications<
  TData = Awaited<ReturnType<typeof listAppNotifications>>,
  TError = AppNotificationResponse
>(
  params?: ListAppNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAppNotifications>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAppNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all agent operations
 */
export const listAgentOperations = (
  params?: ListAgentOperationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AgentOperationResponse>(
    { url: `/agent/operation`, method: 'GET', params, signal },
    options
  );

export const getListAgentOperationsQueryKey = (params?: ListAgentOperationsParams) =>
  [`/agent/operation`, ...(params ? [params] : [])] as const;

export const getListAgentOperationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentOperations>>,
  TError = AgentOperationResponse
>(
  params?: ListAgentOperationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentOperations>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAgentOperationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentOperations>>> = ({ signal }) =>
    listAgentOperations(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentOperations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAgentOperationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAgentOperations>>
>;
export type ListAgentOperationsQueryError = AgentOperationResponse;

export function useListAgentOperations<
  TData = Awaited<ReturnType<typeof listAgentOperations>>,
  TError = AgentOperationResponse
>(
  params: undefined | ListAgentOperationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentOperations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentOperations>>,
          TError,
          Awaited<ReturnType<typeof listAgentOperations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentOperations<
  TData = Awaited<ReturnType<typeof listAgentOperations>>,
  TError = AgentOperationResponse
>(
  params?: ListAgentOperationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentOperations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentOperations>>,
          TError,
          Awaited<ReturnType<typeof listAgentOperations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAgentOperations<
  TData = Awaited<ReturnType<typeof listAgentOperations>>,
  TError = AgentOperationResponse
>(
  params?: ListAgentOperationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentOperations>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all agent operations
 */

export function useListAgentOperations<
  TData = Awaited<ReturnType<typeof listAgentOperations>>,
  TError = AgentOperationResponse
>(
  params?: ListAgentOperationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAgentOperations>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAgentOperationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get askMeAnything agent chat history
 */
export const getAskMeAnythingChatHistory = (
  threadId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<AgentChatHistoryResponse>(
    { url: `/agent/askMeAnything/chat/history/${threadId}`, method: 'GET', signal },
    options
  );

export const getGetAskMeAnythingChatHistoryQueryKey = (threadId: string) =>
  [`/agent/askMeAnything/chat/history/${threadId}`] as const;

export const getGetAskMeAnythingChatHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
  TError = AgentChatHistoryResponse
>(
  threadId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAskMeAnythingChatHistoryQueryKey(threadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>> = ({
    signal
  }) => getAskMeAnythingChatHistory(threadId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!threadId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAskMeAnythingChatHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>
>;
export type GetAskMeAnythingChatHistoryQueryError = AgentChatHistoryResponse;

export function useGetAskMeAnythingChatHistory<
  TData = Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
  TError = AgentChatHistoryResponse
>(
  threadId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
          TError,
          Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAskMeAnythingChatHistory<
  TData = Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
  TError = AgentChatHistoryResponse
>(
  threadId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
          TError,
          Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAskMeAnythingChatHistory<
  TData = Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
  TError = AgentChatHistoryResponse
>(
  threadId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get askMeAnything agent chat history
 */

export function useGetAskMeAnythingChatHistory<
  TData = Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>,
  TError = AgentChatHistoryResponse
>(
  threadId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAskMeAnythingChatHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAskMeAnythingChatHistoryQueryOptions(threadId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List objective comments
 */
export const listActionPlanObjectiveComments = (
  objectiveId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveCommentResponse>(
    { url: `/actionPlan/objective/${objectiveId}/comment`, method: 'GET', signal },
    options
  );

export const getListActionPlanObjectiveCommentsQueryKey = (objectiveId: string) =>
  [`/actionPlan/objective/${objectiveId}/comment`] as const;

export const getListActionPlanObjectiveCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
  TError = ActionPlanObjectiveCommentResponse
>(
  objectiveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActionPlanObjectiveCommentsQueryKey(objectiveId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>> = ({
    signal
  }) => listActionPlanObjectiveComments(objectiveId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!objectiveId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanObjectiveCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanObjectiveComments>>
>;
export type ListActionPlanObjectiveCommentsQueryError = ActionPlanObjectiveCommentResponse;

export function useListActionPlanObjectiveComments<
  TData = Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
  TError = ActionPlanObjectiveCommentResponse
>(
  objectiveId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanObjectiveComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanObjectiveComments<
  TData = Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
  TError = ActionPlanObjectiveCommentResponse
>(
  objectiveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanObjectiveComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanObjectiveComments<
  TData = Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
  TError = ActionPlanObjectiveCommentResponse
>(
  objectiveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List objective comments
 */

export function useListActionPlanObjectiveComments<
  TData = Awaited<ReturnType<typeof listActionPlanObjectiveComments>>,
  TError = ActionPlanObjectiveCommentResponse
>(
  objectiveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanObjectiveComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanObjectiveCommentsQueryOptions(objectiveId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get detailed objective
 */
export const getActionPlanDetailedObjective = (
  id: string,
  params?: GetActionPlanDetailedObjectiveParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveDetailedResponse>(
    { url: `/actionPlan/objective/${id}/detailed`, method: 'GET', params, signal },
    options
  );

export const getGetActionPlanDetailedObjectiveQueryKey = (
  id: string,
  params?: GetActionPlanDetailedObjectiveParams
) => [`/actionPlan/objective/${id}/detailed`, ...(params ? [params] : [])] as const;

export const getGetActionPlanDetailedObjectiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  id: string,
  params?: GetActionPlanDetailedObjectiveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionPlanDetailedObjectiveQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>> = ({
    signal
  }) => getActionPlanDetailedObjective(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionPlanDetailedObjectiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionPlanDetailedObjective>>
>;
export type GetActionPlanDetailedObjectiveQueryError = ActionPlanObjectiveDetailedResponse;

export function useGetActionPlanDetailedObjective<
  TData = Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  id: string,
  params: undefined | GetActionPlanDetailedObjectiveParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanDetailedObjective>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanDetailedObjective<
  TData = Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  id: string,
  params?: GetActionPlanDetailedObjectiveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanDetailedObjective>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionPlanDetailedObjective<
  TData = Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  id: string,
  params?: GetActionPlanDetailedObjectiveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get detailed objective
 */

export function useGetActionPlanDetailedObjective<
  TData = Awaited<ReturnType<typeof getActionPlanDetailedObjective>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  id: string,
  params?: GetActionPlanDetailedObjectiveParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionPlanDetailedObjective>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActionPlanDetailedObjectiveQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List objectives detailed
 */
export const listActionPlanDetailedObjectives = (
  params?: ListActionPlanDetailedObjectivesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanObjectiveDetailedResponse>(
    { url: `/actionPlan/objective/detailed`, method: 'GET', params, signal },
    options
  );

export const getListActionPlanDetailedObjectivesQueryKey = (
  params?: ListActionPlanDetailedObjectivesParams
) => [`/actionPlan/objective/detailed`, ...(params ? [params] : [])] as const;

export const getListActionPlanDetailedObjectivesQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  params?: ListActionPlanDetailedObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActionPlanDetailedObjectivesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>> = ({
    signal
  }) => listActionPlanDetailedObjectives(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanDetailedObjectivesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>
>;
export type ListActionPlanDetailedObjectivesQueryError = ActionPlanObjectiveDetailedResponse;

export function useListActionPlanDetailedObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  params: undefined | ListActionPlanDetailedObjectivesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanDetailedObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  params?: ListActionPlanDetailedObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanDetailedObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  params?: ListActionPlanDetailedObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List objectives detailed
 */

export function useListActionPlanDetailedObjectives<
  TData = Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>,
  TError = ActionPlanObjectiveDetailedResponse
>(
  params?: ListActionPlanDetailedObjectivesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanDetailedObjectives>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanDetailedObjectivesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List initiative comments
 */
export const listActionPlanInitiativeComments = (
  initiativeId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanInitiativeCommentResponse>(
    { url: `/actionPlan/initiative/${initiativeId}/comment`, method: 'GET', signal },
    options
  );

export const getListActionPlanInitiativeCommentsQueryKey = (initiativeId: string) =>
  [`/actionPlan/initiative/${initiativeId}/comment`] as const;

export const getListActionPlanInitiativeCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
  TError = ActionPlanInitiativeCommentResponse
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActionPlanInitiativeCommentsQueryKey(initiativeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>> = ({
    signal
  }) => listActionPlanInitiativeComments(initiativeId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!initiativeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanInitiativeCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanInitiativeComments>>
>;
export type ListActionPlanInitiativeCommentsQueryError = ActionPlanInitiativeCommentResponse;

export function useListActionPlanInitiativeComments<
  TData = Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
  TError = ActionPlanInitiativeCommentResponse
>(
  initiativeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanInitiativeComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanInitiativeComments<
  TData = Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
  TError = ActionPlanInitiativeCommentResponse
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanInitiativeComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanInitiativeComments<
  TData = Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
  TError = ActionPlanInitiativeCommentResponse
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List initiative comments
 */

export function useListActionPlanInitiativeComments<
  TData = Awaited<ReturnType<typeof listActionPlanInitiativeComments>>,
  TError = ActionPlanInitiativeCommentResponse
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanInitiativeComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanInitiativeCommentsQueryOptions(initiativeId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get initiatives suggestion
 */
export const getInitiativeSuggestion = (
  params: GetInitiativeSuggestionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanSuggestionResponse>(
    { url: `/actionPlan/initiative/suggestion`, method: 'GET', params, signal },
    options
  );

export const getGetInitiativeSuggestionQueryKey = (params: GetInitiativeSuggestionParams) =>
  [`/actionPlan/initiative/suggestion`, ...(params ? [params] : [])] as const;

export const getGetInitiativeSuggestionQueryOptions = <
  TData = Awaited<ReturnType<typeof getInitiativeSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetInitiativeSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInitiativeSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInitiativeSuggestionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInitiativeSuggestion>>> = ({
    signal
  }) => getInitiativeSuggestion(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInitiativeSuggestion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInitiativeSuggestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInitiativeSuggestion>>
>;
export type GetInitiativeSuggestionQueryError = ActionPlanSuggestionResponse;

export function useGetInitiativeSuggestion<
  TData = Awaited<ReturnType<typeof getInitiativeSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetInitiativeSuggestionParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInitiativeSuggestion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInitiativeSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getInitiativeSuggestion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInitiativeSuggestion<
  TData = Awaited<ReturnType<typeof getInitiativeSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetInitiativeSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInitiativeSuggestion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInitiativeSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getInitiativeSuggestion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInitiativeSuggestion<
  TData = Awaited<ReturnType<typeof getInitiativeSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetInitiativeSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInitiativeSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get initiatives suggestion
 */

export function useGetInitiativeSuggestion<
  TData = Awaited<ReturnType<typeof getInitiativeSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetInitiativeSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInitiativeSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInitiativeSuggestionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List last updated initiatives
 */
export const listLatestUpdatedInitiatives = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<LastUpdatedInitiativeResponse>(
    { url: `/actionPlan/initiative/latest`, method: 'GET', signal },
    options
  );

export const getListLatestUpdatedInitiativesQueryKey = () =>
  [`/actionPlan/initiative/latest`] as const;

export const getListLatestUpdatedInitiativesQueryOptions = <
  TData = Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
  TError = LastUpdatedInitiativeResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLatestUpdatedInitiativesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>> = ({
    signal
  }) => listLatestUpdatedInitiatives(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLatestUpdatedInitiativesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>
>;
export type ListLatestUpdatedInitiativesQueryError = LastUpdatedInitiativeResponse;

export function useListLatestUpdatedInitiatives<
  TData = Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
  TError = LastUpdatedInitiativeResponse
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
        TError,
        Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListLatestUpdatedInitiatives<
  TData = Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
  TError = LastUpdatedInitiativeResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
        TError,
        Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>
      >,
      'initialData'
    >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListLatestUpdatedInitiatives<
  TData = Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
  TError = LastUpdatedInitiativeResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List last updated initiatives
 */

export function useListLatestUpdatedInitiatives<
  TData = Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>,
  TError = LastUpdatedInitiativeResponse
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listLatestUpdatedInitiatives>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListLatestUpdatedInitiativesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List action item comments
 */
export const listActionPlanActionItemComments = (
  actionItemId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanActionItemCommentResponse>(
    { url: `/actionPlan/actionItem/${actionItemId}/comment`, method: 'GET', signal },
    options
  );

export const getListActionPlanActionItemCommentsQueryKey = (actionItemId: string) =>
  [`/actionPlan/actionItem/${actionItemId}/comment`] as const;

export const getListActionPlanActionItemCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
  TError = ActionPlanActionItemCommentResponse
>(
  actionItemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItemComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActionPlanActionItemCommentsQueryKey(actionItemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActionPlanActionItemComments>>> = ({
    signal
  }) => listActionPlanActionItemComments(actionItemId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!actionItemId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListActionPlanActionItemCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActionPlanActionItemComments>>
>;
export type ListActionPlanActionItemCommentsQueryError = ActionPlanActionItemCommentResponse;

export function useListActionPlanActionItemComments<
  TData = Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
  TError = ActionPlanActionItemCommentResponse
>(
  actionItemId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItemComments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanActionItemComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanActionItemComments<
  TData = Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
  TError = ActionPlanActionItemCommentResponse
>(
  actionItemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItemComments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
          TError,
          Awaited<ReturnType<typeof listActionPlanActionItemComments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListActionPlanActionItemComments<
  TData = Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
  TError = ActionPlanActionItemCommentResponse
>(
  actionItemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItemComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List action item comments
 */

export function useListActionPlanActionItemComments<
  TData = Awaited<ReturnType<typeof listActionPlanActionItemComments>>,
  TError = ActionPlanActionItemCommentResponse
>(
  actionItemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listActionPlanActionItemComments>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListActionPlanActionItemCommentsQueryOptions(actionItemId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get action items suggestion
 */
export const getActionItemsSuggestion = (
  params: GetActionItemsSuggestionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) =>
  customInstance<ActionPlanSuggestionResponse>(
    { url: `/actionPlan/actionItem/suggestion`, method: 'GET', params, signal },
    options
  );

export const getGetActionItemsSuggestionQueryKey = (params: GetActionItemsSuggestionParams) =>
  [`/actionPlan/actionItem/suggestion`, ...(params ? [params] : [])] as const;

export const getGetActionItemsSuggestionQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionItemsSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetActionItemsSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionItemsSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionItemsSuggestionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionItemsSuggestion>>> = ({
    signal
  }) => getActionItemsSuggestion(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionItemsSuggestion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActionItemsSuggestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionItemsSuggestion>>
>;
export type GetActionItemsSuggestionQueryError = ActionPlanSuggestionResponse;

export function useGetActionItemsSuggestion<
  TData = Awaited<ReturnType<typeof getActionItemsSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetActionItemsSuggestionParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionItemsSuggestion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionItemsSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getActionItemsSuggestion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionItemsSuggestion<
  TData = Awaited<ReturnType<typeof getActionItemsSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetActionItemsSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionItemsSuggestion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionItemsSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getActionItemsSuggestion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActionItemsSuggestion<
  TData = Awaited<ReturnType<typeof getActionItemsSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetActionItemsSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionItemsSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get action items suggestion
 */

export function useGetActionItemsSuggestion<
  TData = Awaited<ReturnType<typeof getActionItemsSuggestion>>,
  TError = ActionPlanSuggestionResponse
>(
  params: GetActionItemsSuggestionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionItemsSuggestion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActionItemsSuggestionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete meeting analysis suggestion
 */
export const deleteSharedWorkspaceMeetingAnalysisSuggestion = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/meeting/analysis/suggestion/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteSharedWorkspaceMeetingAnalysisSuggestionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteSharedWorkspaceMeetingAnalysisSuggestion'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteSharedWorkspaceMeetingAnalysisSuggestion(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSharedWorkspaceMeetingAnalysisSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>
>;

export type DeleteSharedWorkspaceMeetingAnalysisSuggestionMutationError = unknown;

/**
 * @summary Delete meeting analysis suggestion
 */
export const useDeleteSharedWorkspaceMeetingAnalysisSuggestion = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSharedWorkspaceMeetingAnalysisSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteSharedWorkspaceMeetingAnalysisSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete workspace calendar event suggestion
 */
export const deleteWorkspaceCalendarEventSuggestion = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>(
    { url: `/workspace/sharedWorkspace/calendar/event/suggestion/${id}`, method: 'DELETE' },
    options
  );

export const getDeleteWorkspaceCalendarEventSuggestionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteWorkspaceCalendarEventSuggestion'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteWorkspaceCalendarEventSuggestion(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkspaceCalendarEventSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>
>;

export type DeleteWorkspaceCalendarEventSuggestionMutationError = unknown;

/**
 * @summary Delete workspace calendar event suggestion
 */
export const useDeleteWorkspaceCalendarEventSuggestion = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkspaceCalendarEventSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteWorkspaceCalendarEventSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete google drive file
 */
export const deleteGoogleDriveFile = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) =>
  customInstance<void>({ url: `/workspace/resource/drive/file/${id}`, method: 'DELETE' }, options);

export const getDeleteGoogleDriveFileMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoogleDriveFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGoogleDriveFile>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteGoogleDriveFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGoogleDriveFile>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteGoogleDriveFile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGoogleDriveFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGoogleDriveFile>>
>;

export type DeleteGoogleDriveFileMutationError = unknown;

/**
 * @summary Delete google drive file
 */
export const useDeleteGoogleDriveFile = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGoogleDriveFile>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGoogleDriveFile>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteGoogleDriveFileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete Meeting
 */
export const deleteCalendarMeeting = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/workbench/${id}`, method: 'DELETE' }, options);

export const getDeleteCalendarMeetingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCalendarMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCalendarMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteCalendarMeeting'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCalendarMeeting>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteCalendarMeeting(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCalendarMeetingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCalendarMeeting>>
>;

export type DeleteCalendarMeetingMutationError = unknown;

/**
 * @summary Delete Meeting
 */
export const useDeleteCalendarMeeting = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCalendarMeeting>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCalendarMeeting>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteCalendarMeetingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete data source
 */
export const deleteDataSource = (id: string, options?: SecondParameter<typeof customInstance>) =>
  customInstance<void>({ url: `/integration/dataSource/${id}`, method: 'DELETE' }, options);

export const getDeleteDataSourceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDataSource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDataSource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteDataSource'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDataSource>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteDataSource(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDataSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDataSource>>
>;

export type DeleteDataSourceMutationError = unknown;

/**
 * @summary Delete data source
 */
export const useDeleteDataSource = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDataSource>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDataSource>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteDataSourceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete answer
 */
export const deleteAskJourneyAnswer = (
  id: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/ask/answer/${id}`, method: 'DELETE' }, options);

export const getDeleteAskJourneyAnswerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAskJourneyAnswer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAskJourneyAnswer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteAskJourneyAnswer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAskJourneyAnswer>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteAskJourneyAnswer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAskJourneyAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAskJourneyAnswer>>
>;

export type DeleteAskJourneyAnswerMutationError = unknown;

/**
 * @summary Delete answer
 */
export const useDeleteAskJourneyAnswer = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAskJourneyAnswer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAskJourneyAnswer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteAskJourneyAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete agent thread
 */
export const deleteAgentThread = (
  threadId: string,
  options?: SecondParameter<typeof customInstance>
) => customInstance<void>({ url: `/agent/thread/${threadId}`, method: 'DELETE' }, options);

export const getDeleteAgentThreadMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentThread>>,
    TError,
    { threadId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAgentThread>>,
  TError,
  { threadId: string },
  TContext
> => {
  const mutationKey = ['deleteAgentThread'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAgentThread>>,
    { threadId: string }
  > = props => {
    const { threadId } = props ?? {};

    return deleteAgentThread(threadId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAgentThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAgentThread>>
>;

export type DeleteAgentThreadMutationError = unknown;

/**
 * @summary Delete agent thread
 */
export const useDeleteAgentThread = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAgentThread>>,
    TError,
    { threadId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAgentThread>>,
  TError,
  { threadId: string },
  TContext
> => {
  const mutationOptions = getDeleteAgentThreadMutationOptions(options);

  return useMutation(mutationOptions);
};
